window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs, an) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.AnswerContainerDown = function() {
	this.initialize(img.MainAssets_AnswerContainerDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,780,130);


(lib.AnswerContainerOver = function() {
	this.initialize(img.MainAssets_AnswerContainerOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,779,129);


(lib.AnswerSlot = function() {
	this.initialize(img.MainAssets_AnswerSlot);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,845,137);


(lib.Asset15x = function() {
	this.initialize(img.MainAssets_Asset15x);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,599,351);


(lib.BackDisabled = function() {
	this.initialize(img.MainAssets_BackDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,221,68);


(lib.BackOver = function() {
	this.initialize(img.MainAssets_BackOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,222,68);


(lib.BackUp = function() {
	this.initialize(img.MainAssets_BackUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,221,68);


(lib.BadDown = function() {
	this.initialize(img.MainAssets_BadDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.BadOver = function() {
	this.initialize(img.MainAssets_BadOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.BadUp = function() {
	this.initialize(img.MainAssets_BadUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.BottomBar = function() {
	this.initialize(img.MainAssets_BottomBar);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1923,179);


(lib.BriefingBackground = function() {
	this.initialize(img.MainAssets_BriefingBackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1921,1081);


(lib.BriefingBlackBar = function() {
	this.initialize(img.MainAssets_BriefingBlackBar);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,37,852);


(lib.BriefingBodybackground = function() {
	this.initialize(img.MainAssets_BriefingBodybackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1268,867);


(lib.BriefingTimeLine = function() {
	this.initialize(img.MainAssets_BriefingTimeLine);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,189,1156);


(lib.BriefingTimelineBackground = function() {
	this.initialize(img.MainAssets_BriefingTimelineBackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,72,1122);


(lib.BriefingTimelineBars = function() {
	this.initialize(img.MainAssets_BriefingTimelineBars);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,87,27);


(lib.ButtonOverWhite = function() {
	this.initialize(img.MainAssets_ButtonOverWhite);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,307,61);


(lib.ButtonOverWhitepngcopy = function() {
	this.initialize(img.MainAssets_ButtonOverWhitepngcopy);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,307,61);


(lib.CloseButtonIcon = function() {
	this.initialize(img.MainAssets_CloseButtonIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,17,17);


(lib.CompletedKDConfirmationScreen = function() {
	this.initialize(img.MainAssets_CompletedKDConfirmationScreen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,141,140);


(lib.ContinueButtonDisabled = function() {
	this.initialize(img.MainAssets_ContinueButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,309,63);


(lib.ContinueButtonHi = function() {
	this.initialize(img.MainAssets_ContinueButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,309,63);


(lib.ContinueButtonUp = function() {
	this.initialize(img.MainAssets_ContinueButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,309,63);


(lib.ContinueTutorialDisabled = function() {
	this.initialize(img.MainAssets_ContinueTutorialDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,352,62);


(lib.ContinueTutorialOver = function() {
	this.initialize(img.MainAssets_ContinueTutorialOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,352,62);


(lib.ContinueTutorialUp = function() {
	this.initialize(img.MainAssets_ContinueTutorialUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,352,62);


(lib.DashboardBGpngcopy = function() {
	this.initialize(img.MainAssets_DashboardBGpngcopy);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1603,903);


(lib.DashboardButton = function() {
	this.initialize(img.MainAssets_DashboardButton);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,160,130);


(lib.DashboardButtonOver = function() {
	this.initialize(img.MainAssets_DashboardButtonOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,160,130);


(lib.DataDashboardNewIcon = function() {
	this.initialize(img.MainAssets_DataDashboardNewIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,33,33);


(lib.DecisionButtonHi = function() {
	this.initialize(img.MainAssets_DecisionButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,724,180);


(lib.DecisionButtonUp = function() {
	this.initialize(img.MainAssets_DecisionButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,724,180);


(lib.DialogBackBackground = function() {
	this.initialize(img.MainAssets_DialogBackBackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,89,47);


(lib.DialogBackButtonDisabled = function() {
	this.initialize(img.MainAssets_DialogBackButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,62,39);


(lib.DialogBackButtonDown = function() {
	this.initialize(img.MainAssets_DialogBackButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,62,39);


(lib.DialogBackButtonUp = function() {
	this.initialize(img.MainAssets_DialogBackButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,62,39);


(lib.DialogButtonRight = function() {
	this.initialize(img.MainAssets_DialogButtonRight);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,483,63);


(lib.DialogButtonUp = function() {
	this.initialize(img.MainAssets_DialogButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,780,131);


(lib.DialogButtonWrong = function() {
	this.initialize(img.MainAssets_DialogButtonWrong);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,483,63);


(lib.DialogNPCTextFieldBG1 = function() {
	this.initialize(img.MainAssets_DialogNPCTextFieldBG1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,780,313);


(lib.EndscreenBG = function() {
	this.initialize(img.MainAssets_EndscreenBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.EpilogueDashboardBackground = function() {
	this.initialize(img.MainAssets_EpilogueDashboardBackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1081);


(lib.EpilogueDashboardContentBackground = function() {
	this.initialize(img.MainAssets_EpilogueDashboardContentBackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1720,983);


(lib.EpilogueDashboardStatsContainer = function() {
	this.initialize(img.MainAssets_EpilogueDashboardStatsContainer);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,634,136);


(lib.EpilogueDashboardStatsContainerLarge = function() {
	this.initialize(img.MainAssets_EpilogueDashboardStatsContainerLarge);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,679,153);


(lib.EpilogueGlobeFullpngcopy = function() {
	this.initialize(img.MainAssets_EpilogueGlobeFullpngcopy);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,700,645);


(lib.ExitIcon = function() {
	this.initialize(img.MainAssets_ExitIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,45,45);


(lib.ExpandOptimal = function() {
	this.initialize(img.MainAssets_ExpandOptimal);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,23,25);


(lib.ExpandPlayerChoice = function() {
	this.initialize(img.MainAssets_ExpandPlayerChoice);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,23,25);


(lib.FeedbackBackground = function() {
	this.initialize(img.MainAssets_FeedbackBackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.FeedbackBGpointer = function() {
	this.initialize(img.MainAssets_FeedbackBGpointer);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,43,96);


(lib.FeedbackBlackBar = function() {
	this.initialize(img.MainAssets_FeedbackBlackBar);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,22,174);


(lib.FeedbackContentContainer = function() {
	this.initialize(img.MainAssets_FeedbackContentContainer);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1775,1080);


(lib.FeedbackIcon = function() {
	this.initialize(img.MainAssets_FeedbackIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,54,42);


(lib.FeedbackInactiveKD = function() {
	this.initialize(img.MainAssets_FeedbackInactiveKD);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,48,49);


(lib.FeedbackInactiveKDOver = function() {
	this.initialize(img.MainAssets_FeedbackInactiveKDOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,49,49);


(lib.FeedbackKDInfoExpansion = function() {
	this.initialize(img.MainAssets_FeedbackKDInfoExpansion);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,508,96);


(lib.FeedbackKDOptimal = function() {
	this.initialize(img.MainAssets_FeedbackKDOptimal);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,279,147);


(lib.FeedbackKDPlayerChoice = function() {
	this.initialize(img.MainAssets_FeedbackKDPlayerChoice);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,279,147);


(lib.FeedbackKDSmall = function() {
	this.initialize(img.MainAssets_FeedbackKDSmall);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,77,77);


(lib.FeedbackLongBar = function() {
	this.initialize(img.MainAssets_FeedbackLongBar);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,21,1080);


(lib.FeedbackPointer = function() {
	this.initialize(img.MainAssets_FeedbackPointer);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,25,48);


(lib.FeedbackSmallBar = function() {
	this.initialize(img.MainAssets_FeedbackSmallBar);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,51,14);


(lib.FeedbackTimelineBGLong = function() {
	this.initialize(img.MainAssets_FeedbackTimelineBGLong);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,28,805);


(lib.FeedbackToolTipBlackScreen = function() {
	this.initialize(img.MainAssets_FeedbackToolTipBlackScreen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,741,338);


(lib.FeedbackToolTipWhiteScreen = function() {
	this.initialize(img.MainAssets_FeedbackToolTipWhiteScreen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,741,338);


(lib.GoodDown = function() {
	this.initialize(img.MainAssets_GoodDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.GoodOver = function() {
	this.initialize(img.MainAssets_GoodOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.GoodUp = function() {
	this.initialize(img.MainAssets_GoodUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.HideOptimalDown = function() {
	this.initialize(img.MainAssets_HideOptimalDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,421,76);


(lib.HideOptimalOver = function() {
	this.initialize(img.MainAssets_HideOptimalOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,421,76);


(lib.HideOptimalUp = function() {
	this.initialize(img.MainAssets_HideOptimalUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,421,76);


(lib.Hub_ExitButtonOver = function() {
	this.initialize(img.MainAssets_Hub_ExitButtonOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,59,59);


(lib.Hub_ExitButtonUp = function() {
	this.initialize(img.MainAssets_Hub_ExitButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,59,59);


(lib.Hub_InfoButtonOver = function() {
	this.initialize(img.MainAssets_Hub_InfoButtonOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,60,59);


(lib.Hub_InfoButtonUp = function() {
	this.initialize(img.MainAssets_Hub_InfoButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,59,59);


(lib.Hub_PauseButtonOver = function() {
	this.initialize(img.MainAssets_Hub_PauseButtonOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,60,59);


(lib.Hub_PauseButtonUp = function() {
	this.initialize(img.MainAssets_Hub_PauseButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,59,59);


(lib.Hub_ResumeButtonOver = function() {
	this.initialize(img.MainAssets_Hub_ResumeButtonOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,60,59);


(lib.Hub_ResumeButtonUp = function() {
	this.initialize(img.MainAssets_Hub_ResumeButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,59,60);


(lib.HUBLaptopOver = function() {
	this.initialize(img.MainAssets_HUBLaptopOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,320,242);


(lib.HUBLaptopUp = function() {
	this.initialize(img.MainAssets_HUBLaptopUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,291,213);


(lib.HUBmapCh1 = function() {
	this.initialize(img.MainAssets_HUBmapCh1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.HUBmapCh1_1 = function() {
	this.initialize(img.MainAssets_HUBmapCh1_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1921,1081);


(lib.HUBmapCh1_2 = function() {
	this.initialize(img.MainAssets_HUBmapCh1_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.HUBNewItemLabel1 = function() {
	this.initialize(img.MainAssets_HUBNewItemLabel1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,84,80);


(lib.HUBSmartphoneOver = function() {
	this.initialize(img.MainAssets_HUBSmartphoneOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,177,241);


(lib.HUBSmartphoneUp = function() {
	this.initialize(img.MainAssets_HUBSmartphoneUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,177,241);


(lib.HUBStakeholderButtonBGDisabled = function() {
	this.initialize(img.MainAssets_HUBStakeholderButtonBGDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,164,166);


(lib.HUBStakeholderButtonBGUp = function() {
	this.initialize(img.MainAssets_HUBStakeholderButtonBGUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,164,166);


(lib.HUBStakeholderButtonLabelDisabled = function() {
	this.initialize(img.MainAssets_HUBStakeholderButtonLabelDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,177,99);


(lib.HUBStakeholderButtonLabelOver = function() {
	this.initialize(img.MainAssets_HUBStakeholderButtonLabelOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,178,99);


(lib.HUBStakeholderButtonLabelUp = function() {
	this.initialize(img.MainAssets_HUBStakeholderButtonLabelUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,177,99);


(lib.HUBTeaCornerButtonBGDisabled = function() {
	this.initialize(img.MainAssets_HUBTeaCornerButtonBGDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,128,129);


(lib.HUBTeaCornerButtonBGUp = function() {
	this.initialize(img.MainAssets_HUBTeaCornerButtonBGUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,128,129);


(lib.HUBTeaCornerButtonLabelDisabled = function() {
	this.initialize(img.MainAssets_HUBTeaCornerButtonLabelDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,228,91);


(lib.HUBTeaCornerButtonLabelOver = function() {
	this.initialize(img.MainAssets_HUBTeaCornerButtonLabelOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,228,91);


(lib.HUBTeaCornerButtonLabelUp = function() {
	this.initialize(img.MainAssets_HUBTeaCornerButtonLabelUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,228,91);


(lib.HubTimelineBGLong = function() {
	this.initialize(img.MainAssets_HubTimelineBGLong);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,28,659);


(lib.KDExpansionPointer = function() {
	this.initialize(img.MainAssets_KDExpansionPointer);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,24,47);


(lib.KeyDecAvailableBG = function() {
	this.initialize(img.MainAssets_KeyDecAvailableBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,660,809);


(lib.KeyDecButtonCompleted = function() {
	this.initialize(img.MainAssets_KeyDecButtonCompleted);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,48,49);


(lib.KeyDecButtonDown = function() {
	this.initialize(img.MainAssets_KeyDecButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,113,114);


(lib.KeyDecButtonHover = function() {
	this.initialize(img.MainAssets_KeyDecButtonHover);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,119,115);


(lib.KeyDecButtonLocked = function() {
	this.initialize(img.MainAssets_KeyDecButtonLocked);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,49,49);


(lib.KeyDecButtonUp = function() {
	this.initialize(img.MainAssets_KeyDecButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,113,109);


(lib.KeyDecDialogueDown = function() {
	this.initialize(img.MainAssets_KeyDecDialogueDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,99,99);


(lib.KeyDecDialogueOver = function() {
	this.initialize(img.MainAssets_KeyDecDialogueOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,116,116);


(lib.KeyDecDialogueUp = function() {
	this.initialize(img.MainAssets_KeyDecDialogueUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,109,108);


(lib.KeyDecDivider = function() {
	this.initialize(img.MainAssets_KeyDecDivider);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,40,13);


(lib.KeyDecDown = function() {
	this.initialize(img.MainAssets_KeyDecDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,120,121);


(lib.keyDecisionPlanComposer_AnswerContainer = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_AnswerContainer);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,953,847);


(lib.keyDecisionPlanComposer_AnswerDisabled = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_AnswerDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,870,162);


(lib.keyDecisionPlanComposer_AnswerDown = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_AnswerDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,886,170);


(lib.keyDecisionPlanComposer_AnswerOver = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_AnswerOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,870,162);


(lib.keyDecisionPlanComposer_AnswerPlaced = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_AnswerPlaced);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,845,138);


(lib.keyDecisionPlanComposer_AnswerPlacedOver = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_AnswerPlacedOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,845,138);


(lib.keyDecisionPlanComposer_AnswerUp = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_AnswerUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,870,162);


(lib.keyDecisionPlanComposer_ButtonDisabled = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_ButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,382,77);


(lib.keyDecisionPlanComposer_ButtonDown = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_ButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,382,77);


(lib.keyDecisionPlanComposer_ButtonOver = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_ButtonOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,382,77);


(lib.keyDecisionPlanComposer_ButtonUp = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_ButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,382,77);


(lib.keyDecisionPlanComposer_InputFieldActive = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_InputFieldActive);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,869,445);


(lib.keyDecisionPlanComposer_InputFieldInac = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_InputFieldInac);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,869,445);


(lib.keyDecisionPlanComposer_SubmitPlanIcon = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_SubmitPlanIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,44,44);


(lib.KeyDecLabel = function() {
	this.initialize(img.MainAssets_KeyDecLabel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,864,170);


(lib.loading_screen = function() {
	this.initialize(img.MainAssets_loading_screen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.LogoGOH = function() {
	this.initialize(img.MainAssets_LogoGOH);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,111,91);


(lib.LogoMoH = function() {
	this.initialize(img.MainAssets_LogoMoH);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,119,118);


(lib.LogoReady = function() {
	this.initialize(img.MainAssets_LogoReady);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,137,32);


(lib.MapBGConfirmation = function() {
	this.initialize(img.MainAssets_MapBGConfirmation);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1921,1081);


(lib.MapBGConfirmationjpgcopy = function() {
	this.initialize(img.MainAssets_MapBGConfirmationjpgcopy);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1921,1081);


(lib.MapInsetCh1 = function() {
	this.initialize(img.MainAssets_MapInsetCh1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,435,365);


(lib.MapInsetCh2 = function() {
	this.initialize(img.MainAssets_MapInsetCh2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,435,365);


(lib.MapNode = function() {
	this.initialize(img.MainAssets_MapNode);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,35,34);


(lib.MapTutorial = function() {
	this.initialize(img.MainAssets_MapTutorial);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1934,1081);


(lib.MediumDown = function() {
	this.initialize(img.MainAssets_MediumDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.MediumOver = function() {
	this.initialize(img.MainAssets_MediumOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.MediumUp = function() {
	this.initialize(img.MainAssets_MediumUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.mockupKD5x = function() {
	this.initialize(img.MainAssets_mockupKD5x);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,3872,2924);


(lib.NarrowContinueDisabled = function() {
	this.initialize(img.MainAssets_NarrowContinueDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,244,62);


(lib.NarrowContinueOver = function() {
	this.initialize(img.MainAssets_NarrowContinueOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,244,62);


(lib.NarrowContinueUp = function() {
	this.initialize(img.MainAssets_NarrowContinueUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,244,62);


(lib.NewKDLabel = function() {
	this.initialize(img.MainAssets_NewKDLabel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,407,88);


(lib.NewKeyDecisionIndicator = function() {
	this.initialize(img.MainAssets_NewKeyDecisionIndicator);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,45);


(lib.NewTopicIcon = function() {
	this.initialize(img.MainAssets_NewTopicIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,55,36);


(lib.NodeColor07 = function() {
	this.initialize(img.MainAssets_NodeColor07);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,79,79);


(lib.NotificationBarEndpngcopy = function() {
	this.initialize(img.MainAssets_NotificationBarEndpngcopy);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,570,104);


(lib.OptimalDown = function() {
	this.initialize(img.MainAssets_OptimalDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.OptimalOver = function() {
	this.initialize(img.MainAssets_OptimalOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.OptimalUp = function() {
	this.initialize(img.MainAssets_OptimalUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.PauseIcon = function() {
	this.initialize(img.MainAssets_PauseIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,44,44);


(lib.PieletjeBlack = function() {
	this.initialize(img.MainAssets_PieletjeBlack);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,60,47);


(lib.POI_NodeColor01 = function() {
	this.initialize(img.MainAssets_POI_NodeColor01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,79,79);


(lib.POI_NodeColor02 = function() {
	this.initialize(img.MainAssets_POI_NodeColor02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,79,79);


(lib.POI_NodeColor03 = function() {
	this.initialize(img.MainAssets_POI_NodeColor03);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,79,79);


(lib.POI_NodeColor04 = function() {
	this.initialize(img.MainAssets_POI_NodeColor04);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,79,79);


(lib.POI_NodeColor05 = function() {
	this.initialize(img.MainAssets_POI_NodeColor05);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,78,79);


(lib.POI_NodeColor06 = function() {
	this.initialize(img.MainAssets_POI_NodeColor06);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,79,79);


(lib.PoILabel0Over = function() {
	this.initialize(img.MainAssets_PoILabel0Over);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,119,138);


(lib.PoILabel0Up = function() {
	this.initialize(img.MainAssets_PoILabel0Up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,119,138);


(lib.PoILabel3Over = function() {
	this.initialize(img.MainAssets_PoILabel3Over);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,119,138);


(lib.PoILabel3Up = function() {
	this.initialize(img.MainAssets_PoILabel3Up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,119,138);


(lib.PoILTextLabelBGSmallWhite = function() {
	this.initialize(img.MainAssets_PoILTextLabelBGSmallWhite);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,355,70);


(lib.PoIPLocationDummy = function() {
	this.initialize(img.MainAssets_PoIPLocationDummy);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,82,130);


(lib.PopUpBackButtonDisabled = function() {
	this.initialize(img.MainAssets_PopUpBackButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,238,66);


(lib.PopUpBackButtonOver = function() {
	this.initialize(img.MainAssets_PopUpBackButtonOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,238,66);


(lib.PopUpBackButtonUp = function() {
	this.initialize(img.MainAssets_PopUpBackButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,238,66);


(lib.PrintButtonDisabled = function() {
	this.initialize(img.MainAssets_PrintButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,119,32);


(lib.PrintButtonDown = function() {
	this.initialize(img.MainAssets_PrintButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,119,32);


(lib.PrintButtonUp = function() {
	this.initialize(img.MainAssets_PrintButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,119,32);


(lib.ShowOptimalDown = function() {
	this.initialize(img.MainAssets_ShowOptimalDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,421,76);


(lib.ShowOptimalOver = function() {
	this.initialize(img.MainAssets_ShowOptimalOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,421,76);


(lib.ShowOptimalUp = function() {
	this.initialize(img.MainAssets_ShowOptimalUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,421,76);


(lib.stakeholder_hasim = function() {
	this.initialize(img.MainAssets_stakeholder_hasim);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,350,460);


(lib.stakeholder_hasim_disabled = function() {
	this.initialize(img.MainAssets_stakeholder_hasim_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,350,460);


(lib.stakeholder_Nia = function() {
	this.initialize(img.MainAssets_stakeholder_Nia);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,350,460);


(lib.stakeholder_nia_disabled = function() {
	this.initialize(img.MainAssets_stakeholder_nia_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,350,460);


(lib.stakeholder_onneetse = function() {
	this.initialize(img.MainAssets_stakeholder_onneetse);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,350,460);


(lib.stakeholder_onneetse_disabled = function() {
	this.initialize(img.MainAssets_stakeholder_onneetse_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,350,460);


(lib.stakeholder_sarah = function() {
	this.initialize(img.MainAssets_stakeholder_sarah);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,350,460);


(lib.stakeholder_sarah_disabled = function() {
	this.initialize(img.MainAssets_stakeholder_sarah_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,350,460);


(lib.StarOptimal = function() {
	this.initialize(img.MainAssets_StarOptimal);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,18,18);


(lib.StarPlayerChoiceEmpty = function() {
	this.initialize(img.MainAssets_StarPlayerChoiceEmpty);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,18,18);


(lib.StarPlayerChoiceFilled = function() {
	this.initialize(img.MainAssets_StarPlayerChoiceFilled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,18,18);


(lib.Tab1 = function() {
	this.initialize(img.MainAssets_Tab1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,690,68);


(lib.tab2 = function() {
	this.initialize(img.MainAssets_tab2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,389,65);


(lib.Tab2BGElement = function() {
	this.initialize(img.MainAssets_Tab2BGElement);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,689,659);


(lib.tab3 = function() {
	this.initialize(img.MainAssets_tab3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,389,65);


(lib.Tab3Info1 = function() {
	this.initialize(img.MainAssets_Tab3Info1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1520,670);


(lib.Tab3Info2 = function() {
	this.initialize(img.MainAssets_Tab3Info2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1520,670);


(lib.Tab3Info3 = function() {
	this.initialize(img.MainAssets_Tab3Info3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1520,670);


(lib.Tab3Info4 = function() {
	this.initialize(img.MainAssets_Tab3Info4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1520,670);


(lib.Tab3Info5 = function() {
	this.initialize(img.MainAssets_Tab3Info5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1520,670);


(lib.Tab3StaticImage = function() {
	this.initialize(img.MainAssets_Tab3StaticImage);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1501,669);


(lib.TeaCornerIcon = function() {
	this.initialize(img.MainAssets_TeaCornerIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,197,224);


(lib.TeaCornerIconDisabled = function() {
	this.initialize(img.MainAssets_TeaCornerIconDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,197,224);


(lib.TimelineBG = function() {
	this.initialize(img.MainAssets_TimelineBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,28,805);


(lib.TimerClock = function() {
	this.initialize(img.MainAssets_TimerClock);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,25,27);


(lib.timerKeyDecision_Neutral = function() {
	this.initialize(img.MainAssets_timerKeyDecision_Neutral);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,385,107);


(lib.timerKeyDecision_Urgent = function() {
	this.initialize(img.MainAssets_timerKeyDecision_Urgent);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,385,107);


(lib.TimingBG = function() {
	this.initialize(img.MainAssets_TimingBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,431,150);


(lib.TopBar = function() {
	this.initialize(img.MainAssets_TopBar);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1923,202);


(lib.TopicButtonDisabled = function() {
	this.initialize(img.MainAssets_TopicButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,235,64);


(lib.TopicButtonDown = function() {
	this.initialize(img.MainAssets_TopicButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,235,64);


(lib.TopicButtonUp = function() {
	this.initialize(img.MainAssets_TopicButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,235,64);


(lib.TopLeftDisabled = function() {
	this.initialize(img.MainAssets_TopLeftDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,120,139);


(lib.TrendDownDark = function() {
	this.initialize(img.MainAssets_TrendDownDark);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,19,19);


(lib.TrendUpDark = function() {
	this.initialize(img.MainAssets_TrendUpDark);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,19,19);


(lib.Tutorial_exit = function() {
	this.initialize(img.MainAssets_Tutorial_exit);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,142,142);


(lib.Tutorial_info = function() {
	this.initialize(img.MainAssets_Tutorial_info);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,143,142);


(lib.Tutorial_pause = function() {
	this.initialize(img.MainAssets_Tutorial_pause);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,142,142);


(lib.TutorialScreens_PopUpShorter = function() {
	this.initialize(img.MainAssets_TutorialScreens_PopUpShorter);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1512,624);


(lib.TutorialScreens_TutorialContainer = function() {
	this.initialize(img.MainAssets_TutorialScreens_TutorialContainer);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1512,737);


(lib.TutorialScreens_TutorialOverlay = function() {
	this.initialize(img.MainAssets_TutorialScreens_TutorialOverlay);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1937,1089);


(lib.UnlockedAnswerIcon = function() {
	this.initialize(img.MainAssets_UnlockedAnswerIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,43,41);


(lib.ViewKDDisabled = function() {
	this.initialize(img.MainAssets_ViewKDDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,330,65);


(lib.ViewKDOver = function() {
	this.initialize(img.MainAssets_ViewKDOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,329,65);


(lib.ViewKDUp = function() {
	this.initialize(img.MainAssets_ViewKDUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,330,65);


(lib.Vinkje = function() {
	this.initialize(img.MainAssets_Vinkje);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,22,16);


(lib.VinkjeHi = function() {
	this.initialize(img.MainAssets_VinkjeHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,21,16);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Tween2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.KeyDecButtonUp();
	this.instance.setTransform(-56.5,-54.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-56.5,-54.5,113,109);


(lib.TutorialSaveIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Tutorial_exit();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialSaveIcon, new cjs.Rectangle(0,0,142,142), null);


(lib.TutorialPopUpContainerShort = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TutorialScreens_PopUpShorter();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialPopUpContainerShort, new cjs.Rectangle(0,0,1512,624), null);


(lib.TutorialPopUpContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TutorialScreens_TutorialContainer();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialPopUpContainer, new cjs.Rectangle(0,0,1512,737), null);


(lib.TutorialPauseIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Tutorial_pause();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialPauseIcon, new cjs.Rectangle(0,0,142,142), null);


(lib.TutorialOverlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#324141").s().p("EiWEBUdMAAAio5MEsJAAAMAAACo5g");
	this.shape.setTransform(960.5,542.95);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialOverlay, new cjs.Rectangle(0,2.5,1921,1081), null);


(lib.TutorialInfoIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Tutorial_info();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialInfoIcon, new cjs.Rectangle(0,0,143,142), null);


(lib.TrendUpRed = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TrendUpDark();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TrendUpRed, new cjs.Rectangle(0,0,19,19), null);


(lib.TrendUpGreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TrendUpDark();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TrendUpGreen, new cjs.Rectangle(0,0,19,19), null);


(lib.TrendDownGreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TrendDownDark();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TrendDownGreen, new cjs.Rectangle(0,0,19,19), null);


(lib.TopBar_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TopBar();
	this.instance.setTransform(3,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TopBar_1, new cjs.Rectangle(3,0,1923,202), null);


(lib.ToolTipWhiteContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.toolTipTextField = new cjs.Text("Gather the paper line list data from CHWs on a weekly basis. If Teo collects them daily, he won’t be able to see any trends and properly prioritize areas. Compiling the data weekly will also make the overall workload more manageable.\nWaiting for a week to gather the paper line list data from CHWs can lead to a delay in identifying and addressing any emerging trends, which can result in a missed opportunity for early intervention.\nWaiting for a week to gather the paper line list data from CHWs can lead to a delay in identifying and addressing any emerging trends, ", "20px 'Work Sans Medium'", "#324141");
	this.toolTipTextField.name = "toolTipTextField";
	this.toolTipTextField.lineHeight = 25;
	this.toolTipTextField.lineWidth = 700;
	this.toolTipTextField.parent = this;
	this.toolTipTextField.setTransform(22.8,16.2);
ranj.TextOffsetFixer.fix(this.toolTipTextField);

	this.instance = new lib.FeedbackToolTipWhiteScreen();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.toolTipTextField}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ToolTipWhiteContainer, new cjs.Rectangle(0,0,741,338), null);


(lib.ToolTipBlackContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.toolTipTextField = new cjs.Text("Gather the paper line list data from CHWs on a weekly basis. If Teo collects them daily, he won’t be able to see any trends and properly prioritize areas. Compiling the data weekly will also make the overall workload more manageable.\nWaiting for a week to gather the paper line list data from CHWs can lead to a delay in identifying and addressing any emerging trends, which can result in a missed opportunity for early intervention.", "20px 'Work Sans Medium'", "#FFFFFF");
	this.toolTipTextField.name = "toolTipTextField";
	this.toolTipTextField.lineHeight = 25;
	this.toolTipTextField.lineWidth = 603;
	this.toolTipTextField.parent = this;
	this.toolTipTextField.setTransform(64.35,48.3);
ranj.TextOffsetFixer.fix(this.toolTipTextField);

	this.instance = new lib.FeedbackToolTipBlackScreen();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.toolTipTextField}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ToolTipBlackContainer, new cjs.Rectangle(0,0,741,338), null);


(lib.TimingBG_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.WeekLabel = new cjs.Text("Week 2", "bold 51px 'Work Sans ExtraBold'", "#2C3C3C");
	this.WeekLabel.name = "WeekLabel";
	this.WeekLabel.lineHeight = 76;
	this.WeekLabel.lineWidth = 343;
	this.WeekLabel.parent = this;
	this.WeekLabel.setTransform(41.85,47.5);
ranj.TextOffsetFixer.fix(this.WeekLabel);

	this.ChapterLabel = new cjs.Text("Chapter 1", "22px 'Work Sans'", "#2C3C3C");
	this.ChapterLabel.name = "ChapterLabel";
	this.ChapterLabel.lineHeight = 28;
	this.ChapterLabel.lineWidth = 240;
	this.ChapterLabel.parent = this;
	this.ChapterLabel.setTransform(41.85,26.75);
ranj.TextOffsetFixer.fix(this.ChapterLabel);

	this.instance = new lib.TimingBG();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.ChapterLabel},{t:this.WeekLabel}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TimingBG_1, new cjs.Rectangle(0,0,431,150), null);


(lib.timerKeyDecision_Urgent_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.timerKeyDecision_Urgent();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.timerKeyDecision_Urgent_1, new cjs.Rectangle(0,0,385,107), null);


(lib.timerKeyDecision_Neutral_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.timerKeyDecision_Neutral();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.timerKeyDecision_Neutral_1, new cjs.Rectangle(0,0,385,107), null);


(lib.TabsBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#295B6D").s().p("Eh6FAD9IAAn5MD0LAAAIAAH5g");
	this.shape.setTransform(781.425,25.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TabsBar, new cjs.Rectangle(0,0,1562.9,50.7), null);


(lib.TabNewIndicator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.DataDashboardNewIcon();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TabNewIndicator, new cjs.Rectangle(0,0,33,33), null);


(lib.TabButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3,selecteUp:4,selectedOver:5,SelectedDown:6,SelectedDisabled:7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// SelectedUpLabelTextField
	this.selectedUpLabelTextField = new cjs.Text("Continue", "bold 32px 'Work Sans'", "#1A3168");
	this.selectedUpLabelTextField.name = "selectedUpLabelTextField";
	this.selectedUpLabelTextField.lineHeight = 40;
	this.selectedUpLabelTextField.lineWidth = 424;
	this.selectedUpLabelTextField.parent = this;
	this.selectedUpLabelTextField.setTransform(16.0452,7.05,1.0149,1);
ranj.TextOffsetFixer.fix(this.selectedUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedUpLabelTextField).wait(8));

	// SelectedDisabledLabelTextField
	this.selectedDisabledLabelTextField = new cjs.Text("Continue", "bold 32px 'Work Sans'", "#295B6D");
	this.selectedDisabledLabelTextField.name = "selectedDisabledLabelTextField";
	this.selectedDisabledLabelTextField.lineHeight = 40;
	this.selectedDisabledLabelTextField.lineWidth = 424;
	this.selectedDisabledLabelTextField.parent = this;
	this.selectedDisabledLabelTextField.setTransform(16.0452,7.05,1.0149,1);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField).wait(8));

	// SelectedDownLabelTextField
	this.selectedDownLabelTextField = new cjs.Text("Continue", "bold 32px 'Work Sans'", "#5F9DB2");
	this.selectedDownLabelTextField.name = "selectedDownLabelTextField";
	this.selectedDownLabelTextField.lineHeight = 40;
	this.selectedDownLabelTextField.lineWidth = 424;
	this.selectedDownLabelTextField.parent = this;
	this.selectedDownLabelTextField.setTransform(16.0452,7.05,1.0149,1);
ranj.TextOffsetFixer.fix(this.selectedDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDownLabelTextField).wait(8));

	// SelectedOverLabelTextField
	this.selectedOverLabelTextField = new cjs.Text("Continue", "bold 32px 'Work Sans'", "#5F9DB2");
	this.selectedOverLabelTextField.name = "selectedOverLabelTextField";
	this.selectedOverLabelTextField.lineHeight = 40;
	this.selectedOverLabelTextField.lineWidth = 424;
	this.selectedOverLabelTextField.parent = this;
	this.selectedOverLabelTextField.setTransform(16.0452,7.05,1.0149,1);
ranj.TextOffsetFixer.fix(this.selectedOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedOverLabelTextField).wait(8));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Continue", "bold 32px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 40;
	this.upLabelTextField.lineWidth = 424;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(16.0452,7.05,1.0149,1);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(8));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Continue", "bold 32px 'Work Sans'", "#295B6D");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 40;
	this.disabledLabelTextField.lineWidth = 424;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(16.0452,7.05,1.0149,1);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(8));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Continue", "bold 32px 'Work Sans'", "#5F9DB2");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 40;
	this.downLabelTextField.lineWidth = 424;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(16.0452,7.05,1.0149,1);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(8));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Continue", "bold 32px 'Work Sans'", "#5F9DB2");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 40;
	this.overLabelTextField.lineWidth = 424;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(16.0452,7.05,1.0149,1);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(8));

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#295B6D").s().p("EgkCAD9IAAn5MBIFAAAIAAH5g");
	this.shape.setTransform(240.8986,25.325,1.0444,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#BFD7E0").s().p("EgkCAD9IAAn5MBIFAAAIAAH5g");
	this.shape_1.setTransform(240.8986,26.025,1.0444,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#EDF4F6").s().p("EgkCAEGIAAoLMBIFAAAIAAILg");
	this.shape_2.setTransform(240.8986,26.725,1.0444,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#295B6D").s().p("EgloAD9IAAn5MBLRAAAIAAH5g");
	this.shape_3.setTransform(240.9,25.325);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape,p:{y:25.325}}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape,p:{y:26.025}}]},2).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,481.8,55.4);


(lib.Tab3InformationSample2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.text = new cjs.Text("Tab3InformationSample2", "39px 'Times New Roman'", "#FF0000");
	this.text.lineHeight = 45;
	this.text.lineWidth = 428;
	this.text.parent = this;
	this.text.setTransform(299.7,297.65);
ranj.TextOffsetFixer.fix(this.text);

	this.instance = new lib.Tab3StaticImage();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.text}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Tab3InformationSample2, new cjs.Rectangle(0,0,1501,669), null);


(lib.Tab3InformationSample1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.text = new cjs.Text("Tab3InformationSample1", "39px 'Times New Roman'", "#FF0000");
	this.text.lineHeight = 45;
	this.text.lineWidth = 428;
	this.text.parent = this;
	this.text.setTransform(306.4,304.7);
ranj.TextOffsetFixer.fix(this.text);

	this.instance = new lib.Tab3StaticImage();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.text}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Tab3InformationSample1, new cjs.Rectangle(0,0,1501,669), null);


(lib.Tab3Info5_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Tab3Info5();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Tab3Info5_1, new cjs.Rectangle(0,-16.1,1520,686.1), null);


(lib.Tab3Info4_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Tab3Info4();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Tab3Info4_1, new cjs.Rectangle(0,-16.1,1520,686.1), null);


(lib.Tab3Info3_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Tab3Info3();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Tab3Info3_1, new cjs.Rectangle(0,-16.1,1520,686.1), null);


(lib.Tab3Info2_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Tab3Info2();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Tab3Info2_1, new cjs.Rectangle(0,-16.1,1520,686.1), null);


(lib.Tab3Info1_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Tab3Info1();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Tab3Info1_1, new cjs.Rectangle(0,-16.1,1520,686.1), null);


(lib.PlanComposerKeyDecision_TabHover = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.tab2();
	this.instance.setTransform(0,-14);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_TabHover, new cjs.Rectangle(0,-14,389,65), null);


(lib.PlanComposerKeyDecision_SubmitIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_SubmitPlanIcon();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_SubmitIcon, new cjs.Rectangle(0,0,44,44), null);


(lib.PlanComposerKeyDecision_InactiveTab = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.tab3();
	this.instance.setTransform(0,-15);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_InactiveTab, new cjs.Rectangle(0,-15,389,65), null);


(lib.PlanComposerKeyDecision_ButtonUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_ButtonUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_ButtonUp, new cjs.Rectangle(0,0,382,77), null);


(lib.PlanComposerKeyDecision_ButtonOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_ButtonOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_ButtonOver, new cjs.Rectangle(0,0,382,77), null);


(lib.PlanComposerKeyDecision_ButtonDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_ButtonDown();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_ButtonDown, new cjs.Rectangle(0,0,382,77), null);


(lib.PlanComposerKeyDecision_ButtonDisabled = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_ButtonDisabled();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_ButtonDisabled, new cjs.Rectangle(0,0,382,77), null);


(lib.PlanComposerKeyDecision_AnsweSlot = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.AnswerSlot();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_AnsweSlot, new cjs.Rectangle(0,0,845,137), null);


(lib.PlanComposerKeyDecision_AnswerUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_AnswerUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_AnswerUp, new cjs.Rectangle(0,0,870,162), null);


(lib.PlanComposerKeyDecision_AnswerOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_AnswerOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_AnswerOver, new cjs.Rectangle(0,0,870,162), null);


(lib.PlanComposerKeyDecision_AnswerLocked = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_AnswerDisabled();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_AnswerLocked, new cjs.Rectangle(0,0,870,162), null);


(lib.PlanComposerKeyDecision_AnswerDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_AnswerDown();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_AnswerDown, new cjs.Rectangle(0,0,886,170), null);


(lib.PlanComposerKeyDecision_AnswerContainerInactive = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// InputfieldStates
	this.instance = new lib.keyDecisionPlanComposer_InputFieldInac();

	this.instance_1 = new lib.keyDecisionPlanComposer_InputFieldActive();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,869,445);


(lib.PlanComposerKeyDecision_AnswerBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_AnswerContainer();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_AnswerBackground, new cjs.Rectangle(0,0,953,847), null);


(lib.PlanComposerKeyDecision_ActiveTab = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Tab1();
	this.instance.setTransform(0,-14);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_ActiveTab, new cjs.Rectangle(0,-14,690,68), null);


(lib.NodeColor06 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.POI_NodeColor06();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NodeColor06, new cjs.Rectangle(0,0,79,79), null);


(lib.NodeColor05 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.POI_NodeColor05();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NodeColor05, new cjs.Rectangle(0,0,78,79), null);


(lib.NodeColor04 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.POI_NodeColor04();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NodeColor04, new cjs.Rectangle(0,0,79,79), null);


(lib.NodeColor03 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.POI_NodeColor03();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NodeColor03, new cjs.Rectangle(0,0,79,79), null);


(lib.NodeColor02 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.POI_NodeColor02();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NodeColor02, new cjs.Rectangle(0,0,79,79), null);


(lib.NodeColor01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.POI_NodeColor01();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NodeColor01, new cjs.Rectangle(0,0,79,79), null);


(lib.newKeyDecIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.NewKeyDecisionIndicator();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.newKeyDecIcon, new cjs.Rectangle(0,0,50,45), null);


(lib.NewKDLabel_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.KDUnlockedText = new cjs.Text("Key decision unlocked!", "24px 'Work Sans'", "#324141");
	this.KDUnlockedText.name = "KDUnlockedText";
	this.KDUnlockedText.lineHeight = 26;
	this.KDUnlockedText.lineWidth = 322;
	this.KDUnlockedText.parent = this;
	this.KDUnlockedText.setTransform(28.3,21.9);
ranj.TextOffsetFixer.fix(this.KDUnlockedText);

	this.instance = new lib.NewKDLabel();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.KDUnlockedText}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NewKDLabel_1, new cjs.Rectangle(0,0,407,88), null);


(lib.MapNodeSmall = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(107,71,49,0.6)").s().p("AhHBIQgegeAAgqQAAgqAegdQAdgeAqAAQAqAAAeAeQAeAdAAAqQAAAqgeAeQgeAegqAAQgqAAgdgeg");
	this.shape.setTransform(10.2,10.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.MapNodeSmall, new cjs.Rectangle(0,0,20.4,20.4), null);


(lib.mapInsetChapter2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// names
	this.text = new cjs.Text("Murelle", "bold 24px 'Work Sans ExtraBold'", "#324141");
	this.text.lineHeight = 37;
	this.text.lineWidth = 101;
	this.text.parent = this;
	this.text.setTransform(121.4,65.05);
ranj.TextOffsetFixer.fix(this.text);

	this.text_1 = new cjs.Text("Myro", "bold 24px 'Work Sans ExtraBold'", "#324141");
	this.text_1.lineHeight = 37;
	this.text_1.lineWidth = 71;
	this.text_1.parent = this;
	this.text_1.setTransform(270.25,157.45);
ranj.TextOffsetFixer.fix(this.text_1);

	this.text_2 = new cjs.Text("THISLAND", "34px 'Work Sans Light'", "#324141");
	this.text_2.lineHeight = 42;
	this.text_2.lineWidth = 182;
	this.text_2.parent = this;
	this.text_2.setTransform(106.65,210.65);
ranj.TextOffsetFixer.fix(this.text_2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.text_2},{t:this.text_1},{t:this.text}]}).wait(1));

	// Layer_1
	this.instance = new lib.MapInsetCh2();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mapInsetChapter2, new cjs.Rectangle(0,0,435,365), null);


(lib.mapInsetChapter1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// names
	this.text = new cjs.Text("Murelle", "bold 24px 'Work Sans ExtraBold'", "#324141");
	this.text.lineHeight = 37;
	this.text.lineWidth = 101;
	this.text.parent = this;
	this.text.setTransform(121.4,70.05);
ranj.TextOffsetFixer.fix(this.text);

	this.text_1 = new cjs.Text("Myro", "bold 24px 'Work Sans ExtraBold'", "#324141");
	this.text_1.lineHeight = 37;
	this.text_1.lineWidth = 71;
	this.text_1.parent = this;
	this.text_1.setTransform(270.25,157.45);
ranj.TextOffsetFixer.fix(this.text_1);

	this.text_2 = new cjs.Text("THISLAND", "34px 'Work Sans Light'", "#324141");
	this.text_2.lineHeight = 42;
	this.text_2.lineWidth = 182;
	this.text_2.parent = this;
	this.text_2.setTransform(106.65,210.65);
ranj.TextOffsetFixer.fix(this.text_2);

	this.instance = new lib.MapInsetCh1();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.text_2},{t:this.text_1},{t:this.text}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mapInsetChapter1, new cjs.Rectangle(0,0,435,365), null);


(lib.locationContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.PoIPLocationDummy();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.locationContainer, new cjs.Rectangle(0,0,82,130), null);


(lib.LoadingBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.loading_screen();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingBG, new cjs.Rectangle(0,0,1920,1080), null);


(lib.KeyDecPopUpBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.KeyDecAvailableBG();
	this.instance.setTransform(-552,-351);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecPopUpBG, new cjs.Rectangle(-552,-351,660,809), null);


(lib.KeyDecLabel_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.descriptionTextField = new cjs.Text("Make sure you have collected all the information you need before making a decision. Make sure you have collected all the information you need before making a decision. ", "21px 'Work Sans'", "#2C3C3C");
	this.descriptionTextField.name = "descriptionTextField";
	this.descriptionTextField.lineHeight = 23;
	this.descriptionTextField.lineWidth = 615;
	this.descriptionTextField.parent = this;
	this.descriptionTextField.setTransform(180.05,64.6);
ranj.TextOffsetFixer.fix(this.descriptionTextField);

	this.titleTextField = new cjs.Text("Key decision", "bold 42px 'Work Sans ExtraBold'", "#2C3C3C");
	this.titleTextField.name = "titleTextField";
	this.titleTextField.lineHeight = 63;
	this.titleTextField.lineWidth = 512;
	this.titleTextField.parent = this;
	this.titleTextField.setTransform(180.05,8);
ranj.TextOffsetFixer.fix(this.titleTextField);

	this.instance = new lib.KeyDecLabel();
	this.instance.setTransform(0,2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.titleTextField},{t:this.descriptionTextField}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecLabel_1, new cjs.Rectangle(0,2,864,170), null);


(lib.keyDecisionPlanComposer_AnswerSelectedUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_AnswerPlaced();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.keyDecisionPlanComposer_AnswerSelectedUp, new cjs.Rectangle(0,0,845,138), null);


(lib.keyDecisionPlanComposer_AnswerSelectedOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_AnswerPlacedOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.keyDecisionPlanComposer_AnswerSelectedOver, new cjs.Rectangle(0,0,845,138), null);


(lib.KeyDecDivider_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.KeyDecDivider();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecDivider_1, new cjs.Rectangle(0,0,40,13), null);


(lib.KeyDecButtonLocked_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.KeyDecButtonLocked();
	this.instance.setTransform(5,4);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecButtonLocked_1, new cjs.Rectangle(5,4,49,49), null);


(lib.KeyDecButtonCompleted_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.KeyDecButtonCompleted();
	this.instance.setTransform(6,5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecButtonCompleted_1, new cjs.Rectangle(6,5,48,49), null);


(lib.KeyDecActiveBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#324141").s().p("AhPJtIAAzZICfAAIAATZg");
	this.shape.setTransform(8,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecActiveBar, new cjs.Rectangle(0,5.1,16,124.20000000000002), null);


(lib.KDPopUpPointer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.KDExpansionPointer();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KDPopUpPointer, new cjs.Rectangle(0,0,24,47), null);


(lib.KDContinueUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ViewKDUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KDContinueUp, new cjs.Rectangle(0,0,330,65), null);


(lib.KDContinueOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ViewKDOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KDContinueOver, new cjs.Rectangle(0,0,329,65), null);


(lib.KDContinueDisabled = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ViewKDDisabled();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KDContinueDisabled, new cjs.Rectangle(0,0,330,65), null);


(lib.KDconfirmationIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CompletedKDConfirmationScreen();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KDconfirmationIcon, new cjs.Rectangle(0,0,141,140), null);


(lib.IconOptimalLocked = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.UnlockedAnswerIcon();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.IconOptimalLocked, new cjs.Rectangle(0,0,43,41), null);


(lib.GraphTitleLabel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#BFD7E0").s().p("A4/C0Qh4AAAAh4IAAh3QAAh4B4AAMAx/AAAQB4AAAAB4IAAB3QAAB4h4AAg");
	this.shape.setTransform(172,18);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GraphTitleLabel, new cjs.Rectangle(0,0,344,36), null);


(lib.Graph = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.GlobeTab2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Tab2BGElement();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GlobeTab2, new cjs.Rectangle(0,0,689,659), null);


(lib.GlobeEpilogue = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.EpilogueGlobeFullpngcopy();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GlobeEpilogue, new cjs.Rectangle(0,0,700,645), null);


(lib.FeedbackTimelineInfoBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.actionNeededTextField2 = new cjs.Text("[Action that is needed]\n[Action that is needed]\n[Action that is needed]", "18px 'Arial'");
	this.actionNeededTextField2.name = "actionNeededTextField2";
	this.actionNeededTextField2.lineHeight = 22;
	this.actionNeededTextField2.lineWidth = 401;
	this.actionNeededTextField2.parent = this;
	this.actionNeededTextField2.setTransform(50.85,8.45);
ranj.TextOffsetFixer.fix(this.actionNeededTextField2);

	this.instance = new lib.FeedbackKDInfoExpansion();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.actionNeededTextField2}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackTimelineInfoBar, new cjs.Rectangle(0,0,508,96), null);


(lib.FeedbackTimelineDivider = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackSmallBar();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackTimelineDivider, new cjs.Rectangle(0,0,51,14), null);


(lib.FeedbackTimelineBlackBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackBlackBar();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackTimelineBlackBar, new cjs.Rectangle(0,0,22,174), null);


(lib.FeedbackTimelineBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackLongBar();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackTimelineBG, new cjs.Rectangle(0,0,21,1080), null);


(lib.FeedbackStarOptimal = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.StarOptimal();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackStarOptimal, new cjs.Rectangle(0,0,18,18), null);


(lib.FeedbackStarFilled = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.StarPlayerChoiceFilled();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackStarFilled, new cjs.Rectangle(0,0,18,18), null);


(lib.FeedbackStarEmpty = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.StarPlayerChoiceEmpty();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackStarEmpty, new cjs.Rectangle(0,0,18,18), null);


(lib.FeedbackPointerWhite = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPointer();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPointerWhite, new cjs.Rectangle(0,0,25,48), null);


(lib.FeedbackPointer_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackBGpointer();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPointer_1, new cjs.Rectangle(0,0,43,96), null);


(lib.FeedbackPlayerChoiceUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.HideOptimalUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPlayerChoiceUp, new cjs.Rectangle(0,0,421,76), null);


(lib.FeedbackPlayerChoiceTooltip = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#324141").ss(5,0,1).p("AEZh7IjgDAIg5AxIg/g2IjZi6");
	this.shape.setTransform(29.3267,20.3276);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer_3
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("Ag+BZIjojmIJNgCIjuDtIg5Axg");
	this.shape_1.setTransform(29.3,17.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPlayerChoiceTooltip, new cjs.Rectangle(-1.3,3.5,61.3,31.200000000000003), null);


(lib.FeedbackPlayerChoiceOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.HideOptimalOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPlayerChoiceOver, new cjs.Rectangle(0,0,421,76), null);


(lib.FeedbackPlayerChoiceDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.HideOptimalDown();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPlayerChoiceDown, new cjs.Rectangle(0,0,421,76), null);


(lib.FeedbackOptimalUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ShowOptimalUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackOptimalUp, new cjs.Rectangle(0,0,421,76), null);


(lib.FeedbackOptimalTooltip = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.PieletjeBlack();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackOptimalTooltip, new cjs.Rectangle(0,0,60,47), null);


(lib.FeedbackOptimalOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ShowOptimalOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackOptimalOver, new cjs.Rectangle(0,0,421,76), null);


(lib.FeedbackOptimalDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ShowOptimalDown();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackOptimalDown, new cjs.Rectangle(0,0,421,76), null);


(lib.FeedbackOptimalAnswerUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.OptimalUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackOptimalAnswerUp, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackOptimalAnswerOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.OptimalOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackOptimalAnswerOver, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackOptimalAnswerDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.OptimalDown();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackOptimalAnswerDown, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackMediumUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.MediumUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackMediumUp, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackMediumOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.MediumOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackMediumOver, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackMediumDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.MediumDown();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackMediumDown, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackKDInactiveButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackInactiveKD();
	this.instance.setTransform(6,4);

	this.instance_1 = new lib.FeedbackInactiveKDOver();
	this.instance_1.setTransform(5,4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(5,4,49,49);


(lib.FeedbackInactiveKD_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackKDSmall();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackInactiveKD_1, new cjs.Rectangle(0,0,77,77), null);


(lib.FeedbackIcon_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackIcon();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackIcon_1, new cjs.Rectangle(0,0,54,42), null);


(lib.FeedbackGoodUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.GoodUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackGoodUp, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackGoodOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.GoodOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackGoodOver, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackGoodDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.GoodDown();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackGoodDown, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackExpandPlayerChoice = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ExpandPlayerChoice();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackExpandPlayerChoice, new cjs.Rectangle(0,0,23,25), null);


(lib.FeedbackExpandOptimal = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ExpandOptimal();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackExpandOptimal, new cjs.Rectangle(0,0,23,25), null);


(lib.FeedbackDividerWhiteScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(50,65,65,0.498)").ss(1,1,1).p("Eh+bAAAMD83AAA");
	this.shape.setTransform(809.175,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackDividerWhiteScreen, new cjs.Rectangle(-1,-1,1620.4,2), null);


(lib.FeedbackDividerBlackScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(255,255,255,0.498)").ss(1,1,1).p("Eh+bAAAMD83AAA");
	this.shape.setTransform(809.175,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackDividerBlackScreen, new cjs.Rectangle(-1,-1,1620.4,2), null);


(lib.FeedbackBadUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BadUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackBadUp, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackBadOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BadOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackBadOver, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackBadDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BadDown();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackBadDown, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackAnswerBGWhite = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#F4F4F4").s().p("EiG4Aw8MAAAhh3MENwAAAMAAABh3g");
	this.shape.setTransform(864.0008,273.5004,1.0009,0.8732);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackAnswerBGWhite, new cjs.Rectangle(0,0,1728,547), null);


(lib.FeedbackAnswerBGBlack = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#2C3C3C").s().p("EiG4Aw8MAAAhh3MENwAAAMAAABh3g");
	this.shape.setTransform(864.0008,273.5004,1.0009,0.8732);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackAnswerBGBlack, new cjs.Rectangle(0,0,1728,547), null);


(lib.FeedbackActiveKDPlayerChoice = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackKDPlayerChoice();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackActiveKDPlayerChoice, new cjs.Rectangle(0,0,279,147), null);


(lib.FeedbackActiveKDOptimal = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackKDOptimal();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackActiveKDOptimal, new cjs.Rectangle(0,0,279,147), null);


(lib.FakeNewIndicator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.EpilogueDashboardBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.EpilogueDashboardContentBackground();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EpilogueDashboardBG, new cjs.Rectangle(0,0,1720,983), null);


(lib.EmailBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.KeyDecButtonUp();
	this.instance.setTransform(287,184);

	this.popupTopic1EmailContent = new cjs.Text("Content Content \n\nContent Content Content Content Content Content Content Content Content Content Content ContentContent Content Content Content Content Content ContentContent Content Content Content Content Content ContentContent Content Content Content Content Content ContentContent Content Content Content Content Content Content Content Content Content Content Content Content ContentContent Content Content Content Content Content ContentContent Content Content Content Content Content ContentContent Content Content Content Content Content ContentContent Content Content Content Content Content Content", "20px 'Work Sans'");
	this.popupTopic1EmailContent.name = "popupTopic1EmailContent";
	this.popupTopic1EmailContent.lineHeight = 25;
	this.popupTopic1EmailContent.lineWidth = 617;
	this.popupTopic1EmailContent.parent = this;
	this.popupTopic1EmailContent.setTransform(144.9,155.15,0.6241,0.6241);
ranj.TextOffsetFixer.fix(this.popupTopic1EmailContent);

	this.popupTopic1EmailSubjectContent = new cjs.Text("Response to Priority Actions Regarding Unknown...", "bold 20px 'Work Sans'");
	this.popupTopic1EmailSubjectContent.name = "popupTopic1EmailSubjectContent";
	this.popupTopic1EmailSubjectContent.lineHeight = 25;
	this.popupTopic1EmailSubjectContent.lineWidth = 520;
	this.popupTopic1EmailSubjectContent.parent = this;
	this.popupTopic1EmailSubjectContent.setTransform(198.2,117.25,0.6241,0.6241);
ranj.TextOffsetFixer.fix(this.popupTopic1EmailSubjectContent);

	this.popupTopic1EmailSubject = new cjs.Text("Subject:", "20px 'Work Sans'");
	this.popupTopic1EmailSubject.name = "popupTopic1EmailSubject";
	this.popupTopic1EmailSubject.lineHeight = 25;
	this.popupTopic1EmailSubject.lineWidth = 81;
	this.popupTopic1EmailSubject.parent = this;
	this.popupTopic1EmailSubject.setTransform(144.9,117.25,0.6241,0.6241);
ranj.TextOffsetFixer.fix(this.popupTopic1EmailSubject);

	this.popupTopic1EmailRecipient = new cjs.Text("You", "bold 20px 'Work Sans'");
	this.popupTopic1EmailRecipient.name = "popupTopic1EmailRecipient";
	this.popupTopic1EmailRecipient.lineHeight = 25;
	this.popupTopic1EmailRecipient.lineWidth = 157;
	this.popupTopic1EmailRecipient.parent = this;
	this.popupTopic1EmailRecipient.setTransform(168.2,100.15,0.6241,0.6241);
ranj.TextOffsetFixer.fix(this.popupTopic1EmailRecipient);

	this.popupTopic1EmailTo = new cjs.Text("To:", "20px 'Work Sans'");
	this.popupTopic1EmailTo.name = "popupTopic1EmailTo";
	this.popupTopic1EmailTo.lineHeight = 25;
	this.popupTopic1EmailTo.lineWidth = 33;
	this.popupTopic1EmailTo.parent = this;
	this.popupTopic1EmailTo.setTransform(144.9,100.15,0.6241,0.6241);
ranj.TextOffsetFixer.fix(this.popupTopic1EmailTo);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("EgifAaUMAAAg0mMBE/AAAMAAAA0mg");
	this.shape.setTransform(339.575,254.55);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.popupTopic1EmailTo},{t:this.popupTopic1EmailRecipient},{t:this.popupTopic1EmailSubject},{t:this.popupTopic1EmailSubjectContent},{t:this.popupTopic1EmailContent},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailBG, new cjs.Rectangle(118.8,86.2,441.59999999999997,336.7), null);


(lib.DashboardLogoReady = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.LogoReady();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DashboardLogoReady, new cjs.Rectangle(0,0,137,32), null);


(lib.DashboardLogoGHO = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.LogoGOH();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DashboardLogoGHO, new cjs.Rectangle(0,0,111,91), null);


(lib.DashboardBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.DashboardBGpngcopy();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DashboardBG, new cjs.Rectangle(0,0,1603,903), null);


(lib.CharacterPlaceholder = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1109,1081);


(lib.ChapterContentContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BriefingBodybackground();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChapterContentContainer, new cjs.Rectangle(0,0,1268,867), null);


(lib.BriefingTimelineSmallBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BriefingTimelineBars();
	this.instance.setTransform(34,23);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BriefingTimelineSmallBar, new cjs.Rectangle(34,23,87,27), null);


(lib.BriefingTimelineBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BriefingBlackBar();
	this.instance.setTransform(0,-133);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BriefingTimelineBar, new cjs.Rectangle(0,-133,37,852), null);


(lib.BriefingTimelineBackground_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BriefingTimelineBackground();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BriefingTimelineBackground_1, new cjs.Rectangle(0,0,72,1122), null);


(lib.BriefingTimeline = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BriefingTimeLine();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BriefingTimeline, new cjs.Rectangle(0,0,189,1156), null);


(lib.BottomBar_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BottomBar();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BottomBar_1, new cjs.Rectangle(0,0,1923,179), null);


(lib.BackUp_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BackUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BackUp_1, new cjs.Rectangle(0,0,221,68), null);


(lib.BackOver_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BackOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BackOver_1, new cjs.Rectangle(0,0,222,68), null);


(lib.BackDisabled_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BackDisabled();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BackDisabled_1, new cjs.Rectangle(0,0,221,68), null);


(lib.AnnotationTab1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#BBD2D7").ss(1,1,1).p("EgtzAAAMBbnAAA");
	this.shape.setTransform(317,37.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer_1
	this.bestPossibleOutcomeNumberTextField = new cjs.Text("2430", "bold 40px 'Work Sans ExtraBold'", "#779936");
	this.bestPossibleOutcomeNumberTextField.name = "bestPossibleOutcomeNumberTextField";
	this.bestPossibleOutcomeNumberTextField.lineHeight = 60;
	this.bestPossibleOutcomeNumberTextField.lineWidth = 109;
	this.bestPossibleOutcomeNumberTextField.alpha = 0.90196078;
	this.bestPossibleOutcomeNumberTextField.parent = this;
	this.bestPossibleOutcomeNumberTextField.setTransform(210.45,80.85);
ranj.TextOffsetFixer.fix(this.bestPossibleOutcomeNumberTextField);

	this.worstPossibleOutcomeNumberTextField = new cjs.Text("2430", "bold 40px 'Work Sans ExtraBold'", "#D74821");
	this.worstPossibleOutcomeNumberTextField.name = "worstPossibleOutcomeNumberTextField";
	this.worstPossibleOutcomeNumberTextField.lineHeight = 60;
	this.worstPossibleOutcomeNumberTextField.lineWidth = 109;
	this.worstPossibleOutcomeNumberTextField.alpha = 0.90196078;
	this.worstPossibleOutcomeNumberTextField.parent = this;
	this.worstPossibleOutcomeNumberTextField.setTransform(410.65,80.85);
ranj.TextOffsetFixer.fix(this.worstPossibleOutcomeNumberTextField);

	this.yourOutcomeNumberTextfield = new cjs.Text("2430", "bold 40px 'Work Sans ExtraBold'", "#2C3C3C");
	this.yourOutcomeNumberTextfield.name = "yourOutcomeNumberTextfield";
	this.yourOutcomeNumberTextfield.lineHeight = 60;
	this.yourOutcomeNumberTextfield.lineWidth = 109;
	this.yourOutcomeNumberTextfield.alpha = 0.90196078;
	this.yourOutcomeNumberTextfield.parent = this;
	this.yourOutcomeNumberTextfield.setTransform(25.35,80.85);
ranj.TextOffsetFixer.fix(this.yourOutcomeNumberTextfield);

	this.worstPossibleOutcomeTextfield = new cjs.Text("Worst possible outcome", "20px 'Work Sans'", "#D74821");
	this.worstPossibleOutcomeTextfield.name = "worstPossibleOutcomeTextfield";
	this.worstPossibleOutcomeTextfield.lineHeight = 18;
	this.worstPossibleOutcomeTextfield.lineWidth = 198;
	this.worstPossibleOutcomeTextfield.alpha = 0.90196078;
	this.worstPossibleOutcomeTextfield.parent = this;
	this.worstPossibleOutcomeTextfield.setTransform(410.65,39.45);
ranj.TextOffsetFixer.fix(this.worstPossibleOutcomeTextfield);

	this.bestPossibleOutcomeTextField = new cjs.Text("Best possible outcome", "20px 'Work Sans'", "#779936");
	this.bestPossibleOutcomeTextField.name = "bestPossibleOutcomeTextField";
	this.bestPossibleOutcomeTextField.lineHeight = 18;
	this.bestPossibleOutcomeTextField.lineWidth = 192;
	this.bestPossibleOutcomeTextField.alpha = 0.90196078;
	this.bestPossibleOutcomeTextField.parent = this;
	this.bestPossibleOutcomeTextField.setTransform(210.45,39.45);
ranj.TextOffsetFixer.fix(this.bestPossibleOutcomeTextField);

	this.yourOutcomeTextField = new cjs.Text("Your outcome", "20px 'Work Sans'", "#2C3C3C");
	this.yourOutcomeTextField.name = "yourOutcomeTextField";
	this.yourOutcomeTextField.lineHeight = 18;
	this.yourOutcomeTextField.lineWidth = 139;
	this.yourOutcomeTextField.alpha = 0.90196078;
	this.yourOutcomeTextField.parent = this;
	this.yourOutcomeTextField.setTransform(25.35,39.45);
ranj.TextOffsetFixer.fix(this.yourOutcomeTextField);

	this.annotationTitleTextField = new cjs.Text("Cumulative number of suspect & confirmed cases", "bold 20px 'Work Sans'", "#2C3C3C");
	this.annotationTitleTextField.name = "annotationTitleTextField";
	this.annotationTitleTextField.lineHeight = 25;
	this.annotationTitleTextField.lineWidth = 560;
	this.annotationTitleTextField.alpha = 0.90196078;
	this.annotationTitleTextField.parent = this;
	this.annotationTitleTextField.setTransform(25.35,9.6);
ranj.TextOffsetFixer.fix(this.annotationTitleTextField);

	this.instance = new lib.EpilogueDashboardStatsContainer();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.annotationTitleTextField},{t:this.yourOutcomeTextField},{t:this.bestPossibleOutcomeTextField},{t:this.worstPossibleOutcomeTextfield},{t:this.yourOutcomeNumberTextfield},{t:this.worstPossibleOutcomeNumberTextField},{t:this.bestPossibleOutcomeNumberTextField}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.AnnotationTab1, new cjs.Rectangle(0,0,634,140.8), null);


(lib.AnnotationBackgroundBig = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.EpilogueDashboardStatsContainerLarge();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.AnnotationBackgroundBig, new cjs.Rectangle(0,0,679,153), null);


(lib.Timer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// TExt
	this.secondsSingleTimerTextField = new cjs.Text("0", "30px 'Arial'", "#FFFFFF");
	this.secondsSingleTimerTextField.name = "secondsSingleTimerTextField";
	this.secondsSingleTimerTextField.textAlign = "center";
	this.secondsSingleTimerTextField.lineHeight = 36;
	this.secondsSingleTimerTextField.lineWidth = 17;
	this.secondsSingleTimerTextField.parent = this;
	this.secondsSingleTimerTextField.setTransform(136.35,6);
ranj.TextOffsetFixer.fix(this.secondsSingleTimerTextField);

	this.secondsDoubleTimerTextField = new cjs.Text("0", "30px 'Arial'", "#FFFFFF");
	this.secondsDoubleTimerTextField.name = "secondsDoubleTimerTextField";
	this.secondsDoubleTimerTextField.textAlign = "center";
	this.secondsDoubleTimerTextField.lineHeight = 36;
	this.secondsDoubleTimerTextField.lineWidth = 17;
	this.secondsDoubleTimerTextField.parent = this;
	this.secondsDoubleTimerTextField.setTransform(115.35,6);
ranj.TextOffsetFixer.fix(this.secondsDoubleTimerTextField);

	this.minutesSingleTimerTextField = new cjs.Text("0", "30px 'Arial'", "#FFFFFF");
	this.minutesSingleTimerTextField.name = "minutesSingleTimerTextField";
	this.minutesSingleTimerTextField.textAlign = "center";
	this.minutesSingleTimerTextField.lineHeight = 36;
	this.minutesSingleTimerTextField.lineWidth = 17;
	this.minutesSingleTimerTextField.parent = this;
	this.minutesSingleTimerTextField.setTransform(84.35,6);
ranj.TextOffsetFixer.fix(this.minutesSingleTimerTextField);

	this.minutesDoubleTimerTextField = new cjs.Text("0", "30px 'Arial'", "#FFFFFF");
	this.minutesDoubleTimerTextField.name = "minutesDoubleTimerTextField";
	this.minutesDoubleTimerTextField.textAlign = "center";
	this.minutesDoubleTimerTextField.lineHeight = 36;
	this.minutesDoubleTimerTextField.lineWidth = 17;
	this.minutesDoubleTimerTextField.parent = this;
	this.minutesDoubleTimerTextField.setTransform(62.35,6);
ranj.TextOffsetFixer.fix(this.minutesDoubleTimerTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.minutesDoubleTimerTextField},{t:this.minutesSingleTimerTextField},{t:this.secondsDoubleTimerTextField},{t:this.secondsSingleTimerTextField}]}).wait(1));

	// Layer_4
	this.text = new cjs.Text(":", "20px 'Arial'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 24;
	this.text.lineWidth = 100;
	this.text.parent = this;
	this.text.setTransform(99,12);
ranj.TextOffsetFixer.fix(this.text);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	// Clock
	this.instance = new lib.TimerClock();
	this.instance.setTransform(12,10);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Timer, new cjs.Rectangle(0,0,158,48), null);


(lib.continueButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Continue", "18px 'Arial'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 20;
	this.disabledLabelTextField.lineWidth = 91;
	this.disabledLabelTextField.alpha = 0.29803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(47.5,2);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Continue", "18px 'Arial'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 20;
	this.downLabelTextField.lineWidth = 91;
	this.downLabelTextField.alpha = 0.29803922;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(47.5,2);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Continue", "18px 'Arial'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 20;
	this.overLabelTextField.lineWidth = 91;
	this.overLabelTextField.alpha = 0.29803922;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(47.5,2);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Continue", "18px 'Arial'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 20;
	this.upLabelTextField.lineWidth = 91;
	this.upLabelTextField.alpha = 0.29803922;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(47.5,2);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Layer_1
	this.instance = new lib.PrintButtonUp();
	this.instance.setTransform(0,0,0.8,0.8);

	this.instance_1 = new lib.PrintButtonDown();
	this.instance_1.setTransform(0,0,0.8,0.8);

	this.instance_2 = new lib.PrintButtonDisabled();
	this.instance_2.setTransform(0,0,0.8,0.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	// cloudstripe
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0.4)").s().p("AgECHIAAkNIAJAAIAAENg");
	this.shape.setTransform(-73.525,17.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(4));

	// cloud
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(255,255,255,0.6)").s().p("AzSCHIAAkNMAmlAAAIAAENg");
	this.shape_1.setTransform(50.475,17.5);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-74,0,248,32);


(lib.ResumeButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bg
	this.instance = new lib.Hub_ResumeButtonUp();
	this.instance.setTransform(-155,-32);

	this.instance_1 = new lib.Hub_ResumeButtonOver();
	this.instance_1.setTransform(-155,-32);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-155,-32,60,60);


(lib.ReplayOnboardingButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bg
	this.instance = new lib.Hub_InfoButtonUp();
	this.instance.setTransform(-155,-32);

	this.instance_1 = new lib.Hub_InfoButtonOver();
	this.instance_1.setTransform(-155,-32);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-155,-32,60,59);


(lib.PopupOverlayBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiV/hUXMEr/AAAMAAACovMkr/AAAg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(0,0,0,0.749)").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PopupOverlayBackground, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.PauseButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bg
	this.instance = new lib.Hub_PauseButtonUp();
	this.instance.setTransform(-155,-32);

	this.instance_1 = new lib.Hub_PauseButtonOver();
	this.instance_1.setTransform(-155,-32);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-155,-32,60,59);


(lib.KDBackButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Back", "28px 'Work Sans'", "#2C3C3C");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 202;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-137,-16.65);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Back", "28px 'Work Sans'", "#2C3C3C");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 202;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-137,-16.65);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Back", "28px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 202;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-137,-16.65);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Back", "28px 'Work Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 202;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-137,-16.65);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// bg
	this.instance = new lib.PopUpBackButtonUp();
	this.instance.setTransform(-155,-32);

	this.instance_1 = new lib.PopUpBackButtonOver();
	this.instance_1.setTransform(-155,-32);

	this.instance_2 = new lib.PopUpBackButtonDisabled();
	this.instance_2.setTransform(-155,-32);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-155,-32,238,66);


(lib.FeedbackPreviousButtonWhiteScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Previous", "28px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "right";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 236;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(135.4,-18.5);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Previous", "28px 'Work Sans'", "#EEEAE5");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "right";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 236;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(135.4,-18.5);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Previous", "28px 'Work Sans'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "right";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 236;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(135.4,-18.5);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Previous", "28px 'Work Sans'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "right";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 236;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(135.4,-18.5);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// bg
	this.instance = new lib.ContinueButtonUp();
	this.instance.setTransform(154,-32,1,1,0,0,180);

	this.instance_1 = new lib.ButtonOverWhite();
	this.instance_1.setTransform(153,-31,1,1,0,0,180);

	this.instance_2 = new lib.ContinueButtonDisabled();
	this.instance_2.setTransform(154,-32,1,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-155,-32,309,63);


(lib.FeedbackPreviousButtonBlackScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "right";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 236;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(135.4,-22.65);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#EEEAE5");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "right";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 236;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(135.4,-22.65);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "right";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 236;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(135.4,-22.65);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#2C3C3C");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "right";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 236;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(135.4,-22.65);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// bg
	this.instance = new lib.ContinueButtonHi();
	this.instance.setTransform(154,-32,1,1,0,0,180);

	this.instance_1 = new lib.ContinueButtonUp();
	this.instance_1.setTransform(154,-32,1,1,0,0,180);

	this.instance_2 = new lib.ContinueButtonDisabled();
	this.instance_2.setTransform(154,-32,1,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-155,-32,309,63);


(lib.FeedbackNextButtonWhiteScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Next", "28px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 236;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-137,-18.5);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Next", "28px 'Work Sans'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 236;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-137,-18.5);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Next", "28px 'Work Sans'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 236;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-137,-18.5);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Next", "28px 'Work Sans'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 236;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-137,-18.5);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// bg
	this.instance = new lib.ContinueButtonUp();
	this.instance.setTransform(-154.5,-31.5);

	this.instance_1 = new lib.ButtonOverWhitepngcopy();
	this.instance_1.setTransform(-155,-32);

	this.instance_2 = new lib.ContinueButtonDisabled();
	this.instance_2.setTransform(-154.5,-31.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-155,-32,309.5,63.5);


(lib.FeedbackNextButtonBlackScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 236;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-137,-18.1);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#EEEAE5");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 236;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-137,-18.1);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 236;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-137,-18.1);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#2C3C3C");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 236;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-137,-18.1);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// bg
	this.instance = new lib.ContinueButtonHi();
	this.instance.setTransform(-154.5,-31.5);

	this.instance_1 = new lib.ContinueButtonUp();
	this.instance_1.setTransform(-154.5,-31.5);

	this.instance_2 = new lib.ContinueButtonDisabled();
	this.instance_2.setTransform(-154.5,-31.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-154.5,-31.5,309,63);


(lib.ExitButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bg
	this.instance = new lib.Hub_ExitButtonUp();
	this.instance.setTransform(-155,-32);

	this.instance_1 = new lib.Hub_ExitButtonOver();
	this.instance_1.setTransform(-155,-32);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-155,-32,59,59);


(lib.EpilogueContinueButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 236;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-137,-17.45);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#EEEAE5");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 236;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-137,-17.45);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 236;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-137,-17.45);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 236;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-137,-17.45);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// bg
	this.instance = new lib.NarrowContinueUp();
	this.instance.setTransform(-154.5,-31.5);

	this.instance_1 = new lib.NarrowContinueOver();
	this.instance_1.setTransform(-153,-31);

	this.instance_2 = new lib.NarrowContinueDisabled();
	this.instance_2.setTransform(-154.5,-31.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-154.5,-31.5,255.5,62.5);


(lib.EpilogueBackButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "right";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 236;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(74,-17.45);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#EEEAE5");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "right";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 236;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(74,-17.45);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "right";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 236;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(74,-17.45);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "right";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 236;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(74,-17.45);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// bg
	this.instance = new lib.NarrowContinueUp();
	this.instance.setTransform(89,-32,1,1,0,0,180);

	this.instance_1 = new lib.NarrowContinueOver();
	this.instance_1.setTransform(91,-31,1,1,0,0,180);

	this.instance_2 = new lib.NarrowContinueDisabled();
	this.instance_2.setTransform(89,-32,1,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-164,-32,255,63);


(lib.EmptySquare = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0.012)").s().p("AjbDcIAAm3IG3AAIAAG3g");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmptySquare, new cjs.Rectangle(-22,-22,44,44), null);


(lib.ContinueButtonTutorialEnd = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 276;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-137,-17.45);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).to({_off:true},4).wait(1));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#EEEAE5");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 277;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-137,-17.45);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).to({_off:true},4).wait(1));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 276;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-137,-17.45);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).to({_off:true},4).wait(1));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 277;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-137,-17.45);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).to({_off:true},4).wait(1));

	// bg
	this.instance = new lib.ContinueTutorialOver();
	this.instance.setTransform(-155,-31);

	this.instance_1 = new lib.ContinueTutorialUp();
	this.instance_1.setTransform(-153,-31);

	this.instance_2 = new lib.ContinueTutorialDisabled();
	this.instance_2.setTransform(-154,-31);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).to({state:[]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-155,-31,354,62);


(lib.ContinueButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 236;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-137,-17.45);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#EEEAE5");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 236;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-137,-17.45);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 236;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-137,-17.45);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 236;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-137,-17.45);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// bg
	this.instance = new lib.ContinueButtonUp();
	this.instance.setTransform(-154.5,-31.5);

	this.instance_1 = new lib.ButtonOverWhite();
	this.instance_1.setTransform(-153,-31);

	this.instance_2 = new lib.ContinueButtonDisabled();
	this.instance_2.setTransform(-154.5,-31.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-154.5,-31.5,309,63);


(lib.CloseButtonBase = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CloseButtonIcon();
	this.instance.setTransform(-8.5,-8.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CloseButtonBase, new cjs.Rectangle(-8.5,-8.5,17,17), null);


(lib.EmptyContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.PlaceholderBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiV/hUXMEr/AAAMAAACovMkr/AAAg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#CCCCCC").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlaceholderBackground, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.InternalStakeholder4Button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// positionDisabledLabelTextField
	this.positionDisabledLabelTextField = new cjs.Text(" Start StartStart StartStart StartStart Start", "17px 'Work Sans'", "#BBD2D7");
	this.positionDisabledLabelTextField.name = "positionDisabledLabelTextField";
	this.positionDisabledLabelTextField.textAlign = "center";
	this.positionDisabledLabelTextField.lineHeight = 16;
	this.positionDisabledLabelTextField.lineWidth = 152;
	this.positionDisabledLabelTextField.parent = this;
	this.positionDisabledLabelTextField.setTransform(0.15,-31.2);
ranj.TextOffsetFixer.fix(this.positionDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionDisabledLabelTextField).wait(4));

	// positionDownLabelTextField
	this.positionDownLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#2C3C3C");
	this.positionDownLabelTextField.name = "positionDownLabelTextField";
	this.positionDownLabelTextField.textAlign = "center";
	this.positionDownLabelTextField.lineHeight = 16;
	this.positionDownLabelTextField.lineWidth = 152;
	this.positionDownLabelTextField.parent = this;
	this.positionDownLabelTextField.setTransform(0.15,-31.05);
ranj.TextOffsetFixer.fix(this.positionDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionDownLabelTextField).wait(4));

	// positionOverLabelTextField
	this.positionOverLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#2C3C3C");
	this.positionOverLabelTextField.name = "positionOverLabelTextField";
	this.positionOverLabelTextField.textAlign = "center";
	this.positionOverLabelTextField.lineHeight = 16;
	this.positionOverLabelTextField.lineWidth = 152;
	this.positionOverLabelTextField.parent = this;
	this.positionOverLabelTextField.setTransform(0.15,-31.05);
ranj.TextOffsetFixer.fix(this.positionOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionOverLabelTextField).wait(4));

	// positionUpLabelTextField
	this.positionUpLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#FFFFFF");
	this.positionUpLabelTextField.name = "positionUpLabelTextField";
	this.positionUpLabelTextField.textAlign = "center";
	this.positionUpLabelTextField.lineHeight = 16;
	this.positionUpLabelTextField.lineWidth = 152;
	this.positionUpLabelTextField.parent = this;
	this.positionUpLabelTextField.setTransform(0.15,-31.05);
ranj.TextOffsetFixer.fix(this.positionUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionUpLabelTextField).wait(4));

	// nameDisabledLabelTextField
	this.nameDisabledLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#BBD2D7");
	this.nameDisabledLabelTextField.name = "nameDisabledLabelTextField";
	this.nameDisabledLabelTextField.textAlign = "center";
	this.nameDisabledLabelTextField.lineHeight = 27;
	this.nameDisabledLabelTextField.lineWidth = 152;
	this.nameDisabledLabelTextField.parent = this;
	this.nameDisabledLabelTextField.setTransform(0.15,-49.85);
ranj.TextOffsetFixer.fix(this.nameDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameDisabledLabelTextField).wait(4));

	// nameDownLabelTextField
	this.nameDownLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#2C3C3C");
	this.nameDownLabelTextField.name = "nameDownLabelTextField";
	this.nameDownLabelTextField.textAlign = "center";
	this.nameDownLabelTextField.lineHeight = 27;
	this.nameDownLabelTextField.lineWidth = 152;
	this.nameDownLabelTextField.parent = this;
	this.nameDownLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameDownLabelTextField).wait(4));

	// nameOverLabelTextField
	this.nameOverLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#2C3C3C");
	this.nameOverLabelTextField.name = "nameOverLabelTextField";
	this.nameOverLabelTextField.textAlign = "center";
	this.nameOverLabelTextField.lineHeight = 27;
	this.nameOverLabelTextField.lineWidth = 152;
	this.nameOverLabelTextField.parent = this;
	this.nameOverLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameOverLabelTextField).wait(4));

	// nameUpLabelTextField
	this.nameUpLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#FFFFFF");
	this.nameUpLabelTextField.name = "nameUpLabelTextField";
	this.nameUpLabelTextField.textAlign = "center";
	this.nameUpLabelTextField.lineHeight = 27;
	this.nameUpLabelTextField.lineWidth = 152;
	this.nameUpLabelTextField.parent = this;
	this.nameUpLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameUpLabelTextField).wait(4));

	// Layer_3
	this.instance = new lib.HUBStakeholderButtonLabelUp();
	this.instance.setTransform(-86,-55);

	this.instance_1 = new lib.HUBStakeholderButtonLabelOver();
	this.instance_1.setTransform(-86,-55);

	this.instance_2 = new lib.HUBStakeholderButtonLabelDisabled();
	this.instance_2.setTransform(-87,-56);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	// Layer_5 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AhDOTIpYpZQgdgcAAgnIAArbQAAgoAdgcIJYpZQAcgcAnAAQAoAAAcAcIJYJZQAdAcAAAoIAALbQAAAngdAcIpYJZQgcAcgoAAQgnAAgcgcg");
	mask.setTransform(0.0676,-118.225);

	// Layer_4
	this.instance_3 = new lib.stakeholder_onneetse();
	this.instance_3.setTransform(-81,-231,0.4594,0.4594);

	this.instance_4 = new lib.stakeholder_onneetse_disabled();
	this.instance_4.setTransform(-81,-231,0.4594,0.4594);

	var maskedShapeInstanceList = [this.instance_3,this.instance_4];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3,p:{y:-231}}]}).to({state:[{t:this.instance_3,p:{y:-238}}]},1).to({state:[{t:this.instance_4}]},2).wait(1));

	// Layer_2
	this.instance_5 = new lib.HUBStakeholderButtonBGUp();
	this.instance_5.setTransform(-81,-172);

	this.instance_6 = new lib.HUBStakeholderButtonBGDisabled();
	this.instance_6.setTransform(-81,-172);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5}]}).to({state:[{t:this.instance_6}]},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-87,-236.4,179,280.4);


(lib.InternalStakeholder3Button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// positionDisabledLabelTextField
	this.positionDisabledLabelTextField = new cjs.Text(" Start StartStart StartStart StartStart Start", "17px 'Work Sans'", "#BBD2D7");
	this.positionDisabledLabelTextField.name = "positionDisabledLabelTextField";
	this.positionDisabledLabelTextField.textAlign = "center";
	this.positionDisabledLabelTextField.lineHeight = 16;
	this.positionDisabledLabelTextField.lineWidth = 152;
	this.positionDisabledLabelTextField.parent = this;
	this.positionDisabledLabelTextField.setTransform(0.15,-31.2);
ranj.TextOffsetFixer.fix(this.positionDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionDisabledLabelTextField).wait(4));

	// positionDownLabelTextField
	this.positionDownLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#2C3C3C");
	this.positionDownLabelTextField.name = "positionDownLabelTextField";
	this.positionDownLabelTextField.textAlign = "center";
	this.positionDownLabelTextField.lineHeight = 16;
	this.positionDownLabelTextField.lineWidth = 152;
	this.positionDownLabelTextField.parent = this;
	this.positionDownLabelTextField.setTransform(0.15,-31.05);
ranj.TextOffsetFixer.fix(this.positionDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionDownLabelTextField).wait(4));

	// positionOverLabelTextField
	this.positionOverLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#2C3C3C");
	this.positionOverLabelTextField.name = "positionOverLabelTextField";
	this.positionOverLabelTextField.textAlign = "center";
	this.positionOverLabelTextField.lineHeight = 16;
	this.positionOverLabelTextField.lineWidth = 152;
	this.positionOverLabelTextField.parent = this;
	this.positionOverLabelTextField.setTransform(0.15,-31.05);
ranj.TextOffsetFixer.fix(this.positionOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionOverLabelTextField).wait(4));

	// positionUpLabelTextField
	this.positionUpLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#FFFFFF");
	this.positionUpLabelTextField.name = "positionUpLabelTextField";
	this.positionUpLabelTextField.textAlign = "center";
	this.positionUpLabelTextField.lineHeight = 16;
	this.positionUpLabelTextField.lineWidth = 152;
	this.positionUpLabelTextField.parent = this;
	this.positionUpLabelTextField.setTransform(0.15,-31.05);
ranj.TextOffsetFixer.fix(this.positionUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionUpLabelTextField).wait(4));

	// nameDisabledLabelTextField
	this.nameDisabledLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#BBD2D7");
	this.nameDisabledLabelTextField.name = "nameDisabledLabelTextField";
	this.nameDisabledLabelTextField.textAlign = "center";
	this.nameDisabledLabelTextField.lineHeight = 27;
	this.nameDisabledLabelTextField.lineWidth = 152;
	this.nameDisabledLabelTextField.parent = this;
	this.nameDisabledLabelTextField.setTransform(0.15,-49.85);
ranj.TextOffsetFixer.fix(this.nameDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameDisabledLabelTextField).wait(4));

	// nameDownLabelTextField
	this.nameDownLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#2C3C3C");
	this.nameDownLabelTextField.name = "nameDownLabelTextField";
	this.nameDownLabelTextField.textAlign = "center";
	this.nameDownLabelTextField.lineHeight = 27;
	this.nameDownLabelTextField.lineWidth = 152;
	this.nameDownLabelTextField.parent = this;
	this.nameDownLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameDownLabelTextField).wait(4));

	// nameOverLabelTextField
	this.nameOverLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#2C3C3C");
	this.nameOverLabelTextField.name = "nameOverLabelTextField";
	this.nameOverLabelTextField.textAlign = "center";
	this.nameOverLabelTextField.lineHeight = 27;
	this.nameOverLabelTextField.lineWidth = 152;
	this.nameOverLabelTextField.parent = this;
	this.nameOverLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameOverLabelTextField).wait(4));

	// nameUpLabelTextField
	this.nameUpLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#FFFFFF");
	this.nameUpLabelTextField.name = "nameUpLabelTextField";
	this.nameUpLabelTextField.textAlign = "center";
	this.nameUpLabelTextField.lineHeight = 27;
	this.nameUpLabelTextField.lineWidth = 152;
	this.nameUpLabelTextField.parent = this;
	this.nameUpLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameUpLabelTextField).wait(4));

	// Layer_3
	this.instance = new lib.HUBStakeholderButtonLabelUp();
	this.instance.setTransform(-86,-55);

	this.instance_1 = new lib.HUBStakeholderButtonLabelOver();
	this.instance_1.setTransform(-86,-55);

	this.instance_2 = new lib.HUBStakeholderButtonLabelDisabled();
	this.instance_2.setTransform(-87,-56);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	// Layer_5 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AhDOTIpYpZQgdgcAAgnIAArbQAAgoAdgcIJYpZQAcgcAnAAQAoAAAcAcIJYJZQAdAcAAAoIAALbQAAAngdAcIpYJZQgcAcgoAAQgnAAgcgcg");
	mask.setTransform(0.0676,-118.225);

	// Layer_4
	this.instance_3 = new lib.stakeholder_hasim();
	this.instance_3.setTransform(-72,-222,0.4313,0.4313);

	this.instance_4 = new lib.stakeholder_hasim_disabled();
	this.instance_4.setTransform(-72,-222,0.4313,0.4313);

	var maskedShapeInstanceList = [this.instance_3,this.instance_4];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3,p:{y:-222}}]}).to({state:[{t:this.instance_3,p:{y:-228}}]},1).to({state:[{t:this.instance_4}]},2).wait(1));

	// Layer_2
	this.instance_5 = new lib.HUBStakeholderButtonBGUp();
	this.instance_5.setTransform(-81,-172);

	this.instance_6 = new lib.HUBStakeholderButtonBGDisabled();
	this.instance_6.setTransform(-81,-172);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5}]}).to({state:[{t:this.instance_6}]},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-87,-228,179,272);


(lib.InternalStakeholder2Button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// positionDisabledLabelTextField
	this.positionDisabledLabelTextField = new cjs.Text(" Start StartStart StartStart StartStart Start", "17px 'Work Sans'", "#BBD2D7");
	this.positionDisabledLabelTextField.name = "positionDisabledLabelTextField";
	this.positionDisabledLabelTextField.textAlign = "center";
	this.positionDisabledLabelTextField.lineHeight = 16;
	this.positionDisabledLabelTextField.lineWidth = 152;
	this.positionDisabledLabelTextField.parent = this;
	this.positionDisabledLabelTextField.setTransform(0.15,-31.2);
ranj.TextOffsetFixer.fix(this.positionDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionDisabledLabelTextField).wait(4));

	// positionDownLabelTextField
	this.positionDownLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#2C3C3C");
	this.positionDownLabelTextField.name = "positionDownLabelTextField";
	this.positionDownLabelTextField.textAlign = "center";
	this.positionDownLabelTextField.lineHeight = 16;
	this.positionDownLabelTextField.lineWidth = 152;
	this.positionDownLabelTextField.parent = this;
	this.positionDownLabelTextField.setTransform(0.15,-31.05);
ranj.TextOffsetFixer.fix(this.positionDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionDownLabelTextField).wait(4));

	// positionOverLabelTextField
	this.positionOverLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#2C3C3C");
	this.positionOverLabelTextField.name = "positionOverLabelTextField";
	this.positionOverLabelTextField.textAlign = "center";
	this.positionOverLabelTextField.lineHeight = 16;
	this.positionOverLabelTextField.lineWidth = 152;
	this.positionOverLabelTextField.parent = this;
	this.positionOverLabelTextField.setTransform(0.15,-31.05);
ranj.TextOffsetFixer.fix(this.positionOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionOverLabelTextField).wait(4));

	// positionUpLabelTextField
	this.positionUpLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#FFFFFF");
	this.positionUpLabelTextField.name = "positionUpLabelTextField";
	this.positionUpLabelTextField.textAlign = "center";
	this.positionUpLabelTextField.lineHeight = 16;
	this.positionUpLabelTextField.lineWidth = 152;
	this.positionUpLabelTextField.parent = this;
	this.positionUpLabelTextField.setTransform(0.15,-31.05);
ranj.TextOffsetFixer.fix(this.positionUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionUpLabelTextField).wait(4));

	// nameDisabledLabelTextField
	this.nameDisabledLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#BBD2D7");
	this.nameDisabledLabelTextField.name = "nameDisabledLabelTextField";
	this.nameDisabledLabelTextField.textAlign = "center";
	this.nameDisabledLabelTextField.lineHeight = 27;
	this.nameDisabledLabelTextField.lineWidth = 152;
	this.nameDisabledLabelTextField.parent = this;
	this.nameDisabledLabelTextField.setTransform(0.15,-49.85);
ranj.TextOffsetFixer.fix(this.nameDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameDisabledLabelTextField).wait(4));

	// nameDownLabelTextField
	this.nameDownLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#2C3C3C");
	this.nameDownLabelTextField.name = "nameDownLabelTextField";
	this.nameDownLabelTextField.textAlign = "center";
	this.nameDownLabelTextField.lineHeight = 27;
	this.nameDownLabelTextField.lineWidth = 152;
	this.nameDownLabelTextField.parent = this;
	this.nameDownLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameDownLabelTextField).wait(4));

	// nameOverLabelTextField
	this.nameOverLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#2C3C3C");
	this.nameOverLabelTextField.name = "nameOverLabelTextField";
	this.nameOverLabelTextField.textAlign = "center";
	this.nameOverLabelTextField.lineHeight = 27;
	this.nameOverLabelTextField.lineWidth = 152;
	this.nameOverLabelTextField.parent = this;
	this.nameOverLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameOverLabelTextField).wait(4));

	// nameUpLabelTextField
	this.nameUpLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#FFFFFF");
	this.nameUpLabelTextField.name = "nameUpLabelTextField";
	this.nameUpLabelTextField.textAlign = "center";
	this.nameUpLabelTextField.lineHeight = 27;
	this.nameUpLabelTextField.lineWidth = 152;
	this.nameUpLabelTextField.parent = this;
	this.nameUpLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameUpLabelTextField).wait(4));

	// Layer_3
	this.instance = new lib.HUBStakeholderButtonLabelUp();
	this.instance.setTransform(-86,-55);

	this.instance_1 = new lib.HUBStakeholderButtonLabelOver();
	this.instance_1.setTransform(-86,-55);

	this.instance_2 = new lib.HUBStakeholderButtonLabelDisabled();
	this.instance_2.setTransform(-87,-56);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	// Layer_5 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AhDOTIpYpZQgdgcAAgnIAArbQAAgoAdgcIJYpZQAcgcAnAAQAoAAAcAcIJYJZQAdAcAAAoIAALbQAAAngdAcIpYJZQgcAcgoAAQgnAAgcgcg");
	mask.setTransform(0.0676,-118.225);

	// image
	this.instance_3 = new lib.stakeholder_sarah();
	this.instance_3.setTransform(-72,-219,0.3873,0.3873);

	this.instance_4 = new lib.stakeholder_sarah_disabled();
	this.instance_4.setTransform(-72,-220,0.3873,0.3873);

	var maskedShapeInstanceList = [this.instance_3,this.instance_4];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3,p:{y:-219}}]}).to({state:[{t:this.instance_3,p:{y:-218}}]},1).to({state:[{t:this.instance_4}]},2).wait(1));

	// Layer_2
	this.instance_5 = new lib.HUBStakeholderButtonBGUp();
	this.instance_5.setTransform(-81,-172);

	this.instance_6 = new lib.HUBStakeholderButtonBGDisabled();
	this.instance_6.setTransform(-81,-172);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5}]}).to({state:[{t:this.instance_6}]},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-87,-220,179,264);


(lib.InternalStakeholder1Button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// positionDisabledLabelTextField
	this.positionDisabledLabelTextField = new cjs.Text(" Start StartStart StartStart StartStart Start", "17px 'Work Sans'", "#BBD2D7");
	this.positionDisabledLabelTextField.name = "positionDisabledLabelTextField";
	this.positionDisabledLabelTextField.textAlign = "center";
	this.positionDisabledLabelTextField.lineHeight = 16;
	this.positionDisabledLabelTextField.lineWidth = 152;
	this.positionDisabledLabelTextField.parent = this;
	this.positionDisabledLabelTextField.setTransform(0.15,-29.9);
ranj.TextOffsetFixer.fix(this.positionDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionDisabledLabelTextField).wait(4));

	// positionDownLabelTextField
	this.positionDownLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#2C3C3C");
	this.positionDownLabelTextField.name = "positionDownLabelTextField";
	this.positionDownLabelTextField.textAlign = "center";
	this.positionDownLabelTextField.lineHeight = 16;
	this.positionDownLabelTextField.lineWidth = 152;
	this.positionDownLabelTextField.parent = this;
	this.positionDownLabelTextField.setTransform(0.15,-29.75);
ranj.TextOffsetFixer.fix(this.positionDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionDownLabelTextField).wait(4));

	// positionOverLabelTextField
	this.positionOverLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#2C3C3C");
	this.positionOverLabelTextField.name = "positionOverLabelTextField";
	this.positionOverLabelTextField.textAlign = "center";
	this.positionOverLabelTextField.lineHeight = 16;
	this.positionOverLabelTextField.lineWidth = 152;
	this.positionOverLabelTextField.parent = this;
	this.positionOverLabelTextField.setTransform(0.15,-29.75);
ranj.TextOffsetFixer.fix(this.positionOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionOverLabelTextField).wait(4));

	// positionUpLabelTextField
	this.positionUpLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#FFFFFF");
	this.positionUpLabelTextField.name = "positionUpLabelTextField";
	this.positionUpLabelTextField.textAlign = "center";
	this.positionUpLabelTextField.lineHeight = 16;
	this.positionUpLabelTextField.lineWidth = 152;
	this.positionUpLabelTextField.parent = this;
	this.positionUpLabelTextField.setTransform(0.15,-29.75);
ranj.TextOffsetFixer.fix(this.positionUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionUpLabelTextField).wait(4));

	// nameDisabledLabelTextField
	this.nameDisabledLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#BBD2D7");
	this.nameDisabledLabelTextField.name = "nameDisabledLabelTextField";
	this.nameDisabledLabelTextField.textAlign = "center";
	this.nameDisabledLabelTextField.lineHeight = 27;
	this.nameDisabledLabelTextField.lineWidth = 152;
	this.nameDisabledLabelTextField.parent = this;
	this.nameDisabledLabelTextField.setTransform(0.15,-48.55);
ranj.TextOffsetFixer.fix(this.nameDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameDisabledLabelTextField).wait(4));

	// nameDownLabelTextField
	this.nameDownLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#2C3C3C");
	this.nameDownLabelTextField.name = "nameDownLabelTextField";
	this.nameDownLabelTextField.textAlign = "center";
	this.nameDownLabelTextField.lineHeight = 27;
	this.nameDownLabelTextField.lineWidth = 152;
	this.nameDownLabelTextField.parent = this;
	this.nameDownLabelTextField.setTransform(0.15,-47.75);
ranj.TextOffsetFixer.fix(this.nameDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameDownLabelTextField).wait(4));

	// nameOverLabelTextField
	this.nameOverLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#2C3C3C");
	this.nameOverLabelTextField.name = "nameOverLabelTextField";
	this.nameOverLabelTextField.textAlign = "center";
	this.nameOverLabelTextField.lineHeight = 27;
	this.nameOverLabelTextField.lineWidth = 152;
	this.nameOverLabelTextField.parent = this;
	this.nameOverLabelTextField.setTransform(0.15,-47.75);
ranj.TextOffsetFixer.fix(this.nameOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameOverLabelTextField).wait(4));

	// nameUpLabelTextField
	this.nameUpLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#FFFFFF");
	this.nameUpLabelTextField.name = "nameUpLabelTextField";
	this.nameUpLabelTextField.textAlign = "center";
	this.nameUpLabelTextField.lineHeight = 27;
	this.nameUpLabelTextField.lineWidth = 152;
	this.nameUpLabelTextField.parent = this;
	this.nameUpLabelTextField.setTransform(0.15,-47.75);
ranj.TextOffsetFixer.fix(this.nameUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameUpLabelTextField).wait(4));

	// Layer_3
	this.instance = new lib.HUBStakeholderButtonLabelUp();
	this.instance.setTransform(-86,-55);

	this.instance_1 = new lib.HUBStakeholderButtonLabelOver();
	this.instance_1.setTransform(-86,-55);

	this.instance_2 = new lib.HUBStakeholderButtonLabelDisabled();
	this.instance_2.setTransform(-87,-56);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	// Layer_5 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AhDSqIpZpYQgcgcAAgoIAAwbQAAgoAcgcIJZpZQAcgcAnAAQAoAAAcAcIJYJZQAdAcAAAoIAAQbQAAAogdAcIpYJYQgcAdgoAAQgnAAgcgdg");
	mask.setTransform(0.075,-146.175);

	// Layer_4
	this.instance_3 = new lib.stakeholder_Nia();
	this.instance_3.setTransform(-79,-230,0.4499,0.4499);

	this.instance_4 = new lib.stakeholder_nia_disabled();
	this.instance_4.setTransform(-79,-231,0.4499,0.4499);

	var maskedShapeInstanceList = [this.instance_3,this.instance_4];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3,p:{x:-79,y:-230}}]}).to({state:[{t:this.instance_3,p:{x:-82,y:-238}}]},1).to({state:[{t:this.instance_4}]},2).wait(1));

	// Layer_2
	this.instance_5 = new lib.HUBStakeholderButtonBGUp();
	this.instance_5.setTransform(-81,-172);

	this.instance_6 = new lib.HUBStakeholderButtonBGDisabled();
	this.instance_6.setTransform(-81,-172);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5}]}).to({state:[{t:this.instance_6}]},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-87,-238,179,282);


(lib.HUBTeaCornerButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Start", "bold 18px 'Work Sans ExtraBold'", "#BBD2D7");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 28;
	this.disabledLabelTextField.lineWidth = 182;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-0.05,-35.15);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Start", "bold 18px 'Work Sans ExtraBold'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 28;
	this.downLabelTextField.lineWidth = 182;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-0.05,-35.15);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Start", "bold 18px 'Work Sans ExtraBold'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 28;
	this.overLabelTextField.lineWidth = 182;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-0.05,-35.15);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Start", "bold 18px 'Work Sans ExtraBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 28;
	this.upLabelTextField.lineWidth = 182;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-0.05,-35.15);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Layer_3
	this.instance = new lib.HUBTeaCornerButtonLabelUp();
	this.instance.setTransform(-109,-60);

	this.instance_1 = new lib.HUBTeaCornerButtonLabelOver();
	this.instance_1.setTransform(-109,-60);

	this.instance_2 = new lib.HUBTeaCornerButtonLabelDisabled();
	this.instance_2.setTransform(-109,-60);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	// Layer_5 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("Aj9DGQg5ghgxgyQiViTAAjUQAAjTCViVQAxgxA5ghQBxhCCMAAQDTAACVCUQCVCVAADTQAADUiVCTQiVCWjTAAQiMgBhxhCg");
	mask.setTransform(-1.5,-75.35);

	// Layer_4
	this.instance_3 = new lib.TeaCornerIcon();
	this.instance_3.setTransform(-53,-156,0.5511,0.5511);

	this.instance_4 = new lib.TeaCornerIconDisabled();
	this.instance_4.setTransform(-53,-157,0.556,0.556);

	var maskedShapeInstanceList = [this.instance_3,this.instance_4];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3,p:{y:-156}}]}).to({state:[{t:this.instance_3,p:{y:-160}}]},1).to({state:[{t:this.instance_4}]},2).wait(1));

	// Layer_2
	this.instance_5 = new lib.HUBTeaCornerButtonBGUp();
	this.instance_5.setTransform(-63,-159);

	this.instance_6 = new lib.HUBTeaCornerButtonBGDisabled();
	this.instance_6.setTransform(-63,-160);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5}]}).to({state:[{t:this.instance_6}]},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-250,-160,369,191);


(lib.ResumeButton_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Continue", "28px 'Work Sans SemiBold'", "#1E1E28");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 377;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(190.5,19);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Continue", "28px 'Work Sans SemiBold'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 376;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(191,19);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Continue", "28px 'Work Sans SemiBold'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 376;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(191,19);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Continue", "28px 'Work Sans SemiBold'", "#1E1E28");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 376;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(191,19);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(255,255,255,0.498)").ss(1,0,1).p("A7Vl2MA2rAAAQCWAAAACWIAAHBQAACWiWAAMg2rAAAQiWAAAAiWIAAnBQAAiWCWAAg");
	this.shape.setTransform(191,38.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("A7VF3QiWAAAAiWIAAnBQAAiWCWAAMA2rAAAQCWAAAACWIAAHBQAACWiWAAg");
	this.shape_1.setTransform(191,38.5);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#295B6D").s().p("A7VF3QiWAAAAiWIAAnBQAAiWCWAAMA2rAAAQCWAAAACWIAAHBQAACWiWAAg");
	this.shape_2.setTransform(191,38.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_1},{t:this.shape}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,382,77);


(lib.SurveyButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Go to Survey", "bold 35px 'Work Sans'", "#A79EB1");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 43;
	this.disabledLabelTextField.lineWidth = 335;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(176.3,19.5);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Go to Survey", "bold 35px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 43;
	this.downLabelTextField.lineWidth = 335;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(176.8,19.5);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Go to Survey", "bold 35px 'Work Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 43;
	this.overLabelTextField.lineWidth = 335;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(176.3,19.5);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Go to Survey", "bold 35px 'Work Sans'", "#2C3C3C");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 43;
	this.upLabelTextField.lineWidth = 335;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(176.3,19.5);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("A5BGuQhIAAg0g0QgzgzAAhJIAAn7QAAhJAzg0QA0gzBIAAMAyDAAAQBIAAA0AzQAzA0AABJIAAH7QAABJgzAzQg0A0hIAAg");
	this.shape.setTransform(177.7,43);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#2C3C3C").s().p("A5BGuQhIAAg0g0QgzgzAAhJIAAn7QAAhJAzg0QA0gzBIAAMAyDAAAQBIAAA0AzQAzA0AABJIAAH7QAABJgzAzQg0A0hIAAg");
	this.shape_1.setTransform(177.7,43);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,355.4,86);


(lib.ReadyWebsiteButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("www.ready-initiative.org", "22px 'Work Sans'", "#A79EB1");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 20;
	this.disabledLabelTextField.lineWidth = 286;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(148.5138,12.75,0.9998,1);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("www.ready-initiative.org", "22px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 20;
	this.downLabelTextField.lineWidth = 286;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(148.5137,12.75,0.9998,1);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("www.ready-initiative.org", "22px 'Work Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 20;
	this.overLabelTextField.lineWidth = 286;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(148.5138,12.75,0.9998,1);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("www.ready-initiative.org", "22px 'Work Sans'", "#2C3C3C");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 20;
	this.upLabelTextField.lineWidth = 286;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(148.5138,12.75,0.9998,1);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("A17D2QgdAAgTgUQgUgUAAgcIAAljQAAgcAUgUQAUgUAcAAMAr3AAAQAcAAAUAUQATAUAAAcIAAFjQAAAcgTAUQgUAUgcAAg");
	this.shape.setTransform(148.7,25.575);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#2C3C3C").s().p("A17D2QgdAAgTgUQgUgUAAgcIAAljQAAgcAUgUQAUgUAcAAMAr3AAAQAcAAAUAUQATAUAAAcIAAFjQAAAcgTAUQgUAUgcAAg");
	this.shape_1.setTransform(148.7,25.575);

	this.text = new cjs.Text("    www.ready-initiative.org", "24px 'Work Sans'", "#1D1D1B");
	this.text.textAlign = "center";
	this.text.lineHeight = 22;
	this.text.lineWidth = 668;
	this.text.parent = this;
	this.text.setTransform(-276.15,172.3);
ranj.TextOffsetFixer.fix(this.text);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape},{t:this.text}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-612.3,1,908.1999999999999,219.4);


(lib.Overlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiV/hUXMEr/AAAMAAACovMkr/AAAg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(0,0,0,0.498)").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Overlay, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.PlaceholderCloseButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(6,1,1).p("AjIjIIDIDIIDJDJADJjIIjJDIIivCw");
	this.shape.setTransform(-1.225,-2.475);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Laag_2
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("AHBAAQAAC6iDCEQiECDi6AAQi5AAiEiDQiEiEAAi6QAAi5CEiEQCEiDC5AAQC6AACECDQCDCEAAC5g");

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#333333").s().p("Ak9E+QiDiEAAi6QAAi5CDiEQCEiDC5gBQC6ABCECDQCECEgBC5QABC6iECEQiECDi6AAQi5AAiEiDg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlaceholderCloseButton, new cjs.Rectangle(-45.9,-45.9,91.9,91.9), null);


(lib.KeyDecisionUnderlayImageContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.KeyDecisionOverlayFader = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecisionOverlayFader, new cjs.Rectangle(-960,-540,1920,1080), null);


(lib.KeyDecisionAvailableBackdrop = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0.349)").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecisionAvailableBackdrop, new cjs.Rectangle(-960,-540,1920,1080), null);


(lib.MapContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.KeyDecInfoBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_2
	this.actionNeededTextField2 = new cjs.Text("[Action that is needed]\n[Action that is needed]\n[Action that is needed]", "21px 'Work Sans'");
	this.actionNeededTextField2.name = "actionNeededTextField2";
	this.actionNeededTextField2.lineHeight = 21;
	this.actionNeededTextField2.lineWidth = 438;
	this.actionNeededTextField2.parent = this;
	this.actionNeededTextField2.setTransform(27.15,11.8);
ranj.TextOffsetFixer.fix(this.actionNeededTextField2);

	this.timeline.addTween(cjs.Tween.get(this.actionNeededTextField2).wait(1));

	// Layer_1
	this.instance = new lib.NotificationBarEndpngcopy();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecInfoBar, new cjs.Rectangle(0,0,570,104), null);


(lib.KeyDecButtonOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.KeyDecButtonHover();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecButtonOver, new cjs.Rectangle(0,0,119,115), null);


(lib.KeyDecButtonDown_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.KeyDecButtonDown();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecButtonDown_1, new cjs.Rectangle(0,0,113,114), null);


(lib.HubKeyDecisionNotificationContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-584.4,-152.1,621.4,205.2);


(lib.HubButtonNewIndicator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.newAmountTextField = new cjs.Text("1", "bold 32px 'Work Sans'", "#FFFFFF");
	this.newAmountTextField.name = "newAmountTextField";
	this.newAmountTextField.textAlign = "center";
	this.newAmountTextField.lineHeight = 40;
	this.newAmountTextField.lineWidth = 52;
	this.newAmountTextField.parent = this;
	this.newAmountTextField.setTransform(-0.55,-24.75);
ranj.TextOffsetFixer.fix(this.newAmountTextField);

	this.timeline.addTween(cjs.Tween.get(this.newAmountTextField).wait(1));

	// Layer_1
	this.instance = new lib.HUBNewItemLabel1();
	this.instance.setTransform(-42,-40);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HubButtonNewIndicator, new cjs.Rectangle(-42,-40,84,80), null);


(lib.HubBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiV/hUXMEr/AAAMAAACovMkr/AAAg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#CCCCCC").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HubBackground, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.TopicButtonUpBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TopicButtonUp();
	this.instance.setTransform(-117.5,-32);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TopicButtonUpBG, new cjs.Rectangle(-117.5,-32,235,64), null);


(lib.TopicButtonDownBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TopicButtonDown();
	this.instance.setTransform(-117.5,-32);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TopicButtonDownBG, new cjs.Rectangle(-117.5,-32,235,64), null);


(lib.TopicButtonDisabledBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TopicButtonDisabled();
	this.instance.setTransform(-117.5,-32);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TopicButtonDisabledBG, new cjs.Rectangle(-117.5,-32,235,64), null);


(lib.NpcTextPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// npcTextField
	this.npcTextField = new cjs.Text("These two communities are facing the highest burden from Enni Virus. They also report higher levels of mistrust towards the district \nhospital. \nHaving ITCs that are more community-based may encourage more cases to seek \nhealth services.", "22px 'Work Sans SemiBold'", "#FFFFFF");
	this.npcTextField.name = "npcTextField";
	this.npcTextField.lineHeight = 26;
	this.npcTextField.lineWidth = 671;
	this.npcTextField.parent = this;
	this.npcTextField.setTransform(-299.35,29.05);
ranj.TextOffsetFixer.fix(this.npcTextField);

	this.timeline.addTween(cjs.Tween.get(this.npcTextField).wait(1));

	// Laag_2
	this.instance = new lib.DialogNPCTextFieldBG1();
	this.instance.setTransform(-330,-34);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NpcTextPanel, new cjs.Rectangle(-330,-34,780,313), null);


(lib.NPCLabelPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.textField = new cjs.Text("Name NPCCCCC", "bold 22px 'Open Sans'", "#609DB0");
	this.textField.name = "textField";
	this.textField.lineHeight = 36;
	this.textField.lineWidth = 529;
	this.textField.parent = this;
	this.textField.setTransform(-67.5,-9.85);
ranj.TextOffsetFixer.fix(this.textField);

	this.timeline.addTween(cjs.Tween.get(this.textField).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NPCLabelPanel, new cjs.Rectangle(-69.5,-11.8,532.8,35.7), null);


(lib.DecisionScreenBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiWAhUXMEsBAAAMAAACovMksBAAAg");
	this.shape.setTransform(0.0004,0,0.9999,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#EEEAE6").s().p("EiWABUYMAAAiovMEsBAAAMAAACovg");
	this.shape_1.setTransform(0.0004,0,0.9999,1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DecisionScreenBackground, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.DecisionScreenBackgroun = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiWAhUXMEsBAAAMAAACovMksBAAAg");
	this.shape.setTransform(0.0004,0,0.9999,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#EEEAE6").s().p("EiWABUYMAAAiovMEsBAAAMAAACovg");
	this.shape_1.setTransform(0.0004,0,0.9999,1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DecisionScreenBackgroun, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.UnderlineMC = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFF8E0").s().p("EgmCAFKIAAqTMBMFAAAIAAKTg");
	this.shape.setTransform(244.5,34);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.UnderlineMC, new cjs.Rectangle(1,1,487,66), null);


(lib.newIndicator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.NewTopicIcon();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.newIndicator, new cjs.Rectangle(0,0,55,36), null);


(lib.AnswerTimer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// flash0_ai
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape.setTransform(120.45,23.95,0.962,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_1.setTransform(105.7,23.95,0.962,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_2.setTransform(828.85,23.95,0.962,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_3.setTransform(814.124,23.95,0.962,1);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_4.setTransform(799.35,23.95,0.962,1);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_5.setTransform(784.6,23.95,0.962,1);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_6.setTransform(769.874,23.95,0.962,1);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_7.setTransform(755.1,23.95,0.962,1);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_8.setTransform(740.374,23.95,0.962,1);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_9.setTransform(725.624,23.95,0.962,1);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_10.setTransform(710.85,23.95,0.962,1);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_11.setTransform(696.124,23.95,0.962,1);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_12.setTransform(681.374,23.95,0.962,1);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_13.setTransform(666.6,23.95,0.962,1);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_14.setTransform(651.85,23.95,0.962,1);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_15.setTransform(637.1,23.95,0.962,1);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_16.setTransform(622.324,23.95,0.962,1);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_17.setTransform(607.6,23.95,0.962,1);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_18.setTransform(592.8,23.95,0.962,1);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_19.setTransform(578.1,23.95,0.962,1);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_20.setTransform(563.35,23.95,0.962,1);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_21.setTransform(548.574,23.95,0.962,1);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_22.setTransform(533.85,23.95,0.962,1);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_23.setTransform(519.1,23.95,0.962,1);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_24.setTransform(504.324,23.95,0.962,1);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_25.setTransform(489.574,23.95,0.962,1);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_26.setTransform(474.85,23.95,0.962,1);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_27.setTransform(460.05,23.95,0.962,1);

	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_28.setTransform(445.324,23.95,0.962,1);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_29.setTransform(430.574,23.95,0.962,1);

	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_30.setTransform(415.8,23.95,0.962,1);

	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_31.setTransform(401.1,23.95,0.962,1);

	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_32.setTransform(386.3,23.95,0.962,1);

	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_33.setTransform(371.574,23.95,0.962,1);

	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_34.setTransform(356.824,23.95,0.962,1);

	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_35.setTransform(342.05,23.95,0.962,1);

	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_36.setTransform(327.3,23.95,0.962,1);

	this.shape_37 = new cjs.Shape();
	this.shape_37.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_37.setTransform(312.574,23.95,0.962,1);

	this.shape_38 = new cjs.Shape();
	this.shape_38.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_38.setTransform(297.774,23.95,0.962,1);

	this.shape_39 = new cjs.Shape();
	this.shape_39.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_39.setTransform(283.05,23.95,0.962,1);

	this.shape_40 = new cjs.Shape();
	this.shape_40.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_40.setTransform(268.324,23.95,0.962,1);

	this.shape_41 = new cjs.Shape();
	this.shape_41.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_41.setTransform(253.524,23.95,0.962,1);

	this.shape_42 = new cjs.Shape();
	this.shape_42.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_42.setTransform(238.8,23.95,0.962,1);

	this.shape_43 = new cjs.Shape();
	this.shape_43.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_43.setTransform(224.074,23.95,0.962,1);

	this.shape_44 = new cjs.Shape();
	this.shape_44.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_44.setTransform(209.3,23.95,0.962,1);

	this.shape_45 = new cjs.Shape();
	this.shape_45.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_45.setTransform(194.55,23.95,0.962,1);

	this.shape_46 = new cjs.Shape();
	this.shape_46.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_46.setTransform(179.824,23.95,0.962,1);

	this.shape_47 = new cjs.Shape();
	this.shape_47.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_47.setTransform(165.05,23.95,0.962,1);

	this.shape_48 = new cjs.Shape();
	this.shape_48.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_48.setTransform(150.3,23.95,0.962,1);

	this.shape_49 = new cjs.Shape();
	this.shape_49.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_49.setTransform(135.55,23.95,0.962,1);

	this.shape_50 = new cjs.Shape();
	this.shape_50.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_50.setTransform(828.85,23.95,0.962,1);

	this.shape_51 = new cjs.Shape();
	this.shape_51.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_51.setTransform(814.124,23.95,0.962,1);

	this.shape_52 = new cjs.Shape();
	this.shape_52.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_52.setTransform(799.35,23.95,0.962,1);

	this.shape_53 = new cjs.Shape();
	this.shape_53.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_53.setTransform(784.6,23.95,0.962,1);

	this.shape_54 = new cjs.Shape();
	this.shape_54.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_54.setTransform(769.874,23.95,0.962,1);

	this.shape_55 = new cjs.Shape();
	this.shape_55.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_55.setTransform(755.1,23.95,0.962,1);

	this.shape_56 = new cjs.Shape();
	this.shape_56.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_56.setTransform(740.374,23.95,0.962,1);

	this.shape_57 = new cjs.Shape();
	this.shape_57.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_57.setTransform(725.624,23.95,0.962,1);

	this.shape_58 = new cjs.Shape();
	this.shape_58.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_58.setTransform(710.85,23.95,0.962,1);

	this.shape_59 = new cjs.Shape();
	this.shape_59.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_59.setTransform(696.124,23.95,0.962,1);

	this.shape_60 = new cjs.Shape();
	this.shape_60.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_60.setTransform(681.374,23.95,0.962,1);

	this.shape_61 = new cjs.Shape();
	this.shape_61.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_61.setTransform(666.6,23.95,0.962,1);

	this.shape_62 = new cjs.Shape();
	this.shape_62.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_62.setTransform(651.85,23.95,0.962,1);

	this.shape_63 = new cjs.Shape();
	this.shape_63.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_63.setTransform(637.1,23.95,0.962,1);

	this.shape_64 = new cjs.Shape();
	this.shape_64.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_64.setTransform(622.324,23.95,0.962,1);

	this.shape_65 = new cjs.Shape();
	this.shape_65.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_65.setTransform(607.6,23.95,0.962,1);

	this.shape_66 = new cjs.Shape();
	this.shape_66.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_66.setTransform(592.8,23.95,0.962,1);

	this.shape_67 = new cjs.Shape();
	this.shape_67.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_67.setTransform(578.1,23.95,0.962,1);

	this.shape_68 = new cjs.Shape();
	this.shape_68.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_68.setTransform(563.35,23.95,0.962,1);

	this.shape_69 = new cjs.Shape();
	this.shape_69.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_69.setTransform(548.574,23.95,0.962,1);

	this.shape_70 = new cjs.Shape();
	this.shape_70.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_70.setTransform(533.85,23.95,0.962,1);

	this.shape_71 = new cjs.Shape();
	this.shape_71.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_71.setTransform(519.1,23.95,0.962,1);

	this.shape_72 = new cjs.Shape();
	this.shape_72.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_72.setTransform(504.324,23.95,0.962,1);

	this.shape_73 = new cjs.Shape();
	this.shape_73.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_73.setTransform(489.574,23.95,0.962,1);

	this.shape_74 = new cjs.Shape();
	this.shape_74.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_74.setTransform(474.85,23.95,0.962,1);

	this.shape_75 = new cjs.Shape();
	this.shape_75.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_75.setTransform(460.05,23.95,0.962,1);

	this.shape_76 = new cjs.Shape();
	this.shape_76.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_76.setTransform(445.324,23.95,0.962,1);

	this.shape_77 = new cjs.Shape();
	this.shape_77.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_77.setTransform(430.574,23.95,0.962,1);

	this.shape_78 = new cjs.Shape();
	this.shape_78.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_78.setTransform(415.8,23.95,0.962,1);

	this.shape_79 = new cjs.Shape();
	this.shape_79.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_79.setTransform(401.1,23.95,0.962,1);

	this.shape_80 = new cjs.Shape();
	this.shape_80.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_80.setTransform(386.3,23.95,0.962,1);

	this.shape_81 = new cjs.Shape();
	this.shape_81.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_81.setTransform(371.574,23.95,0.962,1);

	this.shape_82 = new cjs.Shape();
	this.shape_82.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_82.setTransform(356.824,23.95,0.962,1);

	this.shape_83 = new cjs.Shape();
	this.shape_83.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_83.setTransform(342.05,23.95,0.962,1);

	this.shape_84 = new cjs.Shape();
	this.shape_84.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_84.setTransform(327.3,23.95,0.962,1);

	this.shape_85 = new cjs.Shape();
	this.shape_85.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_85.setTransform(312.574,23.95,0.962,1);

	this.shape_86 = new cjs.Shape();
	this.shape_86.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_86.setTransform(297.774,23.95,0.962,1);

	this.shape_87 = new cjs.Shape();
	this.shape_87.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_87.setTransform(283.05,23.95,0.962,1);

	this.shape_88 = new cjs.Shape();
	this.shape_88.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_88.setTransform(268.324,23.95,0.962,1);

	this.shape_89 = new cjs.Shape();
	this.shape_89.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_89.setTransform(253.524,23.95,0.962,1);

	this.shape_90 = new cjs.Shape();
	this.shape_90.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_90.setTransform(238.8,23.95,0.962,1);

	this.shape_91 = new cjs.Shape();
	this.shape_91.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_91.setTransform(224.074,23.95,0.962,1);

	this.shape_92 = new cjs.Shape();
	this.shape_92.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_92.setTransform(209.3,23.95,0.962,1);

	this.shape_93 = new cjs.Shape();
	this.shape_93.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_93.setTransform(194.55,23.95,0.962,1);

	this.shape_94 = new cjs.Shape();
	this.shape_94.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_94.setTransform(179.824,23.95,0.962,1);

	this.shape_95 = new cjs.Shape();
	this.shape_95.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_95.setTransform(165.05,23.95,0.962,1);

	this.shape_96 = new cjs.Shape();
	this.shape_96.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_96.setTransform(150.3,23.95,0.962,1);

	this.shape_97 = new cjs.Shape();
	this.shape_97.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_97.setTransform(135.55,23.95,0.962,1);

	this.shape_98 = new cjs.Shape();
	this.shape_98.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_98.setTransform(135.55,23.95,0.962,1);

	this.shape_99 = new cjs.Shape();
	this.shape_99.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_99.setTransform(135.55,23.95,0.962,1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_49},{t:this.shape_48,p:{x:150.3}},{t:this.shape_47,p:{x:165.05}},{t:this.shape_46},{t:this.shape_45,p:{x:194.55}},{t:this.shape_44,p:{x:209.3}},{t:this.shape_43,p:{x:224.074}},{t:this.shape_42,p:{x:238.8}},{t:this.shape_41,p:{x:253.524}},{t:this.shape_40,p:{x:268.324}},{t:this.shape_39,p:{x:283.05}},{t:this.shape_38,p:{x:297.774}},{t:this.shape_37,p:{x:312.574}},{t:this.shape_36,p:{x:327.3}},{t:this.shape_35,p:{x:342.05}},{t:this.shape_34,p:{x:356.824}},{t:this.shape_33,p:{x:371.574}},{t:this.shape_32,p:{x:386.3}},{t:this.shape_31,p:{x:401.1}},{t:this.shape_30,p:{x:415.8}},{t:this.shape_29,p:{x:430.574}},{t:this.shape_28,p:{x:445.324}},{t:this.shape_27,p:{x:460.05}},{t:this.shape_26,p:{x:474.85}},{t:this.shape_25,p:{x:489.574}},{t:this.shape_24,p:{x:504.324}},{t:this.shape_23,p:{x:519.1}},{t:this.shape_22,p:{x:533.85}},{t:this.shape_21,p:{x:548.574}},{t:this.shape_20,p:{x:563.35}},{t:this.shape_19,p:{x:578.1}},{t:this.shape_18,p:{x:592.8}},{t:this.shape_17,p:{x:607.6}},{t:this.shape_16,p:{x:622.324}},{t:this.shape_15,p:{x:637.1}},{t:this.shape_14,p:{x:651.85}},{t:this.shape_13,p:{x:666.6}},{t:this.shape_12,p:{x:681.374}},{t:this.shape_11,p:{x:696.124}},{t:this.shape_10,p:{x:710.85}},{t:this.shape_9,p:{x:725.624}},{t:this.shape_8,p:{x:740.374}},{t:this.shape_7,p:{x:755.1}},{t:this.shape_6,p:{x:769.874}},{t:this.shape_5,p:{x:784.6}},{t:this.shape_4,p:{x:799.35}},{t:this.shape_3,p:{x:814.124}},{t:this.shape_2,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]}).to({state:[{t:this.shape_48,p:{x:135.55}},{t:this.shape_47,p:{x:150.3}},{t:this.shape_45,p:{x:165.05}},{t:this.shape_46},{t:this.shape_44,p:{x:194.55}},{t:this.shape_42,p:{x:209.3}},{t:this.shape_43,p:{x:224.074}},{t:this.shape_39,p:{x:238.8}},{t:this.shape_41,p:{x:253.524}},{t:this.shape_40,p:{x:268.324}},{t:this.shape_36,p:{x:283.05}},{t:this.shape_38,p:{x:297.774}},{t:this.shape_37,p:{x:312.574}},{t:this.shape_35,p:{x:327.3}},{t:this.shape_32,p:{x:342.05}},{t:this.shape_34,p:{x:356.824}},{t:this.shape_33,p:{x:371.574}},{t:this.shape_31,p:{x:386.3}},{t:this.shape_30,p:{x:401.1}},{t:this.shape_27,p:{x:415.8}},{t:this.shape_29,p:{x:430.574}},{t:this.shape_28,p:{x:445.324}},{t:this.shape_26,p:{x:460.05}},{t:this.shape_23,p:{x:474.85}},{t:this.shape_25,p:{x:489.574}},{t:this.shape_24,p:{x:504.324}},{t:this.shape_22,p:{x:519.1}},{t:this.shape_20,p:{x:533.85}},{t:this.shape_21,p:{x:548.574}},{t:this.shape_19,p:{x:563.35}},{t:this.shape_18,p:{x:578.1}},{t:this.shape_17,p:{x:592.8}},{t:this.shape_15,p:{x:607.6}},{t:this.shape_16,p:{x:622.324}},{t:this.shape_14,p:{x:637.1}},{t:this.shape_13,p:{x:651.85}},{t:this.shape_10,p:{x:666.6}},{t:this.shape_12,p:{x:681.374}},{t:this.shape_11,p:{x:696.124}},{t:this.shape_7,p:{x:710.85}},{t:this.shape_9,p:{x:725.624}},{t:this.shape_8,p:{x:740.374}},{t:this.shape_5,p:{x:755.1}},{t:this.shape_6,p:{x:769.874}},{t:this.shape_4,p:{x:784.6}},{t:this.shape_2,p:{x:799.35}},{t:this.shape_3,p:{x:814.124}},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_48,p:{x:135.55}},{t:this.shape_47,p:{x:150.3}},{t:this.shape_45,p:{x:165.05}},{t:this.shape_43,p:{x:179.824}},{t:this.shape_44,p:{x:194.55}},{t:this.shape_42,p:{x:209.3}},{t:this.shape_41,p:{x:224.074}},{t:this.shape_39,p:{x:238.8}},{t:this.shape_40,p:{x:253.524}},{t:this.shape_38,p:{x:268.324}},{t:this.shape_36,p:{x:283.05}},{t:this.shape_37,p:{x:297.774}},{t:this.shape_34,p:{x:312.574}},{t:this.shape_35,p:{x:327.3}},{t:this.shape_32,p:{x:342.05}},{t:this.shape_33,p:{x:356.824}},{t:this.shape_29,p:{x:371.574}},{t:this.shape_31,p:{x:386.3}},{t:this.shape_30,p:{x:401.1}},{t:this.shape_27,p:{x:415.8}},{t:this.shape_28,p:{x:430.574}},{t:this.shape_25,p:{x:445.324}},{t:this.shape_26,p:{x:460.05}},{t:this.shape_23,p:{x:474.85}},{t:this.shape_24,p:{x:489.574}},{t:this.shape_21,p:{x:504.324}},{t:this.shape_22,p:{x:519.1}},{t:this.shape_20,p:{x:533.85}},{t:this.shape_16,p:{x:548.574}},{t:this.shape_19,p:{x:563.35}},{t:this.shape_18,p:{x:578.1}},{t:this.shape_17,p:{x:592.8}},{t:this.shape_15,p:{x:607.6}},{t:this.shape_12,p:{x:622.324}},{t:this.shape_14,p:{x:637.1}},{t:this.shape_13,p:{x:651.85}},{t:this.shape_10,p:{x:666.6}},{t:this.shape_11,p:{x:681.374}},{t:this.shape_9,p:{x:696.124}},{t:this.shape_7,p:{x:710.85}},{t:this.shape_8,p:{x:725.624}},{t:this.shape_6,p:{x:740.374}},{t:this.shape_5,p:{x:755.1}},{t:this.shape_3,p:{x:769.874}},{t:this.shape_4,p:{x:784.6}},{t:this.shape_2,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_47,p:{x:135.55}},{t:this.shape_45,p:{x:150.3}},{t:this.shape_44,p:{x:165.05}},{t:this.shape_43,p:{x:179.824}},{t:this.shape_42,p:{x:194.55}},{t:this.shape_39,p:{x:209.3}},{t:this.shape_41,p:{x:224.074}},{t:this.shape_36,p:{x:238.8}},{t:this.shape_40,p:{x:253.524}},{t:this.shape_38,p:{x:268.324}},{t:this.shape_35,p:{x:283.05}},{t:this.shape_37,p:{x:297.774}},{t:this.shape_34,p:{x:312.574}},{t:this.shape_32,p:{x:327.3}},{t:this.shape_31,p:{x:342.05}},{t:this.shape_33,p:{x:356.824}},{t:this.shape_29,p:{x:371.574}},{t:this.shape_30,p:{x:386.3}},{t:this.shape_27,p:{x:401.1}},{t:this.shape_26,p:{x:415.8}},{t:this.shape_28,p:{x:430.574}},{t:this.shape_25,p:{x:445.324}},{t:this.shape_23,p:{x:460.05}},{t:this.shape_22,p:{x:474.85}},{t:this.shape_24,p:{x:489.574}},{t:this.shape_21,p:{x:504.324}},{t:this.shape_20,p:{x:519.1}},{t:this.shape_19,p:{x:533.85}},{t:this.shape_16,p:{x:548.574}},{t:this.shape_18,p:{x:563.35}},{t:this.shape_17,p:{x:578.1}},{t:this.shape_15,p:{x:592.8}},{t:this.shape_14,p:{x:607.6}},{t:this.shape_12,p:{x:622.324}},{t:this.shape_13,p:{x:637.1}},{t:this.shape_10,p:{x:651.85}},{t:this.shape_7,p:{x:666.6}},{t:this.shape_11,p:{x:681.374}},{t:this.shape_9,p:{x:696.124}},{t:this.shape_5,p:{x:710.85}},{t:this.shape_8,p:{x:725.624}},{t:this.shape_6,p:{x:740.374}},{t:this.shape_4,p:{x:755.1}},{t:this.shape_3,p:{x:769.874}},{t:this.shape_2,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_45,p:{x:135.55}},{t:this.shape_44,p:{x:150.3}},{t:this.shape_42,p:{x:165.05}},{t:this.shape_43,p:{x:179.824}},{t:this.shape_39,p:{x:194.55}},{t:this.shape_36,p:{x:209.3}},{t:this.shape_41,p:{x:224.074}},{t:this.shape_35,p:{x:238.8}},{t:this.shape_40,p:{x:253.524}},{t:this.shape_38,p:{x:268.324}},{t:this.shape_32,p:{x:283.05}},{t:this.shape_37,p:{x:297.774}},{t:this.shape_34,p:{x:312.574}},{t:this.shape_31,p:{x:327.3}},{t:this.shape_30,p:{x:342.05}},{t:this.shape_33,p:{x:356.824}},{t:this.shape_29,p:{x:371.574}},{t:this.shape_27,p:{x:386.3}},{t:this.shape_26,p:{x:401.1}},{t:this.shape_23,p:{x:415.8}},{t:this.shape_28,p:{x:430.574}},{t:this.shape_25,p:{x:445.324}},{t:this.shape_22,p:{x:460.05}},{t:this.shape_20,p:{x:474.85}},{t:this.shape_24,p:{x:489.574}},{t:this.shape_21,p:{x:504.324}},{t:this.shape_19,p:{x:519.1}},{t:this.shape_18,p:{x:533.85}},{t:this.shape_16,p:{x:548.574}},{t:this.shape_17,p:{x:563.35}},{t:this.shape_15,p:{x:578.1}},{t:this.shape_14,p:{x:592.8}},{t:this.shape_13,p:{x:607.6}},{t:this.shape_12,p:{x:622.324}},{t:this.shape_10,p:{x:637.1}},{t:this.shape_7,p:{x:651.85}},{t:this.shape_5,p:{x:666.6}},{t:this.shape_11,p:{x:681.374}},{t:this.shape_9,p:{x:696.124}},{t:this.shape_4,p:{x:710.85}},{t:this.shape_8,p:{x:725.624}},{t:this.shape_6,p:{x:740.374}},{t:this.shape_2,p:{x:755.1}},{t:this.shape_3,p:{x:769.874}},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_45,p:{x:135.55}},{t:this.shape_44,p:{x:150.3}},{t:this.shape_42,p:{x:165.05}},{t:this.shape_41,p:{x:179.824}},{t:this.shape_39,p:{x:194.55}},{t:this.shape_36,p:{x:209.3}},{t:this.shape_40,p:{x:224.074}},{t:this.shape_35,p:{x:238.8}},{t:this.shape_38,p:{x:253.524}},{t:this.shape_37,p:{x:268.324}},{t:this.shape_32,p:{x:283.05}},{t:this.shape_34,p:{x:297.774}},{t:this.shape_33,p:{x:312.574}},{t:this.shape_31,p:{x:327.3}},{t:this.shape_30,p:{x:342.05}},{t:this.shape_29,p:{x:356.824}},{t:this.shape_28,p:{x:371.574}},{t:this.shape_27,p:{x:386.3}},{t:this.shape_26,p:{x:401.1}},{t:this.shape_23,p:{x:415.8}},{t:this.shape_25,p:{x:430.574}},{t:this.shape_24,p:{x:445.324}},{t:this.shape_22,p:{x:460.05}},{t:this.shape_20,p:{x:474.85}},{t:this.shape_21,p:{x:489.574}},{t:this.shape_16,p:{x:504.324}},{t:this.shape_19,p:{x:519.1}},{t:this.shape_18,p:{x:533.85}},{t:this.shape_12,p:{x:548.574}},{t:this.shape_17,p:{x:563.35}},{t:this.shape_15,p:{x:578.1}},{t:this.shape_14,p:{x:592.8}},{t:this.shape_13,p:{x:607.6}},{t:this.shape_11,p:{x:622.324}},{t:this.shape_10,p:{x:637.1}},{t:this.shape_7,p:{x:651.85}},{t:this.shape_5,p:{x:666.6}},{t:this.shape_9,p:{x:681.374}},{t:this.shape_8,p:{x:696.124}},{t:this.shape_4,p:{x:710.85}},{t:this.shape_6,p:{x:725.624}},{t:this.shape_3,p:{x:740.374}},{t:this.shape_2,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_44,p:{x:135.55}},{t:this.shape_42,p:{x:150.3}},{t:this.shape_39,p:{x:165.05}},{t:this.shape_41,p:{x:179.824}},{t:this.shape_36,p:{x:194.55}},{t:this.shape_35,p:{x:209.3}},{t:this.shape_40,p:{x:224.074}},{t:this.shape_32,p:{x:238.8}},{t:this.shape_38,p:{x:253.524}},{t:this.shape_37,p:{x:268.324}},{t:this.shape_31,p:{x:283.05}},{t:this.shape_34,p:{x:297.774}},{t:this.shape_33,p:{x:312.574}},{t:this.shape_30,p:{x:327.3}},{t:this.shape_27,p:{x:342.05}},{t:this.shape_29,p:{x:356.824}},{t:this.shape_28,p:{x:371.574}},{t:this.shape_26,p:{x:386.3}},{t:this.shape_23,p:{x:401.1}},{t:this.shape_22,p:{x:415.8}},{t:this.shape_25,p:{x:430.574}},{t:this.shape_24,p:{x:445.324}},{t:this.shape_20,p:{x:460.05}},{t:this.shape_19,p:{x:474.85}},{t:this.shape_21,p:{x:489.574}},{t:this.shape_16,p:{x:504.324}},{t:this.shape_18,p:{x:519.1}},{t:this.shape_17,p:{x:533.85}},{t:this.shape_12,p:{x:548.574}},{t:this.shape_15,p:{x:563.35}},{t:this.shape_14,p:{x:578.1}},{t:this.shape_13,p:{x:592.8}},{t:this.shape_10,p:{x:607.6}},{t:this.shape_11,p:{x:622.324}},{t:this.shape_7,p:{x:637.1}},{t:this.shape_5,p:{x:651.85}},{t:this.shape_4,p:{x:666.6}},{t:this.shape_9,p:{x:681.374}},{t:this.shape_8,p:{x:696.124}},{t:this.shape_2,p:{x:710.85}},{t:this.shape_6,p:{x:725.624}},{t:this.shape_3,p:{x:740.374}},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_44,p:{x:135.55}},{t:this.shape_42,p:{x:150.3}},{t:this.shape_39,p:{x:165.05}},{t:this.shape_40,p:{x:179.824}},{t:this.shape_36,p:{x:194.55}},{t:this.shape_35,p:{x:209.3}},{t:this.shape_38,p:{x:224.074}},{t:this.shape_32,p:{x:238.8}},{t:this.shape_37,p:{x:253.524}},{t:this.shape_34,p:{x:268.324}},{t:this.shape_31,p:{x:283.05}},{t:this.shape_33,p:{x:297.774}},{t:this.shape_29,p:{x:312.574}},{t:this.shape_30,p:{x:327.3}},{t:this.shape_27,p:{x:342.05}},{t:this.shape_28,p:{x:356.824}},{t:this.shape_25,p:{x:371.574}},{t:this.shape_26,p:{x:386.3}},{t:this.shape_23,p:{x:401.1}},{t:this.shape_22,p:{x:415.8}},{t:this.shape_24,p:{x:430.574}},{t:this.shape_21,p:{x:445.324}},{t:this.shape_20,p:{x:460.05}},{t:this.shape_19,p:{x:474.85}},{t:this.shape_16,p:{x:489.574}},{t:this.shape_12,p:{x:504.324}},{t:this.shape_18,p:{x:519.1}},{t:this.shape_17,p:{x:533.85}},{t:this.shape_11,p:{x:548.574}},{t:this.shape_15,p:{x:563.35}},{t:this.shape_14,p:{x:578.1}},{t:this.shape_13,p:{x:592.8}},{t:this.shape_10,p:{x:607.6}},{t:this.shape_9,p:{x:622.324}},{t:this.shape_7,p:{x:637.1}},{t:this.shape_5,p:{x:651.85}},{t:this.shape_4,p:{x:666.6}},{t:this.shape_8,p:{x:681.374}},{t:this.shape_6,p:{x:696.124}},{t:this.shape_2,p:{x:710.85}},{t:this.shape_3,p:{x:725.624}},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_44,p:{x:135.55}},{t:this.shape_42,p:{x:150.3}},{t:this.shape_39,p:{x:165.05}},{t:this.shape_38,p:{x:179.824}},{t:this.shape_36,p:{x:194.55}},{t:this.shape_35,p:{x:209.3}},{t:this.shape_37,p:{x:224.074}},{t:this.shape_32,p:{x:238.8}},{t:this.shape_34,p:{x:253.524}},{t:this.shape_33,p:{x:268.324}},{t:this.shape_31,p:{x:283.05}},{t:this.shape_29,p:{x:297.774}},{t:this.shape_28,p:{x:312.574}},{t:this.shape_30,p:{x:327.3}},{t:this.shape_27,p:{x:342.05}},{t:this.shape_25,p:{x:356.824}},{t:this.shape_24,p:{x:371.574}},{t:this.shape_26,p:{x:386.3}},{t:this.shape_23,p:{x:401.1}},{t:this.shape_22,p:{x:415.8}},{t:this.shape_21,p:{x:430.574}},{t:this.shape_16,p:{x:445.324}},{t:this.shape_20,p:{x:460.05}},{t:this.shape_19,p:{x:474.85}},{t:this.shape_12,p:{x:489.574}},{t:this.shape_11,p:{x:504.324}},{t:this.shape_18,p:{x:519.1}},{t:this.shape_17,p:{x:533.85}},{t:this.shape_9,p:{x:548.574}},{t:this.shape_15,p:{x:563.35}},{t:this.shape_14,p:{x:578.1}},{t:this.shape_13,p:{x:592.8}},{t:this.shape_10,p:{x:607.6}},{t:this.shape_8,p:{x:622.324}},{t:this.shape_7,p:{x:637.1}},{t:this.shape_5,p:{x:651.85}},{t:this.shape_4,p:{x:666.6}},{t:this.shape_6,p:{x:681.374}},{t:this.shape_3,p:{x:696.124}},{t:this.shape_2,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_42,p:{x:135.55}},{t:this.shape_39,p:{x:150.3}},{t:this.shape_36,p:{x:165.05}},{t:this.shape_38,p:{x:179.824}},{t:this.shape_35,p:{x:194.55}},{t:this.shape_32,p:{x:209.3}},{t:this.shape_37,p:{x:224.074}},{t:this.shape_31,p:{x:238.8}},{t:this.shape_34,p:{x:253.524}},{t:this.shape_33,p:{x:268.324}},{t:this.shape_30,p:{x:283.05}},{t:this.shape_29,p:{x:297.774}},{t:this.shape_28,p:{x:312.574}},{t:this.shape_27,p:{x:327.3}},{t:this.shape_26,p:{x:342.05}},{t:this.shape_25,p:{x:356.824}},{t:this.shape_24,p:{x:371.574}},{t:this.shape_23,p:{x:386.3}},{t:this.shape_22,p:{x:401.1}},{t:this.shape_20,p:{x:415.8}},{t:this.shape_21,p:{x:430.574}},{t:this.shape_16,p:{x:445.324}},{t:this.shape_19,p:{x:460.05}},{t:this.shape_18,p:{x:474.85}},{t:this.shape_12,p:{x:489.574}},{t:this.shape_11,p:{x:504.324}},{t:this.shape_17,p:{x:519.1}},{t:this.shape_15,p:{x:533.85}},{t:this.shape_9,p:{x:548.574}},{t:this.shape_14,p:{x:563.35}},{t:this.shape_13,p:{x:578.1}},{t:this.shape_10,p:{x:592.8}},{t:this.shape_7,p:{x:607.6}},{t:this.shape_8,p:{x:622.324}},{t:this.shape_5,p:{x:637.1}},{t:this.shape_4,p:{x:651.85}},{t:this.shape_2,p:{x:666.6}},{t:this.shape_6,p:{x:681.374}},{t:this.shape_3,p:{x:696.124}},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_42,p:{x:135.55}},{t:this.shape_39,p:{x:150.3}},{t:this.shape_36,p:{x:165.05}},{t:this.shape_37,p:{x:179.824}},{t:this.shape_35,p:{x:194.55}},{t:this.shape_32,p:{x:209.3}},{t:this.shape_34,p:{x:224.074}},{t:this.shape_31,p:{x:238.8}},{t:this.shape_33,p:{x:253.524}},{t:this.shape_29,p:{x:268.324}},{t:this.shape_30,p:{x:283.05}},{t:this.shape_28,p:{x:297.774}},{t:this.shape_25,p:{x:312.574}},{t:this.shape_27,p:{x:327.3}},{t:this.shape_26,p:{x:342.05}},{t:this.shape_24,p:{x:356.824}},{t:this.shape_21,p:{x:371.574}},{t:this.shape_23,p:{x:386.3}},{t:this.shape_22,p:{x:401.1}},{t:this.shape_20,p:{x:415.8}},{t:this.shape_16,p:{x:430.574}},{t:this.shape_12,p:{x:445.324}},{t:this.shape_19,p:{x:460.05}},{t:this.shape_18,p:{x:474.85}},{t:this.shape_11,p:{x:489.574}},{t:this.shape_9,p:{x:504.324}},{t:this.shape_17,p:{x:519.1}},{t:this.shape_15,p:{x:533.85}},{t:this.shape_8,p:{x:548.574}},{t:this.shape_14,p:{x:563.35}},{t:this.shape_13,p:{x:578.1}},{t:this.shape_10,p:{x:592.8}},{t:this.shape_7,p:{x:607.6}},{t:this.shape_6,p:{x:622.324}},{t:this.shape_5,p:{x:637.1}},{t:this.shape_4,p:{x:651.85}},{t:this.shape_2,p:{x:666.6}},{t:this.shape_3,p:{x:681.374}},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_42,p:{x:135.55}},{t:this.shape_39,p:{x:150.3}},{t:this.shape_36,p:{x:165.05}},{t:this.shape_34,p:{x:179.824}},{t:this.shape_35,p:{x:194.55}},{t:this.shape_32,p:{x:209.3}},{t:this.shape_33,p:{x:224.074}},{t:this.shape_31,p:{x:238.8}},{t:this.shape_29,p:{x:253.524}},{t:this.shape_28,p:{x:268.324}},{t:this.shape_30,p:{x:283.05}},{t:this.shape_25,p:{x:297.774}},{t:this.shape_24,p:{x:312.574}},{t:this.shape_27,p:{x:327.3}},{t:this.shape_26,p:{x:342.05}},{t:this.shape_21,p:{x:356.824}},{t:this.shape_16,p:{x:371.574}},{t:this.shape_23,p:{x:386.3}},{t:this.shape_22,p:{x:401.1}},{t:this.shape_20,p:{x:415.8}},{t:this.shape_12,p:{x:430.574}},{t:this.shape_11,p:{x:445.324}},{t:this.shape_19,p:{x:460.05}},{t:this.shape_18,p:{x:474.85}},{t:this.shape_9,p:{x:489.574}},{t:this.shape_8,p:{x:504.324}},{t:this.shape_17,p:{x:519.1}},{t:this.shape_15,p:{x:533.85}},{t:this.shape_6,p:{x:548.574}},{t:this.shape_14,p:{x:563.35}},{t:this.shape_13,p:{x:578.1}},{t:this.shape_10,p:{x:592.8}},{t:this.shape_7,p:{x:607.6}},{t:this.shape_3,p:{x:622.324}},{t:this.shape_5,p:{x:637.1}},{t:this.shape_4,p:{x:651.85}},{t:this.shape_2,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_39,p:{x:135.55}},{t:this.shape_36,p:{x:150.3}},{t:this.shape_35,p:{x:165.05}},{t:this.shape_34,p:{x:179.824}},{t:this.shape_32,p:{x:194.55}},{t:this.shape_31,p:{x:209.3}},{t:this.shape_33,p:{x:224.074}},{t:this.shape_30,p:{x:238.8}},{t:this.shape_29,p:{x:253.524}},{t:this.shape_28,p:{x:268.324}},{t:this.shape_27,p:{x:283.05}},{t:this.shape_25,p:{x:297.774}},{t:this.shape_24,p:{x:312.574}},{t:this.shape_26,p:{x:327.3}},{t:this.shape_23,p:{x:342.05}},{t:this.shape_21,p:{x:356.824}},{t:this.shape_16,p:{x:371.574}},{t:this.shape_22,p:{x:386.3}},{t:this.shape_20,p:{x:401.1}},{t:this.shape_19,p:{x:415.8}},{t:this.shape_12,p:{x:430.574}},{t:this.shape_11,p:{x:445.324}},{t:this.shape_18,p:{x:460.05}},{t:this.shape_17,p:{x:474.85}},{t:this.shape_9,p:{x:489.574}},{t:this.shape_8,p:{x:504.324}},{t:this.shape_15,p:{x:519.1}},{t:this.shape_14,p:{x:533.85}},{t:this.shape_6,p:{x:548.574}},{t:this.shape_13,p:{x:563.35}},{t:this.shape_10,p:{x:578.1}},{t:this.shape_7,p:{x:592.8}},{t:this.shape_5,p:{x:607.6}},{t:this.shape_3,p:{x:622.324}},{t:this.shape_4,p:{x:637.1}},{t:this.shape_2,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_36,p:{x:135.55}},{t:this.shape_35,p:{x:150.3}},{t:this.shape_32,p:{x:165.05}},{t:this.shape_34,p:{x:179.824}},{t:this.shape_31,p:{x:194.55}},{t:this.shape_30,p:{x:209.3}},{t:this.shape_33,p:{x:224.074}},{t:this.shape_27,p:{x:238.8}},{t:this.shape_29,p:{x:253.524}},{t:this.shape_28,p:{x:268.324}},{t:this.shape_26,p:{x:283.05}},{t:this.shape_25,p:{x:297.774}},{t:this.shape_24,p:{x:312.574}},{t:this.shape_23,p:{x:327.3}},{t:this.shape_22,p:{x:342.05}},{t:this.shape_21,p:{x:356.824}},{t:this.shape_16,p:{x:371.574}},{t:this.shape_20,p:{x:386.3}},{t:this.shape_19,p:{x:401.1}},{t:this.shape_18,p:{x:415.8}},{t:this.shape_12,p:{x:430.574}},{t:this.shape_11,p:{x:445.324}},{t:this.shape_17,p:{x:460.05}},{t:this.shape_15,p:{x:474.85}},{t:this.shape_9,p:{x:489.574}},{t:this.shape_8,p:{x:504.324}},{t:this.shape_14,p:{x:519.1}},{t:this.shape_13,p:{x:533.85}},{t:this.shape_6,p:{x:548.574}},{t:this.shape_10,p:{x:563.35}},{t:this.shape_7,p:{x:578.1}},{t:this.shape_5,p:{x:592.8}},{t:this.shape_4,p:{x:607.6}},{t:this.shape_3,p:{x:622.324}},{t:this.shape_2,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_35,p:{x:135.55}},{t:this.shape_32,p:{x:150.3}},{t:this.shape_31,p:{x:165.05}},{t:this.shape_34,p:{x:179.824}},{t:this.shape_30,p:{x:194.55}},{t:this.shape_27,p:{x:209.3}},{t:this.shape_33,p:{x:224.074}},{t:this.shape_26,p:{x:238.8}},{t:this.shape_29,p:{x:253.524}},{t:this.shape_28,p:{x:268.324}},{t:this.shape_23,p:{x:283.05}},{t:this.shape_25,p:{x:297.774}},{t:this.shape_24,p:{x:312.574}},{t:this.shape_22,p:{x:327.3}},{t:this.shape_20,p:{x:342.05}},{t:this.shape_21,p:{x:356.824}},{t:this.shape_16,p:{x:371.574}},{t:this.shape_19,p:{x:386.3}},{t:this.shape_18,p:{x:401.1}},{t:this.shape_17,p:{x:415.8}},{t:this.shape_12,p:{x:430.574}},{t:this.shape_11,p:{x:445.324}},{t:this.shape_15,p:{x:460.05}},{t:this.shape_14,p:{x:474.85}},{t:this.shape_9,p:{x:489.574}},{t:this.shape_8,p:{x:504.324}},{t:this.shape_13,p:{x:519.1}},{t:this.shape_10,p:{x:533.85}},{t:this.shape_6,p:{x:548.574}},{t:this.shape_7,p:{x:563.35}},{t:this.shape_5,p:{x:578.1}},{t:this.shape_4,p:{x:592.8}},{t:this.shape_2,p:{x:607.6}},{t:this.shape_3,p:{x:622.324}},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_35,p:{x:135.55}},{t:this.shape_32,p:{x:150.3}},{t:this.shape_31,p:{x:165.05}},{t:this.shape_33,p:{x:179.824}},{t:this.shape_30,p:{x:194.55}},{t:this.shape_27,p:{x:209.3}},{t:this.shape_29,p:{x:224.074}},{t:this.shape_26,p:{x:238.8}},{t:this.shape_28,p:{x:253.524}},{t:this.shape_25,p:{x:268.324}},{t:this.shape_23,p:{x:283.05}},{t:this.shape_24,p:{x:297.774}},{t:this.shape_21,p:{x:312.574}},{t:this.shape_22,p:{x:327.3}},{t:this.shape_20,p:{x:342.05}},{t:this.shape_16,p:{x:356.824}},{t:this.shape_12,p:{x:371.574}},{t:this.shape_19,p:{x:386.3}},{t:this.shape_18,p:{x:401.1}},{t:this.shape_17,p:{x:415.8}},{t:this.shape_11,p:{x:430.574}},{t:this.shape_9,p:{x:445.324}},{t:this.shape_15,p:{x:460.05}},{t:this.shape_14,p:{x:474.85}},{t:this.shape_8,p:{x:489.574}},{t:this.shape_6,p:{x:504.324}},{t:this.shape_13,p:{x:519.1}},{t:this.shape_10,p:{x:533.85}},{t:this.shape_3,p:{x:548.574}},{t:this.shape_7,p:{x:563.35}},{t:this.shape_5,p:{x:578.1}},{t:this.shape_4,p:{x:592.8}},{t:this.shape_2,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_32,p:{x:135.55}},{t:this.shape_31,p:{x:150.3}},{t:this.shape_30,p:{x:165.05}},{t:this.shape_33,p:{x:179.824}},{t:this.shape_27,p:{x:194.55}},{t:this.shape_26,p:{x:209.3}},{t:this.shape_29,p:{x:224.074}},{t:this.shape_23,p:{x:238.8}},{t:this.shape_28,p:{x:253.524}},{t:this.shape_25,p:{x:268.324}},{t:this.shape_22,p:{x:283.05}},{t:this.shape_24,p:{x:297.774}},{t:this.shape_21,p:{x:312.574}},{t:this.shape_20,p:{x:327.3}},{t:this.shape_19,p:{x:342.05}},{t:this.shape_16,p:{x:356.824}},{t:this.shape_12,p:{x:371.574}},{t:this.shape_18,p:{x:386.3}},{t:this.shape_17,p:{x:401.1}},{t:this.shape_15,p:{x:415.8}},{t:this.shape_11,p:{x:430.574}},{t:this.shape_9,p:{x:445.324}},{t:this.shape_14,p:{x:460.05}},{t:this.shape_13,p:{x:474.85}},{t:this.shape_8,p:{x:489.574}},{t:this.shape_6,p:{x:504.324}},{t:this.shape_10,p:{x:519.1}},{t:this.shape_7,p:{x:533.85}},{t:this.shape_3,p:{x:548.574}},{t:this.shape_5,p:{x:563.35}},{t:this.shape_4,p:{x:578.1}},{t:this.shape_2,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_31,p:{x:135.55}},{t:this.shape_30,p:{x:150.3}},{t:this.shape_27,p:{x:165.05}},{t:this.shape_33,p:{x:179.824}},{t:this.shape_26,p:{x:194.55}},{t:this.shape_23,p:{x:209.3}},{t:this.shape_29,p:{x:224.074}},{t:this.shape_22,p:{x:238.8}},{t:this.shape_28,p:{x:253.524}},{t:this.shape_25,p:{x:268.324}},{t:this.shape_20,p:{x:283.05}},{t:this.shape_24,p:{x:297.774}},{t:this.shape_21,p:{x:312.574}},{t:this.shape_19,p:{x:327.3}},{t:this.shape_18,p:{x:342.05}},{t:this.shape_16,p:{x:356.824}},{t:this.shape_12,p:{x:371.574}},{t:this.shape_17,p:{x:386.3}},{t:this.shape_15,p:{x:401.1}},{t:this.shape_14,p:{x:415.8}},{t:this.shape_11,p:{x:430.574}},{t:this.shape_9,p:{x:445.324}},{t:this.shape_13,p:{x:460.05}},{t:this.shape_10,p:{x:474.85}},{t:this.shape_8,p:{x:489.574}},{t:this.shape_6,p:{x:504.324}},{t:this.shape_7,p:{x:519.1}},{t:this.shape_5,p:{x:533.85}},{t:this.shape_3,p:{x:548.574}},{t:this.shape_4,p:{x:563.35}},{t:this.shape_2,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_30,p:{x:135.55}},{t:this.shape_27,p:{x:150.3}},{t:this.shape_26,p:{x:165.05}},{t:this.shape_33,p:{x:179.824}},{t:this.shape_23,p:{x:194.55}},{t:this.shape_22,p:{x:209.3}},{t:this.shape_29,p:{x:224.074}},{t:this.shape_20,p:{x:238.8}},{t:this.shape_28,p:{x:253.524}},{t:this.shape_25,p:{x:268.324}},{t:this.shape_19,p:{x:283.05}},{t:this.shape_24,p:{x:297.774}},{t:this.shape_21,p:{x:312.574}},{t:this.shape_18,p:{x:327.3}},{t:this.shape_17,p:{x:342.05}},{t:this.shape_16,p:{x:356.824}},{t:this.shape_12,p:{x:371.574}},{t:this.shape_15,p:{x:386.3}},{t:this.shape_14,p:{x:401.1}},{t:this.shape_13,p:{x:415.8}},{t:this.shape_11,p:{x:430.574}},{t:this.shape_9,p:{x:445.324}},{t:this.shape_10,p:{x:460.05}},{t:this.shape_7,p:{x:474.85}},{t:this.shape_8,p:{x:489.574}},{t:this.shape_6,p:{x:504.324}},{t:this.shape_5,p:{x:519.1}},{t:this.shape_4,p:{x:533.85}},{t:this.shape_3,p:{x:548.574}},{t:this.shape_2,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_27,p:{x:135.55}},{t:this.shape_26,p:{x:150.3}},{t:this.shape_23,p:{x:165.05}},{t:this.shape_33,p:{x:179.824}},{t:this.shape_22,p:{x:194.55}},{t:this.shape_20,p:{x:209.3}},{t:this.shape_29,p:{x:224.074}},{t:this.shape_19,p:{x:238.8}},{t:this.shape_28,p:{x:253.524}},{t:this.shape_25,p:{x:268.324}},{t:this.shape_18,p:{x:283.05}},{t:this.shape_24,p:{x:297.774}},{t:this.shape_21,p:{x:312.574}},{t:this.shape_17,p:{x:327.3}},{t:this.shape_15,p:{x:342.05}},{t:this.shape_16,p:{x:356.824}},{t:this.shape_12,p:{x:371.574}},{t:this.shape_14,p:{x:386.3}},{t:this.shape_13,p:{x:401.1}},{t:this.shape_10,p:{x:415.8}},{t:this.shape_11,p:{x:430.574}},{t:this.shape_9,p:{x:445.324}},{t:this.shape_7,p:{x:460.05}},{t:this.shape_5,p:{x:474.85}},{t:this.shape_8,p:{x:489.574}},{t:this.shape_6,p:{x:504.324}},{t:this.shape_4,p:{x:519.1}},{t:this.shape_2,p:{x:533.85}},{t:this.shape_3,p:{x:548.574}},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_27,p:{x:135.55}},{t:this.shape_26,p:{x:150.3}},{t:this.shape_23,p:{x:165.05}},{t:this.shape_29,p:{x:179.824}},{t:this.shape_22,p:{x:194.55}},{t:this.shape_20,p:{x:209.3}},{t:this.shape_28,p:{x:224.074}},{t:this.shape_19,p:{x:238.8}},{t:this.shape_25,p:{x:253.524}},{t:this.shape_24,p:{x:268.324}},{t:this.shape_18,p:{x:283.05}},{t:this.shape_21,p:{x:297.774}},{t:this.shape_16,p:{x:312.574}},{t:this.shape_17,p:{x:327.3}},{t:this.shape_15,p:{x:342.05}},{t:this.shape_12,p:{x:356.824}},{t:this.shape_11,p:{x:371.574}},{t:this.shape_14,p:{x:386.3}},{t:this.shape_13,p:{x:401.1}},{t:this.shape_10,p:{x:415.8}},{t:this.shape_9,p:{x:430.574}},{t:this.shape_8,p:{x:445.324}},{t:this.shape_7,p:{x:460.05}},{t:this.shape_5,p:{x:474.85}},{t:this.shape_6,p:{x:489.574}},{t:this.shape_3,p:{x:504.324}},{t:this.shape_4,p:{x:519.1}},{t:this.shape_2,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_26,p:{x:135.55}},{t:this.shape_23,p:{x:150.3}},{t:this.shape_22,p:{x:165.05}},{t:this.shape_29,p:{x:179.824}},{t:this.shape_20,p:{x:194.55}},{t:this.shape_19,p:{x:209.3}},{t:this.shape_28,p:{x:224.074}},{t:this.shape_18,p:{x:238.8}},{t:this.shape_25,p:{x:253.524}},{t:this.shape_24,p:{x:268.324}},{t:this.shape_17,p:{x:283.05}},{t:this.shape_21,p:{x:297.774}},{t:this.shape_16,p:{x:312.574}},{t:this.shape_15,p:{x:327.3}},{t:this.shape_14,p:{x:342.05}},{t:this.shape_12,p:{x:356.824}},{t:this.shape_11,p:{x:371.574}},{t:this.shape_13,p:{x:386.3}},{t:this.shape_10,p:{x:401.1}},{t:this.shape_7,p:{x:415.8}},{t:this.shape_9,p:{x:430.574}},{t:this.shape_8,p:{x:445.324}},{t:this.shape_5,p:{x:460.05}},{t:this.shape_4,p:{x:474.85}},{t:this.shape_6,p:{x:489.574}},{t:this.shape_3,p:{x:504.324}},{t:this.shape_2,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_23,p:{x:135.55}},{t:this.shape_22,p:{x:150.3}},{t:this.shape_20,p:{x:165.05}},{t:this.shape_29,p:{x:179.824}},{t:this.shape_19,p:{x:194.55}},{t:this.shape_18,p:{x:209.3}},{t:this.shape_28,p:{x:224.074}},{t:this.shape_17,p:{x:238.8}},{t:this.shape_25,p:{x:253.524}},{t:this.shape_24,p:{x:268.324}},{t:this.shape_15,p:{x:283.05}},{t:this.shape_21,p:{x:297.774}},{t:this.shape_16,p:{x:312.574}},{t:this.shape_14,p:{x:327.3}},{t:this.shape_13,p:{x:342.05}},{t:this.shape_12,p:{x:356.824}},{t:this.shape_11,p:{x:371.574}},{t:this.shape_10,p:{x:386.3}},{t:this.shape_7,p:{x:401.1}},{t:this.shape_5,p:{x:415.8}},{t:this.shape_9,p:{x:430.574}},{t:this.shape_8,p:{x:445.324}},{t:this.shape_4,p:{x:460.05}},{t:this.shape_2,p:{x:474.85}},{t:this.shape_6,p:{x:489.574}},{t:this.shape_3,p:{x:504.324}},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_23,p:{x:135.55}},{t:this.shape_22,p:{x:150.3}},{t:this.shape_20,p:{x:165.05}},{t:this.shape_28,p:{x:179.824}},{t:this.shape_19,p:{x:194.55}},{t:this.shape_18,p:{x:209.3}},{t:this.shape_25,p:{x:224.074}},{t:this.shape_17,p:{x:238.8}},{t:this.shape_24,p:{x:253.524}},{t:this.shape_21,p:{x:268.324}},{t:this.shape_15,p:{x:283.05}},{t:this.shape_16,p:{x:297.774}},{t:this.shape_12,p:{x:312.574}},{t:this.shape_14,p:{x:327.3}},{t:this.shape_13,p:{x:342.05}},{t:this.shape_11,p:{x:356.824}},{t:this.shape_9,p:{x:371.574}},{t:this.shape_10,p:{x:386.3}},{t:this.shape_7,p:{x:401.1}},{t:this.shape_5,p:{x:415.8}},{t:this.shape_8,p:{x:430.574}},{t:this.shape_6,p:{x:445.324}},{t:this.shape_4,p:{x:460.05}},{t:this.shape_2,p:{x:474.85}},{t:this.shape_3,p:{x:489.574}},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_23,p:{x:135.55}},{t:this.shape_22,p:{x:150.3}},{t:this.shape_20,p:{x:165.05}},{t:this.shape_25,p:{x:179.824}},{t:this.shape_19,p:{x:194.55}},{t:this.shape_18,p:{x:209.3}},{t:this.shape_24,p:{x:224.074}},{t:this.shape_17,p:{x:238.8}},{t:this.shape_21,p:{x:253.524}},{t:this.shape_16,p:{x:268.324}},{t:this.shape_15,p:{x:283.05}},{t:this.shape_12,p:{x:297.774}},{t:this.shape_11,p:{x:312.574}},{t:this.shape_14,p:{x:327.3}},{t:this.shape_13,p:{x:342.05}},{t:this.shape_9,p:{x:356.824}},{t:this.shape_8,p:{x:371.574}},{t:this.shape_10,p:{x:386.3}},{t:this.shape_7,p:{x:401.1}},{t:this.shape_5,p:{x:415.8}},{t:this.shape_6,p:{x:430.574}},{t:this.shape_3,p:{x:445.324}},{t:this.shape_4,p:{x:460.05}},{t:this.shape_2,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_22,p:{x:135.55}},{t:this.shape_20,p:{x:150.3}},{t:this.shape_19,p:{x:165.05}},{t:this.shape_25,p:{x:179.824}},{t:this.shape_18,p:{x:194.55}},{t:this.shape_17,p:{x:209.3}},{t:this.shape_24,p:{x:224.074}},{t:this.shape_15,p:{x:238.8}},{t:this.shape_21,p:{x:253.524}},{t:this.shape_16,p:{x:268.324}},{t:this.shape_14,p:{x:283.05}},{t:this.shape_12,p:{x:297.774}},{t:this.shape_11,p:{x:312.574}},{t:this.shape_13,p:{x:327.3}},{t:this.shape_10,p:{x:342.05}},{t:this.shape_9,p:{x:356.824}},{t:this.shape_8,p:{x:371.574}},{t:this.shape_7,p:{x:386.3}},{t:this.shape_5,p:{x:401.1}},{t:this.shape_4,p:{x:415.8}},{t:this.shape_6,p:{x:430.574}},{t:this.shape_3,p:{x:445.324}},{t:this.shape_2,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_20,p:{x:135.55}},{t:this.shape_19,p:{x:150.3}},{t:this.shape_18,p:{x:165.05}},{t:this.shape_25,p:{x:179.824}},{t:this.shape_17,p:{x:194.55}},{t:this.shape_15,p:{x:209.3}},{t:this.shape_24,p:{x:224.074}},{t:this.shape_14,p:{x:238.8}},{t:this.shape_21,p:{x:253.524}},{t:this.shape_16,p:{x:268.324}},{t:this.shape_13,p:{x:283.05}},{t:this.shape_12,p:{x:297.774}},{t:this.shape_11,p:{x:312.574}},{t:this.shape_10,p:{x:327.3}},{t:this.shape_7,p:{x:342.05}},{t:this.shape_9,p:{x:356.824}},{t:this.shape_8,p:{x:371.574}},{t:this.shape_5,p:{x:386.3}},{t:this.shape_4,p:{x:401.1}},{t:this.shape_2,p:{x:415.8}},{t:this.shape_6,p:{x:430.574}},{t:this.shape_3,p:{x:445.324}},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_20,p:{x:135.55}},{t:this.shape_19,p:{x:150.3}},{t:this.shape_18,p:{x:165.05}},{t:this.shape_24,p:{x:179.824}},{t:this.shape_17,p:{x:194.55}},{t:this.shape_15,p:{x:209.3}},{t:this.shape_21,p:{x:224.074}},{t:this.shape_14,p:{x:238.8}},{t:this.shape_16,p:{x:253.524}},{t:this.shape_12,p:{x:268.324}},{t:this.shape_13,p:{x:283.05}},{t:this.shape_11,p:{x:297.774}},{t:this.shape_9,p:{x:312.574}},{t:this.shape_10,p:{x:327.3}},{t:this.shape_7,p:{x:342.05}},{t:this.shape_8,p:{x:356.824}},{t:this.shape_6,p:{x:371.574}},{t:this.shape_5,p:{x:386.3}},{t:this.shape_4,p:{x:401.1}},{t:this.shape_2,p:{x:415.8}},{t:this.shape_3,p:{x:430.574}},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_20,p:{x:135.55}},{t:this.shape_19,p:{x:150.3}},{t:this.shape_18,p:{x:165.05}},{t:this.shape_21,p:{x:179.824}},{t:this.shape_17,p:{x:194.55}},{t:this.shape_15,p:{x:209.3}},{t:this.shape_16,p:{x:224.074}},{t:this.shape_14,p:{x:238.8}},{t:this.shape_12,p:{x:253.524}},{t:this.shape_11,p:{x:268.324}},{t:this.shape_13,p:{x:283.05}},{t:this.shape_9,p:{x:297.774}},{t:this.shape_8,p:{x:312.574}},{t:this.shape_10,p:{x:327.3}},{t:this.shape_7,p:{x:342.05}},{t:this.shape_6,p:{x:356.824}},{t:this.shape_3,p:{x:371.574}},{t:this.shape_5,p:{x:386.3}},{t:this.shape_4,p:{x:401.1}},{t:this.shape_2,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_19,p:{x:135.55}},{t:this.shape_18,p:{x:150.3}},{t:this.shape_17,p:{x:165.05}},{t:this.shape_21,p:{x:179.824}},{t:this.shape_15,p:{x:194.55}},{t:this.shape_14,p:{x:209.3}},{t:this.shape_16,p:{x:224.074}},{t:this.shape_13,p:{x:238.8}},{t:this.shape_12,p:{x:253.524}},{t:this.shape_11,p:{x:268.324}},{t:this.shape_10,p:{x:283.05}},{t:this.shape_9,p:{x:297.774}},{t:this.shape_8,p:{x:312.574}},{t:this.shape_7,p:{x:327.3}},{t:this.shape_5,p:{x:342.05}},{t:this.shape_6,p:{x:356.824}},{t:this.shape_3,p:{x:371.574}},{t:this.shape_4,p:{x:386.3}},{t:this.shape_2,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_18,p:{x:135.55}},{t:this.shape_17,p:{x:150.3}},{t:this.shape_15,p:{x:165.05}},{t:this.shape_21,p:{x:179.824}},{t:this.shape_14,p:{x:194.55}},{t:this.shape_13,p:{x:209.3}},{t:this.shape_16,p:{x:224.074}},{t:this.shape_10,p:{x:238.8}},{t:this.shape_12,p:{x:253.524}},{t:this.shape_11,p:{x:268.324}},{t:this.shape_7,p:{x:283.05}},{t:this.shape_9,p:{x:297.774}},{t:this.shape_8,p:{x:312.574}},{t:this.shape_5,p:{x:327.3}},{t:this.shape_4,p:{x:342.05}},{t:this.shape_6,p:{x:356.824}},{t:this.shape_3,p:{x:371.574}},{t:this.shape_2,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_17,p:{x:135.55}},{t:this.shape_15,p:{x:150.3}},{t:this.shape_14,p:{x:165.05}},{t:this.shape_21,p:{x:179.824}},{t:this.shape_13,p:{x:194.55}},{t:this.shape_10,p:{x:209.3}},{t:this.shape_16,p:{x:224.074}},{t:this.shape_7,p:{x:238.8}},{t:this.shape_12,p:{x:253.524}},{t:this.shape_11,p:{x:268.324}},{t:this.shape_5,p:{x:283.05}},{t:this.shape_9,p:{x:297.774}},{t:this.shape_8,p:{x:312.574}},{t:this.shape_4,p:{x:327.3}},{t:this.shape_2,p:{x:342.05}},{t:this.shape_6,p:{x:356.824}},{t:this.shape_3,p:{x:371.574}},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_17,p:{x:135.55}},{t:this.shape_15,p:{x:150.3}},{t:this.shape_14,p:{x:165.05}},{t:this.shape_16,p:{x:179.824}},{t:this.shape_13,p:{x:194.55}},{t:this.shape_10,p:{x:209.3}},{t:this.shape_12,p:{x:224.074}},{t:this.shape_7,p:{x:238.8}},{t:this.shape_11,p:{x:253.524}},{t:this.shape_9,p:{x:268.324}},{t:this.shape_5,p:{x:283.05}},{t:this.shape_8,p:{x:297.774}},{t:this.shape_6,p:{x:312.574}},{t:this.shape_4,p:{x:327.3}},{t:this.shape_2,p:{x:342.05}},{t:this.shape_3,p:{x:356.824}},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_17,p:{x:135.55}},{t:this.shape_15,p:{x:150.3}},{t:this.shape_14,p:{x:165.05}},{t:this.shape_12,p:{x:179.824}},{t:this.shape_13,p:{x:194.55}},{t:this.shape_10,p:{x:209.3}},{t:this.shape_11,p:{x:224.074}},{t:this.shape_7,p:{x:238.8}},{t:this.shape_9,p:{x:253.524}},{t:this.shape_8,p:{x:268.324}},{t:this.shape_5,p:{x:283.05}},{t:this.shape_6,p:{x:297.774}},{t:this.shape_3,p:{x:312.574}},{t:this.shape_4,p:{x:327.3}},{t:this.shape_2,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_15,p:{x:135.55}},{t:this.shape_14,p:{x:150.3}},{t:this.shape_13,p:{x:165.05}},{t:this.shape_12,p:{x:179.824}},{t:this.shape_10,p:{x:194.55}},{t:this.shape_7,p:{x:209.3}},{t:this.shape_11,p:{x:224.074}},{t:this.shape_5,p:{x:238.8}},{t:this.shape_9,p:{x:253.524}},{t:this.shape_8,p:{x:268.324}},{t:this.shape_4,p:{x:283.05}},{t:this.shape_6,p:{x:297.774}},{t:this.shape_3,p:{x:312.574}},{t:this.shape_2,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_14,p:{x:135.55}},{t:this.shape_13,p:{x:150.3}},{t:this.shape_10,p:{x:165.05}},{t:this.shape_12,p:{x:179.824}},{t:this.shape_7,p:{x:194.55}},{t:this.shape_5,p:{x:209.3}},{t:this.shape_11,p:{x:224.074}},{t:this.shape_4,p:{x:238.8}},{t:this.shape_9,p:{x:253.524}},{t:this.shape_8,p:{x:268.324}},{t:this.shape_2,p:{x:283.05}},{t:this.shape_6,p:{x:297.774}},{t:this.shape_3,p:{x:312.574}},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_14,p:{x:135.55}},{t:this.shape_13,p:{x:150.3}},{t:this.shape_10,p:{x:165.05}},{t:this.shape_11,p:{x:179.824}},{t:this.shape_7,p:{x:194.55}},{t:this.shape_5,p:{x:209.3}},{t:this.shape_9,p:{x:224.074}},{t:this.shape_4,p:{x:238.8}},{t:this.shape_8,p:{x:253.524}},{t:this.shape_6,p:{x:268.324}},{t:this.shape_2,p:{x:283.05}},{t:this.shape_3,p:{x:297.774}},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_14,p:{x:135.55}},{t:this.shape_13,p:{x:150.3}},{t:this.shape_10,p:{x:165.05}},{t:this.shape_9,p:{x:179.824}},{t:this.shape_7,p:{x:194.55}},{t:this.shape_5,p:{x:209.3}},{t:this.shape_8,p:{x:224.074}},{t:this.shape_4,p:{x:238.8}},{t:this.shape_6,p:{x:253.524}},{t:this.shape_3,p:{x:268.324}},{t:this.shape_2,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_13,p:{x:135.55}},{t:this.shape_10,p:{x:150.3}},{t:this.shape_7,p:{x:165.05}},{t:this.shape_9,p:{x:179.824}},{t:this.shape_5,p:{x:194.55}},{t:this.shape_4,p:{x:209.3}},{t:this.shape_8,p:{x:224.074}},{t:this.shape_2,p:{x:238.8}},{t:this.shape_6,p:{x:253.524}},{t:this.shape_3,p:{x:268.324}},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_13,p:{x:135.55}},{t:this.shape_10,p:{x:150.3}},{t:this.shape_7,p:{x:165.05}},{t:this.shape_8,p:{x:179.824}},{t:this.shape_5,p:{x:194.55}},{t:this.shape_4,p:{x:209.3}},{t:this.shape_6,p:{x:224.074}},{t:this.shape_2,p:{x:238.8}},{t:this.shape_3,p:{x:253.524}},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_13,p:{x:135.55}},{t:this.shape_10,p:{x:150.3}},{t:this.shape_7,p:{x:165.05}},{t:this.shape_6,p:{x:179.824}},{t:this.shape_5,p:{x:194.55}},{t:this.shape_4,p:{x:209.3}},{t:this.shape_3,p:{x:224.074}},{t:this.shape_2,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_10,p:{x:135.55}},{t:this.shape_7,p:{x:150.3}},{t:this.shape_5,p:{x:165.05}},{t:this.shape_6,p:{x:179.824}},{t:this.shape_4,p:{x:194.55}},{t:this.shape_2,p:{x:209.3}},{t:this.shape_3,p:{x:224.074}},{t:this.shape_90,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_10,p:{x:135.55}},{t:this.shape_7,p:{x:150.3}},{t:this.shape_5,p:{x:165.05}},{t:this.shape_3,p:{x:179.824}},{t:this.shape_4,p:{x:194.55}},{t:this.shape_2,p:{x:209.3}},{t:this.shape_91},{t:this.shape_90,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_7,p:{x:135.55}},{t:this.shape_5,p:{x:150.3}},{t:this.shape_4,p:{x:165.05}},{t:this.shape_3,p:{x:179.824}},{t:this.shape_2,p:{x:194.55}},{t:this.shape_92,p:{x:209.3}},{t:this.shape_91},{t:this.shape_90,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_5,p:{x:135.55}},{t:this.shape_4,p:{x:150.3}},{t:this.shape_2,p:{x:165.05}},{t:this.shape_3,p:{x:179.824}},{t:this.shape_93,p:{x:194.55}},{t:this.shape_92,p:{x:209.3}},{t:this.shape_91},{t:this.shape_90,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_5,p:{x:135.55}},{t:this.shape_4,p:{x:150.3}},{t:this.shape_2,p:{x:165.05}},{t:this.shape_94},{t:this.shape_93,p:{x:194.55}},{t:this.shape_92,p:{x:209.3}},{t:this.shape_91},{t:this.shape_90,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_4,p:{x:135.55}},{t:this.shape_2,p:{x:150.3}},{t:this.shape_95,p:{x:165.05}},{t:this.shape_94},{t:this.shape_93,p:{x:194.55}},{t:this.shape_92,p:{x:209.3}},{t:this.shape_91},{t:this.shape_90,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_2,p:{x:135.55}},{t:this.shape_96,p:{x:150.3}},{t:this.shape_95,p:{x:165.05}},{t:this.shape_94},{t:this.shape_93,p:{x:194.55}},{t:this.shape_92,p:{x:209.3}},{t:this.shape_91},{t:this.shape_90,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_97,p:{x:135.55}},{t:this.shape_96,p:{x:150.3}},{t:this.shape_95,p:{x:165.05}},{t:this.shape_94},{t:this.shape_93,p:{x:194.55}},{t:this.shape_92,p:{x:209.3}},{t:this.shape_91},{t:this.shape_90,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_98,p:{x:135.55}},{t:this.shape_97,p:{x:150.3}},{t:this.shape_96,p:{x:165.05}},{t:this.shape_94},{t:this.shape_95,p:{x:194.55}},{t:this.shape_93,p:{x:209.3}},{t:this.shape_91},{t:this.shape_92,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_90,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_87,p:{x:327.3}},{t:this.shape_84,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_83,p:{x:386.3}},{t:this.shape_80,p:{x:401.1}},{t:this.shape_79,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_78,p:{x:460.05}},{t:this.shape_75,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_74,p:{x:519.1}},{t:this.shape_71,p:{x:533.85}},{t:this.shape_69},{t:this.shape_70,p:{x:563.35}},{t:this.shape_68,p:{x:578.1}},{t:this.shape_67,p:{x:592.8}},{t:this.shape_66,p:{x:607.6}},{t:this.shape_64},{t:this.shape_65,p:{x:637.1}},{t:this.shape_63,p:{x:651.85}},{t:this.shape_62,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_61,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_58,p:{x:755.1}},{t:this.shape_54},{t:this.shape_55,p:{x:784.6}},{t:this.shape_53,p:{x:799.35}},{t:this.shape_51},{t:this.shape_52,p:{x:828.85}},{t:this.shape,p:{x:105.7}},{t:this.shape_50,p:{x:120.45}}]},1).to({state:[{t:this.shape_99},{t:this.shape_98,p:{x:150.3}},{t:this.shape_97,p:{x:165.05}},{t:this.shape_94},{t:this.shape_96,p:{x:194.55}},{t:this.shape_95,p:{x:209.3}},{t:this.shape_91},{t:this.shape_93,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_92,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_90,p:{x:327.3}},{t:this.shape_87,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_84,p:{x:386.3}},{t:this.shape_83,p:{x:401.1}},{t:this.shape_80,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_79,p:{x:460.05}},{t:this.shape_78,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_75,p:{x:519.1}},{t:this.shape_74,p:{x:533.85}},{t:this.shape_69},{t:this.shape_71,p:{x:563.35}},{t:this.shape_70,p:{x:578.1}},{t:this.shape_68,p:{x:592.8}},{t:this.shape_67,p:{x:607.6}},{t:this.shape_64},{t:this.shape_66,p:{x:637.1}},{t:this.shape_65,p:{x:651.85}},{t:this.shape_63,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_62,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_61,p:{x:755.1}},{t:this.shape_54},{t:this.shape_58,p:{x:784.6}},{t:this.shape_55,p:{x:799.35}},{t:this.shape_51},{t:this.shape_53,p:{x:828.85}},{t:this.shape_52,p:{x:105.7}},{t:this.shape_50,p:{x:120.45}}]},1).wait(1));

	// Layer_1
	this.shape_100 = new cjs.Shape();
	this.shape_100.graphics.f("rgba(27,41,52,0.749)").s().p("Eg7ZADsIAAnXMB2zAAAIAAHXg");
	this.shape_100.setTransform(502.006,23.575,1.3204,1);

	this.timeline.addTween(cjs.Tween.get(this.shape_100).wait(51));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1004,47.2);


(lib.AnswerShineMC = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.lf(["rgba(255,247,224,0.4)","rgba(255,255,255,0)"],[0,1],-50.1,17.2,50.1,-17.3).s().p("Au2xsIPqlYMAODAowIvqFZg");
	this.shape.setTransform(95.1,147.725);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.AnswerShineMC, new cjs.Rectangle(0,0,190.2,295.5), null);


(lib.ReturnButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// BAck
	this.backLabel = new cjs.Text("BACK", "18px 'Arial'", "#FFFFFF");
	this.backLabel.name = "backLabel";
	this.backLabel.textAlign = "center";
	this.backLabel.lineHeight = 18;
	this.backLabel.lineWidth = 58;
	this.backLabel.parent = this;
	this.backLabel.setTransform(44,16);
ranj.TextOffsetFixer.fix(this.backLabel);

	this.timeline.addTween(cjs.Tween.get(this.backLabel).wait(4));

	// Layer_3
	this.instance = new lib.DialogBackButtonUp();
	this.instance.setTransform(13,7);

	this.instance_1 = new lib.DialogBackButtonDown();
	this.instance_1.setTransform(13,7);

	this.instance_2 = new lib.DialogBackButtonDisabled();
	this.instance_2.setTransform(13,7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	// BG
	this.instance_3 = new lib.DialogBackBackground();

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,89,47);


(lib.BackButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// BAck
	this.endLabel = new cjs.Text("END", "18px 'Arial'", "#FFFFFF");
	this.endLabel.name = "endLabel";
	this.endLabel.textAlign = "center";
	this.endLabel.lineHeight = 18;
	this.endLabel.lineWidth = 58;
	this.endLabel.parent = this;
	this.endLabel.setTransform(44,16);
ranj.TextOffsetFixer.fix(this.endLabel);

	this.timeline.addTween(cjs.Tween.get(this.endLabel).wait(4));

	// Layer_3
	this.instance = new lib.DialogBackButtonUp();
	this.instance.setTransform(13,7);

	this.instance_1 = new lib.DialogBackButtonDown();
	this.instance_1.setTransform(13,7);

	this.instance_2 = new lib.DialogBackButtonDisabled();
	this.instance_2.setTransform(13,7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	// BG
	this.instance_3 = new lib.DialogBackBackground();

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,89,47);


(lib.DecisionImageContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-481,-541,962,1082);


(lib.DecisionButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3,selectedUp:4,"selectedOver":5,selectedDown:6,selectedDisabled:7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// selectedDisabledLabelTextField
	this.selectedDisabledLabelTextField = new cjs.Text("Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet", "24px 'Work Sans'", "#A79EB1");
	this.selectedDisabledLabelTextField.name = "selectedDisabledLabelTextField";
	this.selectedDisabledLabelTextField.lineHeight = 21;
	this.selectedDisabledLabelTextField.lineWidth = 608;
	this.selectedDisabledLabelTextField.parent = this;
	this.selectedDisabledLabelTextField.setTransform(-277,-44);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField).wait(8));

	// selectedDownLabelTextField
	this.selectedDisabledLabelTextField_1 = new cjs.Text("Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet", "24px 'Work Sans'", "#FFFFFF");
	this.selectedDisabledLabelTextField_1.name = "selectedDisabledLabelTextField_1";
	this.selectedDisabledLabelTextField_1.lineHeight = 21;
	this.selectedDisabledLabelTextField_1.lineWidth = 608;
	this.selectedDisabledLabelTextField_1.parent = this;
	this.selectedDisabledLabelTextField_1.setTransform(-277,-44);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField_1);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField_1).wait(8));

	// selectedOverLabelTextField
	this.selectedDisabledLabelTextField_2 = new cjs.Text("Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet", "24px 'Work Sans'", "#A79EB1");
	this.selectedDisabledLabelTextField_2.name = "selectedDisabledLabelTextField_2";
	this.selectedDisabledLabelTextField_2.lineHeight = 21;
	this.selectedDisabledLabelTextField_2.lineWidth = 608;
	this.selectedDisabledLabelTextField_2.parent = this;
	this.selectedDisabledLabelTextField_2.setTransform(-277,-44);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField_2);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField_2).wait(8));

	// selectedUpLabelTextField
	this.selectedDisabledLabelTextField_3 = new cjs.Text("Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet", "24px 'Work Sans'", "#2C3C3C");
	this.selectedDisabledLabelTextField_3.name = "selectedDisabledLabelTextField_3";
	this.selectedDisabledLabelTextField_3.lineHeight = 21;
	this.selectedDisabledLabelTextField_3.lineWidth = 608;
	this.selectedDisabledLabelTextField_3.parent = this;
	this.selectedDisabledLabelTextField_3.setTransform(-277,-44);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField_3);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField_3).wait(8));

	// disabledLabelTextField
	this.selectedDisabledLabelTextField_4 = new cjs.Text("Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet", "24px 'Work Sans'", "#A79EB1");
	this.selectedDisabledLabelTextField_4.name = "selectedDisabledLabelTextField_4";
	this.selectedDisabledLabelTextField_4.lineHeight = 21;
	this.selectedDisabledLabelTextField_4.lineWidth = 608;
	this.selectedDisabledLabelTextField_4.parent = this;
	this.selectedDisabledLabelTextField_4.setTransform(-277,-44);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField_4);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField_4).wait(8));

	// downLabelTextField
	this.selectedDisabledLabelTextField_5 = new cjs.Text("Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet", "24px 'Work Sans'", "#FFFFFF");
	this.selectedDisabledLabelTextField_5.name = "selectedDisabledLabelTextField_5";
	this.selectedDisabledLabelTextField_5.lineHeight = 21;
	this.selectedDisabledLabelTextField_5.lineWidth = 608;
	this.selectedDisabledLabelTextField_5.parent = this;
	this.selectedDisabledLabelTextField_5.setTransform(-277,-44);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField_5);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField_5).wait(8));

	// overLabelTextField
	this.selectedDisabledLabelTextField_6 = new cjs.Text("Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet", "24px 'Work Sans'", "#A79EB1");
	this.selectedDisabledLabelTextField_6.name = "selectedDisabledLabelTextField_6";
	this.selectedDisabledLabelTextField_6.lineHeight = 21;
	this.selectedDisabledLabelTextField_6.lineWidth = 608;
	this.selectedDisabledLabelTextField_6.parent = this;
	this.selectedDisabledLabelTextField_6.setTransform(-277,-44);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField_6);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField_6).wait(8));

	// upLabelTextField
	this.selectedDisabledLabelTextField_7 = new cjs.Text("Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet", "24px 'Work Sans'", "#2C3C3C");
	this.selectedDisabledLabelTextField_7.name = "selectedDisabledLabelTextField_7";
	this.selectedDisabledLabelTextField_7.lineHeight = 21;
	this.selectedDisabledLabelTextField_7.lineWidth = 608;
	this.selectedDisabledLabelTextField_7.parent = this;
	this.selectedDisabledLabelTextField_7.setTransform(-277,-44);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField_7);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField_7).wait(8));

	// vinkje
	this.instance = new lib.Vinkje();
	this.instance.setTransform(-320,-35);

	this.instance_1 = new lib.VinkjeHi();
	this.instance_1.setTransform(-320,-35);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance}]},4).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance}]},2).wait(1));

	// BG
	this.instance_2 = new lib.DecisionButtonUp();
	this.instance_2.setTransform(-348,-65);

	this.instance_3 = new lib.DecisionButtonHi();
	this.instance_3.setTransform(-348,-61);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2,p:{y:-65}}]}).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_2,p:{y:-61}}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_2,p:{y:-61}}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-348,-65,724,196.5);


(lib.GameSavedNoticePanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textField
	this.instance = new lib.Vinkje();
	this.instance.setTransform(-234,-12);

	this.textField = new cjs.Text("_Progress saved", "36px 'Work Sans'", "#FFFFFF");
	this.textField.name = "textField";
	this.textField.lineHeight = 44;
	this.textField.lineWidth = 429;
	this.textField.parent = this;
	this.textField.setTransform(-144.5,-28.75);
ranj.TextOffsetFixer.fix(this.textField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.textField},{t:this.instance}]}).wait(1));

	// panel
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgEFbIAAq1IAJAAIAAK1g");
	this.shape.setTransform(-189.55,-5.425);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#1E1E28").s().p("EgqxAFcIAAq3MBVjAAAIAAK3g");
	this.shape_1.setTransform(12.775,-4.9);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("rgba(50,50,50,0)").ss(1,1,1).p("EgqxgDlMBVjAAAIAAHLMhVjAAAg");
	this.shape_2.setTransform(12.775,23.025);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GameSavedNoticePanel, new cjs.Rectangle(-262,-40.1,549.6,87.2), null);


(lib.BriefingBackground_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiV/hUXMEr/AAAMAAACovMkr/AAAg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#CCCCCC").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BriefingBackground_1, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.PoiCharacterIconContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.PoIPLocationDummy();
	this.instance.setTransform(-41,-65);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PoiCharacterIconContainer, new cjs.Rectangle(-41,-65,82,130), null);


(lib.MapLocationNode = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.instance = new lib.MapNode();
	this.instance.setTransform(-19,-19);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.MapLocationNode, new cjs.Rectangle(-19,-19,35,34), null);


(lib.MapLocationCharacterMenuItemLabel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("[Location]\n[Location]", "18px 'Work Sans'");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 21;
	this.disabledLabelTextField.lineWidth = 279;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-128.85,-32.65);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(1));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("[Location]\n[Location]", "18px 'Work Sans'");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 21;
	this.downLabelTextField.lineWidth = 279;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-128.85,-32.65);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(1));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("[Location]\n[Location]", "18px 'Work Sans'");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 21;
	this.overLabelTextField.lineWidth = 279;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-128.85,-32.65);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(1));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("[Location]\n[Location]", "18px 'Work Sans'");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 21;
	this.upLabelTextField.lineWidth = 279;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-128.85,-32.65);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(1));

	// PoILTextLabelBGSmallWhite_png
	this.instance = new lib.PoILTextLabelBGSmallWhite();
	this.instance.setTransform(-177.5,-40);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.MapLocationCharacterMenuItemLabel, new cjs.Rectangle(-177.5,-40,355,70), null);


(lib.TrendDownRed = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TrendDownDark();

	this.instance_1 = new lib.TrendUpRed();
	this.instance_1.setTransform(7.5,8,1,1,0,0,0,7.5,8);

	this.instance_2 = new lib.TrendUpGreen();
	this.instance_2.setTransform(7.6,8,1,1,0,0,0,8,8);

	this.instance_3 = new lib.TrendDownGreen();
	this.instance_3.setTransform(7.5,8,1,1,0,0,0,7.5,8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-0.4,0,19.4,19);


(lib.timerKeyDecision = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// TextRegular
	this.textField = new cjs.Text("Soft push text goes here\nSoft push text goes here", "18px 'Work Sans'", "#FFFFFF");
	this.textField.name = "textField";
	this.textField.lineHeight = 23;
	this.textField.lineWidth = 247;
	this.textField.parent = this;
	this.textField.setTransform(33,2.35);
ranj.TextOffsetFixer.fix(this.textField);

	this.timeline.addTween(cjs.Tween.get(this.textField).wait(2));

	// Layer_1
	this.timerKeyDecision_Neutral = new lib.timerKeyDecision_Neutral_1();
	this.timerKeyDecision_Neutral.name = "timerKeyDecision_Neutral";
	this.timerKeyDecision_Neutral.setTransform(164.45,27.6,1,1,0,0,0,170.5,29.5);

	this.timerKeyDecision_Urgent = new lib.timerKeyDecision_Urgent_1();
	this.timerKeyDecision_Urgent.name = "timerKeyDecision_Urgent";
	this.timerKeyDecision_Urgent.setTransform(164.65,27.15,1,1,0,0,0,171,29);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.timerKeyDecision_Neutral}]}).to({state:[{t:this.timerKeyDecision_Urgent}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.3,-1.9,385.3,107.10000000000001);


(lib.TabButtonPlanComposer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3,"selecteUp":4,"selectedOver":5,"SelectedDown":6,"SelectedDisabled":7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// SelectedUpLabelTextField
	this.selectedUpLabelTextField = new cjs.Text("Continue", "bold 26px 'Work Sans'", "#324141");
	this.selectedUpLabelTextField.name = "selectedUpLabelTextField";
	this.selectedUpLabelTextField.lineHeight = 28;
	this.selectedUpLabelTextField.lineWidth = 621;
	this.selectedUpLabelTextField.parent = this;
	this.selectedUpLabelTextField.setTransform(34.45,-11.6);
ranj.TextOffsetFixer.fix(this.selectedUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedUpLabelTextField).wait(8));

	// SelectedDisabledLabelTextField
	this.selectedDisabledLabelTextField = new cjs.Text("Continue", "bold 26px 'Work Sans'", "#295B6D");
	this.selectedDisabledLabelTextField.name = "selectedDisabledLabelTextField";
	this.selectedDisabledLabelTextField.lineHeight = 28;
	this.selectedDisabledLabelTextField.lineWidth = 621;
	this.selectedDisabledLabelTextField.parent = this;
	this.selectedDisabledLabelTextField.setTransform(34.45,-11.6);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField).wait(8));

	// SelectedDownLabelTextField
	this.selectedDownLabelTextField = new cjs.Text("Continue", "bold 26px 'Work Sans'", "#324141");
	this.selectedDownLabelTextField.name = "selectedDownLabelTextField";
	this.selectedDownLabelTextField.lineHeight = 28;
	this.selectedDownLabelTextField.lineWidth = 621;
	this.selectedDownLabelTextField.parent = this;
	this.selectedDownLabelTextField.setTransform(34.45,-11.6);
ranj.TextOffsetFixer.fix(this.selectedDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDownLabelTextField).wait(8));

	// SelectedOverLabelTextField
	this.selectedOverLabelTextField = new cjs.Text("Continue", "bold 26px 'Work Sans'", "#324141");
	this.selectedOverLabelTextField.name = "selectedOverLabelTextField";
	this.selectedOverLabelTextField.lineHeight = 28;
	this.selectedOverLabelTextField.lineWidth = 621;
	this.selectedOverLabelTextField.parent = this;
	this.selectedOverLabelTextField.setTransform(34.45,-11.6);
ranj.TextOffsetFixer.fix(this.selectedOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedOverLabelTextField).wait(8));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Continue", "bold 26px 'Work Sans'", "#324141");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 28;
	this.upLabelTextField.lineWidth = 621;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(34.45,-11.6);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(8));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Continue", "bold 26px 'Work Sans'", "#295B6D");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 28;
	this.disabledLabelTextField.lineWidth = 621;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(34.45,-11.6);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(8));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Continue", "bold 26px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 28;
	this.downLabelTextField.lineWidth = 621;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(34.45,-11.6);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(8));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Continue", "bold 26px 'Work Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 28;
	this.overLabelTextField.lineWidth = 621;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(34.45,-11.6);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(8));

	// Layer_1
	this.instance = new lib.PlanComposerKeyDecision_InactiveTab();
	this.instance.setTransform(194.5,34.55,1,1,0,0,0,194.5,33.5);

	this.instance_1 = new lib.PlanComposerKeyDecision_TabHover();
	this.instance_1.setTransform(194.5,35.05,1,1,0,0,0,194.5,34);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#295B6D").s().p("Egi8AFDIAAqFMBF4AAAIAAKFg");
	this.shape.setTransform(223.65,18.075);

	this.instance_2 = new lib.PlanComposerKeyDecision_ActiveTab();
	this.instance_2.setTransform(194.5,33.5,1,1,0,0,0,194.5,33.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.shape}]},2).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.shape}]},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-14.2,690,68.2);


(lib.SaveGamePopUpContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.GameSavedNoticePanel();
	this.instance.setTransform(273.85,43.35,1,1,0,0,0,12.8,3.2);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SaveGamePopUpContainer, new cjs.Rectangle(-0.5,0,548.7,86.7), null);


(lib.NewKDAnim = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.newKeyDecision = new lib.newKeyDecIcon();
	this.newKeyDecision.name = "newKeyDecision";
	this.newKeyDecision.setTransform(106.8,18.7,0.0678,0.0678,0,0,0,25.1,22.9);
	this.newKeyDecision._off = true;

	this.timeline.addTween(cjs.Tween.get(this.newKeyDecision).wait(49).to({_off:false},0).to({regX:25,regY:22.5,scaleX:1,scaleY:1,y:18.65},10).wait(56));

	// Layer_1
	this.instance = new lib.Tween2("synched",0);
	this.instance.setTransform(23.95,39.4,1.3159,1.3159,-52.7013,0,0,0.4,0.4);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:0,regY:0,scaleX:0.8,scaleY:0.8,rotation:0,x:56.5,y:54.5},19).to({scaleX:1,scaleY:1},30).to({scaleX:0.8,scaleY:0.8},30).to({scaleX:1,scaleY:1},35).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-78.8,-63.1,210.60000000000002,205.2);


(lib.HubTimeline = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.keyDecisionsContainer = new lib.HubKeyDecisionNotificationContainer();
	this.keyDecisionsContainer.name = "keyDecisionsContainer";
	this.keyDecisionsContainer.setTransform(167.85,229.75);

	this.timeline.addTween(cjs.Tween.get(this.keyDecisionsContainer).wait(1));

	// Layer_2
	this.instance = new lib.HubTimelineBGLong();
	this.instance.setTransform(118,17);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HubTimeline, new cjs.Rectangle(118,17,28,659), null);


(lib.FeedbackTooltipBodyWhite = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.ToolTipPointer = new lib.FeedbackPlayerChoiceTooltip();
	this.ToolTipPointer.name = "ToolTipPointer";
	this.ToolTipPointer.setTransform(370.5,349.05,1,1,0,0,0,29,23.5);

	this.timeline.addTween(cjs.Tween.get(this.ToolTipPointer).wait(1));

	// Layer_1
	this.ToolTipContainer = new lib.ToolTipWhiteContainer();
	this.ToolTipContainer.name = "ToolTipContainer";
	this.ToolTipContainer.setTransform(370.5,169,1,1,0,0,0,370.5,169);

	this.timeline.addTween(cjs.Tween.get(this.ToolTipContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackTooltipBodyWhite, new cjs.Rectangle(0,0,741,360.2), null);


(lib.FeedbackTooltipBodyBlack = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.ToolTipPointer = new lib.FeedbackOptimalTooltip();
	this.ToolTipPointer.name = "ToolTipPointer";
	this.ToolTipPointer.setTransform(370.5,352.25,1,1,0,0,0,30,23.5);

	this.timeline.addTween(cjs.Tween.get(this.ToolTipPointer).wait(1));

	// Layer_1
	this.ToolTipContainer = new lib.ToolTipBlackContainer();
	this.ToolTipContainer.name = "ToolTipContainer";
	this.ToolTipContainer.setTransform(370.5,169,1,1,0,0,0,370.5,169);

	this.timeline.addTween(cjs.Tween.get(this.ToolTipContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackTooltipBodyBlack, new cjs.Rectangle(0,0,741,375.8), null);


(lib.FeedbackTimelineLong = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.keyDecisionsContainer = new lib.HubKeyDecisionNotificationContainer();
	this.keyDecisionsContainer.name = "keyDecisionsContainer";
	this.keyDecisionsContainer.setTransform(167.85,229.75);

	this.instance = new lib.TimelineBG();
	this.instance.setTransform(118.45,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.keyDecisionsContainer}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackTimelineLong, new cjs.Rectangle(118.5,0,28,805), null);


(lib.FeedbackOptimalStars = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackStarOptimal();
	this.instance.setTransform(43.4,9,1,1,0,0,0,9,9);

	this.instance_1 = new lib.FeedbackStarOptimal();
	this.instance_1.setTransform(26.2,-11.35,1,1,0,0,0,9,9);

	this.instance_2 = new lib.FeedbackStarOptimal();
	this.instance_2.setTransform(9,9,1,1,0,0,0,9,9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackOptimalStars, new cjs.Rectangle(0,-20.3,52.4,38.3), null);


(lib.FeedbackMediumStars = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackStarFilled();
	this.instance.setTransform(26.2,-11.35,1,1,0,0,0,9,9);

	this.instance_1 = new lib.FeedbackStarEmpty();
	this.instance_1.setTransform(43.4,9,1,1,0,0,0,9,9);

	this.instance_2 = new lib.FeedbackStarFilled();
	this.instance_2.setTransform(9,9,1,1,0,0,0,9,9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackMediumStars, new cjs.Rectangle(0,-20.3,52.4,38.3), null);


(lib.FeedbackKDstates = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.FeedbackInactiveKD = new lib.FeedbackInactiveKD_1();
	this.FeedbackInactiveKD.name = "FeedbackInactiveKD";
	this.FeedbackInactiveKD.setTransform(38.5,86.5,1,1,0,0,0,38.5,38.5);

	this.FeedbackActiveKDPlayerChoice = new lib.FeedbackActiveKDPlayerChoice();
	this.FeedbackActiveKDPlayerChoice.name = "FeedbackActiveKDPlayerChoice";
	this.FeedbackActiveKDPlayerChoice.setTransform(104.85,87.95,1,1,0,0,0,139.5,73.5);

	this.FeedbackActiveKDOptimal = new lib.FeedbackActiveKDOptimal();
	this.FeedbackActiveKDOptimal.name = "FeedbackActiveKDOptimal";
	this.FeedbackActiveKDOptimal.setTransform(104.85,87.95,1,1,0,0,0,139.5,73.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.FeedbackInactiveKD}]}).to({state:[{t:this.FeedbackInactiveKD},{t:this.FeedbackActiveKDPlayerChoice}]},1).to({state:[{t:this.FeedbackInactiveKD},{t:this.FeedbackActiveKDPlayerChoice},{t:this.FeedbackActiveKDOptimal}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-34.6,14.5,279,147);


(lib.FeedbackInactiveKDstate = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.buttonFeedbackInactive = new lib.FeedbackKDInactiveButton();
	this.buttonFeedbackInactive.name = "buttonFeedbackInactive";
	this.buttonFeedbackInactive.setTransform(24,24.5,1,1,0,0,0,30,28.5);

	this.timeline.addTween(cjs.Tween.get(this.buttonFeedbackInactive).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackInactiveKDstate, new cjs.Rectangle(0,0,48,49), null);


(lib.FeedbackGoodStars = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackStarFilled();
	this.instance.setTransform(43.4,9,1,1,0,0,0,9,9);

	this.instance_1 = new lib.FeedbackStarFilled();
	this.instance_1.setTransform(26.2,-11.35,1,1,0,0,0,9,9);

	this.instance_2 = new lib.FeedbackStarFilled();
	this.instance_2.setTransform(9,9,1,1,0,0,0,9,9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackGoodStars, new cjs.Rectangle(0,-20.3,52.4,38.3), null);


(lib.FeedbackBadStars = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackStarEmpty();
	this.instance.setTransform(43.4,9,1,1,0,0,0,9,9);

	this.instance_1 = new lib.FeedbackStarEmpty();
	this.instance_1.setTransform(26.2,-11.35,1,1,0,0,0,9,9);

	this.instance_2 = new lib.FeedbackStarFilled();
	this.instance_2.setTransform(9,9,1,1,0,0,0,9,9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackBadStars, new cjs.Rectangle(0,-20.3,52.4,38.3), null);


(lib.DataElementTwoLines = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Title
	this.DataTitleTextField = new cjs.Text("Data Title\nData Title", "22px 'Work Sans'", "#295B6D");
	this.DataTitleTextField.name = "DataTitleTextField";
	this.DataTitleTextField.lineHeight = 21;
	this.DataTitleTextField.lineWidth = 339;
	this.DataTitleTextField.parent = this;
	this.DataTitleTextField.setTransform(48.55,-28.4);
ranj.TextOffsetFixer.fix(this.DataTitleTextField);

	this.timeline.addTween(cjs.Tween.get(this.DataTitleTextField).wait(1));

	// Nr
	this.DataNrTextField = new cjs.Text("Nr.", "bold 40px 'Work Sans ExtraBold'", "#295B6D");
	this.DataNrTextField.name = "DataNrTextField";
	this.DataNrTextField.lineHeight = 60;
	this.DataNrTextField.lineWidth = 317;
	this.DataNrTextField.parent = this;
	this.DataNrTextField.setTransform(48.55,28.8);
ranj.TextOffsetFixer.fix(this.DataNrTextField);

	this.timeline.addTween(cjs.Tween.get(this.DataNrTextField).wait(1));

	// Arrow
	this.Trend = new lib.TrendDownRed();
	this.Trend.name = "Trend";
	this.Trend.setTransform(59.85,86.95,1,1,0,0,0,8,8);

	this.timeline.addTween(cjs.Tween.get(this.Trend).wait(1));

	// TrendGreen
	this.TrendIndicatorGoodTextField = new cjs.Text("trendIndicator", "32px 'Work Sans Light'", "#324141");
	this.TrendIndicatorGoodTextField.name = "TrendIndicatorGoodTextField";
	this.TrendIndicatorGoodTextField.lineHeight = 40;
	this.TrendIndicatorGoodTextField.lineWidth = 296;
	this.TrendIndicatorGoodTextField.parent = this;
	this.TrendIndicatorGoodTextField.setTransform(76.1,68.8);
ranj.TextOffsetFixer.fix(this.TrendIndicatorGoodTextField);

	this.timeline.addTween(cjs.Tween.get(this.TrendIndicatorGoodTextField).wait(1));

	// TrendRed
	this.TrendIndicatorBadTextField = new cjs.Text("trendIndicator", "32px 'Work Sans Light'", "#324141");
	this.TrendIndicatorBadTextField.name = "TrendIndicatorBadTextField";
	this.TrendIndicatorBadTextField.lineHeight = 40;
	this.TrendIndicatorBadTextField.lineWidth = 296;
	this.TrendIndicatorBadTextField.parent = this;
	this.TrendIndicatorBadTextField.setTransform(76.1,68.8);
ranj.TextOffsetFixer.fix(this.TrendIndicatorBadTextField);

	this.timeline.addTween(cjs.Tween.get(this.TrendIndicatorBadTextField).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DataElementTwoLines, new cjs.Rectangle(46.6,-30.4,343,156.3), null);


(lib.DataElement = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Title
	this.DataTitleTextField = new cjs.Text("Data Title\nData Title", "22px 'Work Sans'", "#295B6D");
	this.DataTitleTextField.name = "DataTitleTextField";
	this.DataTitleTextField.lineHeight = 21;
	this.DataTitleTextField.lineWidth = 317;
	this.DataTitleTextField.parent = this;
	this.DataTitleTextField.setTransform(49,3.8);
ranj.TextOffsetFixer.fix(this.DataTitleTextField);

	this.timeline.addTween(cjs.Tween.get(this.DataTitleTextField).wait(1));

	// Nr
	this.DataNrTextField = new cjs.Text("Nr.", "bold 40px 'Work Sans ExtraBold'", "#295B6D");
	this.DataNrTextField.name = "DataNrTextField";
	this.DataNrTextField.lineHeight = 60;
	this.DataNrTextField.lineWidth = 317;
	this.DataNrTextField.parent = this;
	this.DataNrTextField.setTransform(48,44);
ranj.TextOffsetFixer.fix(this.DataNrTextField);

	this.timeline.addTween(cjs.Tween.get(this.DataNrTextField).wait(1));

	// Arrow
	this.Trend = new lib.TrendDownRed();
	this.Trend.name = "Trend";
	this.Trend.setTransform(52,95);

	this.timeline.addTween(cjs.Tween.get(this.Trend).wait(1));

	// TrendGreen
	this.TrendIndicatorGoodTextField = new cjs.Text("trendIndicator", "32px 'Work Sans Light'", "#324141");
	this.TrendIndicatorGoodTextField.name = "TrendIndicatorGoodTextField";
	this.TrendIndicatorGoodTextField.lineHeight = 40;
	this.TrendIndicatorGoodTextField.lineWidth = 296;
	this.TrendIndicatorGoodTextField.parent = this;
	this.TrendIndicatorGoodTextField.setTransform(76,84);
ranj.TextOffsetFixer.fix(this.TrendIndicatorGoodTextField);

	this.timeline.addTween(cjs.Tween.get(this.TrendIndicatorGoodTextField).wait(1));

	// TrendRed
	this.TrendIndicatorBadTextField = new cjs.Text("trendIndicator", "32px 'Work Sans Light'", "#324141");
	this.TrendIndicatorBadTextField.name = "TrendIndicatorBadTextField";
	this.TrendIndicatorBadTextField.lineHeight = 40;
	this.TrendIndicatorBadTextField.lineWidth = 296;
	this.TrendIndicatorBadTextField.parent = this;
	this.TrendIndicatorBadTextField.setTransform(76,84);
ranj.TextOffsetFixer.fix(this.TrendIndicatorBadTextField);

	this.timeline.addTween(cjs.Tween.get(this.TrendIndicatorBadTextField).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DataElement, new cjs.Rectangle(46,1.8,328.3,139.29999999999998), null);


(lib.DataDashboardIconTutorial = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// newIndicator
	this.newIndicator = new lib.FakeNewIndicator();
	this.newIndicator.name = "newIndicator";
	this.newIndicator.setTransform(115.5,-73.15);

	this.timeline.addTween(cjs.Tween.get(this.newIndicator).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Data Dashboard", "bold 18px 'Work Sans ExtraBold'", "#BBD2D7");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 28;
	this.disabledLabelTextField.lineWidth = 182;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-0.05,38.7);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Data Dashboard", "bold 18px 'Work Sans ExtraBold'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 28;
	this.downLabelTextField.lineWidth = 182;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-0.05,38.7);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Data Dashboard", "bold 18px 'Work Sans ExtraBold'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 28;
	this.overLabelTextField.lineWidth = 182;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-0.05,38.7);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Data Dashboard", "bold 18px 'Work Sans ExtraBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 28;
	this.upLabelTextField.lineWidth = 182;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-0.05,38.7);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Layer_10
	this.instance = new lib.HUBTeaCornerButtonLabelUp();
	this.instance.setTransform(-109,13);

	this.instance_1 = new lib.HUBTeaCornerButtonLabelOver();
	this.instance_1.setTransform(-109,12);

	this.instance_2 = new lib.HUBTeaCornerButtonLabelDisabled();
	this.instance_2.setTransform(-109,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	// Layer_1
	this.instance_3 = new lib.DashboardButton();
	this.instance_3.setTransform(-64,-90);

	this.instance_4 = new lib.DashboardButtonOver();
	this.instance_4.setTransform(-64,-90);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3}]}).to({state:[{t:this.instance_4}]},1).wait(3));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-109,-90,228,194);


(lib.DataDashboardIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// newIndicator
	this.newIndicator = new lib.HubButtonNewIndicator();
	this.newIndicator.name = "newIndicator";
	this.newIndicator.setTransform(115.5,-73.15);

	this.timeline.addTween(cjs.Tween.get(this.newIndicator).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Data Dashboard", "bold 18px 'Work Sans ExtraBold'", "#BBD2D7");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 28;
	this.disabledLabelTextField.lineWidth = 182;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-0.05,37.95);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Data Dashboard", "bold 18px 'Work Sans ExtraBold'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 28;
	this.downLabelTextField.lineWidth = 182;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-0.05,37.95);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Data Dashboard", "bold 18px 'Work Sans ExtraBold'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 28;
	this.overLabelTextField.lineWidth = 182;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-0.05,37.95);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Data Dashboard", "bold 18px 'Work Sans ExtraBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 28;
	this.upLabelTextField.lineWidth = 182;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-0.05,37.95);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Layer_10
	this.instance = new lib.HUBTeaCornerButtonLabelUp();
	this.instance.setTransform(-109,13);

	this.instance_1 = new lib.HUBTeaCornerButtonLabelOver();
	this.instance_1.setTransform(-109,12);

	this.instance_2 = new lib.HUBTeaCornerButtonLabelDisabled();
	this.instance_2.setTransform(-109,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	// Layer_1
	this.instance_3 = new lib.DashboardButton();
	this.instance_3.setTransform(-64,-90);

	this.instance_4 = new lib.DashboardButtonOver();
	this.instance_4.setTransform(-64,-90);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3}]}).to({state:[{t:this.instance_4}]},1).wait(3));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-109,-113.1,266.5,217.1);


(lib.DashboardTab3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.imageContainer = new lib.Tab3Info1_1();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(750.5,334.5,1,1,0,0,0,750.5,334.5);

	this.instance = new lib.EmptyContainer();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.imageContainer}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DashboardTab3, new cjs.Rectangle(0,0,1520,670), null);


(lib.DashboardLogoWHO = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.LogoMoH();

	this.instance_1 = new lib.DashboardLogoReady();
	this.instance_1.setTransform(62.6,59,1,1,0,0,0,68.5,16);

	this.instance_2 = new lib.DashboardLogoGHO();
	this.instance_2.setTransform(59.5,59,1,1,0,0,0,55.5,45.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.9,0,137,118);


(lib.AnnotationTab2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#BBD2D7").ss(1,1,1).p("EgvgAAAMBfBAAA");
	this.shape.setTransform(338.025,43.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer_1
	this.bestPossibleOutcomeNumberTextField = new cjs.Text("2430", "bold 40px 'Work Sans ExtraBold'", "#779936");
	this.bestPossibleOutcomeNumberTextField.name = "bestPossibleOutcomeNumberTextField";
	this.bestPossibleOutcomeNumberTextField.lineHeight = 60;
	this.bestPossibleOutcomeNumberTextField.lineWidth = 109;
	this.bestPossibleOutcomeNumberTextField.alpha = 0.90196078;
	this.bestPossibleOutcomeNumberTextField.parent = this;
	this.bestPossibleOutcomeNumberTextField.setTransform(216.35,88.05);
ranj.TextOffsetFixer.fix(this.bestPossibleOutcomeNumberTextField);

	this.worstPossibleOutcomeNumberTextField = new cjs.Text("2430", "bold 40px 'Work Sans ExtraBold'", "#D74821");
	this.worstPossibleOutcomeNumberTextField.name = "worstPossibleOutcomeNumberTextField";
	this.worstPossibleOutcomeNumberTextField.lineHeight = 60;
	this.worstPossibleOutcomeNumberTextField.lineWidth = 109;
	this.worstPossibleOutcomeNumberTextField.alpha = 0.90196078;
	this.worstPossibleOutcomeNumberTextField.parent = this;
	this.worstPossibleOutcomeNumberTextField.setTransform(446.05,88.05);
ranj.TextOffsetFixer.fix(this.worstPossibleOutcomeNumberTextField);

	this.yourOutcomeNumberTextfield = new cjs.Text("2430", "bold 40px 'Work Sans ExtraBold'", "#2C3C3C");
	this.yourOutcomeNumberTextfield.name = "yourOutcomeNumberTextfield";
	this.yourOutcomeNumberTextfield.lineHeight = 60;
	this.yourOutcomeNumberTextfield.lineWidth = 109;
	this.yourOutcomeNumberTextfield.alpha = 0.90196078;
	this.yourOutcomeNumberTextfield.parent = this;
	this.yourOutcomeNumberTextfield.setTransform(35.9,88.05);
ranj.TextOffsetFixer.fix(this.yourOutcomeNumberTextfield);

	this.worstPossibleOutcomeTextfield = new cjs.Text("Worst possible outcome", "20px 'Work Sans'", "#D74821");
	this.worstPossibleOutcomeTextfield.name = "worstPossibleOutcomeTextfield";
	this.worstPossibleOutcomeTextfield.lineHeight = 18;
	this.worstPossibleOutcomeTextfield.lineWidth = 202;
	this.worstPossibleOutcomeTextfield.alpha = 0.90196078;
	this.worstPossibleOutcomeTextfield.parent = this;
	this.worstPossibleOutcomeTextfield.setTransform(446.05,49.05);
ranj.TextOffsetFixer.fix(this.worstPossibleOutcomeTextfield);

	this.bestPossibleOutcomeTextField = new cjs.Text("Best possible outcome", "20px 'Work Sans'", "#779936");
	this.bestPossibleOutcomeTextField.name = "bestPossibleOutcomeTextField";
	this.bestPossibleOutcomeTextField.lineHeight = 18;
	this.bestPossibleOutcomeTextField.lineWidth = 220;
	this.bestPossibleOutcomeTextField.alpha = 0.90196078;
	this.bestPossibleOutcomeTextField.parent = this;
	this.bestPossibleOutcomeTextField.setTransform(216.35,49.05);
ranj.TextOffsetFixer.fix(this.bestPossibleOutcomeTextField);

	this.yourOutcomeTextField = new cjs.Text("Your outcome", "20px 'Work Sans'", "#2C3C3C");
	this.yourOutcomeTextField.name = "yourOutcomeTextField";
	this.yourOutcomeTextField.lineHeight = 18;
	this.yourOutcomeTextField.lineWidth = 139;
	this.yourOutcomeTextField.alpha = 0.90196078;
	this.yourOutcomeTextField.parent = this;
	this.yourOutcomeTextField.setTransform(35.9,49.05);
ranj.TextOffsetFixer.fix(this.yourOutcomeTextField);

	this.annotationTitleTextField = new cjs.Text("Cumulative number of suspect & confirmed cases", "bold 20px 'Work Sans'", "#2C3C3C");
	this.annotationTitleTextField.name = "annotationTitleTextField";
	this.annotationTitleTextField.lineHeight = 25;
	this.annotationTitleTextField.lineWidth = 560;
	this.annotationTitleTextField.alpha = 0.90196078;
	this.annotationTitleTextField.parent = this;
	this.annotationTitleTextField.setTransform(35.9,15.3);
ranj.TextOffsetFixer.fix(this.annotationTitleTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.annotationTitleTextField},{t:this.yourOutcomeTextField},{t:this.bestPossibleOutcomeTextField},{t:this.worstPossibleOutcomeTextfield},{t:this.yourOutcomeNumberTextfield},{t:this.worstPossibleOutcomeNumberTextField},{t:this.bestPossibleOutcomeNumberTextField}]}).wait(1));

	// Layer_3
	this.instance = new lib.AnnotationBackgroundBig();
	this.instance.setTransform(339,86,1,1,0,0,0,339,86);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.AnnotationTab2, new cjs.Rectangle(0,0,679,153), null);


(lib.TransitionScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// locationTextField
	this.continueButton = new lib.ContinueButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(-415.5,99.75);

	this.locationTextField = new cjs.Text("[Location]", "bold 50px 'Work Sans ExtraBold'", "#2C3C3C");
	this.locationTextField.name = "locationTextField";
	this.locationTextField.lineHeight = 48;
	this.locationTextField.lineWidth = 1132;
	this.locationTextField.parent = this;
	this.locationTextField.setTransform(-568,-407.05);
ranj.TextOffsetFixer.fix(this.locationTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.locationTextField},{t:this.continueButton}]}).wait(1));

	// premiseTextField
	this.bodyTextField = new cjs.Text("[Premise of this turn]\n[Premise of this turn]\n[Premise of this turn]\n[Premise of this turn]\n[Premise of this turn]\n[Premise of this turn]\n[Premise of this turn]\n[Premise of this turn]", "28px 'Work Sans'", "#2C3C3C");
	this.bodyTextField.name = "bodyTextField";
	this.bodyTextField.lineHeight = 35;
	this.bodyTextField.lineWidth = 872;
	this.bodyTextField.parent = this;
	this.bodyTextField.setTransform(-568,-303);
ranj.TextOffsetFixer.fix(this.bodyTextField);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextField).wait(1));

	// travelLabelTextField
	this.travelLabelTextField = new cjs.Text("Travel to:", "28px 'Work Sans'", "#2C3C3C");
	this.travelLabelTextField.name = "travelLabelTextField";
	this.travelLabelTextField.lineHeight = 35;
	this.travelLabelTextField.lineWidth = 962;
	this.travelLabelTextField.parent = this;
	this.travelLabelTextField.setTransform(-568,-394.05);
ranj.TextOffsetFixer.fix(this.travelLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.travelLabelTextField).wait(1));

	// imageContainer
	this.imageContainer = new lib.EmptyContainer();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(-960,-540);

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TransitionScreenSkin, new cjs.Rectangle(-962,-542,1925,1085), null);


(lib.SavegameFeedbackPopupSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// PopUp
	this.SaveGamePopUpContainer = new lib.SaveGamePopUpContainer();
	this.SaveGamePopUpContainer.name = "SaveGamePopUpContainer";
	this.SaveGamePopUpContainer.setTransform(-94.8,-506.8,1,1,0,0,0,179,24);

	this.timeline.addTween(cjs.Tween.get(this.SaveGamePopUpContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SavegameFeedbackPopupSkin, new cjs.Rectangle(-960.5,-540.5,1921,1081), null);


(lib.PlaceholderScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// continueButton
	this.continueButton = new lib.ContinueButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(682.35,389.1);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// contentTextField
	this.contentTextField = new cjs.Text("[Body]", "48px 'Arial'");
	this.contentTextField.name = "contentTextField";
	this.contentTextField.textAlign = "center";
	this.contentTextField.lineHeight = 71;
	this.contentTextField.lineWidth = 1704;
	this.contentTextField.parent = this;
	this.contentTextField.setTransform(0,-430.7);
ranj.TextOffsetFixer.fix(this.contentTextField);

	this.timeline.addTween(cjs.Tween.get(this.contentTextField).wait(1));

	// bg
	this.bg = new lib.PlaceholderBackground();
	this.bg.name = "bg";
	this.bg.setTransform(0,1.55);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlaceholderScreenSkin, new cjs.Rectangle(-960.5,-538.9,1921,1081), null);


(lib.PausePopupSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.resumeButton = new lib.ResumeButton_1();
	this.resumeButton.name = "resumeButton";
	this.resumeButton.setTransform(-49.5,30,1,1,0,0,0,141,38.5);

	this.timeline.addTween(cjs.Tween.get(this.resumeButton).wait(1));

	// titleTextField
	this.titleTextField = new cjs.Text("The game is paused", "48px 'Work Sans SemiBold'", "#FFFFFF");
	this.titleTextField.name = "titleTextField";
	this.titleTextField.lineHeight = 52;
	this.titleTextField.lineWidth = 657;
	this.titleTextField.parent = this;
	this.titleTextField.setTransform(-298.45,-136.8);
ranj.TextOffsetFixer.fix(this.titleTextField);

	this.timeline.addTween(cjs.Tween.get(this.titleTextField).wait(1));

	// Icon
	this.instance = new lib.PauseIcon();
	this.instance.setTransform(-354,-122);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// panelBG
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#1E1E28").s().p("Eg0LAVGQiVAAhphpQhqhqAAiVIAA+7QAAiVBqhqQBphpCVAAMBoXAAAQCVAABqBpQBpBqAACVIAAe7QAACVhpBqQhqBpiVAAg");
	this.shape.setTransform(0,-35);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Overlay
	this.bg = new lib.Overlay();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PausePopupSkin, new cjs.Rectangle(-960.5,-540.5,1921,1081), null);


(lib.LoadingScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// contentTextField
	this.loadingTextField = new cjs.Text("Loading chapter content...", "bold 55px 'Work Sans'", "#324141");
	this.loadingTextField.name = "loadingTextField";
	this.loadingTextField.lineHeight = 67;
	this.loadingTextField.lineWidth = 752;
	this.loadingTextField.parent = this;
	this.loadingTextField.setTransform(-566.9,-390.95);
ranj.TextOffsetFixer.fix(this.loadingTextField);

	this.timeline.addTween(cjs.Tween.get(this.loadingTextField).wait(1));

	// bg
	this.bg = new lib.LoadingBG();
	this.bg.name = "bg";
	this.bg.setTransform(0,0,1,1,0,0,0,960,540);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingScreenSkin, new cjs.Rectangle(-960,-540,1920,1080), null);


(lib.KeyDecisionUnderlayScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// topBar
	this.topBar = new lib.TopBar_1();
	this.topBar.name = "topBar";
	this.topBar.setTransform(-4,-439,0.9989,1,0,0,0,960.5,101);

	this.timeline.addTween(cjs.Tween.get(this.topBar).wait(1));

	// bottomBar
	this.bottomBar = new lib.BottomBar_1();
	this.bottomBar.name = "bottomBar";
	this.bottomBar.setTransform(-1,451.5,0.9989,1,0,0,0,960.5,89.5);

	this.timeline.addTween(cjs.Tween.get(this.bottomBar).wait(1));

	// imageContainer
	this.imageContainer = new lib.KeyDecisionUnderlayImageContainer();
	this.imageContainer.name = "imageContainer";

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecisionUnderlayScreenSkin, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.KeyDecisionConfirmationScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// text
	this.continueButton = new lib.ContinueButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(-459.45,173.25,1,1,0,0,0,10.5,1);

	this.bodyTextField = new cjs.Text("You've just submitted your key decision and are now being informed on how things will proceed, after which you can click continue to, well, continue playing.", "24px 'Work Sans Medium'", "#324141");
	this.bodyTextField.name = "bodyTextField";
	this.bodyTextField.lineHeight = 30;
	this.bodyTextField.lineWidth = 616;
	this.bodyTextField.parent = this;
	this.bodyTextField.setTransform(-622.45,-73.75);
ranj.TextOffsetFixer.fix(this.bodyTextField);

	this.titleTextField = new cjs.Text("Key decision submitted", "bold 50px 'Work Sans ExtraBold'", "#324141");
	this.titleTextField.name = "titleTextField";
	this.titleTextField.lineHeight = 74;
	this.titleTextField.lineWidth = 616;
	this.titleTextField.parent = this;
	this.titleTextField.setTransform(-622.45,-175.6);
ranj.TextOffsetFixer.fix(this.titleTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.titleTextField},{t:this.bodyTextField},{t:this.continueButton}]}).wait(1));

	// overlayforreadability
	this.instance = new lib.KDconfirmationIcon();
	this.instance.setTransform(-694.95,-109.65,1,1,0,0,0,70.5,70);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(255,255,255,0.498)").ss(1,1,1).p("Ehy2g3sMDljAAAIAKAAMAAABvZIgKAA");
	this.shape.setTransform(225.95,-183.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(255,255,255,0.278)").s().p("EiV/BUYMAAAiovMBGdAAAMDliAAAMAAABvZMAAAA5Wg");
	this.shape_1.setTransform(0.0125,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape},{t:this.instance}]}).wait(1));

	// bg
	this.instance_1 = new lib.MapBGConfirmationjpgcopy();
	this.instance_1.setTransform(-960,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecisionConfirmationScreenSkin, new cjs.Rectangle(-960,-541,1922,1082), null);


(lib.ExitPopupSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.resumeButton = new lib.ResumeButton_1();
	this.resumeButton.name = "resumeButton";
	this.resumeButton.setTransform(-190.5,101.5);

	this.timeline.addTween(cjs.Tween.get(this.resumeButton).wait(1));

	// titleTextField
	this.titleTextField = new cjs.Text("Exit the simulation", "48px 'Work Sans SemiBold'", "#FFFFFF");
	this.titleTextField.name = "titleTextField";
	this.titleTextField.lineHeight = 56;
	this.titleTextField.lineWidth = 652;
	this.titleTextField.parent = this;
	this.titleTextField.setTransform(-298.45,-136.8);
ranj.TextOffsetFixer.fix(this.titleTextField);

	this.timeline.addTween(cjs.Tween.get(this.titleTextField).wait(1));

	// bodytext
	this.descriptionTextField = new cjs.Text("You can exit the sim anytime by closing the browser tab. The sim is saved automatically during play.", "24px 'Work Sans'", "#FFFFFF");
	this.descriptionTextField.name = "descriptionTextField";
	this.descriptionTextField.lineHeight = 22;
	this.descriptionTextField.lineWidth = 636;
	this.descriptionTextField.parent = this;
	this.descriptionTextField.setTransform(-298.45,-44);
ranj.TextOffsetFixer.fix(this.descriptionTextField);

	this.timeline.addTween(cjs.Tween.get(this.descriptionTextField).wait(1));

	// Icon
	this.instance = new lib.ExitIcon();
	this.instance.setTransform(-354,-122);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Overlay
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#1E1E28").s().p("Eg0LAc6QiVAAhphqQhqhpAAiVMAAAgujQAAiVBqhqQBphpCVAAMBoXAAAQCVAABqBpQBpBqAACVMAAAAujQAACVhpBpQhqBqiVAAg");
	this.shape.setTransform(0,15);

	this.bg = new lib.Overlay();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bg},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ExitPopupSkin, new cjs.Rectangle(-960.5,-540.5,1921,1081), null);


(lib.DecisionScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// dilemmaTextField
	this.dilemmaTextField = new cjs.Text("[Text Lorem ipsum dolor sit amet.]", "italic 32px 'Work Sans'", "#2C3C3C");
	this.dilemmaTextField.name = "dilemmaTextField";
	this.dilemmaTextField.lineHeight = 48;
	this.dilemmaTextField.lineWidth = 502;
	this.dilemmaTextField.parent = this;
	this.dilemmaTextField.setTransform(254.05,-445.6);
ranj.TextOffsetFixer.fix(this.dilemmaTextField);

	this.timeline.addTween(cjs.Tween.get(this.dilemmaTextField).wait(1));

	// continueButton
	this.continueButton = new lib.ContinueButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(619.5,469);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// optionButtons
	this.option4 = new lib.DecisionButton();
	this.option4.name = "option4";
	this.option4.setTransform(428,335.3);

	this.option3 = new lib.DecisionButton();
	this.option3.name = "option3";
	this.option3.setTransform(428,178.4);

	this.option2 = new lib.DecisionButton();
	this.option2.name = "option2";
	this.option2.setTransform(428,21.5);

	this.option1 = new lib.DecisionButton();
	this.option1.name = "option1";
	this.option1.setTransform(428,-135.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.option1},{t:this.option2},{t:this.option3},{t:this.option4}]}).wait(1));

	// imageContainer
	this.imageContainer = new lib.DecisionImageContainer();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(-344,16);

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(1));

	// background
	this.bg = new lib.DecisionScreenBackground();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DecisionScreenSkin, new cjs.Rectangle(-960.5,-540.5,1921,1081), null);


(lib.ConversationStatementScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// characternameTextField
	this.characterNameTextField = new cjs.Text("[Name]", "italic 32px 'Work Sans'", "#2C3C3C");
	this.characterNameTextField.name = "characterNameTextField";
	this.characterNameTextField.lineHeight = 48;
	this.characterNameTextField.lineWidth = 634;
	this.characterNameTextField.parent = this;
	this.characterNameTextField.setTransform(262,-481);
ranj.TextOffsetFixer.fix(this.characterNameTextField);

	this.timeline.addTween(cjs.Tween.get(this.characterNameTextField).wait(1));

	// characterfunctionSubTextField
	this.characterFunctionSubTextField = new cjs.Text("[function]\n[function]", "24px 'Work Sans'", "#2C3C3C");
	this.characterFunctionSubTextField.name = "characterFunctionSubTextField";
	this.characterFunctionSubTextField.lineHeight = 31;
	this.characterFunctionSubTextField.lineWidth = 634;
	this.characterFunctionSubTextField.parent = this;
	this.characterFunctionSubTextField.setTransform(262,-430);
ranj.TextOffsetFixer.fix(this.characterFunctionSubTextField);

	this.timeline.addTween(cjs.Tween.get(this.characterFunctionSubTextField).wait(1));

	// statementTextField
	this.statementTextField = new cjs.Text("[You greet the [Ministry of Health official] who responds warmly. She tells you that officially there are no cases in the country yet, but she too has seen the news and is worried. However, the issue has become politically sensitive. \n\nShe offers to send on the national response plan but warns that it isn’t really designed for this eventuality. \n\nShe concludes by asking you to stay in touch. As you hang up, you’re glad you called—an email might have received a more bureaucratic and less informative response.]\n", "24px 'Work Sans'", "#2C3C3C");
	this.statementTextField.name = "statementTextField";
	this.statementTextField.lineHeight = 30;
	this.statementTextField.lineWidth = 639;
	this.statementTextField.parent = this;
	this.statementTextField.setTransform(263.05,-346.9);
ranj.TextOffsetFixer.fix(this.statementTextField);

	this.timeline.addTween(cjs.Tween.get(this.statementTextField).wait(1));

	// continueButton
	this.continueButton = new lib.ContinueButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(749.75,468.5);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// imageMask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("EhHtBLKQlcAAj2j2Qj2j2AAlcMAAAh8DQAAlcD2j2QD2j2FcAAMCPbAAAQFcAAD2D2QD2D2AAFcMAAAB8DQAAFcj2D2Qj2D2lcAAg");
	mask.setTransform(-344,16);

	// imageContainer
	this.imageContainer = new lib.DecisionImageContainer();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(-344,16);

	var maskedShapeInstanceList = [this.imageContainer];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(1));

	// background
	this.bg = new lib.DecisionScreenBackgroun();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationStatementScreenSkin, new cjs.Rectangle(-960.5,-540.5,1921,1081), null);


(lib.BriefingScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// continueButton
	this.ContinueButton = new lib.ContinueButton();
	this.ContinueButton.name = "ContinueButton";
	this.ContinueButton.setTransform(267.25,353.3);

	this.timeline.addTween(cjs.Tween.get(this.ContinueButton).wait(1));

	// headerTextField
	this.CWeekNumber = new cjs.Text("Week 1", "50px 'Work Sans Light'");
	this.CWeekNumber.name = "CWeekNumber";
	this.CWeekNumber.lineHeight = 61;
	this.CWeekNumber.lineWidth = 331;
	this.CWeekNumber.parent = this;
	this.CWeekNumber.setTransform(-352.45,-373.05);
ranj.TextOffsetFixer.fix(this.CWeekNumber);

	this.BulletPoint = new cjs.Text("• ", "50px 'Work Sans Light'");
	this.BulletPoint.name = "BulletPoint";
	this.BulletPoint.lineHeight = 61;
	this.BulletPoint.lineWidth = 22;
	this.BulletPoint.parent = this;
	this.BulletPoint.setTransform(-394.2,-373.05);
ranj.TextOffsetFixer.fix(this.BulletPoint);

	this.ChapterTitle = new cjs.Text("Bacterial Meningitis or Something More?", "bold 50px 'Work Sans'");
	this.ChapterTitle.name = "ChapterTitle";
	this.ChapterTitle.lineHeight = 61;
	this.ChapterTitle.lineWidth = 1050;
	this.ChapterTitle.parent = this;
	this.ChapterTitle.setTransform(-642.55,-319.9);
ranj.TextOffsetFixer.fix(this.ChapterTitle);

	this.ChapterNumber = new cjs.Text("Chapter 1:", "50px 'Work Sans Light'");
	this.ChapterNumber.name = "ChapterNumber";
	this.ChapterNumber.lineHeight = 61;
	this.ChapterNumber.lineWidth = 247;
	this.ChapterNumber.parent = this;
	this.ChapterNumber.setTransform(-642.55,-373.05);
ranj.TextOffsetFixer.fix(this.ChapterNumber);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.ChapterNumber},{t:this.ChapterTitle},{t:this.BulletPoint},{t:this.CWeekNumber}]}).wait(1));

	// contentTextField
	this.ChapterContent = new cjs.Text("You just left a sub-national Health Coordination Group meeting, chaired by the Ministry of Health (MoH), with attendees from health organizations in Murelle and nearby areas.\n\nThe meeting discussed 12 cases of suspected bacterial meningitis with respiratory symptoms in the district hospital over the past 3 weeks. One non-governmental organization (NGO) Health Coordinator mentioned a similar outbreak caused by the Enni Virus (EnV) in Kwaland a few years ago, spread by infected bats, simberri sap and respiratory droplets. Other organizations suggested it may be a common seasonal respiratory disease but were concerned about the altered level of consciousness in patients.\n\nThe MoH is conducting further testing in the main national laboratory in the capital city of Myro in an effort to sequence the pathogen responsible for these recent cases. The MoH says the additional testing is a precautionary measure, and that there is no cause for alarm, but everyone must monitor the situation closely.", "24px 'Work Sans'");
	this.ChapterContent.name = "ChapterContent";
	this.ChapterContent.lineHeight = 30;
	this.ChapterContent.lineWidth = 1026;
	this.ChapterContent.parent = this;
	this.ChapterContent.setTransform(-642.55,-220);
ranj.TextOffsetFixer.fix(this.ChapterContent);

	this.timeline.addTween(cjs.Tween.get(this.ChapterContent).wait(1));

	// Layer_2
	this.ChapterContentContainer = new lib.ChapterContentContainer();
	this.ChapterContentContainer.name = "ChapterContentContainer";
	this.ChapterContentContainer.setTransform(-209.1,-73.4,1,1,0,0,0,557,353.5);

	this.timeline.addTween(cjs.Tween.get(this.ChapterContentContainer).wait(1));

	// horizontal_bars
	this.BriefingTimelineSmallBar = new lib.BriefingTimelineSmallBar();
	this.BriefingTimelineSmallBar.name = "BriefingTimelineSmallBar";
	this.BriefingTimelineSmallBar.setTransform(-792.35,453,1,1,0,0,0,80,36.5);

	this.BriefingTimelineSmallBar_1 = new lib.BriefingTimelineSmallBar();
	this.BriefingTimelineSmallBar_1.name = "BriefingTimelineSmallBar_1";
	this.BriefingTimelineSmallBar_1.setTransform(-792.35,-422,1,1,0,0,0,80,36.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.BriefingTimelineSmallBar_1},{t:this.BriefingTimelineSmallBar}]}).wait(1));

	// black_bar
	this.BriefingTimelineBar = new lib.BriefingTimelineBar();
	this.BriefingTimelineBar.name = "BriefingTimelineBar";
	this.BriefingTimelineBar.setTransform(-795.8,63.5,1,1,0,0,0,18.5,341);

	this.timeline.addTween(cjs.Tween.get(this.BriefingTimelineBar).wait(1));

	// Timeline
	this.BriefingTimelineBackground = new lib.BriefingTimelineBackground_1();
	this.BriefingTimelineBackground.name = "BriefingTimelineBackground";
	this.BriefingTimelineBackground.setTransform(-792.8,3.7,1,1,0,0,0,36,561);

	this.timeline.addTween(cjs.Tween.get(this.BriefingTimelineBackground).wait(1));

	// bg
	this.instance = new lib.BriefingBackground();
	this.instance.setTransform(-960,-540);

	this.bg = new lib.BriefingBackground_1();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bg},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BriefingScreenSkin, new cjs.Rectangle(-960.5,-557.3,1921.5,1122), null);


(lib.NPCPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// continueButton
	this.continueButton = new lib.continueButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(206,-56.4,1,1,0,0,0,50,15.5);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// npcNamePanel
	this.npcNamePanel = new lib.NPCLabelPanel();
	this.npcNamePanel.name = "npcNamePanel";
	this.npcNamePanel.setTransform(-231.5,-16.4);

	this.timeline.addTween(cjs.Tween.get(this.npcNamePanel).wait(1));

	// npcTextPanel
	this.npcTextPanel = new lib.NpcTextPanel();
	this.npcTextPanel.name = "npcTextPanel";
	this.npcTextPanel.setTransform(0,0.4,1,1,0,0,0,0,0.9);

	this.timeline.addTween(cjs.Tween.get(this.npcTextPanel).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NPCPanel, new cjs.Rectangle(-330,-71.9,780,350.4), null);


(lib.PlanComposerKeyDecision_SubmitButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Submit", "28px 'Work Sans SemiBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 278;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-73.2,-10.65);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Submit", "28px 'Work Sans SemiBold'", "#D1D2C6");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 278;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-73.2,-10.65);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Submit", "28px 'Work Sans SemiBold'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 278;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-73.2,-10.65);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Submit", "28px 'Work Sans SemiBold'", "#324141");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 278;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-73.2,-10.65);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// bg
	this.instance = new lib.PlanComposerKeyDecision_SubmitIcon();
	this.instance.setTransform(-113.6,5.85,1,1,0,0,0,22,22);

	this.instance_1 = new lib.PlanComposerKeyDecision_ButtonUp();
	this.instance_1.setTransform(36.5,7,1,1,0,0,0,191,38.5);

	this.instance_2 = new lib.PlanComposerKeyDecision_ButtonOver();
	this.instance_2.setTransform(36.55,6.45,1,1,0,0,0,191,38.5);

	this.instance_3 = new lib.PlanComposerKeyDecision_ButtonDown();
	this.instance_3.setTransform(36.55,6.45,1,1,0,0,0,191,38.5);

	this.instance_4 = new lib.PlanComposerKeyDecision_ButtonDisabled();
	this.instance_4.setTransform(37.5,6.6,1,1,0,0,0,191,38.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance}]},1).to({state:[{t:this.instance_3},{t:this.instance}]},1).to({state:[{t:this.instance_4},{t:this.instance}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-154.5,-32,383,77.5);


(lib.PlanComposerKeyDecision_AnswerButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3,"selecteUp":4,"selectedOver":5,"SelectedDown":6,"SelectedDisabled":7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance ", "24px 'Work Sans'", "#2C3C3C");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 30;
	this.upLabelTextField.lineWidth = 717;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(62.4,14.55);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(8));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Unlock by gathering more inforamtion", "24px 'Work Sans'", "#98A0A0");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 30;
	this.disabledLabelTextField.lineWidth = 717;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(62.4,14.55);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(8));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance ", "24px 'Work Sans'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 30;
	this.downLabelTextField.lineWidth = 717;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(62.4,14.55);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(8));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance ", "24px 'Work Sans'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 30;
	this.overLabelTextField.lineWidth = 717;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(62.4,14.55);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(8));

	// bg
	this.instance = new lib.PlanComposerKeyDecision_AnswerUp();
	this.instance.setTransform(411.65,78.5,1,1,0,0,0,416,80.5);

	this.instance_1 = new lib.PlanComposerKeyDecision_AnswerOver();
	this.instance_1.setTransform(411.65,78.5,1,1,0,0,0,416,80.5);

	this.instance_2 = new lib.ContinueButtonHi();
	this.instance_2.setTransform(43,22);

	this.instance_3 = new lib.PlanComposerKeyDecision_AnswerDown();
	this.instance_3.setTransform(434.15,84.5,1,1,0,0,0,438.5,84.5);

	this.instance_4 = new lib.PlanComposerKeyDecision_AnswerLocked();
	this.instance_4.setTransform(411.05,79.75,1,1,0,0,0,416,80.5);

	this.instance_5 = new lib.ContinueButtonDisabled();
	this.instance_5.setTransform(43,24);

	this.instance_6 = new lib.keyDecisionPlanComposer_AnswerSelectedUp();
	this.instance_6.setTransform(403.5,68,1,1,0,0,0,403.5,68);

	this.instance_7 = new lib.keyDecisionPlanComposer_AnswerSelectedOver();
	this.instance_7.setTransform(403.3,67.9,1,1,0,0,0,403.5,68);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2,p:{x:43,y:22}},{t:this.instance_1}]},1).to({state:[{t:this.instance_2,p:{x:49,y:24}},{t:this.instance_3}]},1).to({state:[{t:this.instance_5},{t:this.instance_4,p:{x:411.05}}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_2,p:{x:49,y:24}},{t:this.instance_3}]},1).to({state:[{t:this.instance_5},{t:this.instance_4,p:{x:411.65}}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-4.9,-2,886.6,172);


(lib.PauseResumeButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {pauseButton:0,resumeButton:1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bg
	this.pauseButton = new lib.PauseButton();
	this.pauseButton.name = "pauseButton";
	this.pauseButton.setTransform(-125.5,-2.5,1,1,0,0,0,-125.5,-2.5);

	this.resumeButton = new lib.ResumeButton();
	this.resumeButton.name = "resumeButton";
	this.resumeButton.setTransform(-125.5,-2,1,1,0,0,0,-125.5,-2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.pauseButton}]}).to({state:[{t:this.resumeButton}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-155,-32,59,60);


(lib.KDContinueButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 236;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-137,-17.65);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#EEEAE5");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 236;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-137,-17.65);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#DE7824");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 236;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-137,-17.65);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#DE7824");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 236;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-137,-17.65);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// bg
	this.instance = new lib.KDContinueUp();
	this.instance.setTransform(10.5,1,1,1,0,0,0,165,32.5);

	this.instance_1 = new lib.KDContinueOver();
	this.instance_1.setTransform(10.5,1,1,1,0,0,0,165,32.5);

	this.instance_2 = new lib.KDContinueDisabled();
	this.instance_2.setTransform(10.5,1,1,1,0,0,0,165,32.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-154.5,-31.5,330,65);


(lib.FeedbackToggleButtonWhiteScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Show optimal answers\nShow optimal answers", "28px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 31;
	this.upLabelTextField.lineWidth = 326;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-132,-30.3);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Show optimal answers\nShow optimal answers", "28px 'Work Sans'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 31;
	this.disabledLabelTextField.lineWidth = 326;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-132,-30.3);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Show optimal answers\nShow optimal answers", "28px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 31;
	this.downLabelTextField.lineWidth = 326;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-132,-30.3);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Show optimal answers\nShow optimal answers", "28px 'Work Sans'", "#84A346");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 31;
	this.overLabelTextField.lineWidth = 326;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-132,-30.3);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// bg
	this.instance = new lib.FeedbackOptimalUp();
	this.instance.setTransform(15.4,10.35,1,1,0,0,0,223,45.5);

	this.instance_1 = new lib.FeedbackOptimalOver();
	this.instance_1.setTransform(10.9,5.35,1,1,0,0,0,218.5,40.5);

	this.instance_2 = new lib.FeedbackOptimalDown();
	this.instance_2.setTransform(16.4,5.35,1,1,0,0,0,224,40.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-207.6,-35.1,421,76);


(lib.FeedbackToggleButtonBlackScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Hide optimal answers\nHide optimal answers", "28px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 326;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-134.1,-33.15);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Hide optimal answers\nHide optimal answers", "28px 'Work Sans'", "#324141");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 326;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-134.1,-33.15);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Hide optimal answers\nHide optimal answers", "28px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 326;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-134.1,-33.15);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Hide optimal answers\nHide optimal answers", "28px 'Work Sans'", "#324141");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 326;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-134.1,-33.15);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// bg
	this.instance = new lib.FeedbackPlayerChoiceUp();
	this.instance.setTransform(15.4,10.35,1,1,0,0,0,223,45.5);

	this.instance_1 = new lib.FeedbackPlayerChoiceOver();
	this.instance_1.setTransform(10.9,5.35,1,1,0,0,0,218.5,40.5);

	this.instance_2 = new lib.FeedbackPlayerChoiceDown();
	this.instance_2.setTransform(16.4,5.35,1,1,0,0,0,224,40.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-207.6,-35.1,421,76);


(lib.FeedbackButtonOptimalGreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 21;
	this.upLabelTextField.lineWidth = 440;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-131.4,-19.4);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 21;
	this.disabledLabelTextField.lineWidth = 440;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-131.4,-19.4);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 21;
	this.downLabelTextField.lineWidth = 440;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-131.4,-19.4);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 21;
	this.overLabelTextField.lineWidth = 440;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-131.4,-19.4);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Stars_and_expand
	this.instance = new lib.FeedbackGoodStars();
	this.instance.setTransform(-180.45,24.35,1,1,0,0,0,36.6,9);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// bg
	this.OptimalLockedAnswer = new lib.IconOptimalLocked();
	this.OptimalLockedAnswer.name = "OptimalLockedAnswer";
	this.OptimalLockedAnswer.setTransform(-239.05,-17.5,1,1,0,0,0,21,20.5);

	this.instance_1 = new lib.FeedbackGoodUp();
	this.instance_1.setTransform(130.05,33,1,1,0,0,0,369,64.5);

	this.instance_2 = new lib.FeedbackGoodOver();
	this.instance_2.setTransform(130.05,33,1,1,0,0,0,369,64.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.OptimalLockedAnswer}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-260,-38,607.1,103.5);


(lib.FeedbackButtonOptimal = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.OptimalLockedAnswer = new lib.IconOptimalLocked();
	this.OptimalLockedAnswer.name = "OptimalLockedAnswer";
	this.OptimalLockedAnswer.setTransform(-239.05,-20.5,1,1,0,0,0,21,20.5);

	this.timeline.addTween(cjs.Tween.get(this.OptimalLockedAnswer).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#324141");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 21;
	this.upLabelTextField.lineWidth = 440;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-131.4,-19.4);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#324141");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 21;
	this.disabledLabelTextField.lineWidth = 440;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-131.4,-19.4);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#324141");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 21;
	this.downLabelTextField.lineWidth = 440;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-131.4,-19.4);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#324141");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 21;
	this.overLabelTextField.lineWidth = 440;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-131.4,-19.4);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Stars_and_expand
	this.instance = new lib.FeedbackOptimalStars();
	this.instance.setTransform(-180.45,24.35,1,1,0,0,0,36.6,9);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// bg
	this.instance_1 = new lib.FeedbackOptimalAnswerUp();
	this.instance_1.setTransform(130.05,33,1,1,0,0,0,369,64.5);

	this.instance_2 = new lib.FeedbackOptimalAnswerOver();
	this.instance_2.setTransform(130.05,33,1,1,0,0,0,369,64.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-260,-41,607.1,106.5);


(lib.FeedbackButtonMedium = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 21;
	this.upLabelTextField.lineWidth = 440;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 21;
	this.disabledLabelTextField.lineWidth = 440;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 21;
	this.downLabelTextField.lineWidth = 440;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 21;
	this.overLabelTextField.lineWidth = 440;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Stars_and_expand
	this.instance = new lib.FeedbackMediumStars();
	this.instance.setTransform(-180.45,24.35,1,1,0,0,0,36.6,9);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// bg
	this.instance_1 = new lib.FeedbackMediumUp();
	this.instance_1.setTransform(130.05,33,1,1,0,0,0,369,64.5);

	this.instance_2 = new lib.FeedbackMediumOver();
	this.instance_2.setTransform(130.05,33,1,1,0,0,0,369,64.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-238.9,-31.5,586,95);


(lib.FeedbackButtonGood = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 21;
	this.upLabelTextField.lineWidth = 440;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-131.4,-19.4);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 21;
	this.disabledLabelTextField.lineWidth = 440;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-131.4,-19.4);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 21;
	this.downLabelTextField.lineWidth = 440;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-131.4,-19.4);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 21;
	this.overLabelTextField.lineWidth = 440;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-131.4,-19.4);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Stars_and_expand
	this.instance = new lib.FeedbackGoodStars();
	this.instance.setTransform(-180.45,24.35,1,1,0,0,0,36.6,9);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// bg
	this.instance_1 = new lib.FeedbackGoodUp();
	this.instance_1.setTransform(130.05,33,1,1,0,0,0,369,64.5);

	this.instance_2 = new lib.FeedbackGoodOver();
	this.instance_2.setTransform(130.05,33,1,1,0,0,0,369,64.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-238.9,-31.5,586,97);


(lib.FeedbackButtonBad = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 21;
	this.upLabelTextField.lineWidth = 440;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 21;
	this.disabledLabelTextField.lineWidth = 440;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 21;
	this.downLabelTextField.lineWidth = 440;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 21;
	this.overLabelTextField.lineWidth = 440;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Stars_and_expand
	this.instance = new lib.FeedbackBadStars();
	this.instance.setTransform(-180.45,24.35,1,1,0,0,0,36.6,9);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// bg
	this.instance_1 = new lib.FeedbackBadUp();
	this.instance_1.setTransform(130.05,33,1,1,0,0,0,369,64.5);

	this.instance_2 = new lib.FeedbackBadOver();
	this.instance_2.setTransform(130.05,33,1,1,0,0,0,369,64.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-238.9,-31.5,586,95);


(lib.TopBarCloseWindowButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hitArea
	this.hitArea = new lib.EmptySquare();
	this.hitArea.name = "hitArea";

	this.timeline.addTween(cjs.Tween.get(this.hitArea).wait(4));

	// Layer_2
	this.instance = new lib.CloseButtonBase();
	this.instance.setTransform(0.5,0.5);
	var instanceFilter_1 = new cjs.ColorFilter(0,0,0,1,83,71,65,0);
	this.instance.filters = [instanceFilter_1];
	this.instance.cache(-10,-10,21,21);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2).to({scaleX:0.8235,scaleY:0.8235,x:0.4,y:0.4},0).wait(1).to({scaleX:1,scaleY:1,x:0.5,y:0.5},0).wait(1));
	this.timeline.addTween(cjs.Tween.get(instanceFilter_1).wait(2).to(new cjs.ColorFilter(0,0,0,1,103,102,111,0), 0).wait(1).to(new cjs.ColorFilter(0,0,0,1,235,234,234,0), 0).wait(1));

	this.filterCacheList = [];
	this.filterCacheList.push({instance: this.instance, startFrame:2, endFrame:2, x:-10, y:-10, w:21, h:21});
	this.filterCacheList.push({instance: this.instance, startFrame:0, endFrame:0, x:-10, y:-10, w:21, h:21});
	this.filterCacheList.push({instance: this.instance, startFrame:3, endFrame:3, x:-10, y:-10, w:21, h:21});
	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22,-22,44,44);


(lib.AbortButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Start", "28px 'Work Sans SemiBold'", "#A0A0A0");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 112;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-101,-8.3);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Start", "28px 'Work Sans SemiBold'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 112;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-101,-8.3);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Start", "28px 'Work Sans SemiBold'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 112;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-101,-8.3);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Start", "28px 'Work Sans SemiBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 112;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-101,-8.3);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// bg
	this.instance = new lib.BackOver_1();
	this.instance.setTransform(-115.85,28.35,1,1,0,0,0,108,54);

	this.instance_1 = new lib.BackUp_1();
	this.instance_1.setTransform(-114.85,28.9,1,1,0,0,0,108.5,54.5);

	this.instance_2 = new lib.BackDisabled_1();
	this.instance_2.setTransform(-115.55,29.2,1,1,0,0,0,108,54);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-223.8,-25.6,222,68.80000000000001);


(lib.EndScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// titleTextField
	this.titleTextField = new cjs.Text("_Thank you for playing Outbreak READY 2!: Thisland in Crisis. \nPlease take five minutes to complete a brief survey on Outbreak READY!", "bold 38px 'Work Sans'", "#324141");
	this.titleTextField.name = "titleTextField";
	this.titleTextField.textAlign = "center";
	this.titleTextField.lineHeight = 53;
	this.titleTextField.lineWidth = 1766;
	this.titleTextField.parent = this;
	this.titleTextField.setTransform(0,-325.2);
ranj.TextOffsetFixer.fix(this.titleTextField);

	this.timeline.addTween(cjs.Tween.get(this.titleTextField).wait(1));

	// bodyTextField
	this.bodyTextField = new cjs.Text("READY, led by Save the Children in consortium with the Johns Hopkins Center for Communication Programs, the Johns Hopkins Center for Humanitarian Health, UK-Med, EcoHealth Alliance, and Mercy Malaysia, is augmenting global capacity to respond to major outbreaks of infectious disease with epidemic or pandemic potential. ", "17px 'Work Sans'", "#324141");
	this.bodyTextField.name = "bodyTextField";
	this.bodyTextField.textAlign = "center";
	this.bodyTextField.lineHeight = 14;
	this.bodyTextField.lineWidth = 1384;
	this.bodyTextField.parent = this;
	this.bodyTextField.setTransform(0.85,242.3);
ranj.TextOffsetFixer.fix(this.bodyTextField);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextField).wait(1));

	// websiteInformationTextField
	this.websiteInformationTextField = new cjs.Text("For more information, visit our website at", "bold 24px 'Work Sans'", "#324141");
	this.websiteInformationTextField.name = "websiteInformationTextField";
	this.websiteInformationTextField.textAlign = "right";
	this.websiteInformationTextField.lineHeight = 22;
	this.websiteInformationTextField.lineWidth = 655;
	this.websiteInformationTextField.parent = this;
	this.websiteInformationTextField.setTransform(90.35,-89.25);
ranj.TextOffsetFixer.fix(this.websiteInformationTextField);

	this.timeline.addTween(cjs.Tween.get(this.websiteInformationTextField).wait(1));

	// acknowledgementTextField
	this.acknowledgementTextField = new cjs.Text("Outbreak READY! is made possible by the generous support of the American people through the United States Agency for International Development (USAID). The contents are the responsibility of the READY consortium and do not necessarily reflect the views of USAID or the United States Government.", "17px 'Work Sans'", "#324141");
	this.acknowledgementTextField.name = "acknowledgementTextField";
	this.acknowledgementTextField.textAlign = "center";
	this.acknowledgementTextField.lineHeight = 16;
	this.acknowledgementTextField.lineWidth = 1382;
	this.acknowledgementTextField.parent = this;
	this.acknowledgementTextField.setTransform(-0.15,323);
ranj.TextOffsetFixer.fix(this.acknowledgementTextField);

	this.timeline.addTween(cjs.Tween.get(this.acknowledgementTextField).wait(1));

	// surveyButton
	this.surveyButton = new lib.SurveyButton();
	this.surveyButton.name = "surveyButton";
	this.surveyButton.setTransform(-10.9,-175.05,1,1,0,0,0,171,38.5);

	this.timeline.addTween(cjs.Tween.get(this.surveyButton).wait(1));

	// readyWebsiteButton
	this.readyWebsiteButton = new lib.ReadyWebsiteButton();
	this.readyWebsiteButton.name = "readyWebsiteButton";
	this.readyWebsiteButton.setTransform(289.65,-63.5,1,1,0,0,0,171,38.5);

	this.timeline.addTween(cjs.Tween.get(this.readyWebsiteButton).wait(1));

	// Layer_3
	this.instance = new lib.EndscreenBG();
	this.instance.setTransform(-960,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EndScreenSkin, new cjs.Rectangle(-960,-540,1920,1080), null);


(lib.MapNodeInformationPopupPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// descriptionTextField
	this.descriptionTextField = new cjs.Text("[Description]", "48px 'Arial'");
	this.descriptionTextField.name = "descriptionTextField";
	this.descriptionTextField.textAlign = "center";
	this.descriptionTextField.lineHeight = 71;
	this.descriptionTextField.lineWidth = 940;
	this.descriptionTextField.parent = this;
	this.descriptionTextField.setTransform(0,-136.15);
ranj.TextOffsetFixer.fix(this.descriptionTextField);

	this.timeline.addTween(cjs.Tween.get(this.descriptionTextField).wait(1));

	// titleTextField
	this.titleTextField = new cjs.Text("[Title]", "72px 'Arial'");
	this.titleTextField.name = "titleTextField";
	this.titleTextField.textAlign = "center";
	this.titleTextField.lineHeight = 106;
	this.titleTextField.lineWidth = 940;
	this.titleTextField.parent = this;
	this.titleTextField.setTransform(0,-238.2);
ranj.TextOffsetFixer.fix(this.titleTextField);

	this.timeline.addTween(cjs.Tween.get(this.titleTextField).wait(1));

	// closeButton
	this.closeButton = new lib.PlaceholderCloseButton();
	this.closeButton.name = "closeButton";
	this.closeButton.setTransform(544.85,-285.15);

	this.timeline.addTween(cjs.Tween.get(this.closeButton).wait(1));

	// continueButton
	this.continueButton = new lib.HUBTeaCornerButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(0,161.8,1,1,0,0,0,0,20);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// panel
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EhVIgqaMCqRAAAMAAABU1MiqRAAAg");
	this.shape.setTransform(0,-0.025);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#999999").s().p("EhVIAqbMAAAhU1MCqRAAAMAAABU1g");
	this.shape_1.setTransform(0,-0.025);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.MapNodeInformationPopupPanel, new cjs.Rectangle(-545.8,-330.6,1136.1,603.1), null);


(lib.KeyDecisionAvailablePanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.instance = new lib.KeyDecDown();
	this.instance.setTransform(-515,-296);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(219,120,35,0.518)").ss(1,1,1).p("Egv5gN1MBfzAAAEgv5AN2MBfzAAA");
	this.shape.setTransform(-226.8,-76.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Laag_1
	this.KDbackButton = new lib.KDBackButton();
	this.KDbackButton.name = "KDbackButton";
	this.KDbackButton.setTransform(-352.1,330.4,1,1,0,0,0,10.5,1);

	this.continueButton = new lib.KDContinueButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(-112.6,330.1);

	this.disclaimerTextField = new cjs.Text("You can always exit the Key Decision for further investigation.", "bold 20px 'Work Sans'", "#DD7823");
	this.disclaimerTextField.name = "disclaimerTextField";
	this.disclaimerTextField.lineHeight = 21;
	this.disclaimerTextField.lineWidth = 465;
	this.disclaimerTextField.parent = this;
	this.disclaimerTextField.setTransform(-506.35,370.75);
ranj.TextOffsetFixer.fix(this.disclaimerTextField);

	this.keyDecisionTextfield = new cjs.Text("Determine your first priority steps when hearing of the outbreak. Determine your first priority steps when hearing of the outbreak. Determine your first priority steps when hearing of the outbreak.", "bold 24px 'Work Sans ExtraBold'", "#FFFFFF");
	this.keyDecisionTextfield.name = "keyDecisionTextfield";
	this.keyDecisionTextfield.lineHeight = 33;
	this.keyDecisionTextfield.lineWidth = 583;
	this.keyDecisionTextfield.parent = this;
	this.keyDecisionTextfield.setTransform(-518,-160.5);
ranj.TextOffsetFixer.fix(this.keyDecisionTextfield);

	this.headerTextField = new cjs.Text("Key decision", "bold 50px 'Work Sans ExtraBold'", "#FFFFFF");
	this.headerTextField.name = "headerTextField";
	this.headerTextField.lineHeight = 74;
	this.headerTextField.lineWidth = 336;
	this.headerTextField.parent = this;
	this.headerTextField.setTransform(-367.05,-284.1);
ranj.TextOffsetFixer.fix(this.headerTextField);

	this.descriptionTextField = new cjs.Text("You have received a message of concern from a Clinic Supervisor from the IDP. It is important to figure out how best to act on this. If there appears to be an outbreak of a new virus, it is vital to prioritize. Think carefully about your choices before you send them out.", "24px 'Work Sans Medium'", "#FFFFFF");
	this.descriptionTextField.name = "descriptionTextField";
	this.descriptionTextField.lineHeight = 28;
	this.descriptionTextField.lineWidth = 582;
	this.descriptionTextField.parent = this;
	this.descriptionTextField.setTransform(-518,24.4);
ranj.TextOffsetFixer.fix(this.descriptionTextField);

	this.bg = new lib.KeyDecPopUpBG();
	this.bg.name = "bg";
	this.bg.setTransform(550.75,351,1,1,0,0,0,552,350.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bg},{t:this.descriptionTextField},{t:this.headerTextField},{t:this.keyDecisionTextfield},{t:this.disclaimerTextField},{t:this.continueButton},{t:this.KDbackButton}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecisionAvailablePanel, new cjs.Rectangle(-553.2,-350.5,660,809), null);


(lib.KeyDecButtonUp_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// States
	this.instance = new lib.KeyDecButtonUp();
	this.instance.setTransform(3,-1);

	this.instance_1 = new lib.KeyDecButtonOver();
	this.instance_1.setTransform(108,107,1,1,0,0,0,107,107);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(1,-1,119,116);


(lib.KeyDecButton_Dialog = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Icon
	this.instance = new lib.KeyDecDialogueUp();
	this.instance.setTransform(13,10);

	this.instance_1 = new lib.KeyDecDialogueOver();
	this.instance_1.setTransform(10,8);

	this.instance_2 = new lib.KeyDecDialogueDown();
	this.instance_2.setTransform(18,16);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// States
	this.instance_3 = new lib.KeyDecButtonUp();

	this.instance_4 = new lib.KeyDecButtonOver();
	this.instance_4.setTransform(104,105,1,1,0,0,0,107,107);

	this.instance_5 = new lib.KeyDecButtonDown_1();
	this.instance_5.setTransform(102,100,1,1,0,0,0,92,93.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3}]}).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3,-2,129,126);


(lib.InternalStakeholders = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// internalStakeholder4
	this.internalStakeholder1 = new lib.InternalStakeholder1Button();
	this.internalStakeholder1.name = "internalStakeholder1";
	this.internalStakeholder1.setTransform(-345.3,-57.5,1,1,0,0,0,-95.5,-7.5);

	this.internalStakeholder2 = new lib.InternalStakeholder2Button();
	this.internalStakeholder2.name = "internalStakeholder2";
	this.internalStakeholder2.setTransform(-167.45,-57.5,1,1,0,0,0,-95.5,-7.5);

	this.internalStakeholder3 = new lib.InternalStakeholder3Button();
	this.internalStakeholder3.name = "internalStakeholder3";
	this.internalStakeholder3.setTransform(10.4,-57.5,1,1,0,0,0,-95.5,-7.5);

	this.internalStakeholder4 = new lib.InternalStakeholder4Button();
	this.internalStakeholder4.name = "internalStakeholder4";
	this.internalStakeholder4.setTransform(188.25,-57.5,1,1,0,0,0,-95.5,-7.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.internalStakeholder4},{t:this.internalStakeholder3},{t:this.internalStakeholder2},{t:this.internalStakeholder1}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.InternalStakeholders, new cjs.Rectangle(-335.8,-318.4,710.6,312.4), null);


(lib.HudSmartphoneButtonTutorial = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// newIndicator
	this.newIndicator = new lib.FakeNewIndicator();
	this.newIndicator.name = "newIndicator";
	this.newIndicator.setTransform(63.25,-58.15);

	this.timeline.addTween(cjs.Tween.get(this.newIndicator).wait(4));

	// bg
	this.instance = new lib.HUBSmartphoneUp();
	this.instance.setTransform(-89,-121);

	this.instance_1 = new lib.HUBSmartphoneOver();
	this.instance_1.setTransform(-89,-121);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-89,-121,177,311.4);


(lib.HudSmartphoneButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// newIndicator
	this.newIndicator = new lib.HubButtonNewIndicator();
	this.newIndicator.name = "newIndicator";
	this.newIndicator.setTransform(63.25,-58.15);

	this.timeline.addTween(cjs.Tween.get(this.newIndicator).wait(4));

	// bg
	this.instance = new lib.HUBSmartphoneUp();
	this.instance.setTransform(-89,-121);

	this.instance_1 = new lib.HUBSmartphoneOver();
	this.instance_1.setTransform(-89,-121);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-89,-121,194.3,311.4);


(lib.HudLaptopButtonTutorial = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// newIndicator
	this.newIndicator = new lib.FakeNewIndicator();
	this.newIndicator.name = "newIndicator";
	this.newIndicator.setTransform(112.25,-73.15);

	this.timeline.addTween(cjs.Tween.get(this.newIndicator).wait(4));

	// bg
	this.instance = new lib.HUBLaptopUp();
	this.instance.setTransform(-141,-99);

	this.instance_1 = new lib.HUBLaptopOver();
	this.instance_1.setTransform(-161,-119);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-161,-119,320,309.2);


(lib.HudLaptopButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// newIndicator
	this.newIndicator = new lib.HubButtonNewIndicator();
	this.newIndicator.name = "newIndicator";
	this.newIndicator.setTransform(112.25,-73.15);

	this.timeline.addTween(cjs.Tween.get(this.newIndicator).wait(4));

	// bg
	this.instance = new lib.HUBLaptopUp();
	this.instance.setTransform(-141,-99);

	this.instance_1 = new lib.HUBLaptopOver();
	this.instance_1.setTransform(-161,-119);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-161,-119,320,309.2);


(lib.HubKeyDecisionNotification_Mail = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.button = new lib.KeyDecButtonUp_1();
	this.button.name = "button";
	this.button.setTransform(15.15,19.25,1,1,0,0,0,107,107);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HubKeyDecisionNotification_Mail, new cjs.Rectangle(-88.8,-88.7,113,109), null);


(lib.HubKeyDecisionNotification_Generic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// NewKDAnim
	this.NewKDAnim = new lib.NewKDAnim();
	this.NewKDAnim.name = "NewKDAnim";
	this.NewKDAnim.setTransform(-32.5,-34.5,1,1,0,0,0,56.5,54.5);

	this.timeline.addTween(cjs.Tween.get(this.NewKDAnim).to({_off:true},1).wait(6));

	// NewIndicator
	this.newKeyDecision = new lib.newKeyDecIcon();
	this.newKeyDecision.name = "newKeyDecision";
	this.newKeyDecision.setTransform(18.9,-69.5,1,1,0,0,0,25,22.5);
	this.newKeyDecision._off = true;

	this.timeline.addTween(cjs.Tween.get(this.newKeyDecision).wait(1).to({_off:false},0).wait(1).to({_off:true},1).wait(4));

	// ActiveKD
	this.button = new lib.HubKeyDecisionNotification_Mail();
	this.button.name = "button";
	this.button.setTransform(0,-0.95);
	this.button._off = true;

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1).to({_off:false},0).wait(3).to({_off:true},1).wait(2));

	// Pointer
	this.pointer = new lib.KDPopUpPointer();
	this.pointer.name = "pointer";
	this.pointer.setTransform(-95,-36.5,1,1,0,0,0,12,23.5);
	this.pointer._off = true;

	this.timeline.addTween(cjs.Tween.get(this.pointer).wait(4).to({_off:false},0).to({_off:true},1).wait(2));

	// NewIndicator
	this.panel = new lib.NewKDLabel_1();
	this.panel.name = "panel";
	this.panel.setTransform(-265.65,-29.35,1,1,0,0,0,203.5,44);
	this.panel._off = true;

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1).to({_off:false},0).to({_off:true},1).wait(5));

	// KDCompleted
	this.button_1 = new lib.KeyDecButtonCompleted_1();
	this.button_1.name = "button_1";
	this.button_1.setTransform(-33.15,-33.9,1,1,0,0,0,31.5,31.5);
	this.button_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.button_1).wait(6).to({_off:false},0).wait(1));

	// KDLocked
	this.button_2 = new lib.KeyDecButtonLocked_1();
	this.button_2.name = "button_2";
	this.button_2.setTransform(-33.15,-33.5,1,1,0,0,0,31,31);
	this.button_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.button_2).wait(5).to({_off:false},0).to({_off:true},1).wait(1));

	// Layer_2
	this.panel2 = new lib.KeyDecInfoBar();
	this.panel2.name = "panel2";
	this.panel2.setTransform(-222.45,-3.75,1,1,0,0,0,368,79);
	this.panel2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.panel2).wait(3).to({_off:false},0).to({_off:true},1).wait(3));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-590.4,-152.1,634.3,205.2);


(lib.HubKeyDecisionNotification_Dialog = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.button = new lib.KeyDecButton_Dialog();
	this.button.name = "button";
	this.button.setTransform(-2.95,4,1,1,0,0,0,107,107);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	// panel
	this.panel = new lib.KeyDecInfoBar();
	this.panel.name = "panel";
	this.panel.setTransform(-160.65,-1.2,1,1,0,0,0,368,79);

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HubKeyDecisionNotification_Dialog, new cjs.Rectangle(-528.6,-103,570,126.8), null);


(lib.HubKeyDecisionNotification_Composer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Dividers
	this.dividerActive = new lib.KeyDecDivider_1();
	this.dividerActive.name = "dividerActive";
	this.dividerActive.setTransform(-35.25,35.25,1,1,0,0,0,20,6.5);

	this.dividerInactive = new lib.KeyDecDivider_1();
	this.dividerInactive.name = "dividerInactive";
	this.dividerInactive.setTransform(-35.25,9.1,1,1,0,0,0,20,6.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.dividerActive}]}).to({state:[{t:this.dividerInactive}]},2).wait(2));

	// NewIndicator
	this.newKeyDecision = new lib.newKeyDecIcon();
	this.newKeyDecision.name = "newKeyDecision";
	this.newKeyDecision.setTransform(12,-69.5,1,1,0,0,0,25,22.5);

	this.timeline.addTween(cjs.Tween.get(this.newKeyDecision).to({_off:true},1).wait(3));

	// KDCompleted
	this.CompletedKeyDecision = new lib.KeyDecButtonCompleted_1();
	this.CompletedKeyDecision.name = "CompletedKeyDecision";
	this.CompletedKeyDecision.setTransform(-33.15,-33.9,1,1,0,0,0,31.5,31.5);
	this.CompletedKeyDecision._off = true;

	this.timeline.addTween(cjs.Tween.get(this.CompletedKeyDecision).wait(3).to({_off:false},0).wait(1));

	// KDLocked
	this.LockedKeyDecision = new lib.KeyDecButtonLocked_1();
	this.LockedKeyDecision.name = "LockedKeyDecision";
	this.LockedKeyDecision.setTransform(-33.15,-33.5,1,1,0,0,0,31,31);
	this.LockedKeyDecision._off = true;

	this.timeline.addTween(cjs.Tween.get(this.LockedKeyDecision).wait(2).to({_off:false},0).to({_off:true},1).wait(1));

	// button
	this.button = new lib.KeyDecButtonUp_1();
	this.button.name = "button";
	this.button.setTransform(15.15,18.75,1,1,0,0,0,107,107);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1).to({_off:true},1).wait(2));

	// panel
	this.panel = new lib.KeyDecInfoBar();
	this.panel.name = "panel";
	this.panel.setTransform(-216.45,-2.8,1,1,0,0,0,368,79);

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1).to({_off:true},1).wait(2));

	// ActiveBar
	this.activeBar = new lib.KeyDecActiveBar();
	this.activeBar.name = "activeBar";
	this.activeBar.setTransform(-35.2,-31.95,1,1,0,0,0,8,70);

	this.instance = new lib.KeyDecActiveBar();
	this.instance.setTransform(-35.2,-31.95,1,1,0,0,0,8,70);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.activeBar}]}).to({state:[{t:this.instance}]},1).to({state:[]},1).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-584.4,-96.8,621.4,138.6);


(lib.FeedbackKeyDecisionNotification_Generic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// NewKDAnim
	this.instance = new lib.NewKDAnim();
	this.instance.setTransform(-32.5,-34.5,1,1,0,0,0,56.5,54.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},1).wait(6));

	// NewIndicator
	this.newKeyDecision = new lib.newKeyDecIcon();
	this.newKeyDecision.name = "newKeyDecision";
	this.newKeyDecision.setTransform(18.9,-69.5,1,1,0,0,0,25,22.5);
	this.newKeyDecision._off = true;

	this.timeline.addTween(cjs.Tween.get(this.newKeyDecision).wait(1).to({_off:false},0).wait(1).to({_off:true},1).wait(4));

	// ActiveKD
	this.button = new lib.HubKeyDecisionNotification_Mail();
	this.button.name = "button";
	this.button.setTransform(0,-0.95);
	this.button._off = true;

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1).to({_off:false},0).to({_off:true},2).wait(1).to({_off:false},0).to({_off:true},1).wait(2));

	// Pointer
	this.pointer = new lib.FeedbackPointerWhite();
	this.pointer.name = "pointer";
	this.pointer.setTransform(35.85,-36,1,1,0,0,0,12.5,24);
	this.pointer._off = true;

	this.timeline.addTween(cjs.Tween.get(this.pointer).wait(4).to({_off:false},0).to({_off:true},1).wait(2));

	// NewIndicator
	this.panel = new lib.NewKDLabel_1();
	this.panel.name = "panel";
	this.panel.setTransform(-265.65,-29.35,1,1,0,0,0,203.5,44);
	this.panel._off = true;

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1).to({_off:false},0).to({_off:true},1).wait(5));

	// KDCompleted
	this.button_1 = new lib.KeyDecButtonCompleted_1();
	this.button_1.name = "button_1";
	this.button_1.setTransform(-33.15,-33.9,1,1,0,0,0,31.5,31.5);
	this.button_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.button_1).wait(6).to({_off:false},0).wait(1));

	// KDLocked
	this.button_2 = new lib.KeyDecButtonLocked_1();
	this.button_2.name = "button_2";
	this.button_2.setTransform(-33.15,-33.5,1,1,0,0,0,31,31);
	this.button_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.button_2).wait(5).to({_off:false},0).to({_off:true},1).wait(1));

	// Layer_4
	this.buttonFeedbackInactive = new lib.FeedbackInactiveKDstate();
	this.buttonFeedbackInactive.name = "buttonFeedbackInactive";
	this.buttonFeedbackInactive.setTransform(-34.25,-36.3,1,1,0,0,0,24,24.5);
	this.buttonFeedbackInactive._off = true;

	this.timeline.addTween(cjs.Tween.get(this.buttonFeedbackInactive).wait(3).to({_off:false},0).to({_off:true},1).wait(3));

	// Layer_2
	this.panel2 = new lib.FeedbackTimelineInfoBar();
	this.panel2.name = "panel2";
	this.panel2.setTransform(248.95,-31,1,1,0,0,0,254,48);
	this.panel2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.panel2).wait(3).to({_off:false},0).to({_off:true},1).wait(3));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-469.1,-152.1,972.1,205.2);


(lib.FeedbackKeyDecisionElaboration = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.button = new lib.KeyDecButtonUp_1();
	this.button.name = "button";
	this.button.setTransform(15.15,19.25,1,1,0,0,0,107,107);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackKeyDecisionElaboration, new cjs.Rectangle(-88.8,-88.7,113,109), null);


(lib.FeedbackKeyDecisionContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// KDLocked
	this.instance = new lib.FeedbackKDInactiveButton();
	this.instance.setTransform(-63.65,-35.5,1,1,0,0,0,29.5,28.5);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2).to({_off:false},0).to({_off:true},1).wait(3));

	// FeedbackPointer
	this.FeedbackPointer = new lib.FeedbackPointer_1();
	this.FeedbackPointer.name = "FeedbackPointer";
	this.FeedbackPointer.setTransform(18.5,-36,1,1,0,0,0,21.5,48);

	this.timeline.addTween(cjs.Tween.get(this.FeedbackPointer).to({_off:true},2).wait(4));

	// ActiveKD_s
	this.instance_1 = new lib.FeedbackKeyDecisionElaboration();
	this.instance_1.setTransform(187.8,-34.15,1,1,0,0,0,214.8,-33.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({_off:true},2).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-584.4,-96.8,624.4,133);


(lib.TopicButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// New_Topic_Indicator
	this.newIndicator = new lib.newIndicator();
	this.newIndicator.name = "newIndicator";
	this.newIndicator.setTransform(190,-10);

	this.timeline.addTween(cjs.Tween.get(this.newIndicator).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("When will we be able to test the ", "18px 'Arial'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 22;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(18,8);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("When will we be able to test the ", "18px 'Arial'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 22;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(18,8);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("When will we be able to test the ", "18px 'Arial'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 22;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(18,8);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("When will we be able to test the ", "18px 'Arial'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 22;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(18,8);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Layer_3
	this.instance = new lib.TopicButtonUpBG();
	this.instance.setTransform(117.5,32);

	this.instance_1 = new lib.TopicButtonDownBG();
	this.instance_1.setTransform(117.5,32);

	this.instance_2 = new lib.TopicButtonDisabledBG();
	this.instance_2.setTransform(117.5,32);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-10,245,102.2);


(lib.RightAnimationMC = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_23 = function() {
		//stop();
		///* js 
		//this.stop(); 
		//*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(23).call(this.frame_23).wait(1));

	// Layer_4 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("EgmMAFUIAAqnMBMZAAAIAAKng");
	mask.setTransform(241,31.5);

	// Layer_3_copy
	this.instance = new lib.AnswerShineMC();
	this.instance.setTransform(-73,55,1,1,0,0,0,95.1,147.7);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({x:20.4},0).wait(1).to({x:113.85},0).wait(1).to({x:207.25},0).wait(1).to({x:300.7},0).wait(1).to({x:394.1},0).wait(1).to({x:487.55},0).wait(1).to({x:581},0).wait(6).to({x:-107},0).wait(1).to({x:-10.05},0).wait(1).to({x:86.95},0).wait(1).to({x:183.95},0).wait(1).to({x:280.95},0).wait(1).to({x:377.95},0).wait(1).to({x:474.95},0).wait(1).to({x:572},0).wait(4));

	// Green
	this.instance_1 = new lib.DialogButtonRight();

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(24));

	// Layer_2
	this.instance_2 = new lib.UnderlineMC();
	this.instance_2.setTransform(241.5,32,1,1,0,0,0,244.5,34);
	this.instance_2.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1).to({alpha:0.25},0).wait(1).to({alpha:0.5},0).wait(1).to({alpha:0.75},0).wait(1).to({alpha:1},0).wait(16).to({alpha:0.75},0).wait(1).to({alpha:0.5},0).wait(1).to({alpha:0.25},0).wait(1).to({alpha:0},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-202.1,-92.7,878.2,295.5);


(lib.Map_Chapter3_Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// MapNodes
	this.thisland_murelle_phc = new cjs.Text("Murelle PHC", "28px 'Work Sans'", "#6B4731");
	this.thisland_murelle_phc.name = "thisland_murelle_phc";
	this.thisland_murelle_phc.textAlign = "right";
	this.thisland_murelle_phc.lineHeight = 35;
	this.thisland_murelle_phc.lineWidth = 192;
	this.thisland_murelle_phc.alpha = 0.60000000;
	this.thisland_murelle_phc.parent = this;
	this.thisland_murelle_phc.setTransform(21,-180.95);
ranj.TextOffsetFixer.fix(this.thisland_murelle_phc);

	this.thisland_ready_office = new cjs.Text("READY Office", "28px 'Work Sans'", "#6B4731");
	this.thisland_ready_office.name = "thisland_ready_office";
	this.thisland_ready_office.lineHeight = 35;
	this.thisland_ready_office.lineWidth = 238;
	this.thisland_ready_office.alpha = 0.60000000;
	this.thisland_ready_office.parent = this;
	this.thisland_ready_office.setTransform(149.05,-167.95);
ranj.TextOffsetFixer.fix(this.thisland_ready_office);

	this.instance = new lib.MapNodeSmall();
	this.instance.setTransform(136.85,-151.75,1,1,0,0,0,10.2,10.2);
	this.instance.alpha = 0.4297;

	this.thisland_bakuna_phc = new cjs.Text("Bakuna PHC", "28px 'Work Sans'", "#6B4731");
	this.thisland_bakuna_phc.name = "thisland_bakuna_phc";
	this.thisland_bakuna_phc.lineHeight = 35;
	this.thisland_bakuna_phc.lineWidth = 375;
	this.thisland_bakuna_phc.alpha = 0.60000000;
	this.thisland_bakuna_phc.parent = this;
	this.thisland_bakuna_phc.setTransform(111,-369.45);
ranj.TextOffsetFixer.fix(this.thisland_bakuna_phc);

	this.instance_1 = new lib.MapNodeSmall();
	this.instance_1.setTransform(98.8,-353.75,1,1,0,0,0,10.2,10.2);
	this.instance_1.alpha = 0.4297;

	this.thisland_simberri_farms = new cjs.Text("Simberri Farms", "42px 'Work Sans'", "#324141");
	this.thisland_simberri_farms.name = "thisland_simberri_farms";
	this.thisland_simberri_farms.textAlign = "center";
	this.thisland_simberri_farms.lineHeight = 51;
	this.thisland_simberri_farms.lineWidth = 420;
	this.thisland_simberri_farms.parent = this;
	this.thisland_simberri_farms.setTransform(-641.75,278.65);
ranj.TextOffsetFixer.fix(this.thisland_simberri_farms);

	this.town2_clinic = new cjs.Text("Tamdu PHC", "bold 28px 'Work Sans'", "#324141");
	this.town2_clinic.name = "town2_clinic";
	this.town2_clinic.lineHeight = 35;
	this.town2_clinic.lineWidth = 325;
	this.town2_clinic.parent = this;
	this.town2_clinic.setTransform(-306.85,266.8);
ranj.TextOffsetFixer.fix(this.town2_clinic);

	this.idp_settlement_clinic = new cjs.Text("IDP Settlement 1 PHC", "bold 28px 'Work Sans'", "#324141");
	this.idp_settlement_clinic.name = "idp_settlement_clinic";
	this.idp_settlement_clinic.lineHeight = 35;
	this.idp_settlement_clinic.lineWidth = 325;
	this.idp_settlement_clinic.parent = this;
	this.idp_settlement_clinic.setTransform(-374.7,96.85);
ranj.TextOffsetFixer.fix(this.idp_settlement_clinic);

	this.thisland_relief_office = new cjs.Text("Thisland Relief", "bold 28px 'Work Sans'", "#324141");
	this.thisland_relief_office.name = "thisland_relief_office";
	this.thisland_relief_office.lineHeight = 35;
	this.thisland_relief_office.lineWidth = 227;
	this.thisland_relief_office.parent = this;
	this.thisland_relief_office.setTransform(-49.4,-39.6);
ranj.TextOffsetFixer.fix(this.thisland_relief_office);

	this.thisland_idp4_phc = new cjs.Text("IDP Settlement 4 PHC", "28px 'Work Sans'", "#6B4731");
	this.thisland_idp4_phc.name = "thisland_idp4_phc";
	this.thisland_idp4_phc.lineHeight = 35;
	this.thisland_idp4_phc.lineWidth = 325;
	this.thisland_idp4_phc.alpha = 0.60000000;
	this.thisland_idp4_phc.parent = this;
	this.thisland_idp4_phc.setTransform(270.7,44.2);
ranj.TextOffsetFixer.fix(this.thisland_idp4_phc);

	this.thisland_idp3_phc = new cjs.Text("IDP Settlement 3 PHC", "28px 'Work Sans'", "#6B4731");
	this.thisland_idp3_phc.name = "thisland_idp3_phc";
	this.thisland_idp3_phc.lineHeight = 35;
	this.thisland_idp3_phc.lineWidth = 325;
	this.thisland_idp3_phc.alpha = 0.60000000;
	this.thisland_idp3_phc.parent = this;
	this.thisland_idp3_phc.setTransform(149.05,-295.9);
ranj.TextOffsetFixer.fix(this.thisland_idp3_phc);

	this.thisland_district_hospital = new cjs.Text("District hospital", "28px 'Work Sans'", "#6B4731");
	this.thisland_district_hospital.name = "thisland_district_hospital";
	this.thisland_district_hospital.lineHeight = 35;
	this.thisland_district_hospital.lineWidth = 238;
	this.thisland_district_hospital.alpha = 0.60000000;
	this.thisland_district_hospital.parent = this;
	this.thisland_district_hospital.setTransform(169.45,-116);
ranj.TextOffsetFixer.fix(this.thisland_district_hospital);

	this.thisland_idp2_phc = new cjs.Text("IDP Settlement 2 PHC", "28px 'Work Sans'", "#6B4731");
	this.thisland_idp2_phc.name = "thisland_idp2_phc";
	this.thisland_idp2_phc.lineHeight = 35;
	this.thisland_idp2_phc.lineWidth = 325;
	this.thisland_idp2_phc.alpha = 0.60000000;
	this.thisland_idp2_phc.parent = this;
	this.thisland_idp2_phc.setTransform(-427.75,-244.8);
ranj.TextOffsetFixer.fix(this.thisland_idp2_phc);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.thisland_idp2_phc},{t:this.thisland_district_hospital},{t:this.thisland_idp3_phc},{t:this.thisland_idp4_phc},{t:this.thisland_relief_office},{t:this.idp_settlement_clinic},{t:this.town2_clinic},{t:this.thisland_simberri_farms},{t:this.instance_1},{t:this.thisland_bakuna_phc},{t:this.instance},{t:this.thisland_ready_office},{t:this.thisland_murelle_phc}]}).wait(1));

	// Layer_3
	this.instance_2 = new lib.MapNodeSmall();
	this.instance_2.setTransform(238.1,133.75,1,1,0,0,0,10.2,10.2);
	this.instance_2.alpha = 0.4297;

	this.thisland_murelle = new cjs.Text("Murelle", "bold 48px 'Work Sans'", "#6B4731");
	this.thisland_murelle.name = "thisland_murelle";
	this.thisland_murelle.lineHeight = 58;
	this.thisland_murelle.lineWidth = 289;
	this.thisland_murelle.alpha = 0.60000000;
	this.thisland_murelle.parent = this;
	this.thisland_murelle.setTransform(238.75,-77.85);
ranj.TextOffsetFixer.fix(this.thisland_murelle);

	this.instance_3 = new lib.MapNodeSmall();
	this.instance_3.setTransform(36.5,-162.1,1,1,0,0,0,10.2,10.2);
	this.instance_3.alpha = 0.4297;

	this.instance_4 = new lib.MapLocationNode();
	this.instance_4.setTransform(-324.85,261.65);

	this.moh_office = new cjs.Text("MoH Office", "28px 'Work Sans'", "#6B4731");
	this.moh_office.name = "moh_office";
	this.moh_office.lineHeight = 35;
	this.moh_office.lineWidth = 325;
	this.moh_office.alpha = 0.60000000;
	this.moh_office.parent = this;
	this.moh_office.setTransform(256.6,116.15);
ranj.TextOffsetFixer.fix(this.moh_office);

	this.instance_5 = new lib.MapNodeSmall();
	this.instance_5.setTransform(-439.95,-228.45,1,1,0,0,0,10.2,10.2);
	this.instance_5.alpha = 0.4297;

	this.instance_6 = new lib.MapNodeSmall();
	this.instance_6.setTransform(157.25,-99.8,1,1,0,0,0,10.2,10.2);
	this.instance_6.alpha = 0.4297;

	this.instance_7 = new lib.MapNodeSmall();
	this.instance_7.setTransform(136.85,-280.05,1,1,0,0,0,10.2,10.2);
	this.instance_7.alpha = 0.4297;

	this.instance_8 = new lib.MapNodeSmall();
	this.instance_8.setTransform(258.5,60.8,1,1,0,0,0,10.2,10.2);
	this.instance_8.alpha = 0.4297;

	this.instance_9 = new lib.MapLocationNode();
	this.instance_9.setTransform(-390.95,153.05);

	this.instance_10 = new lib.MapLocationNode();
	this.instance_10.setTransform(100.1,-57.35);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.moh_office},{t:this.instance_4},{t:this.instance_3},{t:this.thisland_murelle},{t:this.instance_2}]}).wait(1));

	// MapBG
	this.instance_11 = new lib.HUBmapCh1();
	this.instance_11.setTransform(-961,-541);

	this.timeline.addTween(cjs.Tween.get(this.instance_11).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Map_Chapter3_Background, new cjs.Rectangle(-961,-541,1920,1080), null);


(lib.Map_Chapter2_Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.thisland_simberri_farms = new cjs.Text("Simberri Farms", "42px 'Work Sans'", "#324141");
	this.thisland_simberri_farms.name = "thisland_simberri_farms";
	this.thisland_simberri_farms.textAlign = "center";
	this.thisland_simberri_farms.lineHeight = 51;
	this.thisland_simberri_farms.lineWidth = 420;
	this.thisland_simberri_farms.alpha = 0.69411765;
	this.thisland_simberri_farms.parent = this;
	this.thisland_simberri_farms.setTransform(-208.95,255.35);
ranj.TextOffsetFixer.fix(this.thisland_simberri_farms);

	this.outdoor_meeting_space_2 = new cjs.Text("_Rural village", "bold 28px 'Work Sans'", "#324141");
	this.outdoor_meeting_space_2.name = "outdoor_meeting_space_2";
	this.outdoor_meeting_space_2.textAlign = "center";
	this.outdoor_meeting_space_2.lineHeight = 28;
	this.outdoor_meeting_space_2.lineWidth = 215;
	this.outdoor_meeting_space_2.parent = this;
	this.outdoor_meeting_space_2.setTransform(-11.35,210.8);
ranj.TextOffsetFixer.fix(this.outdoor_meeting_space_2);

	this.Ready_PHC = new cjs.Text("Ready PHC", "bold 28px 'Work Sans'", "#324141");
	this.Ready_PHC.name = "Ready_PHC";
	this.Ready_PHC.lineHeight = 28;
	this.Ready_PHC.lineWidth = 205;
	this.Ready_PHC.parent = this;
	this.Ready_PHC.setTransform(301.85,123.95);
ranj.TextOffsetFixer.fix(this.Ready_PHC);

	this.family_dwelling = new cjs.Text("_IDP shelter", "bold 28px 'Work Sans'", "#324141");
	this.family_dwelling.name = "family_dwelling";
	this.family_dwelling.lineHeight = 28;
	this.family_dwelling.lineWidth = 524;
	this.family_dwelling.parent = this;
	this.family_dwelling.setTransform(110.15,-21.7);
ranj.TextOffsetFixer.fix(this.family_dwelling);

	this.thisland_ready_phc = new cjs.Text("READY PHC", "28px 'Work Sans'", "#6B4731");
	this.thisland_ready_phc.name = "thisland_ready_phc";
	this.thisland_ready_phc.textAlign = "right";
	this.thisland_ready_phc.lineHeight = 28;
	this.thisland_ready_phc.lineWidth = 205;
	this.thisland_ready_phc.alpha = 0.60000000;
	this.thisland_ready_phc.parent = this;
	this.thisland_ready_phc.setTransform(-26.35,-132.45);
ranj.TextOffsetFixer.fix(this.thisland_ready_phc);

	this.outdoor_meeting_space_1 = new cjs.Text("Community Meeting Space", "bold 28px 'Work Sans'", "#324141");
	this.outdoor_meeting_space_1.name = "outdoor_meeting_space_1";
	this.outdoor_meeting_space_1.lineHeight = 28;
	this.outdoor_meeting_space_1.lineWidth = 436;
	this.outdoor_meeting_space_1.parent = this;
	this.outdoor_meeting_space_1.setTransform(143.7,-87.9);
ranj.TextOffsetFixer.fix(this.outdoor_meeting_space_1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.outdoor_meeting_space_1},{t:this.thisland_ready_phc},{t:this.family_dwelling},{t:this.Ready_PHC},{t:this.outdoor_meeting_space_2},{t:this.thisland_simberri_farms}]}).wait(1));

	// MapNodes
	this.instance = new lib.MapNodeSmall();
	this.instance.setTransform(22,-59.7,1,1,0,0,0,10.2,10.2);
	this.instance.alpha = 0.4297;

	this.thisland_murelle = new cjs.Text("Murelle", "bold 48px 'Work Sans'", "#6B4731");
	this.thisland_murelle.name = "thisland_murelle";
	this.thisland_murelle.textAlign = "right";
	this.thisland_murelle.lineHeight = 58;
	this.thisland_murelle.lineWidth = 419;
	this.thisland_murelle.alpha = 0.60000000;
	this.thisland_murelle.parent = this;
	this.thisland_murelle.setTransform(780.65,-377.75);
ranj.TextOffsetFixer.fix(this.thisland_murelle);

	this.thisland_idp1 = new cjs.Text("IDP Settlement 1", "bold 38px 'Work Sans'", "#6B4731");
	this.thisland_idp1.name = "thisland_idp1";
	this.thisland_idp1.lineHeight = 47;
	this.thisland_idp1.lineWidth = 576;
	this.thisland_idp1.alpha = 0.60000000;
	this.thisland_idp1.parent = this;
	this.thisland_idp1.setTransform(-93.95,-206);
ranj.TextOffsetFixer.fix(this.thisland_idp1);

	this.instance_1 = new lib.MapLocationNode();
	this.instance_1.setTransform(284.4,122.45);

	this.instance_2 = new lib.MapLocationNode();
	this.instance_2.setTransform(-40.35,192.15);

	this.instance_3 = new lib.MapLocationNode();
	this.instance_3.setTransform(127.6,-53.65);

	this.instance_4 = new lib.MapLocationNode();
	this.instance_4.setTransform(89.3,-13.6);

	this.thisland_tamdu = new cjs.Text("Tamdu", "bold 48px 'Work Sans'", "#6B4731");
	this.thisland_tamdu.name = "thisland_tamdu";
	this.thisland_tamdu.lineHeight = 58;
	this.thisland_tamdu.lineWidth = 169;
	this.thisland_tamdu.alpha = 0.60000000;
	this.thisland_tamdu.parent = this;
	this.thisland_tamdu.setTransform(256.5,195.05);
ranj.TextOffsetFixer.fix(this.thisland_tamdu);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.thisland_tamdu},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.thisland_idp1},{t:this.thisland_murelle},{t:this.instance}]}).wait(1));

	// MapBG
	this.instance_5 = new lib.HUBmapCh1_2();
	this.instance_5.setTransform(-961,-541);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Map_Chapter2_Background, new cjs.Rectangle(-961,-541,1920,1080), null);


(lib.Map_Chapter1_Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.thisland_ready_office = new cjs.Text("READY Office", "28px 'Work Sans'", "#6B4731");
	this.thisland_ready_office.name = "thisland_ready_office";
	this.thisland_ready_office.lineHeight = 35;
	this.thisland_ready_office.lineWidth = 238;
	this.thisland_ready_office.alpha = 0.60000000;
	this.thisland_ready_office.parent = this;
	this.thisland_ready_office.setTransform(149.05,-167.95);
ranj.TextOffsetFixer.fix(this.thisland_ready_office);

	this.thisland_simberri_farms = new cjs.Text("Simberri Farms", "42px 'Work Sans'", "#324141");
	this.thisland_simberri_farms.name = "thisland_simberri_farms";
	this.thisland_simberri_farms.textAlign = "center";
	this.thisland_simberri_farms.lineHeight = 51;
	this.thisland_simberri_farms.lineWidth = 420;
	this.thisland_simberri_farms.parent = this;
	this.thisland_simberri_farms.setTransform(-641.75,258.25);
ranj.TextOffsetFixer.fix(this.thisland_simberri_farms);

	this.town2_clinic = new cjs.Text("Tamdu PHC", "bold 28px 'Work Sans'", "#324141");
	this.town2_clinic.name = "town2_clinic";
	this.town2_clinic.lineHeight = 31;
	this.town2_clinic.lineWidth = 325;
	this.town2_clinic.parent = this;
	this.town2_clinic.setTransform(-306.6,259.3);
ranj.TextOffsetFixer.fix(this.town2_clinic);

	this.thisland_murelle_phc = new cjs.Text("Murelle PHC", "28px 'Work Sans'", "#6B4731");
	this.thisland_murelle_phc.name = "thisland_murelle_phc";
	this.thisland_murelle_phc.textAlign = "right";
	this.thisland_murelle_phc.lineHeight = 35;
	this.thisland_murelle_phc.lineWidth = 192;
	this.thisland_murelle_phc.alpha = 0.60000000;
	this.thisland_murelle_phc.parent = this;
	this.thisland_murelle_phc.setTransform(21,-180.95);
ranj.TextOffsetFixer.fix(this.thisland_murelle_phc);

	this.idp_settlement_clinic = new cjs.Text("IDP Settlement 1 PHC\nIDP Settlement 1 PHC", "bold 28px 'Work Sans'", "#324141");
	this.idp_settlement_clinic.name = "idp_settlement_clinic";
	this.idp_settlement_clinic.lineHeight = 31;
	this.idp_settlement_clinic.lineWidth = 325;
	this.idp_settlement_clinic.parent = this;
	this.idp_settlement_clinic.setTransform(-374.45,95.25);
ranj.TextOffsetFixer.fix(this.idp_settlement_clinic);

	this.thisland_relief_office = new cjs.Text("Thisland Relief", "bold 28px 'Work Sans'", "#324141");
	this.thisland_relief_office.name = "thisland_relief_office";
	this.thisland_relief_office.lineHeight = 31;
	this.thisland_relief_office.lineWidth = 227;
	this.thisland_relief_office.parent = this;
	this.thisland_relief_office.setTransform(-49.4,-39.6);
ranj.TextOffsetFixer.fix(this.thisland_relief_office);

	this.thisland_idp4_phc = new cjs.Text("IDP Settlement 4 PHC", "28px 'Work Sans'", "#6B4731");
	this.thisland_idp4_phc.name = "thisland_idp4_phc";
	this.thisland_idp4_phc.lineHeight = 35;
	this.thisland_idp4_phc.lineWidth = 325;
	this.thisland_idp4_phc.alpha = 0.60000000;
	this.thisland_idp4_phc.parent = this;
	this.thisland_idp4_phc.setTransform(270.7,44.2);
ranj.TextOffsetFixer.fix(this.thisland_idp4_phc);

	this.thisland_idp3_phc = new cjs.Text("IDP Settlement 3 PHC", "28px 'Work Sans'", "#6B4731");
	this.thisland_idp3_phc.name = "thisland_idp3_phc";
	this.thisland_idp3_phc.lineHeight = 35;
	this.thisland_idp3_phc.lineWidth = 325;
	this.thisland_idp3_phc.alpha = 0.60000000;
	this.thisland_idp3_phc.parent = this;
	this.thisland_idp3_phc.setTransform(149.05,-295.9);
ranj.TextOffsetFixer.fix(this.thisland_idp3_phc);

	this.thisland_district_hospital = new cjs.Text("District hospital", "28px 'Work Sans'", "#6B4731");
	this.thisland_district_hospital.name = "thisland_district_hospital";
	this.thisland_district_hospital.lineHeight = 35;
	this.thisland_district_hospital.lineWidth = 238;
	this.thisland_district_hospital.alpha = 0.60000000;
	this.thisland_district_hospital.parent = this;
	this.thisland_district_hospital.setTransform(169.45,-116);
ranj.TextOffsetFixer.fix(this.thisland_district_hospital);

	this.thisland_bakuna_phc = new cjs.Text("Bakuna PHC", "28px 'Work Sans'", "#6B4731");
	this.thisland_bakuna_phc.name = "thisland_bakuna_phc";
	this.thisland_bakuna_phc.lineHeight = 35;
	this.thisland_bakuna_phc.lineWidth = 375;
	this.thisland_bakuna_phc.alpha = 0.60000000;
	this.thisland_bakuna_phc.parent = this;
	this.thisland_bakuna_phc.setTransform(111,-369.45);
ranj.TextOffsetFixer.fix(this.thisland_bakuna_phc);

	this.thisland_idp2_phc = new cjs.Text("IDP Settlement 2 PHC", "28px 'Work Sans'", "#6B4731");
	this.thisland_idp2_phc.name = "thisland_idp2_phc";
	this.thisland_idp2_phc.lineHeight = 35;
	this.thisland_idp2_phc.lineWidth = 325;
	this.thisland_idp2_phc.alpha = 0.60000000;
	this.thisland_idp2_phc.parent = this;
	this.thisland_idp2_phc.setTransform(-427.75,-244.8);
ranj.TextOffsetFixer.fix(this.thisland_idp2_phc);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.thisland_idp2_phc},{t:this.thisland_bakuna_phc},{t:this.thisland_district_hospital},{t:this.thisland_idp3_phc},{t:this.thisland_idp4_phc},{t:this.thisland_relief_office},{t:this.idp_settlement_clinic},{t:this.thisland_murelle_phc},{t:this.town2_clinic},{t:this.thisland_simberri_farms},{t:this.thisland_ready_office}]}).wait(1));

	// MapNodes
	this.instance = new lib.MapNodeSmall();
	this.instance.setTransform(136.85,-151.75,1,1,0,0,0,10.2,10.2);
	this.instance.alpha = 0.4297;

	this.thisland_murelle = new cjs.Text("Murelle", "bold 48px 'Work Sans'", "#6B4731");
	this.thisland_murelle.name = "thisland_murelle";
	this.thisland_murelle.lineHeight = 58;
	this.thisland_murelle.lineWidth = 289;
	this.thisland_murelle.alpha = 0.60000000;
	this.thisland_murelle.parent = this;
	this.thisland_murelle.setTransform(238.75,-77.85);
ranj.TextOffsetFixer.fix(this.thisland_murelle);

	this.instance_1 = new lib.MapNodeSmall();
	this.instance_1.setTransform(98.8,-353.75,1,1,0,0,0,10.2,10.2);
	this.instance_1.alpha = 0.4297;

	this.instance_2 = new lib.MapNodeSmall();
	this.instance_2.setTransform(-439.95,-228.45,1,1,0,0,0,10.2,10.2);
	this.instance_2.alpha = 0.4297;

	this.instance_3 = new lib.MapNodeSmall();
	this.instance_3.setTransform(157.25,-99.8,1,1,0,0,0,10.2,10.2);
	this.instance_3.alpha = 0.4297;

	this.instance_4 = new lib.MapNodeSmall();
	this.instance_4.setTransform(136.85,-280.05,1,1,0,0,0,10.2,10.2);
	this.instance_4.alpha = 0.4297;

	this.instance_5 = new lib.MapNodeSmall();
	this.instance_5.setTransform(258.5,60.8,1,1,0,0,0,10.2,10.2);
	this.instance_5.alpha = 0.4297;

	this.instance_6 = new lib.MapLocationNode();
	this.instance_6.setTransform(-323.6,259.25);

	this.instance_7 = new lib.MapLocationNode();
	this.instance_7.setTransform(-395.45,152.8);

	this.instance_8 = new lib.MapNodeSmall();
	this.instance_8.setTransform(36.5,-162.1,1,1,0,0,0,10.2,10.2);
	this.instance_8.alpha = 0.4297;

	this.instance_9 = new lib.MapLocationNode();
	this.instance_9.setTransform(100.1,-57.35);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.thisland_murelle},{t:this.instance}]}).wait(1));

	// MapBG
	this.instance_10 = new lib.HUBmapCh1();
	this.instance_10.setTransform(-961,-541);

	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Map_Chapter1_Background, new cjs.Rectangle(-961,-541,1920,1080), null);


(lib.PlaceholderPoiImage = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3,"selectedUp":4,"selectedOver":5,"selectedDown":6,"selectedDisabled":7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AgxJ+IlSlSQgVgVAAgdIAAnzQAAgdAVgVIFSlSQAVgUAcgBQAeABATAUIFTFSQAVAVAAAdIAAHzQAAAdgVAVIlTFSQgTAVgeAAQgcAAgVgVg");
	mask.setTransform(0.025,-26.45);

	// Laag_3
	this.locationContainer = new lib.locationContainer();
	this.locationContainer.name = "locationContainer";
	this.locationContainer.setTransform(-24.15,19.75,1,1,0,0,0,41,65);

	var maskedShapeInstanceList = [this.locationContainer];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.locationContainer).wait(8));

	// disabledNodeColor
	this.instance = new lib.NodeColor07();
	this.instance.setTransform(-40,-39);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(3).to({_off:false},0).to({_off:true},1).wait(3).to({_off:false},0).wait(1));

	// NodeColor04
	this.NodeColor04 = new lib.NodeColor04();
	this.NodeColor04.name = "NodeColor04";
	this.NodeColor04.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.timeline.addTween(cjs.Tween.get(this.NodeColor04).wait(8));

	// NodeColor06
	this.NodeColor06 = new lib.NodeColor06();
	this.NodeColor06.name = "NodeColor06";
	this.NodeColor06.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.timeline.addTween(cjs.Tween.get(this.NodeColor06).wait(8));

	// NodeColor05
	this.NodeColor05 = new lib.NodeColor05();
	this.NodeColor05.name = "NodeColor05";
	this.NodeColor05.setTransform(-1,0.5,1,1,0,0,0,39,39.5);

	this.timeline.addTween(cjs.Tween.get(this.NodeColor05).wait(8));

	// NodeColor03
	this.NodeColor03 = new lib.NodeColor03();
	this.NodeColor03.name = "NodeColor03";
	this.NodeColor03.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.instance_1 = new lib.POI_NodeColor01();
	this.instance_1.setTransform(-40,-39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.NodeColor03}]}).wait(8));

	// NodeColor02
	this.NodeColor02 = new lib.NodeColor02();
	this.NodeColor02.name = "NodeColor02";
	this.NodeColor02.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.instance_2 = new lib.POI_NodeColor01();
	this.instance_2.setTransform(-40,-39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.NodeColor02}]}).wait(8));

	// NodeColor01
	this.NodeColor01 = new lib.NodeColor01();
	this.NodeColor01.name = "NodeColor01";
	this.NodeColor01.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.timeline.addTween(cjs.Tween.get(this.NodeColor01).wait(8));

	// Laag_1
	this.instance_3 = new lib.PoILabel3Up();
	this.instance_3.setTransform(-60,-68);

	this.instance_4 = new lib.PoILabel3Over();
	this.instance_4.setTransform(-60,-68);

	this.instance_5 = new lib.TopLeftDisabled();
	this.instance_5.setTransform(-61,-69);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3}]}).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_3},{t:this.instance_5}]},2).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_3},{t:this.instance_5}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-61,-69,120,139);


(lib.PlaceholderPoiCharacter = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"over":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// iconMask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AgxJ+IlSlSQgVgVAAgdIAAnzQAAgdAVgVIFSlSQAVgUAcgBQAeABATAUIFTFSQAVAVAAAdIAAHzQAAAdgVAVIlTFSQgTAVgeAAQgcAAgVgVg");
	mask.setTransform(0.025,-26.45);

	// icon
	this.characterContainer = new lib.PoiCharacterIconContainer();
	this.characterContainer.name = "characterContainer";
	this.characterContainer.setTransform(4,-7);

	var maskedShapeInstanceList = [this.characterContainer];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.characterContainer).wait(4));

	// NodeColor06
	this.NodeColor06 = new lib.NodeColor06();
	this.NodeColor06.name = "NodeColor06";
	this.NodeColor06.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.timeline.addTween(cjs.Tween.get(this.NodeColor06).wait(4));

	// NodeColor05
	this.NodeColor05 = new lib.NodeColor05();
	this.NodeColor05.name = "NodeColor05";
	this.NodeColor05.setTransform(-1,0.5,1,1,0,0,0,39,39.5);

	this.timeline.addTween(cjs.Tween.get(this.NodeColor05).wait(4));

	// NodeColor04
	this.NodeColor04 = new lib.NodeColor04();
	this.NodeColor04.name = "NodeColor04";
	this.NodeColor04.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.timeline.addTween(cjs.Tween.get(this.NodeColor04).wait(4));

	// NodeColor03
	this.NodeColor03 = new lib.NodeColor03();
	this.NodeColor03.name = "NodeColor03";
	this.NodeColor03.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.instance = new lib.POI_NodeColor01();
	this.instance.setTransform(-40,-39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.NodeColor03}]}).wait(4));

	// NodeColor02
	this.NodeColor02 = new lib.NodeColor02();
	this.NodeColor02.name = "NodeColor02";
	this.NodeColor02.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.instance_1 = new lib.POI_NodeColor01();
	this.instance_1.setTransform(-40,-39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.NodeColor02}]}).wait(4));

	// NodeColor01
	this.NodeColor01 = new lib.NodeColor01();
	this.NodeColor01.name = "NodeColor01";
	this.NodeColor01.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.timeline.addTween(cjs.Tween.get(this.NodeColor01).wait(4));

	// bitmap
	this.instance_2 = new lib.PoILabel0Up();
	this.instance_2.setTransform(-60,-68);

	this.instance_3 = new lib.PoILabel0Over();
	this.instance_3.setTransform(-60,-68);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-60,-72,119,142);


(lib.PlanComposerKeyDecision_Topic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.ExplanationTextField = new cjs.Text("Drag three options to compose your plan", "24px 'Work Sans'", "#2C3C3C");
	this.ExplanationTextField.name = "ExplanationTextField";
	this.ExplanationTextField.textAlign = "center";
	this.ExplanationTextField.lineHeight = 30;
	this.ExplanationTextField.lineWidth = 841;
	this.ExplanationTextField.parent = this;
	this.ExplanationTextField.setTransform(431.55,450.15);
ranj.TextOffsetFixer.fix(this.ExplanationTextField);

	this.Answer6 = new lib.PlanComposerKeyDecision_AnswerButton();
	this.Answer6.name = "Answer6";
	this.Answer6.setTransform(1158.8,754.8,1,1,0,0,0,212.2,31.3);

	this.Answer5 = new lib.PlanComposerKeyDecision_AnswerButton();
	this.Answer5.name = "Answer5";
	this.Answer5.setTransform(1158.8,608.5,1,1,0,0,0,212.2,31.3);

	this.Answer4 = new lib.PlanComposerKeyDecision_AnswerButton();
	this.Answer4.name = "Answer4";
	this.Answer4.setTransform(1158.8,462.2,1,1,0,0,0,212.2,31.3);

	this.Answer3 = new lib.PlanComposerKeyDecision_AnswerButton();
	this.Answer3.name = "Answer3";
	this.Answer3.setTransform(1158.8,315.9,1,1,0,0,0,212.2,31.3);

	this.Answer2 = new lib.PlanComposerKeyDecision_AnswerButton();
	this.Answer2.name = "Answer2";
	this.Answer2.setTransform(1158.8,169.6,1,1,0,0,0,212.2,31.3);

	this.Answer1 = new lib.PlanComposerKeyDecision_AnswerButton();
	this.Answer1.name = "Answer1";
	this.Answer1.setTransform(1158.8,23.3,1,1,0,0,0,212.2,31.3);

	this.topicQuestionTextField = new cjs.Text("What first priority steps do you need to take when hearing of a possible outbreak?  What first priority steps do you need to take when hearing of a possible outbreak?  What first priority steps do you need to take when hearing of a possible outbreak?  ", "24px 'Work Sans'", "#2C3C3C");
	this.topicQuestionTextField.name = "topicQuestionTextField";
	this.topicQuestionTextField.lineHeight = 30;
	this.topicQuestionTextField.lineWidth = 805;
	this.topicQuestionTextField.parent = this;
	this.topicQuestionTextField.setTransform(27.1,68.45);
ranj.TextOffsetFixer.fix(this.topicQuestionTextField);

	this.DropZone3 = new lib.PlanComposerKeyDecision_AnsweSlot();
	this.DropZone3.name = "DropZone3";
	this.DropZone3.setTransform(413.2,603.6,1,1,0,0,0,403.5,68.5);

	this.DropZone2 = new lib.PlanComposerKeyDecision_AnsweSlot();
	this.DropZone2.name = "DropZone2";
	this.DropZone2.setTransform(413.2,461.25,1,1,0,0,0,403.5,68.5);

	this.DropZone1 = new lib.PlanComposerKeyDecision_AnsweSlot();
	this.DropZone1.name = "DropZone1";
	this.DropZone1.setTransform(413.2,318.95,1,1,0,0,0,403.5,68.5);

	this.AnswerContainer = new lib.PlanComposerKeyDecision_AnswerContainerInactive();
	this.AnswerContainer.name = "AnswerContainer";
	this.AnswerContainer.setTransform(413.95,461.05,1,1,0,0,0,415.5,222.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.AnswerContainer},{t:this.DropZone1},{t:this.DropZone2},{t:this.DropZone3},{t:this.topicQuestionTextField},{t:this.Answer1},{t:this.Answer2},{t:this.Answer3},{t:this.Answer4},{t:this.Answer5},{t:this.Answer6},{t:this.ExplanationTextField}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_Topic, new cjs.Rectangle(-1.5,-10,1813.8,893.5), null);


(lib.FeedbackWhiteScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Titles
	this.READYfeedbackTitle = new cjs.Text("READY feedback", "28px 'Work Sans SemiBold'", "#324141");
	this.READYfeedbackTitle.name = "READYfeedbackTitle";
	this.READYfeedbackTitle.lineHeight = 35;
	this.READYfeedbackTitle.lineWidth = 252;
	this.READYfeedbackTitle.parent = this;
	this.READYfeedbackTitle.setTransform(789,343.4);
ranj.TextOffsetFixer.fix(this.READYfeedbackTitle);

	this.yourAnswersTitle = new cjs.Text("Your answers", "28px 'Work Sans SemiBold'", "#324141");
	this.yourAnswersTitle.name = "yourAnswersTitle";
	this.yourAnswersTitle.lineHeight = 35;
	this.yourAnswersTitle.lineWidth = 348;
	this.yourAnswersTitle.parent = this;
	this.yourAnswersTitle.setTransform(101.55,343.4);
ranj.TextOffsetFixer.fix(this.yourAnswersTitle);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.yourAnswersTitle},{t:this.READYfeedbackTitle}]}).wait(1));

	// feedback
	this.AnswerFeedback4 = new cjs.Text("Decide how recruitment of Community Health Workers should proceed as the number of infections increases. Decide how recruitment of Community Health Workers should proceed as the number of infections increases. ", "20px 'Work Sans'", "#2C3C3C");
	this.AnswerFeedback4.name = "AnswerFeedback4";
	this.AnswerFeedback4.lineHeight = 23;
	this.AnswerFeedback4.lineWidth = 931;
	this.AnswerFeedback4.parent = this;
	this.AnswerFeedback4.setTransform(789,794,0.9999,1);
ranj.TextOffsetFixer.fix(this.AnswerFeedback4);

	this.AnswerFeedback3 = new cjs.Text("Virtual training may not be effective for training CHWs on EnVD response. Focusing on general precautions and notifying RRT about all possible cases may dilute focus on actual EnVD cases.", "20px 'Work Sans'", "#2C3C3C");
	this.AnswerFeedback3.name = "AnswerFeedback3";
	this.AnswerFeedback3.lineHeight = 23;
	this.AnswerFeedback3.lineWidth = 931;
	this.AnswerFeedback3.parent = this;
	this.AnswerFeedback3.setTransform(789,663,0.9999,1);
ranj.TextOffsetFixer.fix(this.AnswerFeedback3);

	this.AnswerFeedback2 = new cjs.Text("Waiting for a week to gather the paper line list data from CHWs can lead to a delay in identifying and addressing any emerging trends, which can result in a missed opportunity for early intervention.", "20px 'Work Sans'", "#2C3C3C");
	this.AnswerFeedback2.name = "AnswerFeedback2";
	this.AnswerFeedback2.lineHeight = 23;
	this.AnswerFeedback2.lineWidth = 931;
	this.AnswerFeedback2.parent = this;
	this.AnswerFeedback2.setTransform(789,532.5,0.9999,1);
ranj.TextOffsetFixer.fix(this.AnswerFeedback2);

	this.AnswerFeedback1 = new cjs.Text("Pausing all other CHW activities can have negative consequences. It can lead to a disruption of essential health services, which may be critical to the health and well-being of the community.", "20px 'Work Sans'", "#2C3C3C");
	this.AnswerFeedback1.name = "AnswerFeedback1";
	this.AnswerFeedback1.lineHeight = 23;
	this.AnswerFeedback1.lineWidth = 931;
	this.AnswerFeedback1.parent = this;
	this.AnswerFeedback1.setTransform(789,404,0.9999,1);
ranj.TextOffsetFixer.fix(this.AnswerFeedback1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.AnswerFeedback1},{t:this.AnswerFeedback2},{t:this.AnswerFeedback3},{t:this.AnswerFeedback4}]}).wait(1));

	// answers
	this.ButtonAnswerGood4 = new lib.FeedbackButtonGood();
	this.ButtonAnswerGood4.name = "ButtonAnswerGood4";
	this.ButtonAnswerGood4.setTransform(468.6,869.5,1,1,0,0,0,130.1,33);

	this.ButtonAnswerGood3 = new lib.FeedbackButtonGood();
	this.ButtonAnswerGood3.name = "ButtonAnswerGood3";
	this.ButtonAnswerGood3.setTransform(468.6,739,1,1,0,0,0,130.1,33);

	this.ButtonAnswerGood2 = new lib.FeedbackButtonGood();
	this.ButtonAnswerGood2.name = "ButtonAnswerGood2";
	this.ButtonAnswerGood2.setTransform(468.6,608,1,1,0,0,0,130.1,33);

	this.ButtonAnswerGood1 = new lib.FeedbackButtonGood();
	this.ButtonAnswerGood1.name = "ButtonAnswerGood1";
	this.ButtonAnswerGood1.setTransform(468.6,479,1,1,0,0,0,130.1,33);

	this.ButtonAnswerMedium4 = new lib.FeedbackButtonMedium();
	this.ButtonAnswerMedium4.name = "ButtonAnswerMedium4";
	this.ButtonAnswerMedium4.setTransform(468.6,869.5,1,1,0,0,0,130.1,33);

	this.ButtonAnswerMedium3 = new lib.FeedbackButtonMedium();
	this.ButtonAnswerMedium3.name = "ButtonAnswerMedium3";
	this.ButtonAnswerMedium3.setTransform(468.6,739,1,1,0,0,0,130.1,33);

	this.ButtonAnswerMedium2 = new lib.FeedbackButtonMedium();
	this.ButtonAnswerMedium2.name = "ButtonAnswerMedium2";
	this.ButtonAnswerMedium2.setTransform(468.65,608,1,1,0,0,0,130.1,33);

	this.ButtonAnswerMedium1 = new lib.FeedbackButtonMedium();
	this.ButtonAnswerMedium1.name = "ButtonAnswerMedium1";
	this.ButtonAnswerMedium1.setTransform(468.6,479,1,1,0,0,0,130.1,33);

	this.ButtonAnswerBad4 = new lib.FeedbackButtonBad();
	this.ButtonAnswerBad4.name = "ButtonAnswerBad4";
	this.ButtonAnswerBad4.setTransform(468.6,869.5,1,1,0,0,0,130.1,33);

	this.ButtonAnswerBad3 = new lib.FeedbackButtonBad();
	this.ButtonAnswerBad3.name = "ButtonAnswerBad3";
	this.ButtonAnswerBad3.setTransform(468.6,739,1,1,0,0,0,130.1,33);

	this.ButtonAnswerBad2 = new lib.FeedbackButtonBad();
	this.ButtonAnswerBad2.name = "ButtonAnswerBad2";
	this.ButtonAnswerBad2.setTransform(468.6,608,1,1,0,0,0,130.1,33);

	this.ButtonAnswerBad1 = new lib.FeedbackButtonBad();
	this.ButtonAnswerBad1.name = "ButtonAnswerBad1";
	this.ButtonAnswerBad1.setTransform(468.6,479,1,1,0,0,0,130.1,33);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.ButtonAnswerBad1},{t:this.ButtonAnswerBad2},{t:this.ButtonAnswerBad3},{t:this.ButtonAnswerBad4},{t:this.ButtonAnswerMedium1},{t:this.ButtonAnswerMedium2},{t:this.ButtonAnswerMedium3},{t:this.ButtonAnswerMedium4},{t:this.ButtonAnswerGood1},{t:this.ButtonAnswerGood2},{t:this.ButtonAnswerGood3},{t:this.ButtonAnswerGood4}]}).wait(1));

	// lines
	this.instance = new lib.FeedbackDividerWhiteScreen();
	this.instance.setTransform(911.4,786.65,1.0018,1,0,0,0,809.2,0);

	this.instance_1 = new lib.FeedbackDividerWhiteScreen();
	this.instance_1.setTransform(911.4,656.65,1.0018,1,0,0,0,809.2,0);

	this.instance_2 = new lib.FeedbackDividerWhiteScreen();
	this.instance_2.setTransform(911.4,526.45,1.0018,1,0,0,0,809.2,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// answersbg
	this.instance_3 = new lib.FeedbackAnswerBGWhite();
	this.instance_3.setTransform(911,660.5,1,1,0,0,0,864,273.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackWhiteScreen, new cjs.Rectangle(47,341.4,1728,592.6), null);


(lib.FeedbackToggle = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.ShowOptimal = new lib.FeedbackToggleButtonWhiteScreen();
	this.ShowOptimal.name = "ShowOptimal";
	this.ShowOptimal.setTransform(207.6,35.15);

	this.HideOptimal = new lib.FeedbackToggleButtonBlackScreen();
	this.HideOptimal.name = "HideOptimal";
	this.HideOptimal.setTransform(207.6,35.15);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.ShowOptimal}]}).to({state:[{t:this.HideOptimal}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,421,76);


(lib.FeedbackTimeline = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.FeedbackTimelineDivider = new lib.FeedbackTimelineDivider();
	this.FeedbackTimelineDivider.name = "FeedbackTimelineDivider";
	this.FeedbackTimelineDivider.setTransform(37.5,749.35,1,1,0,0,0,25.5,7);

	this.instance = new lib.FeedbackKDstates();
	this.instance.setTransform(432,772.15,1,1,0,0,0,432,162.5);

	this.FeedbackTimelineDivider_1 = new lib.FeedbackTimelineDivider();
	this.FeedbackTimelineDivider_1.name = "FeedbackTimelineDivider_1";
	this.FeedbackTimelineDivider_1.setTransform(37.5,641.55,1,1,0,0,0,25.5,7);

	this.instance_1 = new lib.FeedbackKDstates();
	this.instance_1.setTransform(432,664.35,1,1,0,0,0,432,162.5);

	this.FeedbackTimelineDivider_2 = new lib.FeedbackTimelineDivider();
	this.FeedbackTimelineDivider_2.name = "FeedbackTimelineDivider_2";
	this.FeedbackTimelineDivider_2.setTransform(37.5,533.75,1,1,0,0,0,25.5,7);

	this.instance_2 = new lib.FeedbackKDstates();
	this.instance_2.setTransform(432,556.55,1,1,0,0,0,432,162.5);

	this.FeedbackTimelineDivider_3 = new lib.FeedbackTimelineDivider();
	this.FeedbackTimelineDivider_3.name = "FeedbackTimelineDivider_3";
	this.FeedbackTimelineDivider_3.setTransform(37.5,428,1,1,0,0,0,25.5,7);

	this.instance_3 = new lib.FeedbackKDstates();
	this.instance_3.setTransform(432,279.5,1,1,0,0,0,432,162.5);

	this.FeedbackTimelineDivider_4 = new lib.FeedbackTimelineDivider();
	this.FeedbackTimelineDivider_4.name = "FeedbackTimelineDivider_4";
	this.FeedbackTimelineDivider_4.setTransform(37.5,254,1,1,0,0,0,25.5,7);

	this.FeedbackTimelineDivider_5 = new lib.FeedbackTimelineDivider();
	this.FeedbackTimelineDivider_5.name = "FeedbackTimelineDivider_5";
	this.FeedbackTimelineDivider_5.setTransform(37.5,152.7,1,1,0,0,0,25.5,7);

	this.instance_4 = new lib.FeedbackKDstates();
	this.instance_4.setTransform(432,417,1,1,0,0,0,432,162.5);

	this.instance_5 = new lib.FeedbackTimelineBlackBar();
	this.instance_5.setTransform(36,341,1,1,0,0,0,11,87);

	this.FeedbackTimelineBG = new lib.FeedbackTimelineBG();
	this.FeedbackTimelineBG.name = "FeedbackTimelineBG";
	this.FeedbackTimelineBG.setTransform(36.5,540,1,1,0,0,0,10.5,540);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.FeedbackTimelineBG},{t:this.instance_5},{t:this.instance_4},{t:this.FeedbackTimelineDivider_5},{t:this.FeedbackTimelineDivider_4},{t:this.instance_3},{t:this.FeedbackTimelineDivider_3},{t:this.instance_2},{t:this.FeedbackTimelineDivider_2},{t:this.instance_1},{t:this.FeedbackTimelineDivider_1},{t:this.instance},{t:this.FeedbackTimelineDivider}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackTimeline, new cjs.Rectangle(0,0,77,1080), null);


(lib.FeedbackTimeline_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackKeyDecisionContainer();
	this.instance.setTransform(131.3,189.2,1,1,0,0,0,-65.8,-49.5);

	this.instance_1 = new lib.FeedbackTimelineBGLong();
	this.instance_1.setTransform(119,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackTimeline_1, new cjs.Rectangle(81.3,0,155.8,805), null);


(lib.FeedbackBlackScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.READYfeedbackTitle = new cjs.Text("READY feedback", "28px 'Work Sans SemiBold'", "#324141");
	this.READYfeedbackTitle.name = "READYfeedbackTitle";
	this.READYfeedbackTitle.lineHeight = 35;
	this.READYfeedbackTitle.lineWidth = 252;
	this.READYfeedbackTitle.parent = this;
	this.READYfeedbackTitle.setTransform(789,343.4);
ranj.TextOffsetFixer.fix(this.READYfeedbackTitle);

	this.optimalAnswersTitle = new cjs.Text("Optimal answers", "28px 'Work Sans SemiBold'", "#324141");
	this.optimalAnswersTitle.name = "optimalAnswersTitle";
	this.optimalAnswersTitle.lineHeight = 35;
	this.optimalAnswersTitle.lineWidth = 399;
	this.optimalAnswersTitle.parent = this;
	this.optimalAnswersTitle.setTransform(101.55,343.4);
ranj.TextOffsetFixer.fix(this.optimalAnswersTitle);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.optimalAnswersTitle},{t:this.READYfeedbackTitle}]}).wait(1));

	// feedback
	this.AnswerFeedback4 = new cjs.Text("Virtual training may not be effective for training CHWs on EnVD response. Focusing on general precautions and notifying RRT about all possible cases may dilute focus on actual EnVD cases.", "20px 'Work Sans'", "#FFFFFF");
	this.AnswerFeedback4.name = "AnswerFeedback4";
	this.AnswerFeedback4.lineHeight = 23;
	this.AnswerFeedback4.lineWidth = 931;
	this.AnswerFeedback4.parent = this;
	this.AnswerFeedback4.setTransform(789,792.6);
ranj.TextOffsetFixer.fix(this.AnswerFeedback4);

	this.AnswerFeedback3 = new cjs.Text("Decide how recruitment of Community Health Workers should proceed as the number of infections increases. Decide how recruitment of Community Health Workers should proceed as the number of infections increases. Decide how recruitment of Community Health Workers should proceedDecide how recruitment of Community Health Workers should proceedDecide how recruitment of Community Health Workers should proceed", "20px 'Work Sans'", "#FFFFFF");
	this.AnswerFeedback3.name = "AnswerFeedback3";
	this.AnswerFeedback3.lineHeight = 23;
	this.AnswerFeedback3.lineWidth = 931;
	this.AnswerFeedback3.parent = this;
	this.AnswerFeedback3.setTransform(789,661.6);
ranj.TextOffsetFixer.fix(this.AnswerFeedback3);

	this.AnswerFeedback2 = new cjs.Text("Waiting for a week to gather the paper line list data from CHWs can lead to a delay in identifying and addressing any emerging trends, which can result in a missed opportunity for early intervention.", "20px 'Work Sans'", "#FFFFFF");
	this.AnswerFeedback2.name = "AnswerFeedback2";
	this.AnswerFeedback2.lineHeight = 23;
	this.AnswerFeedback2.lineWidth = 931;
	this.AnswerFeedback2.parent = this;
	this.AnswerFeedback2.setTransform(789,531.1);
ranj.TextOffsetFixer.fix(this.AnswerFeedback2);

	this.AnswerFeedback1 = new cjs.Text("Pausing all other CHW activities can have negative consequences. It can lead to a disruption of essential health services, which may be critical to the health and well-being of the community.", "20px 'Work Sans'", "#FFFFFF");
	this.AnswerFeedback1.name = "AnswerFeedback1";
	this.AnswerFeedback1.lineHeight = 23;
	this.AnswerFeedback1.lineWidth = 931;
	this.AnswerFeedback1.parent = this;
	this.AnswerFeedback1.setTransform(789,402.6);
ranj.TextOffsetFixer.fix(this.AnswerFeedback1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.AnswerFeedback1},{t:this.AnswerFeedback2},{t:this.AnswerFeedback3},{t:this.AnswerFeedback4}]}).wait(1));

	// answers
	this.OptimalLockedIcon = new lib.IconOptimalLocked();
	this.OptimalLockedIcon.name = "OptimalLockedIcon";
	this.OptimalLockedIcon.setTransform(99,968.9,1,1,0,0,0,21,20.5);

	this.OptimalLockedExplanation = new cjs.Text("This answer was not discovered in preparation to compose your plan.", "20px 'Work Sans SemiBold'", "#2C3C3C");
	this.OptimalLockedExplanation.name = "OptimalLockedExplanation";
	this.OptimalLockedExplanation.lineHeight = 23;
	this.OptimalLockedExplanation.lineWidth = 721;
	this.OptimalLockedExplanation.parent = this;
	this.OptimalLockedExplanation.setTransform(129.9,958.05);
ranj.TextOffsetFixer.fix(this.OptimalLockedExplanation);

	this.ButtonAnswerGood4 = new lib.FeedbackButtonOptimalGreen();
	this.ButtonAnswerGood4.name = "ButtonAnswerGood4";
	this.ButtonAnswerGood4.setTransform(468.6,869.5,1,1,0,0,0,130.1,33);

	this.ButtonAnswerGood3 = new lib.FeedbackButtonOptimalGreen();
	this.ButtonAnswerGood3.name = "ButtonAnswerGood3";
	this.ButtonAnswerGood3.setTransform(468.6,739,1,1,0,0,0,130.1,33);

	this.ButtonAnswerGood2 = new lib.FeedbackButtonOptimalGreen();
	this.ButtonAnswerGood2.name = "ButtonAnswerGood2";
	this.ButtonAnswerGood2.setTransform(468.6,608,1,1,0,0,0,130.1,33);

	this.ButtonAnswerGood1 = new lib.FeedbackButtonOptimalGreen();
	this.ButtonAnswerGood1.name = "ButtonAnswerGood1";
	this.ButtonAnswerGood1.setTransform(468.6,479,1,1,0,0,0,130.1,33);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.ButtonAnswerGood1},{t:this.ButtonAnswerGood2},{t:this.ButtonAnswerGood3},{t:this.ButtonAnswerGood4},{t:this.OptimalLockedExplanation},{t:this.OptimalLockedIcon}]}).wait(1));

	// lines
	this.instance = new lib.FeedbackDividerBlackScreen();
	this.instance.setTransform(909.95,787.5,1.0059,1,0,0,0,809.2,0);

	this.instance_1 = new lib.FeedbackDividerBlackScreen();
	this.instance_1.setTransform(909.95,657.45,1.0059,1,0,0,0,809.2,0);

	this.instance_2 = new lib.FeedbackDividerBlackScreen();
	this.instance_2.setTransform(909.95,528.25,1.0059,1,0,0,0,809.2,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// answerBG
	this.instance_3 = new lib.FeedbackAnswerBGBlack();
	this.instance_3.setTransform(910.2,700.2,1,1,0,0,0,863.2,313.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackBlackScreen, new cjs.Rectangle(47,341.4,1728,648), null);


(lib.DashboardTab2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// EpilogueMaterial
	this.Annotation3 = new lib.AnnotationTab2();
	this.Annotation3.name = "Annotation3";
	this.Annotation3.setTransform(303.05,329.25,1,1,0,0,0,310.5,68.5);

	this.timeline.addTween(cjs.Tween.get(this.Annotation3).wait(1));

	// CategoryTitles
	this.ThirdCategoryTitleTextField = new cjs.Text("Category title here", "18px 'Work Sans'", "#295B6D");
	this.ThirdCategoryTitleTextField.name = "ThirdCategoryTitleTextField";
	this.ThirdCategoryTitleTextField.lineHeight = 23;
	this.ThirdCategoryTitleTextField.lineWidth = 253;
	this.ThirdCategoryTitleTextField.parent = this;
	this.ThirdCategoryTitleTextField.setTransform(2,421);
ranj.TextOffsetFixer.fix(this.ThirdCategoryTitleTextField);

	this.SecondCategoryTitleTextField = new cjs.Text("Category title here", "18px 'Work Sans'", "#295B6D");
	this.SecondCategoryTitleTextField.name = "SecondCategoryTitleTextField";
	this.SecondCategoryTitleTextField.lineHeight = 23;
	this.SecondCategoryTitleTextField.lineWidth = 253;
	this.SecondCategoryTitleTextField.parent = this;
	this.SecondCategoryTitleTextField.setTransform(2,223);
ranj.TextOffsetFixer.fix(this.SecondCategoryTitleTextField);

	this.FirstCategoryTitleTextField = new cjs.Text("Category title here", "18px 'Work Sans'", "#295B6D");
	this.FirstCategoryTitleTextField.name = "FirstCategoryTitleTextField";
	this.FirstCategoryTitleTextField.lineHeight = 23;
	this.FirstCategoryTitleTextField.lineWidth = 253;
	this.FirstCategoryTitleTextField.parent = this;
	this.FirstCategoryTitleTextField.setTransform(2,53);
ranj.TextOffsetFixer.fix(this.FirstCategoryTitleTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.FirstCategoryTitleTextField},{t:this.SecondCategoryTitleTextField},{t:this.ThirdCategoryTitleTextField}]}).wait(1));

	// Layer_2
	this.LabelTab2Color = new cjs.Text("Showing weekly data from Northeast region of Thisland (total population 4.2m)", "bold 22px 'Work Sans'", "#1A3168");
	this.LabelTab2Color.name = "LabelTab2Color";
	this.LabelTab2Color.lineHeight = 28;
	this.LabelTab2Color.lineWidth = 1017;
	this.LabelTab2Color.parent = this;
	this.LabelTab2Color.setTransform(2,2);
ranj.TextOffsetFixer.fix(this.LabelTab2Color);

	this.timeline.addTween(cjs.Tween.get(this.LabelTab2Color).wait(1));

	// Layer_1
	this.instance = new lib.DashboardLogoReady();
	this.instance.setTransform(1382.9,10.45,1,1,0,0,0,68.5,16);

	this.LabelTab2 = new cjs.Text("Showing weekly data from Northeast region of Thisland (total population 4.2m)", "bold 22px 'Work Sans'", "#295B6D");
	this.LabelTab2.name = "LabelTab2";
	this.LabelTab2.lineHeight = 28;
	this.LabelTab2.lineWidth = 1017;
	this.LabelTab2.parent = this;
	this.LabelTab2.setTransform(2,2);
ranj.TextOffsetFixer.fix(this.LabelTab2);

	this.DataElement6 = new lib.DataElementTwoLines();
	this.DataElement6.name = "DataElement6";
	this.DataElement6.setTransform(490.65,577.15,1,1,0,0,0,184.2,86.5);

	this.DataElement5 = new lib.DataElementTwoLines();
	this.DataElement5.name = "DataElement5";
	this.DataElement5.setTransform(137.15,577.15,1,1,0,0,0,184.2,86.5);

	this.DataElement8 = new lib.DataElementTwoLines();
	this.DataElement8.name = "DataElement8";
	this.DataElement8.setTransform(1197.65,577.15,1,1,0,0,0,184.2,86.5);

	this.DataElement7 = new lib.DataElementTwoLines();
	this.DataElement7.name = "DataElement7";
	this.DataElement7.setTransform(844.15,577.15,1,1,0,0,0,184.2,86.5);

	this.DataElement4 = new lib.DataElementTwoLines();
	this.DataElement4.name = "DataElement4";
	this.DataElement4.setTransform(490.65,377.3,1,1,0,0,0,184.2,86.5);

	this.DataElement3 = new lib.DataElementTwoLines();
	this.DataElement3.name = "DataElement3";
	this.DataElement3.setTransform(137.15,377.3,1,1,0,0,0,184.2,86.5);

	this.DataElement2 = new lib.DataElement();
	this.DataElement2.name = "DataElement2";
	this.DataElement2.setTransform(307,91.45);

	this.DataElement1 = new lib.DataElement();
	this.DataElement1.name = "DataElement1";
	this.DataElement1.setTransform(-46.5,91.45);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#295B6D").ss(1,1,1).p("EhsXActMDYvAAAEhsXgcsMDYvAAAEhsXgCQMDYvAAA");
	this.shape.setTransform(694.275,263.125);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.DataElement1},{t:this.DataElement2},{t:this.DataElement3},{t:this.DataElement4},{t:this.DataElement7},{t:this.DataElement8},{t:this.DataElement5},{t:this.DataElement6},{t:this.LabelTab2},{t:this.instance}]}).wait(1));

	// EpilogueGlobe
	this.GlobeEpilogue = new lib.GlobeEpilogue();
	this.GlobeEpilogue.name = "GlobeEpilogue";
	this.GlobeEpilogue.setTransform(1191,380.5,1,1,0,0,0,350,322.5);

	this.timeline.addTween(cjs.Tween.get(this.GlobeEpilogue).wait(1));

	// BGitem
	this.GlobeTab2 = new lib.GlobeTab2();
	this.GlobeTab2.name = "GlobeTab2";
	this.GlobeTab2.setTransform(1133.5,331.5,1,1,0,0,0,344.5,329.5);

	this.timeline.addTween(cjs.Tween.get(this.GlobeTab2).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DashboardTab2, new cjs.Rectangle(-7.4,-5.5,1548.4,708.5), null);


(lib.DashboardTab1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.LabelTab1Color = new cjs.Text("Showing data from Northeast region of Thisland (total population 4.2m)", "bold 22px 'Work Sans'", "#1A3168");
	this.LabelTab1Color.name = "LabelTab1Color";
	this.LabelTab1Color.lineHeight = 28;
	this.LabelTab1Color.lineWidth = 1323;
	this.LabelTab1Color.parent = this;
	this.LabelTab1Color.setTransform(2,-6.2);
ranj.TextOffsetFixer.fix(this.LabelTab1Color);

	this.timeline.addTween(cjs.Tween.get(this.LabelTab1Color).wait(1));

	// EpilogueAnnotations
	this.Annotation2 = new lib.AnnotationTab1();
	this.Annotation2.name = "Annotation2";
	this.Annotation2.setTransform(309.5,239.05,1,1,0,0,0,310.5,68.5);

	this.Annotation1 = new lib.AnnotationTab1();
	this.Annotation1.name = "Annotation1";
	this.Annotation1.setTransform(309.5,97.25,1,1,0,0,0,310.5,68.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.Annotation1},{t:this.Annotation2}]}).wait(1));

	// Layer_1
	this.LabelGraph2 = new cjs.Text("Number of new cases", "bold 18px 'Work Sans'", "#295B6D");
	this.LabelGraph2.name = "LabelGraph2";
	this.LabelGraph2.lineHeight = 23;
	this.LabelGraph2.lineWidth = 318;
	this.LabelGraph2.parent = this;
	this.LabelGraph2.setTransform(791,355.95);
ranj.TextOffsetFixer.fix(this.LabelGraph2);

	this.Graph2 = new lib.Graph();
	this.Graph2.name = "Graph2";
	this.Graph2.setTransform(778,442.85);

	this.Graph1 = new lib.Graph();
	this.Graph1.name = "Graph1";
	this.Graph1.setTransform(778,127.1);

	this.LabelGraph1 = new cjs.Text("Number of new cases", "bold 18px 'Work Sans'", "#295B6D");
	this.LabelGraph1.name = "LabelGraph1";
	this.LabelGraph1.lineHeight = 23;
	this.LabelGraph1.lineWidth = 317;
	this.LabelGraph1.parent = this;
	this.LabelGraph1.setTransform(791,55.6);
ranj.TextOffsetFixer.fix(this.LabelGraph1);

	this.LabelTab1 = new cjs.Text("Showing select monthly data from READY PHCs (total catchment area: 177,250 people)", "bold 22px 'Work Sans'", "#295B6D");
	this.LabelTab1.name = "LabelTab1";
	this.LabelTab1.lineHeight = 28;
	this.LabelTab1.lineWidth = 1323;
	this.LabelTab1.parent = this;
	this.LabelTab1.setTransform(2,-6.2);
ranj.TextOffsetFixer.fix(this.LabelTab1);

	this.instance = new lib.GraphTitleLabel();
	this.instance.setTransform(946.85,369.25,1,1,0,0,0,170,20.5);

	this.instance_1 = new lib.GraphTitleLabel();
	this.instance_1.setTransform(946.85,69.7,1,1,0,0,0,170,20.5);

	this.instance_2 = new lib.DashboardLogoGHO();
	this.instance_2.setTransform(1386.15,191.45,1,1,0,0,0,55.5,45.5);

	this.DataElement8 = new lib.DataElement();
	this.DataElement8.name = "DataElement8";
	this.DataElement8.setTransform(466.05,560.1,1,1,0,0,0,184.2,86.5);

	this.DataElement7 = new lib.DataElement();
	this.DataElement7.name = "DataElement7";
	this.DataElement7.setTransform(137.15,560.1,1,1,0,0,0,184.2,86.5);

	this.DataElement6 = new lib.DataElement();
	this.DataElement6.name = "DataElement6";
	this.DataElement6.setTransform(466.05,410.9,1,1,0,0,0,184.2,86.5);

	this.DataElement5 = new lib.DataElement();
	this.DataElement5.name = "DataElement5";
	this.DataElement5.setTransform(137.15,410.9,1,1,0,0,0,184.2,86.5);

	this.DataElement4 = new lib.DataElement();
	this.DataElement4.name = "DataElement4";
	this.DataElement4.setTransform(466.05,261.65,1,1,0,0,0,184.2,86.5);

	this.DataElement3 = new lib.DataElement();
	this.DataElement3.name = "DataElement3";
	this.DataElement3.setTransform(137.15,261.65,1,1,0,0,0,184.2,86.5);

	this.DataElement2 = new lib.DataElement();
	this.DataElement2.name = "DataElement2";
	this.DataElement2.setTransform(466.05,123.75,1,1,0,0,0,184.2,86.5);

	this.DataElement1 = new lib.DataElement();
	this.DataElement1.name = "DataElement1";
	this.DataElement1.setTransform(-47,37.25);

	this.DashboardTabLogo = new lib.DashboardLogoWHO();
	this.DashboardTabLogo.name = "DashboardTabLogo";
	this.DashboardTabLogo.setTransform(1383.15,59,1,1,0,0,0,59.5,59);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#295B6D").ss(1,1,1).p("EgtWgLwMBatAAAEgtWALxMBatAAA");
	this.shape.setTransform(290.3,393.55);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.DashboardTabLogo},{t:this.DataElement1},{t:this.DataElement2},{t:this.DataElement3},{t:this.DataElement4},{t:this.DataElement5},{t:this.DataElement6},{t:this.DataElement7},{t:this.DataElement8},{t:this.instance_2},{t:this.instance_1},{t:this.instance},{t:this.LabelTab1},{t:this.LabelGraph1},{t:this.Graph1},{t:this.Graph2},{t:this.LabelGraph2}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DashboardTab1, new cjs.Rectangle(-229.7,-363.7,1919.9,1080), null);


(lib.TopicAnswerButtonPanelSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {state1:0,animIn:1,state2:14,animOut:15};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_14 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(14).call(this.frame_14).wait(13));

	// dialogOptionButton1
	this.topicsOptionButton8 = new lib.TopicButton();
	this.topicsOptionButton8.name = "topicsOptionButton8";
	this.topicsOptionButton8.setTransform(875.5,161,1,1,0,0,0,122.5,27);

	this.topicsOptionButton4 = new lib.TopicButton();
	this.topicsOptionButton4.name = "topicsOptionButton4";
	this.topicsOptionButton4.setTransform(875.5,87,1,1,0,0,0,122.5,27);

	this.topicsOptionButton7 = new lib.TopicButton();
	this.topicsOptionButton7.name = "topicsOptionButton7";
	this.topicsOptionButton7.setTransform(629.5,161,1,1,0,0,0,122.5,27);

	this.topicsOptionButton3 = new lib.TopicButton();
	this.topicsOptionButton3.name = "topicsOptionButton3";
	this.topicsOptionButton3.setTransform(629.5,87,1,1,0,0,0,122.5,27);

	this.topicsOptionButton6 = new lib.TopicButton();
	this.topicsOptionButton6.name = "topicsOptionButton6";
	this.topicsOptionButton6.setTransform(379.5,161,1,1,0,0,0,122.5,27);

	this.topicsOptionButton2 = new lib.TopicButton();
	this.topicsOptionButton2.name = "topicsOptionButton2";
	this.topicsOptionButton2.setTransform(379.5,87,1,1,0,0,0,122.5,27);

	this.topicsOptionButton5 = new lib.TopicButton();
	this.topicsOptionButton5.name = "topicsOptionButton5";
	this.topicsOptionButton5.setTransform(133.5,161,1,1,0,0,0,122.5,27);

	this.topicsOptionButton1 = new lib.TopicButton();
	this.topicsOptionButton1.name = "topicsOptionButton1";
	this.topicsOptionButton1.setTransform(133.5,87,1,1,0,0,0,122.5,27);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.topicsOptionButton1},{t:this.topicsOptionButton5},{t:this.topicsOptionButton2},{t:this.topicsOptionButton6},{t:this.topicsOptionButton3},{t:this.topicsOptionButton7},{t:this.topicsOptionButton4},{t:this.topicsOptionButton8}]}).wait(27));

	// Button
	this.endButton = new lib.BackButton();
	this.endButton.name = "endButton";
	this.endButton.setTransform(20,25,1,1,0,0,0,20,20);

	this.timeline.addTween(cjs.Tween.get(this.endButton).wait(27));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,5,998,221.2);


(lib.PlanComposerScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// PlanComposerButton
	this.SubmitButton = new lib.PlanComposerKeyDecision_SubmitButton();
	this.SubmitButton.name = "SubmitButton";
	this.SubmitButton.setTransform(-459.1,432.35,1,1,0,0,0,36.5,7);

	this.Topic2Button = new lib.TabButtonPlanComposer();
	this.Topic2Button.name = "Topic2Button";
	this.Topic2Button.setTransform(-270.3,-322.7,1,1,0,0,0,194.5,34.6);

	this.Topic1Button = new lib.TabButtonPlanComposer();
	this.Topic1Button.name = "Topic1Button";
	this.Topic1Button.setTransform(-680.8,-322.7,1,1,0,0,0,194.5,34.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.Topic1Button},{t:this.Topic2Button},{t:this.SubmitButton}]}).wait(1));

	// Topic2
	this.Topic2 = new lib.PlanComposerKeyDecision_Topic();
	this.Topic2.name = "Topic2";
	this.Topic2.setTransform(17.65,84.65,1,1,0,0,0,851.9,446.2);

	this.timeline.addTween(cjs.Tween.get(this.Topic2).wait(1));

	// Topic1
	this.Topic1 = new lib.PlanComposerKeyDecision_Topic();
	this.Topic1.name = "Topic1";
	this.Topic1.setTransform(-35,84.7,1,1,0,0,0,851.9,446.2);

	this.timeline.addTween(cjs.Tween.get(this.Topic1).wait(1));

	// PlanComposerShell
	this.DecisionContainer = new lib.PlanComposerKeyDecision_AnswerBackground();
	this.DecisionContainer.name = "DecisionContainer";
	this.DecisionContainer.setTransform(-464.5,102,1,1,0,0,0,460,423);

	this.timeline.addTween(cjs.Tween.get(this.DecisionContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerScreenSkin, new cjs.Rectangle(-961.5,-541.2,1939.5,1082.2), null);


(lib.MapNodeInformationPopupSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// panel
	this.panel = new lib.MapNodeInformationPopupPanel();
	this.panel.name = "panel";

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1));

	// overlay
	this.overlay = new lib.PopupOverlayBackground();
	this.overlay.name = "overlay";

	this.timeline.addTween(cjs.Tween.get(this.overlay).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.MapNodeInformationPopupSkin, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.KeyDecisionOverlayScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// fader
	this.fader = new lib.KeyDecisionOverlayFader();
	this.fader.name = "fader";

	this.timeline.addTween(cjs.Tween.get(this.fader).wait(1));

	// abortButton
	this.abortButton = new lib.AbortButton();
	this.abortButton.name = "abortButton";
	this.abortButton.setTransform(-878.15,-445.9,1,1,0,0,0,-141.5,14.5);

	this.timeline.addTween(cjs.Tween.get(this.abortButton).wait(1));

	// Layer_2
	this.keyDecisionPanel = new lib.KeyDecLabel_1();
	this.keyDecisionPanel.name = "keyDecisionPanel";
	this.keyDecisionPanel.setTransform(-9.5,-456,1,1,0,0,0,422.5,87);

	this.timeline.addTween(cjs.Tween.get(this.keyDecisionPanel).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecisionOverlayScreenSkin, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.KeyDecisionAvailableScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// panel
	this.panel = new lib.KeyDecisionAvailablePanel();
	this.panel.name = "panel";
	this.panel.setTransform(726.15,-71.5);

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1));

	// overlay
	this.keyDecisionsContainer = new lib.HubKeyDecisionNotificationContainer();
	this.keyDecisionsContainer.name = "keyDecisionsContainer";
	this.keyDecisionsContainer.setTransform(917.4,-177.25);

	this.overlay = new lib.KeyDecisionAvailableBackdrop();
	this.overlay.name = "overlay";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.overlay},{t:this.keyDecisionsContainer}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecisionAvailableScreenSkin, new cjs.Rectangle(-960,-540,1920,1080), null);


(lib.HubScreenSkinTutorial = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// internalStakeholders
	this.internalStakeholders = new lib.InternalStakeholders();
	this.internalStakeholders.name = "internalStakeholders";
	this.internalStakeholders.setTransform(548.6,451.4);

	this.timeline.addTween(cjs.Tween.get(this.internalStakeholders).wait(1));

	// timerKeyDecision
	this.timerKeyDecision = new lib.timerKeyDecision();
	this.timerKeyDecision.name = "timerKeyDecision";
	this.timerKeyDecision.setTransform(605.9,-358.35,1,1,0,0,0,137.5,22.5);

	this.timeline.addTween(cjs.Tween.get(this.timerKeyDecision).wait(1));

	// teaCorner
	this.dashboardButton = new lib.DataDashboardIconTutorial();
	this.dashboardButton.name = "dashboardButton";
	this.dashboardButton.setTransform(-302.35,318.35);

	this.teaCorner = new lib.HUBTeaCornerButton();
	this.teaCorner.name = "teaCorner";
	this.teaCorner.setTransform(-2.2,390.2,1,1,0,0,0,-95.5,-7.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.teaCorner},{t:this.dashboardButton}]}).wait(1));

	// keyDecisionContainer
	this.hubTimeline = new lib.HubTimeline();
	this.hubTimeline.name = "hubTimeline";
	this.hubTimeline.setTransform(851.65,-182.35,1,1,0,0,0,102.1,288.5);

	this.timeline.addTween(cjs.Tween.get(this.hubTimeline).wait(1));

	// smartphoneButton
	this.smartphoneButton = new lib.HudSmartphoneButtonTutorial();
	this.smartphoneButton.name = "smartphoneButton";
	this.smartphoneButton.setTransform(-814.9,313.35);

	this.timeline.addTween(cjs.Tween.get(this.smartphoneButton).wait(1));

	// laptopButton
	this.laptopButton = new lib.HudLaptopButtonTutorial();
	this.laptopButton.name = "laptopButton";
	this.laptopButton.setTransform(-574.65,308.35);

	this.timeline.addTween(cjs.Tween.get(this.laptopButton).wait(1));

	// mapContainer
	this.mapContainer = new lib.MapContainer();
	this.mapContainer.name = "mapContainer";

	this.timeline.addTween(cjs.Tween.get(this.mapContainer).wait(1));

	// bg_template
	this.instance = new lib.MapTutorial();
	this.instance.setTransform(-974,-553);

	this.TimingBG = new lib.TimingBG_1();
	this.TimingBG.name = "TimingBG";
	this.TimingBG.setTransform(652.05,-431.05,1,1,0,0,0,215.5,75);

	this.instance_1 = new lib.MapBGConfirmation();
	this.instance_1.setTransform(-961,-546);

	this.instance_2 = new lib.HUBmapCh1_1();
	this.instance_2.setTransform(-961,-546);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.TimingBG},{t:this.instance}]}).wait(1));

	// bg
	this.bg = new lib.HubBackground();
	this.bg.name = "bg";
	this.bg.setTransform(0,-13);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HubScreenSkinTutorial, new cjs.Rectangle(-974,-553.5,1934.5,1088.5), null);


(lib.ExitPauseInfoButtonScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// PopUp
	this.pauseResumeButtons = new lib.PauseResumeButton();
	this.pauseResumeButtons.name = "pauseResumeButtons";
	this.pauseResumeButtons.setTransform(-827.6,-487.65,1,1,0,0,0,-125.5,-2.5);

	this.replayOnboardingButton = new lib.ReplayOnboardingButton();
	this.replayOnboardingButton.name = "replayOnboardingButton";
	this.replayOnboardingButton.setTransform(-753.45,-487.65,1,1,0,0,0,-125.5,-2.5);

	this.exitButton = new lib.ExitButton();
	this.exitButton.name = "exitButton";
	this.exitButton.setTransform(-899.55,-487.65,1,1,0,0,0,-125.5,-2.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.exitButton},{t:this.replayOnboardingButton},{t:this.pauseResumeButtons}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ExitPauseInfoButtonScreenSkin, new cjs.Rectangle(-960.5,-540.5,1921,1081), null);


(lib.EpilogueDashboardScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_6
	this.EpilogueBackButton = new lib.EpilogueBackButton();
	this.EpilogueBackButton.name = "EpilogueBackButton";
	this.EpilogueBackButton.setTransform(-663.05,424,1,1,0,0,0,-26.8,-0.5);

	this.EpilogueContinueButton = new lib.EpilogueContinueButton();
	this.EpilogueContinueButton.name = "EpilogueContinueButton";
	this.EpilogueContinueButton.setTransform(735.15,424.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.EpilogueContinueButton},{t:this.EpilogueBackButton}]}).wait(1));

	// Tab3
	this.DashboardTab3 = new lib.DashboardTab3();
	this.DashboardTab3.name = "DashboardTab3";
	this.DashboardTab3.setTransform(-25.95,-237.75,1,1,0,0,0,726.6,37.2);

	this.timeline.addTween(cjs.Tween.get(this.DashboardTab3).wait(1));

	// Tab2
	this.DashboardTab2 = new lib.DashboardTab2();
	this.DashboardTab2.name = "DashboardTab2";
	this.DashboardTab2.setTransform(-729.55,-229.45);

	this.timeline.addTween(cjs.Tween.get(this.DashboardTab2).wait(1));

	// Tab1
	this.DashboardTab1 = new lib.DashboardTab1();
	this.DashboardTab1.name = "DashboardTab1";
	this.DashboardTab1.setTransform(-729.5,-217.75);

	this.timeline.addTween(cjs.Tween.get(this.DashboardTab1).wait(1));

	// Layer_5
	this.subTitleTextField = new cjs.Text("EnVD Epidemiology", "bold 32px 'Work Sans'", "#1A3168");
	this.subTitleTextField.name = "subTitleTextField";
	this.subTitleTextField.lineHeight = 40;
	this.subTitleTextField.lineWidth = 692;
	this.subTitleTextField.parent = this;
	this.subTitleTextField.setTransform(-728.55,-273.4);
ranj.TextOffsetFixer.fix(this.subTitleTextField);

	this.timeline.addTween(cjs.Tween.get(this.subTitleTextField).wait(1));

	// titleTextfield
	this.WeekTextField = new cjs.Text("Thisland, week 19", "24px 'Work Sans'", "#1A3168");
	this.WeekTextField.name = "WeekTextField";
	this.WeekTextField.lineHeight = 22;
	this.WeekTextField.lineWidth = 506;
	this.WeekTextField.parent = this;
	this.WeekTextField.setTransform(-727.3,-381.1);
ranj.TextOffsetFixer.fix(this.WeekTextField);

	this.TitleLightTextField = new cjs.Text("dashboard ", "48px 'Work Sans Light'", "#1A3168");
	this.TitleLightTextField.name = "TitleLightTextField";
	this.TitleLightTextField.lineHeight = 58;
	this.TitleLightTextField.lineWidth = 541;
	this.TitleLightTextField.parent = this;
	this.TitleLightTextField.setTransform(-342,-441.05);
ranj.TextOffsetFixer.fix(this.TitleLightTextField);

	this.TitleExtraBoldTextField = new cjs.Text("Enni Virus(EnV) ", "bold 48px 'Work Sans ExtraBold'", "#1A3168");
	this.TitleExtraBoldTextField.name = "TitleExtraBoldTextField";
	this.TitleExtraBoldTextField.lineHeight = 72;
	this.TitleExtraBoldTextField.lineWidth = 431;
	this.TitleExtraBoldTextField.parent = this;
	this.TitleExtraBoldTextField.setTransform(-728.55,-440.65);
ranj.TextOffsetFixer.fix(this.TitleExtraBoldTextField);

	this.TitleSubTextField = new cjs.Text("Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut ", "bold 22px 'Work Sans'", "#1A3168");
	this.TitleSubTextField.name = "TitleSubTextField";
	this.TitleSubTextField.lineHeight = 20;
	this.TitleSubTextField.lineWidth = 1400;
	this.TitleSubTextField.parent = this;
	this.TitleSubTextField.setTransform(-727.3,-336.4);
ranj.TextOffsetFixer.fix(this.TitleSubTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.TitleSubTextField},{t:this.TitleExtraBoldTextField},{t:this.TitleLightTextField},{t:this.WeekTextField}]}).wait(1));

	// TabDividers
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#295B6D").s().p("AgfABIAAgBIA/AAIAAABg");
	this.shape.setTransform(-320.2,-289.35);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// TabButton
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("Egi8gD8MBF5AAAIAAH5MhF5AAAg");
	this.shape_1.setTransform(-578.3,-315.475);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

	// imageMask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("EhHtBLKQlcAAj2j2Qj2j2AAlcMAAAh8DQAAlcD2j2QD2j2FcAAMCPbAAAQFcAAD2D2QD2D2AAFcMAAAB8DQAAFcj2D2Qj2D2lcAAg");
	mask.setTransform(-344,16);

	// imageContainer
	this.imageContainer = new lib.DecisionImageContainer();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(-344,16);

	var maskedShapeInstanceList = [this.imageContainer];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(1));

	// background
	this.DashboardBG = new lib.EpilogueDashboardBG();
	this.DashboardBG.name = "DashboardBG";
	this.DashboardBG.setTransform(-38.75,-16.75,1,1,0,0,0,801.5,451.5);

	this.timeline.addTween(cjs.Tween.get(this.DashboardBG).wait(1));

	// BackgroundBackground
	this.instance = new lib.EpilogueDashboardBackground();
	this.instance.setTransform(-960,-541);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiV/hUXMEr/AAAMAAACovMkr/AAAg");
	this.shape_2.setTransform(0.15,-0.75);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("rgba(0,0,0,0.6)").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");
	this.shape_3.setTransform(0.15,-0.75);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_3},{t:this.shape_2}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EpilogueDashboardScreenSkin, new cjs.Rectangle(-960.8,-541.7,1922,1082), null);


(lib.DashboardScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Tab3
	this.DashboardTab3 = new lib.DashboardTab3();
	this.DashboardTab3.name = "DashboardTab3";
	this.DashboardTab3.setTransform(-772,-267);

	this.timeline.addTween(cjs.Tween.get(this.DashboardTab3).wait(1));

	// Tab2
	this.DashboardTab2 = new lib.DashboardTab2();
	this.DashboardTab2.name = "DashboardTab2";
	this.DashboardTab2.setTransform(-716,-236);

	this.timeline.addTween(cjs.Tween.get(this.DashboardTab2).wait(1));

	// Tab1
	this.DashboardTab1 = new lib.DashboardTab1();
	this.DashboardTab1.name = "DashboardTab1";
	this.DashboardTab1.setTransform(-715,-236);

	this.timeline.addTween(cjs.Tween.get(this.DashboardTab1).wait(1));

	// CloseButton
	this.closeButton = new lib.TopBarCloseWindowButton();
	this.closeButton.name = "closeButton";
	this.closeButton.setTransform(715.2,-395.95);

	this.timeline.addTween(cjs.Tween.get(this.closeButton).wait(1));
	this.closeButton.addEventListener("tick", AdobeAn.handleFilterCache);

	// titleTextfield
	this.TitleLightTextField = new cjs.Text("dashboard ", "48px 'Work Sans Light'", "#1A3168");
	this.TitleLightTextField.name = "TitleLightTextField";
	this.TitleLightTextField.lineHeight = 58;
	this.TitleLightTextField.lineWidth = 605;
	this.TitleLightTextField.parent = this;
	this.TitleLightTextField.setTransform(-373.15,-415.2);
ranj.TextOffsetFixer.fix(this.TitleLightTextField);

	this.TitleExtraBoldTextField = new cjs.Text("Enni Virus (EnV) ", "bold 48px 'Work Sans ExtraBold'", "#1A3168");
	this.TitleExtraBoldTextField.name = "TitleExtraBoldTextField";
	this.TitleExtraBoldTextField.lineHeight = 72;
	this.TitleExtraBoldTextField.lineWidth = 431;
	this.TitleExtraBoldTextField.parent = this;
	this.TitleExtraBoldTextField.setTransform(-766.3,-415.95);
ranj.TextOffsetFixer.fix(this.TitleExtraBoldTextField);

	this.TitleSubTextField = new cjs.Text("Thisland, week 4", "24px 'Work Sans'", "#1A3168");
	this.TitleSubTextField.name = "TitleSubTextField";
	this.TitleSubTextField.lineHeight = 30;
	this.TitleSubTextField.lineWidth = 634;
	this.TitleSubTextField.parent = this;
	this.TitleSubTextField.setTransform(-763.2,-359.1);
ranj.TextOffsetFixer.fix(this.TitleSubTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.TitleSubTextField},{t:this.TitleExtraBoldTextField},{t:this.TitleLightTextField}]}).wait(1));

	// TabDividers
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#295B6D").s().p("AgfABIAAgBIA/AAIAAABg");
	this.shape.setTransform(-295.7,-272.85);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#78A5AF").s().p("EAlpAD+IAAn5IBAAAIAAH5gEgmoAD9IAAn6IBAAAIAAH6g");
	this.shape_1.setTransform(-3.35,-298.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	// TabNewIndicator
	this.TabNewIndicator3 = new lib.TabNewIndicator();
	this.TabNewIndicator3.name = "TabNewIndicator3";
	this.TabNewIndicator3.setTransform(698.7,-298.5,1,1,0,0,0,16.5,16.5);

	this.TabNewIndicator2 = new lib.TabNewIndicator();
	this.TabNewIndicator2.name = "TabNewIndicator2";
	this.TabNewIndicator2.setTransform(211.5,-298.5,1,1,0,0,0,16.5,16.5);

	this.TabNewIndicator1 = new lib.TabNewIndicator();
	this.TabNewIndicator1.name = "TabNewIndicator1";
	this.TabNewIndicator1.setTransform(-276.2,-298.5,1,1,0,0,0,16.5,16.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.TabNewIndicator1},{t:this.TabNewIndicator2},{t:this.TabNewIndicator3}]}).wait(1));

	// TabButton
	this.TabButton3 = new lib.TabButton();
	this.TabButton3.name = "TabButton3";
	this.TabButton3.setTransform(467.65,-299,1,1,0,0,0,223.7,25.3);

	this.TabButton2 = new lib.TabButton();
	this.TabButton2.name = "TabButton2";
	this.TabButton2.setTransform(-20.55,-299,1,1,0,0,0,223.7,25.3);

	this.TabButton1 = new lib.TabButton();
	this.TabButton1.name = "TabButton1";
	this.TabButton1.setTransform(-508.75,-299,1,1,0,0,0,223.7,25.3);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("Egi8gD8MBF5AAAIAAH5MhF5AAAg");
	this.shape_2.setTransform(-553.8,-298.975);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.TabButton1},{t:this.TabButton2},{t:this.TabButton3}]}).wait(1));

	// TabBar
	this.instance = new lib.TabsBar();
	this.instance.setTransform(-19.2,-298.45,1,1,0,0,0,781.4,25.3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// imageMask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("EhHtBLKQlcAAj2j2Qj2j2AAlcMAAAh8DQAAlcD2j2QD2j2FcAAMCPbAAAQFcAAD2D2QD2D2AAFcMAAAB8DQAAFcj2D2Qj2D2lcAAg");
	mask.setTransform(-344,16);

	// imageContainer
	this.imageContainer = new lib.DecisionImageContainer();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(-344,16);

	var maskedShapeInstanceList = [this.imageContainer];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(1));

	// background
	this.DashboardBG = new lib.DashboardBG();
	this.DashboardBG.name = "DashboardBG";
	this.DashboardBG.setTransform(-14.25,-0.25,1,1,0,0,0,801.5,451.5);

	this.timeline.addTween(cjs.Tween.get(this.DashboardBG).wait(1));

	// Layer_2
	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiV/hUXMEr/AAAMAAACovMkr/AAAg");
	this.shape_3.setTransform(0.15,-0.75);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("rgba(0,0,0,0.6)").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");
	this.shape_4.setTransform(0.15,-0.75);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_4},{t:this.shape_3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DashboardScreenSkin, new cjs.Rectangle(-960.8,-541.7,1922,1082), null);


(lib.FeedbackScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// containerblack
	this.FeedbackBlackScreen = new lib.FeedbackBlackScreen();
	this.FeedbackBlackScreen.name = "FeedbackBlackScreen";
	this.FeedbackBlackScreen.setTransform(-814.85,-563.95);

	this.timeline.addTween(cjs.Tween.get(this.FeedbackBlackScreen).wait(1));

	// containerwhite
	this.FeedbackWhiteScreen = new lib.FeedbackWhiteScreen();
	this.FeedbackWhiteScreen.name = "FeedbackWhiteScreen";
	this.FeedbackWhiteScreen.setTransform(-959.85,-563.95,1,1,0,0,0,-145,0);

	this.timeline.addTween(cjs.Tween.get(this.FeedbackWhiteScreen).wait(1));

	// Layer_2
	this.hubTimeline = new lib.FeedbackTimelineLong();
	this.hubTimeline.name = "hubTimeline";
	this.hubTimeline.setTransform(-834.65,-208.75,1,1,0,0,0,143.2,288.5);

	this.timeline.addTween(cjs.Tween.get(this.hubTimeline).wait(1));

	// Buttons
	this.FeedbackToggle = new lib.FeedbackToggle();
	this.FeedbackToggle.name = "FeedbackToggle";
	this.FeedbackToggle.setTransform(92.25,468.5,1,1,0,0,0,204.5,33);

	this.FeedbackNext = new lib.FeedbackNextButtonWhiteScreen();
	this.FeedbackNext.name = "FeedbackNext";
	this.FeedbackNext.setTransform(765.35,470.65);

	this.FeedbackPrevious = new lib.FeedbackPreviousButtonWhiteScreen();
	this.FeedbackPrevious.name = "FeedbackPrevious";
	this.FeedbackPrevious.setTransform(-560.25,471.15);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.FeedbackPrevious},{t:this.FeedbackNext},{t:this.FeedbackToggle}]}).wait(1));

	// Layer_3
	this.instance = new lib.FeedbackIcon_1();
	this.instance.setTransform(-686.85,-435.2,1,1,0,0,0,27,21);

	this.FeedbackKDdescription = new cjs.Text("The MoH has requested that Thisland Relief add active EnVD case finding to the existing community-based surveillance conducted by the CHWs in the areas where they currently operate. The MoH has shared the additional reporting tools. Thisland Relief is seeking support and guidance from READY to operationalize the MoH’s request.", "24px 'Work Sans'", "#2C3C3C");
	this.FeedbackKDdescription.name = "FeedbackKDdescription";
	this.FeedbackKDdescription.lineHeight = 30;
	this.FeedbackKDdescription.lineWidth = 1621;
	this.FeedbackKDdescription.parent = this;
	this.FeedbackKDdescription.setTransform(-712.85,-349.95);
ranj.TextOffsetFixer.fix(this.FeedbackKDdescription);

	this.FeedbackDisclaimer = new cjs.Text("Disclaimer: answers marked as optimal in the sim don’t always have to be optimal in reality.", "italic 18px 'Work Sans'", "#93A5A4");
	this.FeedbackDisclaimer.name = "FeedbackDisclaimer";
	this.FeedbackDisclaimer.lineHeight = 28;
	this.FeedbackDisclaimer.lineWidth = 1104;
	this.FeedbackDisclaimer.parent = this;
	this.FeedbackDisclaimer.setTransform(-712.85,-381.95);
ranj.TextOffsetFixer.fix(this.FeedbackDisclaimer);

	this.FeedbackTitle = new cjs.Text("Key Decision feedback", "bold 50px 'Work Sans'", "#2C3C3C");
	this.FeedbackTitle.name = "FeedbackTitle";
	this.FeedbackTitle.lineHeight = 61;
	this.FeedbackTitle.lineWidth = 586;
	this.FeedbackTitle.parent = this;
	this.FeedbackTitle.setTransform(-642.85,-475.95);
ranj.TextOffsetFixer.fix(this.FeedbackTitle);

	this.instance_1 = new lib.FeedbackContentContainer();
	this.instance_1.setTransform(-815,-539);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.FeedbackTitle},{t:this.FeedbackDisclaimer},{t:this.FeedbackKDdescription},{t:this.instance}]}).wait(1));

	// bg
	this.instance_2 = new lib.FeedbackBackground();
	this.instance_2.setTransform(-961,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackScreenSkin, new cjs.Rectangle(-961,-540,1921.2,1081), null);


(lib.DialogAnswerCorrection = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {correct:0,incorrect:1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.RightAnimationMC();
	this.instance.setTransform(241.5,31.5,1,1,0,0,0,241.5,31.5);

	this.instance_1 = new lib.DialogButtonWrong();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-168.1,-92.7,654.1,295.5);


(lib.DialogButtoncopy = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3,"selectedUp":4,"selectedOver":5,"selectedDown":6,"selectedDisabled":7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Lorem ipsum \ndolor \nsit amet\nsit amet", "24px 'Work Sans'", "#2C3C3C");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 28;
	this.disabledLabelTextField.lineWidth = 653;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-325.95,-53.5);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(8));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Lorem ipsum \ndolor \nsit amet\nsit amet", "24px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 28;
	this.downLabelTextField.lineWidth = 654;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-323,-55.9);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(8));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Lorem ipsum \ndolor \nsit amet\nsit amet", "24px 'Work Sans'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 28;
	this.overLabelTextField.lineWidth = 654;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-323,-56.7);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(8));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Lorem ipsum \ndolor \nsit amet\nsit amet", "24px 'Work Sans'", "#2C3C3C");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 28;
	this.upLabelTextField.lineWidth = 654;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-327,-53.5);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(8));

	// correction
	this.correction = new lib.DialogAnswerCorrection();
	this.correction.name = "correction";
	this.correction.setTransform(-281.55,-43.5);

	this.timeline.addTween(cjs.Tween.get(this.correction).wait(8));

	// BG
	this.instance = new lib.DialogButtonUp();
	this.instance.setTransform(-374,-57);

	this.instance_1 = new lib.AnswerContainerOver();
	this.instance_1.setTransform(-370,-59);

	this.instance_2 = new lib.AnswerContainerDown();
	this.instance_2.setTransform(-370,-59);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance}]},1).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-449.6,-136.2,1016.6,295.5);


(lib.PlaceholderMapNode3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.NewCharacterAvailable = new lib.newKeyDecIcon();
	this.NewCharacterAvailable.name = "NewCharacterAvailable";
	this.NewCharacterAvailable.setTransform(-111.75,-82.15,1,1,0,0,180,25,22.5);

	this.timeline.addTween(cjs.Tween.get(this.NewCharacterAvailable).wait(4));

	// image
	this.locationImage = new lib.PlaceholderPoiImage();
	this.locationImage.name = "locationImage";
	this.locationImage.setTransform(-52,-52.5);

	this.timeline.addTween(cjs.Tween.get(this.locationImage).wait(4));

	// node
	this.node = new lib.MapLocationNode();
	this.node.name = "node";
	this.node.setTransform(5,-6);

	this.timeline.addTween(cjs.Tween.get(this.node).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-461,-144.8,482,274);


(lib.PlaceholderMapNode2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.NewCharacterAvailable = new lib.newKeyDecIcon();
	this.NewCharacterAvailable.name = "NewCharacterAvailable";
	this.NewCharacterAvailable.setTransform(-111.75,-82.15,1,1,0,0,180,25,22.5);

	this.timeline.addTween(cjs.Tween.get(this.NewCharacterAvailable).wait(4));

	// image
	this.locationImage = new lib.PlaceholderPoiImage();
	this.locationImage.name = "locationImage";
	this.locationImage.setTransform(-52,-52.5);

	this.timeline.addTween(cjs.Tween.get(this.locationImage).wait(4));

	// node
	this.node = new lib.MapLocationNode();
	this.node.name = "node";
	this.node.setTransform(-6,6);

	this.timeline.addTween(cjs.Tween.get(this.node).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-461,-144.8,471,274);


(lib.PlaceholderMapNode = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.NewCharacterAvailable = new lib.newKeyDecIcon();
	this.NewCharacterAvailable.name = "NewCharacterAvailable";
	this.NewCharacterAvailable.setTransform(-111.75,-82.15,1,1,0,0,180,25,22.5);

	this.timeline.addTween(cjs.Tween.get(this.NewCharacterAvailable).wait(4));

	// image
	this.locationImage = new lib.PlaceholderPoiImage();
	this.locationImage.name = "locationImage";
	this.locationImage.setTransform(-52,-52.5);

	this.timeline.addTween(cjs.Tween.get(this.locationImage).wait(4));

	// node
	this.node = new lib.MapLocationNode();
	this.node.name = "node";

	this.timeline.addTween(cjs.Tween.get(this.node).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-461,-144.8,477,274);


(lib.MapLocationCharacterMenu = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// images
	this.image2 = new lib.PlaceholderPoiCharacter();
	this.image2.name = "image2";
	this.image2.setTransform(-52,58.65,1,1,0,0,0,0,-0.5);

	this.image1 = new lib.PlaceholderPoiCharacter();
	this.image1.name = "image1";
	this.image1.setTransform(-102.7,3.15,1,1,0,0,0,0,-0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.image1},{t:this.image2}]}).wait(1));

	// labels
	this.label2 = new lib.MapLocationCharacterMenuItemLabel();
	this.label2.name = "label2";
	this.label2.setTransform(-233.5,66);

	this.label1 = new lib.MapLocationCharacterMenuItemLabel();
	this.label1.name = "label1";
	this.label1.setTransform(-283.5,10);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.label1},{t:this.label2}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.MapLocationCharacterMenu, new cjs.Rectangle(-461,-88.6,468,217.79999999999998), null);


(lib.TutorialScreenSkin3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_15
	this.TutorialInfoIcon = new lib.TutorialInfoIcon();
	this.TutorialInfoIcon.name = "TutorialInfoIcon";
	this.TutorialInfoIcon.setTransform(486.5,-90.55,1,1,0,0,0,71.5,71);

	this.timeline.addTween(cjs.Tween.get(this.TutorialInfoIcon).wait(1));

	// Layer_12
	this.TutorialPauseIcon = new lib.TutorialPauseIcon();
	this.TutorialPauseIcon.name = "TutorialPauseIcon";
	this.TutorialPauseIcon.setTransform(-2.8,-90.55,1,1,0,0,0,71,71);

	this.timeline.addTween(cjs.Tween.get(this.TutorialPauseIcon).wait(1));

	// Layer_11
	this.TutorialSaveIcon = new lib.TutorialSaveIcon();
	this.TutorialSaveIcon.name = "TutorialSaveIcon";
	this.TutorialSaveIcon.setTransform(-492.1,-90.55,1,1,0,0,0,71,71);

	this.timeline.addTween(cjs.Tween.get(this.TutorialSaveIcon).wait(1));

	// Container
	this.tutorialTitletext = new cjs.Text("Tutorial", "bold 40px 'Work Sans'", "#FFFFFF");
	this.tutorialTitletext.name = "tutorialTitletext";
	this.tutorialTitletext.textAlign = "center";
	this.tutorialTitletext.lineHeight = 49;
	this.tutorialTitletext.lineWidth = 399;
	this.tutorialTitletext.parent = this;
	this.tutorialTitletext.setTransform(486.5,-225.25);
ranj.TextOffsetFixer.fix(this.tutorialTitletext);

	this.pauseTitleText = new cjs.Text("Pause", "bold 40px 'Work Sans'", "#FFFFFF");
	this.pauseTitleText.name = "pauseTitleText";
	this.pauseTitleText.textAlign = "center";
	this.pauseTitleText.lineHeight = 49;
	this.pauseTitleText.lineWidth = 399;
	this.pauseTitleText.parent = this;
	this.pauseTitleText.setTransform(-2.8,-225.25);
ranj.TextOffsetFixer.fix(this.pauseTitleText);

	this.exitTitleText = new cjs.Text("Exit", "bold 40px 'Work Sans'", "#FFFFFF");
	this.exitTitleText.name = "exitTitleText";
	this.exitTitleText.textAlign = "center";
	this.exitTitleText.lineHeight = 49;
	this.exitTitleText.lineWidth = 399;
	this.exitTitleText.parent = this;
	this.exitTitleText.setTransform(-492.1,-225.25);
ranj.TextOffsetFixer.fix(this.exitTitleText);

	this.popupContinueButton = new lib.ContinueButtonTutorialEnd();
	this.popupContinueButton.name = "popupContinueButton";
	this.popupContinueButton.setTransform(713,487);

	this.popupTopic3Description = new cjs.Text("You can revisit this tutorial by clicking on the information-icon on the screen.", "20px 'Work Sans Medium'", "#FFFFFF");
	this.popupTopic3Description.name = "popupTopic3Description";
	this.popupTopic3Description.lineHeight = 25;
	this.popupTopic3Description.lineWidth = 399;
	this.popupTopic3Description.parent = this;
	this.popupTopic3Description.setTransform(287.05,46.8);
ranj.TextOffsetFixer.fix(this.popupTopic3Description);

	this.popupTopic2Description = new cjs.Text("You can pause the sim at any time by clicking on the pause-button on the screen.", "20px 'Work Sans Medium'", "#FFFFFF");
	this.popupTopic2Description.name = "popupTopic2Description";
	this.popupTopic2Description.lineHeight = 25;
	this.popupTopic2Description.lineWidth = 399;
	this.popupTopic2Description.parent = this;
	this.popupTopic2Description.setTransform(-202.25,46.8);
ranj.TextOffsetFixer.fix(this.popupTopic2Description);

	this.popupTopic1Description = new cjs.Text("You can exit the simulation at any time by closing the browser or window. Your progress will automatically be saved to the start of the arc e.g. chapter 1 arc 1. ", "20px 'Work Sans Medium'", "#FFFFFF");
	this.popupTopic1Description.name = "popupTopic1Description";
	this.popupTopic1Description.lineHeight = 25;
	this.popupTopic1Description.lineWidth = 399;
	this.popupTopic1Description.parent = this;
	this.popupTopic1Description.setTransform(-691.55,46.8);
ranj.TextOffsetFixer.fix(this.popupTopic1Description);

	this.popupTitle = new cjs.Text("Saving progress, pausing and the tutorial", "bold 50px 'Work Sans'", "#FFFFFF");
	this.popupTitle.name = "popupTitle";
	this.popupTitle.lineHeight = 61;
	this.popupTitle.lineWidth = 1369;
	this.popupTitle.parent = this;
	this.popupTitle.setTransform(-691.55,-332.4);
ranj.TextOffsetFixer.fix(this.popupTitle);

	this.instance = new lib.TutorialPopUpContainerShort();
	this.instance.setTransform(0,7.5,1,1,0,0,0,756,368.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.popupTitle},{t:this.popupTopic1Description},{t:this.popupTopic2Description},{t:this.popupTopic3Description},{t:this.popupContinueButton},{t:this.exitTitleText},{t:this.pauseTitleText},{t:this.tutorialTitletext}]}).wait(1));

	// Overlay
	this.instance_1 = new lib.TutorialOverlay();
	this.instance_1.setTransform(6.35,-5,1.0078,1,0,0,0,960,540);
	this.instance_1.alpha = 0.8008;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// HubBG
	this.HubScreenSkin = new lib.HubScreenSkinTutorial();
	this.HubScreenSkin.name = "HubScreenSkin";
	this.HubScreenSkin.setTransform(12.85,-2.9,1,1,0,0,0,0,-6.9);

	this.timeline.addTween(cjs.Tween.get(this.HubScreenSkin).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialScreenSkin3, new cjs.Rectangle(-961.1,-549.5,1936,1088.5), null);


(lib.TutorialScreenSkin2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Container
	this.overlayKeyDecisionsTitle = new cjs.Text("Key decisions", "bold 24px 'Work Sans'", "#FFFFFF");
	this.overlayKeyDecisionsTitle.name = "overlayKeyDecisionsTitle";
	this.overlayKeyDecisionsTitle.textAlign = "right";
	this.overlayKeyDecisionsTitle.lineHeight = 30;
	this.overlayKeyDecisionsTitle.lineWidth = 399;
	this.overlayKeyDecisionsTitle.parent = this;
	this.overlayKeyDecisionsTitle.setTransform(809.25,-200.85);
ranj.TextOffsetFixer.fix(this.overlayKeyDecisionsTitle);

	this.overlayColleaguesTitle = new cjs.Text("Colleagues", "bold 24px 'Work Sans'", "#FFFFFF");
	this.overlayColleaguesTitle.name = "overlayColleaguesTitle";
	this.overlayColleaguesTitle.textAlign = "center";
	this.overlayColleaguesTitle.lineHeight = 30;
	this.overlayColleaguesTitle.lineWidth = 473;
	this.overlayColleaguesTitle.parent = this;
	this.overlayColleaguesTitle.setTransform(563.65,46.15);
ranj.TextOffsetFixer.fix(this.overlayColleaguesTitle);

	this.overlayColleaguesDescription = new cjs.Text("Your colleagues, Nia, Sarah, Hassim, and Onneetse, keep you up-to-date on their activities and share new information when available.", "20px 'Work Sans Medium'", "#FFFFFF");
	this.overlayColleaguesDescription.name = "overlayColleaguesDescription";
	this.overlayColleaguesDescription.textAlign = "center";
	this.overlayColleaguesDescription.lineHeight = 25;
	this.overlayColleaguesDescription.lineWidth = 474;
	this.overlayColleaguesDescription.parent = this;
	this.overlayColleaguesDescription.setTransform(563.85,78.3);
ranj.TextOffsetFixer.fix(this.overlayColleaguesDescription);

	this.overlayTeaCornerTitle = new cjs.Text("Tea corner", "bold 24px 'Work Sans'", "#FFFFFF");
	this.overlayTeaCornerTitle.name = "overlayTeaCornerTitle";
	this.overlayTeaCornerTitle.textAlign = "center";
	this.overlayTeaCornerTitle.lineHeight = 30;
	this.overlayTeaCornerTitle.lineWidth = 216;
	this.overlayTeaCornerTitle.parent = this;
	this.overlayTeaCornerTitle.setTransform(99.25,46.15);
ranj.TextOffsetFixer.fix(this.overlayTeaCornerTitle);

	this.overlayTeaCornerDescription = new cjs.Text("At the tea corner, you can pick-up informal information from colleagues.", "20px 'Work Sans Medium'", "#FFFFFF");
	this.overlayTeaCornerDescription.name = "overlayTeaCornerDescription";
	this.overlayTeaCornerDescription.textAlign = "center";
	this.overlayTeaCornerDescription.lineHeight = 25;
	this.overlayTeaCornerDescription.lineWidth = 217;
	this.overlayTeaCornerDescription.parent = this;
	this.overlayTeaCornerDescription.setTransform(99.4,78.3);
ranj.TextOffsetFixer.fix(this.overlayTeaCornerDescription);

	this.overlayDashboardTitle = new cjs.Text("Data Dashboard", "bold 24px 'Work Sans'", "#FFFFFF");
	this.overlayDashboardTitle.name = "overlayDashboardTitle";
	this.overlayDashboardTitle.textAlign = "center";
	this.overlayDashboardTitle.lineHeight = 30;
	this.overlayDashboardTitle.lineWidth = 239;
	this.overlayDashboardTitle.parent = this;
	this.overlayDashboardTitle.setTransform(-288.25,46.15);
ranj.TextOffsetFixer.fix(this.overlayDashboardTitle);

	this.overlayDashboardDescription = new cjs.Text("The data dashboard provides you with data on the Enni Virus on national level.", "20px 'Work Sans Medium'", "#FFFFFF");
	this.overlayDashboardDescription.name = "overlayDashboardDescription";
	this.overlayDashboardDescription.textAlign = "center";
	this.overlayDashboardDescription.lineHeight = 25;
	this.overlayDashboardDescription.lineWidth = 239;
	this.overlayDashboardDescription.parent = this;
	this.overlayDashboardDescription.setTransform(-288.15,78.3);
ranj.TextOffsetFixer.fix(this.overlayDashboardDescription);

	this.overlayLaptopTitle = new cjs.Text("Laptop", "bold 24px 'Work Sans'", "#FFFFFF");
	this.overlayLaptopTitle.name = "overlayLaptopTitle";
	this.overlayLaptopTitle.textAlign = "center";
	this.overlayLaptopTitle.lineHeight = 30;
	this.overlayLaptopTitle.lineWidth = 213;
	this.overlayLaptopTitle.parent = this;
	this.overlayLaptopTitle.setTransform(-559.75,46.15);
ranj.TextOffsetFixer.fix(this.overlayLaptopTitle);

	this.overlayLaptopDescription = new cjs.Text("Your laptop provides you access to your e-mail and important documents.", "20px 'Work Sans Medium'", "#FFFFFF");
	this.overlayLaptopDescription.name = "overlayLaptopDescription";
	this.overlayLaptopDescription.textAlign = "center";
	this.overlayLaptopDescription.lineHeight = 25;
	this.overlayLaptopDescription.lineWidth = 213;
	this.overlayLaptopDescription.parent = this;
	this.overlayLaptopDescription.setTransform(-559.75,78.3);
ranj.TextOffsetFixer.fix(this.overlayLaptopDescription);

	this.overlaySmartphoneTitle = new cjs.Text("Phone", "bold 24px 'Work Sans'", "#FFFFFF");
	this.overlaySmartphoneTitle.name = "overlaySmartphoneTitle";
	this.overlaySmartphoneTitle.textAlign = "center";
	this.overlaySmartphoneTitle.lineHeight = 30;
	this.overlaySmartphoneTitle.lineWidth = 193;
	this.overlaySmartphoneTitle.parent = this;
	this.overlaySmartphoneTitle.setTransform(-818.75,46.15);
ranj.TextOffsetFixer.fix(this.overlaySmartphoneTitle);

	this.overlaySmartphoneDescription = new cjs.Text("On your phone you receive message from colleagues.", "20px 'Work Sans Medium'", "#FFFFFF");
	this.overlaySmartphoneDescription.name = "overlaySmartphoneDescription";
	this.overlaySmartphoneDescription.textAlign = "center";
	this.overlaySmartphoneDescription.lineHeight = 25;
	this.overlaySmartphoneDescription.lineWidth = 193;
	this.overlaySmartphoneDescription.parent = this;
	this.overlaySmartphoneDescription.setTransform(-818.85,78.3);
ranj.TextOffsetFixer.fix(this.overlaySmartphoneDescription);

	this.OverlayContinueButton = new lib.FeedbackNextButtonBlackScreen();
	this.OverlayContinueButton.name = "OverlayContinueButton";
	this.OverlayContinueButton.setTransform(757,487);

	this.overlayKeyDecisionsDescription = new cjs.Text("You can access a key decision when it is unlocked. An unlocked key decision is recognizable by the key-icon.", "20px 'Work Sans Medium'", "#FFFFFF");
	this.overlayKeyDecisionsDescription.name = "overlayKeyDecisionsDescription";
	this.overlayKeyDecisionsDescription.textAlign = "right";
	this.overlayKeyDecisionsDescription.lineHeight = 25;
	this.overlayKeyDecisionsDescription.lineWidth = 399;
	this.overlayKeyDecisionsDescription.parent = this;
	this.overlayKeyDecisionsDescription.setTransform(809.05,-163.45);
ranj.TextOffsetFixer.fix(this.overlayKeyDecisionsDescription);

	this.overlayMapDescription = new cjs.Text("You can visit people and locations within the region to gather information.", "20px 'Work Sans'", "#FFFFFF");
	this.overlayMapDescription.name = "overlayMapDescription";
	this.overlayMapDescription.textAlign = "center";
	this.overlayMapDescription.lineHeight = 25;
	this.overlayMapDescription.lineWidth = 439;
	this.overlayMapDescription.parent = this;
	this.overlayMapDescription.setTransform(66.7,-329.5);
ranj.TextOffsetFixer.fix(this.overlayMapDescription);

	this.overlayMapTitle = new cjs.Text("Map", "bold 24px 'Work Sans'", "#FFFFFF");
	this.overlayMapTitle.name = "overlayMapTitle";
	this.overlayMapTitle.textAlign = "center";
	this.overlayMapTitle.lineHeight = 30;
	this.overlayMapTitle.lineWidth = 439;
	this.overlayMapTitle.parent = this;
	this.overlayMapTitle.setTransform(66.75,-361.65);
ranj.TextOffsetFixer.fix(this.overlayMapTitle);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.overlayMapTitle},{t:this.overlayMapDescription},{t:this.overlayKeyDecisionsDescription},{t:this.OverlayContinueButton},{t:this.overlaySmartphoneDescription},{t:this.overlaySmartphoneTitle},{t:this.overlayLaptopDescription},{t:this.overlayLaptopTitle},{t:this.overlayDashboardDescription},{t:this.overlayDashboardTitle},{t:this.overlayTeaCornerDescription},{t:this.overlayTeaCornerTitle},{t:this.overlayColleaguesDescription},{t:this.overlayColleaguesTitle},{t:this.overlayKeyDecisionsTitle}]}).wait(1));

	// Overlay
	this.instance = new lib.TutorialScreens_TutorialOverlay();
	this.instance.setTransform(-962,-549);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.instance_1 = new lib.KeyDecButtonLocked_1();
	this.instance_1.setTransform(882.9,-242.3,1,1,0,0,0,29.5,28.5);

	this.instance_2 = new lib.KeyDecButtonUp_1();
	this.instance_2.setTransform(885.1,-148.35,1,1,0,0,0,59.5,53.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1}]}).wait(1));

	// HubBG
	this.HubScreenSkin = new lib.HubScreenSkinTutorial();
	this.HubScreenSkin.name = "HubScreenSkin";
	this.HubScreenSkin.setTransform(12.5,-2.9,1,1,0,0,0,0,-6.9);

	this.timeline.addTween(cjs.Tween.get(this.HubScreenSkin).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialScreenSkin2, new cjs.Rectangle(-962,-549.5,1937,1089.5), null);


(lib.TutorialScreenSkin1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_14 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("A91VQQiWAAAAiWMAAAglzQAAiWCWAAMA7rAAAQCWAAAACWMAAAAlzQAACWiWAAg");
	mask.setTransform(488,-31.2);

	// Layer_15
	this.popupTopic3KDOverviewAnswer2 = new cjs.Text("Answer text", "8px 'Work Sans'", "#2C3C3C");
	this.popupTopic3KDOverviewAnswer2.name = "popupTopic3KDOverviewAnswer2";
	this.popupTopic3KDOverviewAnswer2.lineHeight = 11;
	this.popupTopic3KDOverviewAnswer2.lineWidth = 210;
	this.popupTopic3KDOverviewAnswer2.parent = this;
	this.popupTopic3KDOverviewAnswer2.setTransform(408.3,66.25);
ranj.TextOffsetFixer.fix(this.popupTopic3KDOverviewAnswer2);

	this.popupTopic3KDOverviewAnswer1 = new cjs.Text("Answer text", "8px 'Work Sans'", "#2C3C3C");
	this.popupTopic3KDOverviewAnswer1.name = "popupTopic3KDOverviewAnswer1";
	this.popupTopic3KDOverviewAnswer1.lineHeight = 11;
	this.popupTopic3KDOverviewAnswer1.lineWidth = 210;
	this.popupTopic3KDOverviewAnswer1.parent = this;
	this.popupTopic3KDOverviewAnswer1.setTransform(408.3,10.15);
ranj.TextOffsetFixer.fix(this.popupTopic3KDOverviewAnswer1);

	this.popupTopic3KDOverviewOptimalAnswers = new cjs.Text("Optimal answers", "bold 12px 'Work Sans'", "#2C3C3C");
	this.popupTopic3KDOverviewOptimalAnswers.name = "popupTopic3KDOverviewOptimalAnswers";
	this.popupTopic3KDOverviewOptimalAnswers.lineHeight = 16;
	this.popupTopic3KDOverviewOptimalAnswers.lineWidth = 348;
	this.popupTopic3KDOverviewOptimalAnswers.parent = this;
	this.popupTopic3KDOverviewOptimalAnswers.setTransform(376.6,-32.15);
ranj.TextOffsetFixer.fix(this.popupTopic3KDOverviewOptimalAnswers);

	this.popupTopic3KDOverviewDescription = new cjs.Text("Body text", "8px 'Work Sans'", "#2C3C3C");
	this.popupTopic3KDOverviewDescription.name = "popupTopic3KDOverviewDescription";
	this.popupTopic3KDOverviewDescription.lineHeight = 11;
	this.popupTopic3KDOverviewDescription.lineWidth = 348;
	this.popupTopic3KDOverviewDescription.parent = this;
	this.popupTopic3KDOverviewDescription.setTransform(376.6,-72.4);
ranj.TextOffsetFixer.fix(this.popupTopic3KDOverviewDescription);

	this.popupTopic3KDOverviewDisclaimer = new cjs.Text("Disclaimer", "italic 8px 'Work Sans Light'", "#2C3C3C");
	this.popupTopic3KDOverviewDisclaimer.name = "popupTopic3KDOverviewDisclaimer";
	this.popupTopic3KDOverviewDisclaimer.lineHeight = 14;
	this.popupTopic3KDOverviewDisclaimer.lineWidth = 348;
	this.popupTopic3KDOverviewDisclaimer.parent = this;
	this.popupTopic3KDOverviewDisclaimer.setTransform(376.6,-89.45);
ranj.TextOffsetFixer.fix(this.popupTopic3KDOverviewDisclaimer);

	this.popupTopic3KDOverviewTitle = new cjs.Text("Key Decision feedback", "bold 20px 'Work Sans'", "#2C3C3C");
	this.popupTopic3KDOverviewTitle.name = "popupTopic3KDOverviewTitle";
	this.popupTopic3KDOverviewTitle.lineHeight = 25;
	this.popupTopic3KDOverviewTitle.lineWidth = 348;
	this.popupTopic3KDOverviewTitle.parent = this;
	this.popupTopic3KDOverviewTitle.setTransform(413.6,-126.65);
ranj.TextOffsetFixer.fix(this.popupTopic3KDOverviewTitle);

	this.instance = new lib.Asset15x();
	this.instance.setTransform(265,-180);

	var maskedShapeInstanceList = [this.popupTopic3KDOverviewAnswer2,this.popupTopic3KDOverviewAnswer1,this.popupTopic3KDOverviewOptimalAnswers,this.popupTopic3KDOverviewDescription,this.popupTopic3KDOverviewDisclaimer,this.popupTopic3KDOverviewTitle,this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.popupTopic3KDOverviewTitle},{t:this.popupTopic3KDOverviewDisclaimer},{t:this.popupTopic3KDOverviewDescription},{t:this.popupTopic3KDOverviewOptimalAnswers},{t:this.popupTopic3KDOverviewAnswer1},{t:this.popupTopic3KDOverviewAnswer2}]}).wait(1));

	// Layer_13 (mask)
	var mask_1 = new cjs.Shape();
	mask_1._off = true;
	mask_1.graphics.p("A91VQQiWAAAAiWMAAAglzQAAiWCWAAMA7rAAAQCWAAAACWMAAAAlzQAACWiWAAg");
	mask_1.setTransform(0.55,-31.2);

	// Layer_12
	this.popupTopic2KDBack = new cjs.Text("Back", "20px 'Work Sans'", "#2C3C3C");
	this.popupTopic2KDBack.name = "popupTopic2KDBack";
	this.popupTopic2KDBack.lineHeight = 25;
	this.popupTopic2KDBack.lineWidth = 78;
	this.popupTopic2KDBack.parent = this;
	this.popupTopic2KDBack.setTransform(-143.6,-123.35);
ranj.TextOffsetFixer.fix(this.popupTopic2KDBack);

	this.popupTopic2KDDescription = new cjs.Text("Body text body text body text body text body textBody text body text body text body text body textBody text body text body text body text body text", "14px 'Work Sans'", "#2C3C3C");
	this.popupTopic2KDDescription.name = "popupTopic2KDDescription";
	this.popupTopic2KDDescription.lineHeight = 18;
	this.popupTopic2KDDescription.lineWidth = 433;
	this.popupTopic2KDDescription.parent = this;
	this.popupTopic2KDDescription.setTransform(-117.1,-14.1);
ranj.TextOffsetFixer.fix(this.popupTopic2KDDescription);

	this.instance_1 = new lib.BackUp();
	this.instance_1.setTransform(-205,-135,0.7861,0.7861);

	this.popupTopic2KDTitle = new cjs.Text("Priority Readiness Actions", "bold 14px 'Work Sans'", "#2C3C3C");
	this.popupTopic2KDTitle.name = "popupTopic2KDTitle";
	this.popupTopic2KDTitle.lineHeight = 18;
	this.popupTopic2KDTitle.lineWidth = 178;
	this.popupTopic2KDTitle.parent = this;
	this.popupTopic2KDTitle.setTransform(-110.6,-66.25);
ranj.TextOffsetFixer.fix(this.popupTopic2KDTitle);

	this.instance_2 = new lib.mockupKD5x();
	this.instance_2.setTransform(-205,-169,0.1449,0.1449);

	var maskedShapeInstanceList = [this.popupTopic2KDBack,this.popupTopic2KDDescription,this.instance_1,this.popupTopic2KDTitle,this.instance_2];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask_1;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.popupTopic2KDTitle},{t:this.instance_1},{t:this.popupTopic2KDDescription},{t:this.popupTopic2KDBack}]}).wait(1));

	// Layer_10 (mask)
	var mask_2 = new cjs.Shape();
	mask_2._off = true;
	mask_2.graphics.p("Egz7AVQQiWAAAAiWMAAAglzQAAiWCWAAMA7rAAAQCWAAAACWMAAAAlzQAACWiWAAg");
	mask_2.setTransform(-347.375,-31.2);

	// Layer_11
	this.EmailBG = new lib.EmailBG();
	this.EmailBG.name = "EmailBG";
	this.EmailBG.setTransform(-437.8,7.6,1,1,0,0,0,394.2,269.8);

	var maskedShapeInstanceList = [this.EmailBG];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask_2;
	}

	this.timeline.addTween(cjs.Tween.get(this.EmailBG).wait(1));

	// Container
	this.popupContinueButton = new lib.FeedbackNextButtonBlackScreen();
	this.popupContinueButton.name = "popupContinueButton";
	this.popupContinueButton.setTransform(757,487);

	this.popupTopic3Description = new cjs.Text("You discover and unlock key decisions throughout a chapter by checking your email and phone, talking to colleagues and reading files.", "20px 'Work Sans Medium'", "#FFFFFF");
	this.popupTopic3Description.name = "popupTopic3Description";
	this.popupTopic3Description.lineHeight = 25;
	this.popupTopic3Description.lineWidth = 399;
	this.popupTopic3Description.parent = this;
	this.popupTopic3Description.setTransform(287.05,134.1);
ranj.TextOffsetFixer.fix(this.popupTopic3Description);

	this.popupTopic2Description = new cjs.Text("You discover and unlock key decisions throughout a chapter by checking your email and phone, talking to colleagues and reading files.", "20px 'Work Sans Medium'", "#FFFFFF");
	this.popupTopic2Description.name = "popupTopic2Description";
	this.popupTopic2Description.lineHeight = 25;
	this.popupTopic2Description.lineWidth = 399;
	this.popupTopic2Description.parent = this;
	this.popupTopic2Description.setTransform(-203.8,134.1);
ranj.TextOffsetFixer.fix(this.popupTopic2Description);

	this.popupTopic1Description = new cjs.Text("You discover and unlock key decisions throughout a chapter by checking your email and phone, talking to colleagues and reading files.", "20px 'Work Sans Medium'", "#FFFFFF");
	this.popupTopic1Description.name = "popupTopic1Description";
	this.popupTopic1Description.lineHeight = 25;
	this.popupTopic1Description.lineWidth = 399;
	this.popupTopic1Description.parent = this;
	this.popupTopic1Description.setTransform(-693.1,134.1);
ranj.TextOffsetFixer.fix(this.popupTopic1Description);

	this.popupDescription = new cjs.Text("This simulation includes three chapters, each with several key decisions. You progress in the story, and to the next chapter, by making key decisions. In key decisions you determine how you handle the situation at hand.", "bold 24px 'Work Sans'", "#FFFFFF");
	this.popupDescription.name = "popupDescription";
	this.popupDescription.lineHeight = 30;
	this.popupDescription.lineWidth = 929;
	this.popupDescription.parent = this;
	this.popupDescription.setTransform(-693.1,-304.7);
ranj.TextOffsetFixer.fix(this.popupDescription);

	this.popupTitle = new cjs.Text("Making key decisions", "bold 50px 'Work Sans'", "#FFFFFF");
	this.popupTitle.name = "popupTitle";
	this.popupTitle.lineHeight = 61;
	this.popupTitle.lineWidth = 1213;
	this.popupTitle.parent = this;
	this.popupTitle.setTransform(-693.1,-382.7);
ranj.TextOffsetFixer.fix(this.popupTitle);

	this.instance_3 = new lib.TutorialPopUpContainer();
	this.instance_3.setTransform(0,-42.8,1,1,0,0,0,756,368.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3},{t:this.popupTitle},{t:this.popupDescription},{t:this.popupTopic1Description},{t:this.popupTopic2Description},{t:this.popupTopic3Description},{t:this.popupContinueButton}]}).wait(1));

	// Overlay
	this.instance_4 = new lib.TutorialOverlay();
	this.instance_4.setTransform(4.35,-2.55,1.0083,1,0,0,0,959.8,540);
	this.instance_4.alpha = 0.8008;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1));

	// HubBG
	this.HubScreenSkin = new lib.HubScreenSkinTutorial();
	this.HubScreenSkin.name = "HubScreenSkin";
	this.HubScreenSkin.setTransform(13.5,-2.9,1,1,0,0,0,0,-6.9);

	this.timeline.addTween(cjs.Tween.get(this.HubScreenSkin).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialScreenSkin1, new cjs.Rectangle(-963.4,-549.5,1937.4,1090.4), null);


(lib.HubScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// ButtonsTopLeft
	this.exitPauseInfoButtonScreenSkin = new lib.ExitPauseInfoButtonScreenSkin();
	this.exitPauseInfoButtonScreenSkin.name = "exitPauseInfoButtonScreenSkin";
	this.exitPauseInfoButtonScreenSkin.setTransform(-830.1,-493,1,1,0,0,0,-826.5,-487.7);

	this.timeline.addTween(cjs.Tween.get(this.exitPauseInfoButtonScreenSkin).wait(1));

	// internalStakeholders
	this.internalStakeholders = new lib.InternalStakeholders();
	this.internalStakeholders.name = "internalStakeholders";
	this.internalStakeholders.setTransform(548.6,546.7);

	this.timeline.addTween(cjs.Tween.get(this.internalStakeholders).wait(1));

	// TimeIndicator
	this.TimingBG = new lib.TimingBG_1();
	this.TimingBG.name = "TimingBG";
	this.TimingBG.setTransform(641.75,-421.75,1,1,0,0,0,215.5,75);

	this.timeline.addTween(cjs.Tween.get(this.TimingBG).wait(1));

	// timerKeyDecision
	this.timerKeyDecision = new lib.timerKeyDecision();
	this.timerKeyDecision.name = "timerKeyDecision";
	this.timerKeyDecision.setTransform(596.15,-347.45,1,1,0,0,0,137.5,22.5);

	this.timeline.addTween(cjs.Tween.get(this.timerKeyDecision).wait(1));

	// teaCorner
	this.dashboardButton = new lib.DataDashboardIcon();
	this.dashboardButton.name = "dashboardButton";
	this.dashboardButton.setTransform(-290.65,420);

	this.teaCorner = new lib.HUBTeaCornerButton();
	this.teaCorner.name = "teaCorner";
	this.teaCorner.setTransform(9.5,485.5,1,1,0,0,0,-95.5,-7.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.teaCorner},{t:this.dashboardButton}]}).wait(1));

	// keyDecisionContainer
	this.gameSavedNoticePanel = new lib.GameSavedNoticePanel();
	this.gameSavedNoticePanel.name = "gameSavedNoticePanel";
	this.gameSavedNoticePanel.setTransform(0,-489.45,1,1,0,0,0,12.8,3.2);

	this.hubTimeline = new lib.HubTimeline();
	this.hubTimeline.name = "hubTimeline";
	this.hubTimeline.setTransform(851.65,-111.5,1,1,0,0,0,102.1,288.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.hubTimeline},{t:this.gameSavedNoticePanel}]}).wait(1));

	// smartphoneButton
	this.smartphoneButton = new lib.HudSmartphoneButton();
	this.smartphoneButton.name = "smartphoneButton";
	this.smartphoneButton.setTransform(-803.2,425);

	this.timeline.addTween(cjs.Tween.get(this.smartphoneButton).wait(1));

	// laptopButton
	this.laptopButton = new lib.HudLaptopButton();
	this.laptopButton.name = "laptopButton";
	this.laptopButton.setTransform(-562.95,420);

	this.timeline.addTween(cjs.Tween.get(this.laptopButton).wait(1));

	// mapContainer
	this.mapContainer = new lib.MapContainer();
	this.mapContainer.name = "mapContainer";
	this.mapContainer.setTransform(0,7);

	this.timeline.addTween(cjs.Tween.get(this.mapContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HubScreenSkin, new cjs.Rectangle(-961,-552.5,1921.5,1097.5), null);


(lib.DialogAnswerButtonPanelSkincopy = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// backButton
	this.backButton = new lib.ReturnButton();
	this.backButton.name = "backButton";
	this.backButton.setTransform(-449.65,-24.5,1,1,0,0,0,44.5,23.5);

	this.timeline.addTween(cjs.Tween.get(this.backButton).wait(1));

	// answerTimer
	this.answerTimer = new lib.AnswerTimer();
	this.answerTimer.name = "answerTimer";
	this.answerTimer.setTransform(7.85,-24.55,1,1,0,0,0,502,23.6);

	this.timeline.addTween(cjs.Tween.get(this.answerTimer).wait(1));

	// dialogOptionButton
	this.dialogOptionButton4 = new lib.DialogButtoncopy();
	this.dialogOptionButton4.name = "dialogOptionButton4";
	this.dialogOptionButton4.setTransform(-16,447.25);

	this.timeline.addTween(cjs.Tween.get(this.dialogOptionButton4).wait(1));

	// dialogOptionButton3
	this.dialogOptionButton3 = new lib.DialogButtoncopy();
	this.dialogOptionButton3.name = "dialogOptionButton3";
	this.dialogOptionButton3.setTransform(-16,319.3);

	this.timeline.addTween(cjs.Tween.get(this.dialogOptionButton3).wait(1));

	// dialogOptionButton2
	this.dialogOptionButton2 = new lib.DialogButtoncopy();
	this.dialogOptionButton2.name = "dialogOptionButton2";
	this.dialogOptionButton2.setTransform(-16,191.25);

	this.timeline.addTween(cjs.Tween.get(this.dialogOptionButton2).wait(1));

	// dialogOptionButton1
	this.dialogOptionButton1 = new lib.DialogButtoncopy();
	this.dialogOptionButton1.name = "dialogOptionButton1";
	this.dialogOptionButton1.setTransform(-16,62.95);

	this.timeline.addTween(cjs.Tween.get(this.dialogOptionButton1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DialogAnswerButtonPanelSkincopy, new cjs.Rectangle(-494.1,-73.2,1004,679.7), null);


(lib.DialogPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Topic
	this.topicSelectionButtonPanel = new lib.TopicAnswerButtonPanelSkin();
	this.topicSelectionButtonPanel.name = "topicSelectionButtonPanel";
	this.topicSelectionButtonPanel.setTransform(-6.8,-83,1,1,0,0,0,496.2,99.5);

	this.timeline.addTween(cjs.Tween.get(this.topicSelectionButtonPanel).wait(1));

	// _Dialog
	this.dialogAnswerButtonPanel = new lib.DialogAnswerButtonPanelSkincopy();
	this.dialogAnswerButtonPanel.name = "dialogAnswerButtonPanel";
	this.dialogAnswerButtonPanel.setTransform(26.35,-198.7);

	this.timeline.addTween(cjs.Tween.get(this.dialogAnswerButtonPanel).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DialogPanel, new cjs.Rectangle(-503,-271.9,1039.2,679.7), null);


(lib.Map_Chapter3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// node_1_CH1
	this.node_1 = new lib.PlaceholderMapNode();
	this.node_1.name = "node_1";
	this.node_1.setTransform(-324.65,255.45);

	this.timeline.addTween(cjs.Tween.get(this.node_1).wait(1));

	// node_3_CH1
	this.node_3 = new lib.PlaceholderMapNode();
	this.node_3.name = "node_3";
	this.node_3.setTransform(-390.7,146.45);

	this.timeline.addTween(cjs.Tween.get(this.node_3).wait(1));

	// node_2_CH1
	this.node_2 = new lib.PlaceholderMapNode();
	this.node_2.name = "node_2";
	this.node_2.setTransform(100.05,-64.05);

	this.timeline.addTween(cjs.Tween.get(this.node_2).wait(1));

	// Map_Inset_Chapter1
	this.mapInsetChapter1 = new lib.mapInsetChapter1();
	this.mapInsetChapter1.name = "mapInsetChapter1";
	this.mapInsetChapter1.setTransform(-722.15,-241.5,1,1,0,0,0,217.5,182.5);

	this.timeline.addTween(cjs.Tween.get(this.mapInsetChapter1).wait(1));

	// Map_Chapter1_Background
	this.bg = new lib.Map_Chapter3_Background();
	this.bg.name = "bg";
	this.bg.setTransform(1.25,-6.25);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Map_Chapter3, new cjs.Rectangle(-959.7,-547.2,1920,1080), null);


(lib.Map_Chapter2w6 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// node_1_CH1
	this.node_1 = new lib.PlaceholderMapNode();
	this.node_1.name = "node_1";
	this.node_1.setTransform(100.7,-63.85);

	this.timeline.addTween(cjs.Tween.get(this.node_1).wait(1));

	// Map_Inset_Chapter1
	this.mapInsetChapter1 = new lib.mapInsetChapter1();
	this.mapInsetChapter1.name = "mapInsetChapter1";
	this.mapInsetChapter1.setTransform(-722.15,-241.5,1,1,0,0,0,217.5,182.5);

	this.timeline.addTween(cjs.Tween.get(this.mapInsetChapter1).wait(1));

	// Map_Chapter1_Background
	this.bg = new lib.Map_Chapter3_Background();
	this.bg.name = "bg";
	this.bg.setTransform(1.25,-6.25);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Map_Chapter2w6, new cjs.Rectangle(-959.7,-547.2,1920,1080), null);


(lib.Map_Chapter2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// node_4_CH1
	this.node_4 = new lib.PlaceholderMapNode();
	this.node_4.name = "node_4";
	this.node_4.setTransform(-39.5,186);

	this.timeline.addTween(cjs.Tween.get(this.node_4).wait(1));

	// node_5_CH2
	this.node_5 = new lib.PlaceholderMapNode();
	this.node_5.name = "node_5";
	this.node_5.setTransform(286.2,116.75);

	this.timeline.addTween(cjs.Tween.get(this.node_5).wait(1));

	// node_2_CH1
	this.node_2 = new lib.PlaceholderMapNode3();
	this.node_2.name = "node_2";
	this.node_2.setTransform(86,-13.75);

	this.timeline.addTween(cjs.Tween.get(this.node_2).wait(1));

	// node_3_CH1
	this.node_3 = new lib.PlaceholderMapNode2();
	this.node_3.name = "node_3";
	this.node_3.setTransform(134.55,-65.9);

	this.timeline.addTween(cjs.Tween.get(this.node_3).wait(1));

	// Map_Inset_Chapter1
	this.mapInsetChapter1 = new lib.mapInsetChapter2();
	this.mapInsetChapter1.name = "mapInsetChapter1";
	this.mapInsetChapter1.setTransform(-722.15,-241.5,1,1,0,0,0,217.5,182.5);

	this.timeline.addTween(cjs.Tween.get(this.mapInsetChapter1).wait(1));

	// Map_Chapter1_Background
	this.bg = new lib.Map_Chapter2_Background();
	this.bg.name = "bg";
	this.bg.setTransform(1.25,-6.25);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Map_Chapter2, new cjs.Rectangle(-959.7,-547.2,1920,1080), null);


(lib.Map_Chapter1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// node_3_CH1
	this.node_3 = new lib.PlaceholderMapNode();
	this.node_3.name = "node_3";
	this.node_3.setTransform(100.2,-63.55);

	this.timeline.addTween(cjs.Tween.get(this.node_3).wait(1));

	// node_2_CH1
	this.node_2 = new lib.PlaceholderMapNode();
	this.node_2.name = "node_2";
	this.node_2.setTransform(-323.8,253.4);

	this.timeline.addTween(cjs.Tween.get(this.node_2).wait(1));

	// node_1_CH1
	this.node_1 = new lib.PlaceholderMapNode();
	this.node_1.name = "node_1";
	this.node_1.setTransform(-394.65,146.55);

	this.timeline.addTween(cjs.Tween.get(this.node_1).wait(1));

	// Map_Inset_Chapter1
	this.mapInsetChapter1 = new lib.mapInsetChapter1();
	this.mapInsetChapter1.name = "mapInsetChapter1";
	this.mapInsetChapter1.setTransform(-722.15,-241.5,1,1,0,0,0,217.5,182.5);

	this.timeline.addTween(cjs.Tween.get(this.mapInsetChapter1).wait(1));

	// Map_Chapter1_Background
	this.bg = new lib.Map_Chapter1_Background();
	this.bg.name = "bg";
	this.bg.setTransform(1.25,-6.25);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Map_Chapter1, new cjs.Rectangle(-959.7,-547.2,1920,1080), null);


(lib.DialogScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// npcTextPanelFlipped
	this.npcPanelFlipped = new lib.NPCPanel();
	this.npcPanelFlipped.name = "npcPanelFlipped";
	this.npcPanelFlipped.setTransform(474.1,-242.05);

	this.timeline.addTween(cjs.Tween.get(this.npcPanelFlipped).wait(1));

	// npcTextPanel
	this.npcPanel = new lib.NPCPanel();
	this.npcPanel.name = "npcPanel";
	this.npcPanel.setTransform(-569.2,-286.6);

	this.timeline.addTween(cjs.Tween.get(this.npcPanel).wait(1));

	// Layer_6 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("EhbxBUYMAAAiovMC3jAAAMAAACovg");
	mask.setTransform(372.65,0);

	// ImagePlaceholder
	this.ImagePlaceholder = new lib.CharacterPlaceholder();
	this.ImagePlaceholder.name = "ImagePlaceholder";
	this.ImagePlaceholder.setTransform(-199.8,-540);

	var maskedShapeInstanceList = [this.ImagePlaceholder];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.ImagePlaceholder).wait(1));

	// DialogPanel
	this.dialogPanel = new lib.DialogPanel();
	this.dialogPanel.name = "dialogPanel";
	this.dialogPanel.setTransform(-538.7,184.1);

	this.timeline.addTween(cjs.Tween.get(this.dialogPanel).wait(1));

	// Timer
	this.dialogTimer = new lib.Timer();
	this.dialogTimer.name = "dialogTimer";
	this.dialogTimer.setTransform(822.2,-470.1,1,1,0,0,0,79,24);

	this.timeline.addTween(cjs.Tween.get(this.dialogTimer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DialogScreenSkin, new cjs.Rectangle(-1041.7,-540.5,2002.8000000000002,1132.4), null);


// stage content:
(lib.MainAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);
// library properties:
lib.properties = {
	id: 'C1DF5F666281484DA9D1F4AEE495446B',
	width: 1920,
	height: 1080,
	fps: 60,
	color: "#FF00FF",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/AnswerContainerDown.png", id:"MainAssets_AnswerContainerDown", bundle:"MainAssets"},
		{src:"assets/skins/images/AnswerContainerOver.png", id:"MainAssets_AnswerContainerOver", bundle:"MainAssets"},
		{src:"assets/skins/images/AnswerSlot.png", id:"MainAssets_AnswerSlot", bundle:"MainAssets"},
		{src:"assets/skins/images/Asset15x.png", id:"MainAssets_Asset15x", bundle:"MainAssets"},
		{src:"assets/skins/images/BackDisabled.png", id:"MainAssets_BackDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/BackOver.png", id:"MainAssets_BackOver", bundle:"MainAssets"},
		{src:"assets/skins/images/BackUp.png", id:"MainAssets_BackUp", bundle:"MainAssets"},
		{src:"assets/skins/images/BadDown.png", id:"MainAssets_BadDown", bundle:"MainAssets"},
		{src:"assets/skins/images/BadOver.png", id:"MainAssets_BadOver", bundle:"MainAssets"},
		{src:"assets/skins/images/BadUp.png", id:"MainAssets_BadUp", bundle:"MainAssets"},
		{src:"assets/skins/images/BottomBar.png", id:"MainAssets_BottomBar", bundle:"MainAssets"},
		{src:"assets/skins/images/BriefingBackground.jpg", id:"MainAssets_BriefingBackground", bundle:"MainAssets"},
		{src:"assets/skins/images/BriefingBlackBar.png", id:"MainAssets_BriefingBlackBar", bundle:"MainAssets"},
		{src:"assets/skins/images/BriefingBodybackground.png", id:"MainAssets_BriefingBodybackground", bundle:"MainAssets"},
		{src:"assets/skins/images/BriefingTimeLine.png", id:"MainAssets_BriefingTimeLine", bundle:"MainAssets"},
		{src:"assets/skins/images/BriefingTimelineBackground.png", id:"MainAssets_BriefingTimelineBackground", bundle:"MainAssets"},
		{src:"assets/skins/images/BriefingTimelineBars.png", id:"MainAssets_BriefingTimelineBars", bundle:"MainAssets"},
		{src:"assets/skins/images/ButtonOverWhite.png", id:"MainAssets_ButtonOverWhite", bundle:"MainAssets"},
		{src:"assets/skins/images/ButtonOverWhitepngcopy.png", id:"MainAssets_ButtonOverWhitepngcopy", bundle:"MainAssets"},
		{src:"assets/skins/images/CloseButtonIcon.png", id:"MainAssets_CloseButtonIcon", bundle:"MainAssets"},
		{src:"assets/skins/images/CompletedKDConfirmationScreen.png", id:"MainAssets_CompletedKDConfirmationScreen", bundle:"MainAssets"},
		{src:"assets/skins/images/ContinueButtonDisabled.png", id:"MainAssets_ContinueButtonDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/ContinueButtonHi.png", id:"MainAssets_ContinueButtonHi", bundle:"MainAssets"},
		{src:"assets/skins/images/ContinueButtonUp.png", id:"MainAssets_ContinueButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/ContinueTutorialDisabled.png", id:"MainAssets_ContinueTutorialDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/ContinueTutorialOver.png", id:"MainAssets_ContinueTutorialOver", bundle:"MainAssets"},
		{src:"assets/skins/images/ContinueTutorialUp.png", id:"MainAssets_ContinueTutorialUp", bundle:"MainAssets"},
		{src:"assets/skins/images/DashboardBGpngcopy.png", id:"MainAssets_DashboardBGpngcopy", bundle:"MainAssets"},
		{src:"assets/skins/images/DashboardButton.png", id:"MainAssets_DashboardButton", bundle:"MainAssets"},
		{src:"assets/skins/images/DashboardButtonOver.png", id:"MainAssets_DashboardButtonOver", bundle:"MainAssets"},
		{src:"assets/skins/images/DataDashboardNewIcon.png", id:"MainAssets_DataDashboardNewIcon", bundle:"MainAssets"},
		{src:"assets/skins/images/DecisionButtonHi.png", id:"MainAssets_DecisionButtonHi", bundle:"MainAssets"},
		{src:"assets/skins/images/DecisionButtonUp.png", id:"MainAssets_DecisionButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/DialogBackBackground.png", id:"MainAssets_DialogBackBackground", bundle:"MainAssets"},
		{src:"assets/skins/images/DialogBackButtonDisabled.png", id:"MainAssets_DialogBackButtonDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/DialogBackButtonDown.png", id:"MainAssets_DialogBackButtonDown", bundle:"MainAssets"},
		{src:"assets/skins/images/DialogBackButtonUp.png", id:"MainAssets_DialogBackButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/DialogButtonRight.png", id:"MainAssets_DialogButtonRight", bundle:"MainAssets"},
		{src:"assets/skins/images/DialogButtonUp.png", id:"MainAssets_DialogButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/DialogButtonWrong.png", id:"MainAssets_DialogButtonWrong", bundle:"MainAssets"},
		{src:"assets/skins/images/DialogNPCTextFieldBG1.png", id:"MainAssets_DialogNPCTextFieldBG1", bundle:"MainAssets"},
		{src:"assets/skins/images/EndscreenBG.jpg", id:"MainAssets_EndscreenBG", bundle:"MainAssets"},
		{src:"assets/skins/images/EpilogueDashboardBackground.jpg", id:"MainAssets_EpilogueDashboardBackground", bundle:"MainAssets"},
		{src:"assets/skins/images/EpilogueDashboardContentBackground.png", id:"MainAssets_EpilogueDashboardContentBackground", bundle:"MainAssets"},
		{src:"assets/skins/images/EpilogueDashboardStatsContainer.png", id:"MainAssets_EpilogueDashboardStatsContainer", bundle:"MainAssets"},
		{src:"assets/skins/images/EpilogueDashboardStatsContainerLarge.png", id:"MainAssets_EpilogueDashboardStatsContainerLarge", bundle:"MainAssets"},
		{src:"assets/skins/images/EpilogueGlobeFullpngcopy.png", id:"MainAssets_EpilogueGlobeFullpngcopy", bundle:"MainAssets"},
		{src:"assets/skins/images/ExitIcon.png", id:"MainAssets_ExitIcon", bundle:"MainAssets"},
		{src:"assets/skins/images/ExpandOptimal.png", id:"MainAssets_ExpandOptimal", bundle:"MainAssets"},
		{src:"assets/skins/images/ExpandPlayerChoice.png", id:"MainAssets_ExpandPlayerChoice", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackBackground.jpg", id:"MainAssets_FeedbackBackground", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackBGpointer.png", id:"MainAssets_FeedbackBGpointer", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackBlackBar.png", id:"MainAssets_FeedbackBlackBar", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackContentContainer.png", id:"MainAssets_FeedbackContentContainer", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackIcon.png", id:"MainAssets_FeedbackIcon", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackInactiveKD.png", id:"MainAssets_FeedbackInactiveKD", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackInactiveKDOver.png", id:"MainAssets_FeedbackInactiveKDOver", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackKDInfoExpansion.png", id:"MainAssets_FeedbackKDInfoExpansion", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackKDOptimal.png", id:"MainAssets_FeedbackKDOptimal", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackKDPlayerChoice.png", id:"MainAssets_FeedbackKDPlayerChoice", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackKDSmall.png", id:"MainAssets_FeedbackKDSmall", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackLongBar.png", id:"MainAssets_FeedbackLongBar", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackPointer.png", id:"MainAssets_FeedbackPointer", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackSmallBar.png", id:"MainAssets_FeedbackSmallBar", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackTimelineBGLong.png", id:"MainAssets_FeedbackTimelineBGLong", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackToolTipBlackScreen.png", id:"MainAssets_FeedbackToolTipBlackScreen", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackToolTipWhiteScreen.png", id:"MainAssets_FeedbackToolTipWhiteScreen", bundle:"MainAssets"},
		{src:"assets/skins/images/GoodDown.png", id:"MainAssets_GoodDown", bundle:"MainAssets"},
		{src:"assets/skins/images/GoodOver.png", id:"MainAssets_GoodOver", bundle:"MainAssets"},
		{src:"assets/skins/images/GoodUp.png", id:"MainAssets_GoodUp", bundle:"MainAssets"},
		{src:"assets/skins/images/HideOptimalDown.png", id:"MainAssets_HideOptimalDown", bundle:"MainAssets"},
		{src:"assets/skins/images/HideOptimalOver.png", id:"MainAssets_HideOptimalOver", bundle:"MainAssets"},
		{src:"assets/skins/images/HideOptimalUp.png", id:"MainAssets_HideOptimalUp", bundle:"MainAssets"},
		{src:"assets/skins/images/Hub_ExitButtonOver.png", id:"MainAssets_Hub_ExitButtonOver", bundle:"MainAssets"},
		{src:"assets/skins/images/Hub_ExitButtonUp.png", id:"MainAssets_Hub_ExitButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/Hub_InfoButtonOver.png", id:"MainAssets_Hub_InfoButtonOver", bundle:"MainAssets"},
		{src:"assets/skins/images/Hub_InfoButtonUp.png", id:"MainAssets_Hub_InfoButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/Hub_PauseButtonOver.png", id:"MainAssets_Hub_PauseButtonOver", bundle:"MainAssets"},
		{src:"assets/skins/images/Hub_PauseButtonUp.png", id:"MainAssets_Hub_PauseButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/Hub_ResumeButtonOver.png", id:"MainAssets_Hub_ResumeButtonOver", bundle:"MainAssets"},
		{src:"assets/skins/images/Hub_ResumeButtonUp.png", id:"MainAssets_Hub_ResumeButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBLaptopOver.png", id:"MainAssets_HUBLaptopOver", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBLaptopUp.png", id:"MainAssets_HUBLaptopUp", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBmapCh1.jpg", id:"MainAssets_HUBmapCh1", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBmapCh1_1.png", id:"MainAssets_HUBmapCh1_1", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBmapCh1_2.jpg", id:"MainAssets_HUBmapCh1_2", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBNewItemLabel1.png", id:"MainAssets_HUBNewItemLabel1", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBSmartphoneOver.png", id:"MainAssets_HUBSmartphoneOver", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBSmartphoneUp.png", id:"MainAssets_HUBSmartphoneUp", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBStakeholderButtonBGDisabled.png", id:"MainAssets_HUBStakeholderButtonBGDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBStakeholderButtonBGUp.png", id:"MainAssets_HUBStakeholderButtonBGUp", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBStakeholderButtonLabelDisabled.png", id:"MainAssets_HUBStakeholderButtonLabelDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBStakeholderButtonLabelOver.png", id:"MainAssets_HUBStakeholderButtonLabelOver", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBStakeholderButtonLabelUp.png", id:"MainAssets_HUBStakeholderButtonLabelUp", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBTeaCornerButtonBGDisabled.png", id:"MainAssets_HUBTeaCornerButtonBGDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBTeaCornerButtonBGUp.png", id:"MainAssets_HUBTeaCornerButtonBGUp", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBTeaCornerButtonLabelDisabled.png", id:"MainAssets_HUBTeaCornerButtonLabelDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBTeaCornerButtonLabelOver.png", id:"MainAssets_HUBTeaCornerButtonLabelOver", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBTeaCornerButtonLabelUp.png", id:"MainAssets_HUBTeaCornerButtonLabelUp", bundle:"MainAssets"},
		{src:"assets/skins/images/HubTimelineBGLong.png", id:"MainAssets_HubTimelineBGLong", bundle:"MainAssets"},
		{src:"assets/skins/images/KDExpansionPointer.png", id:"MainAssets_KDExpansionPointer", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecAvailableBG.png", id:"MainAssets_KeyDecAvailableBG", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecButtonCompleted.png", id:"MainAssets_KeyDecButtonCompleted", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecButtonDown.png", id:"MainAssets_KeyDecButtonDown", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecButtonHover.png", id:"MainAssets_KeyDecButtonHover", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecButtonLocked.png", id:"MainAssets_KeyDecButtonLocked", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecButtonUp.png", id:"MainAssets_KeyDecButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecDialogueDown.png", id:"MainAssets_KeyDecDialogueDown", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecDialogueOver.png", id:"MainAssets_KeyDecDialogueOver", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecDialogueUp.png", id:"MainAssets_KeyDecDialogueUp", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecDivider.png", id:"MainAssets_KeyDecDivider", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecDown.png", id:"MainAssets_KeyDecDown", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_AnswerContainer.png", id:"MainAssets_keyDecisionPlanComposer_AnswerContainer", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_AnswerDisabled.png", id:"MainAssets_keyDecisionPlanComposer_AnswerDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_AnswerDown.png", id:"MainAssets_keyDecisionPlanComposer_AnswerDown", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_AnswerOver.png", id:"MainAssets_keyDecisionPlanComposer_AnswerOver", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_AnswerPlaced.png", id:"MainAssets_keyDecisionPlanComposer_AnswerPlaced", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_AnswerPlacedOver.png", id:"MainAssets_keyDecisionPlanComposer_AnswerPlacedOver", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_AnswerUp.png", id:"MainAssets_keyDecisionPlanComposer_AnswerUp", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_ButtonDisabled.png", id:"MainAssets_keyDecisionPlanComposer_ButtonDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_ButtonDown.png", id:"MainAssets_keyDecisionPlanComposer_ButtonDown", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_ButtonOver.png", id:"MainAssets_keyDecisionPlanComposer_ButtonOver", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_ButtonUp.png", id:"MainAssets_keyDecisionPlanComposer_ButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_InputFieldActive.png", id:"MainAssets_keyDecisionPlanComposer_InputFieldActive", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_InputFieldInac.png", id:"MainAssets_keyDecisionPlanComposer_InputFieldInac", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_SubmitPlanIcon.png", id:"MainAssets_keyDecisionPlanComposer_SubmitPlanIcon", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecLabel.png", id:"MainAssets_KeyDecLabel", bundle:"MainAssets"},
		{src:"assets/skins/images/loading_screen.jpg", id:"MainAssets_loading_screen", bundle:"MainAssets"},
		{src:"assets/skins/images/LogoGOH.png", id:"MainAssets_LogoGOH", bundle:"MainAssets"},
		{src:"assets/skins/images/LogoMoH.png", id:"MainAssets_LogoMoH", bundle:"MainAssets"},
		{src:"assets/skins/images/LogoReady.png", id:"MainAssets_LogoReady", bundle:"MainAssets"},
		{src:"assets/skins/images/MapBGConfirmation.jpg", id:"MainAssets_MapBGConfirmation", bundle:"MainAssets"},
		{src:"assets/skins/images/MapBGConfirmationjpgcopy.jpg", id:"MainAssets_MapBGConfirmationjpgcopy", bundle:"MainAssets"},
		{src:"assets/skins/images/MapInsetCh1.png", id:"MainAssets_MapInsetCh1", bundle:"MainAssets"},
		{src:"assets/skins/images/MapInsetCh2.png", id:"MainAssets_MapInsetCh2", bundle:"MainAssets"},
		{src:"assets/skins/images/MapNode.png", id:"MainAssets_MapNode", bundle:"MainAssets"},
		{src:"assets/skins/images/MapTutorial.jpg", id:"MainAssets_MapTutorial", bundle:"MainAssets"},
		{src:"assets/skins/images/MediumDown.png", id:"MainAssets_MediumDown", bundle:"MainAssets"},
		{src:"assets/skins/images/MediumOver.png", id:"MainAssets_MediumOver", bundle:"MainAssets"},
		{src:"assets/skins/images/MediumUp.png", id:"MainAssets_MediumUp", bundle:"MainAssets"},
		{src:"assets/skins/images/mockupKD5x.png", id:"MainAssets_mockupKD5x", bundle:"MainAssets"},
		{src:"assets/skins/images/NarrowContinueDisabled.png", id:"MainAssets_NarrowContinueDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/NarrowContinueOver.png", id:"MainAssets_NarrowContinueOver", bundle:"MainAssets"},
		{src:"assets/skins/images/NarrowContinueUp.png", id:"MainAssets_NarrowContinueUp", bundle:"MainAssets"},
		{src:"assets/skins/images/NewKDLabel.png", id:"MainAssets_NewKDLabel", bundle:"MainAssets"},
		{src:"assets/skins/images/NewKeyDecisionIndicator.png", id:"MainAssets_NewKeyDecisionIndicator", bundle:"MainAssets"},
		{src:"assets/skins/images/NewTopicIcon.png", id:"MainAssets_NewTopicIcon", bundle:"MainAssets"},
		{src:"assets/skins/images/NodeColor07.png", id:"MainAssets_NodeColor07", bundle:"MainAssets"},
		{src:"assets/skins/images/NotificationBarEndpngcopy.png", id:"MainAssets_NotificationBarEndpngcopy", bundle:"MainAssets"},
		{src:"assets/skins/images/OptimalDown.png", id:"MainAssets_OptimalDown", bundle:"MainAssets"},
		{src:"assets/skins/images/OptimalOver.png", id:"MainAssets_OptimalOver", bundle:"MainAssets"},
		{src:"assets/skins/images/OptimalUp.png", id:"MainAssets_OptimalUp", bundle:"MainAssets"},
		{src:"assets/skins/images/PauseIcon.png", id:"MainAssets_PauseIcon", bundle:"MainAssets"},
		{src:"assets/skins/images/PieletjeBlack.png", id:"MainAssets_PieletjeBlack", bundle:"MainAssets"},
		{src:"assets/skins/images/POI_NodeColor01.png", id:"MainAssets_POI_NodeColor01", bundle:"MainAssets"},
		{src:"assets/skins/images/POI_NodeColor02.png", id:"MainAssets_POI_NodeColor02", bundle:"MainAssets"},
		{src:"assets/skins/images/POI_NodeColor03.png", id:"MainAssets_POI_NodeColor03", bundle:"MainAssets"},
		{src:"assets/skins/images/POI_NodeColor04.png", id:"MainAssets_POI_NodeColor04", bundle:"MainAssets"},
		{src:"assets/skins/images/POI_NodeColor05.png", id:"MainAssets_POI_NodeColor05", bundle:"MainAssets"},
		{src:"assets/skins/images/POI_NodeColor06.png", id:"MainAssets_POI_NodeColor06", bundle:"MainAssets"},
		{src:"assets/skins/images/PoILabel0Over.png", id:"MainAssets_PoILabel0Over", bundle:"MainAssets"},
		{src:"assets/skins/images/PoILabel0Up.png", id:"MainAssets_PoILabel0Up", bundle:"MainAssets"},
		{src:"assets/skins/images/PoILabel3Over.png", id:"MainAssets_PoILabel3Over", bundle:"MainAssets"},
		{src:"assets/skins/images/PoILabel3Up.png", id:"MainAssets_PoILabel3Up", bundle:"MainAssets"},
		{src:"assets/skins/images/PoILTextLabelBGSmallWhite.png", id:"MainAssets_PoILTextLabelBGSmallWhite", bundle:"MainAssets"},
		{src:"assets/skins/images/PoIPLocationDummy.png", id:"MainAssets_PoIPLocationDummy", bundle:"MainAssets"},
		{src:"assets/skins/images/PopUpBackButtonDisabled.png", id:"MainAssets_PopUpBackButtonDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/PopUpBackButtonOver.png", id:"MainAssets_PopUpBackButtonOver", bundle:"MainAssets"},
		{src:"assets/skins/images/PopUpBackButtonUp.png", id:"MainAssets_PopUpBackButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/PrintButtonDisabled.png", id:"MainAssets_PrintButtonDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/PrintButtonDown.png", id:"MainAssets_PrintButtonDown", bundle:"MainAssets"},
		{src:"assets/skins/images/PrintButtonUp.png", id:"MainAssets_PrintButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/ShowOptimalDown.png", id:"MainAssets_ShowOptimalDown", bundle:"MainAssets"},
		{src:"assets/skins/images/ShowOptimalOver.png", id:"MainAssets_ShowOptimalOver", bundle:"MainAssets"},
		{src:"assets/skins/images/ShowOptimalUp.png", id:"MainAssets_ShowOptimalUp", bundle:"MainAssets"},
		{src:"assets/skins/images/stakeholder_hasim.png", id:"MainAssets_stakeholder_hasim", bundle:"MainAssets"},
		{src:"assets/skins/images/stakeholder_hasim_disabled.png", id:"MainAssets_stakeholder_hasim_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/stakeholder_Nia.png", id:"MainAssets_stakeholder_Nia", bundle:"MainAssets"},
		{src:"assets/skins/images/stakeholder_nia_disabled.png", id:"MainAssets_stakeholder_nia_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/stakeholder_onneetse.png", id:"MainAssets_stakeholder_onneetse", bundle:"MainAssets"},
		{src:"assets/skins/images/stakeholder_onneetse_disabled.png", id:"MainAssets_stakeholder_onneetse_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/stakeholder_sarah.png", id:"MainAssets_stakeholder_sarah", bundle:"MainAssets"},
		{src:"assets/skins/images/stakeholder_sarah_disabled.png", id:"MainAssets_stakeholder_sarah_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/StarOptimal.png", id:"MainAssets_StarOptimal", bundle:"MainAssets"},
		{src:"assets/skins/images/StarPlayerChoiceEmpty.png", id:"MainAssets_StarPlayerChoiceEmpty", bundle:"MainAssets"},
		{src:"assets/skins/images/StarPlayerChoiceFilled.png", id:"MainAssets_StarPlayerChoiceFilled", bundle:"MainAssets"},
		{src:"assets/skins/images/Tab1.png", id:"MainAssets_Tab1", bundle:"MainAssets"},
		{src:"assets/skins/images/tab2.png", id:"MainAssets_tab2", bundle:"MainAssets"},
		{src:"assets/skins/images/Tab2BGElement.png", id:"MainAssets_Tab2BGElement", bundle:"MainAssets"},
		{src:"assets/skins/images/tab3.png", id:"MainAssets_tab3", bundle:"MainAssets"},
		{src:"assets/skins/images/Tab3Info1.png", id:"MainAssets_Tab3Info1", bundle:"MainAssets"},
		{src:"assets/skins/images/Tab3Info2.png", id:"MainAssets_Tab3Info2", bundle:"MainAssets"},
		{src:"assets/skins/images/Tab3Info3.png", id:"MainAssets_Tab3Info3", bundle:"MainAssets"},
		{src:"assets/skins/images/Tab3Info4.png", id:"MainAssets_Tab3Info4", bundle:"MainAssets"},
		{src:"assets/skins/images/Tab3Info5.png", id:"MainAssets_Tab3Info5", bundle:"MainAssets"},
		{src:"assets/skins/images/Tab3StaticImage.png", id:"MainAssets_Tab3StaticImage", bundle:"MainAssets"},
		{src:"assets/skins/images/TeaCornerIcon.png", id:"MainAssets_TeaCornerIcon", bundle:"MainAssets"},
		{src:"assets/skins/images/TeaCornerIconDisabled.png", id:"MainAssets_TeaCornerIconDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/TimelineBG.png", id:"MainAssets_TimelineBG", bundle:"MainAssets"},
		{src:"assets/skins/images/TimerClock.png", id:"MainAssets_TimerClock", bundle:"MainAssets"},
		{src:"assets/skins/images/timerKeyDecision_Neutral.png", id:"MainAssets_timerKeyDecision_Neutral", bundle:"MainAssets"},
		{src:"assets/skins/images/timerKeyDecision_Urgent.png", id:"MainAssets_timerKeyDecision_Urgent", bundle:"MainAssets"},
		{src:"assets/skins/images/TimingBG.png", id:"MainAssets_TimingBG", bundle:"MainAssets"},
		{src:"assets/skins/images/TopBar.png", id:"MainAssets_TopBar", bundle:"MainAssets"},
		{src:"assets/skins/images/TopicButtonDisabled.png", id:"MainAssets_TopicButtonDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/TopicButtonDown.png", id:"MainAssets_TopicButtonDown", bundle:"MainAssets"},
		{src:"assets/skins/images/TopicButtonUp.png", id:"MainAssets_TopicButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/TopLeftDisabled.png", id:"MainAssets_TopLeftDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/TrendDownDark.png", id:"MainAssets_TrendDownDark", bundle:"MainAssets"},
		{src:"assets/skins/images/TrendUpDark.png", id:"MainAssets_TrendUpDark", bundle:"MainAssets"},
		{src:"assets/skins/images/Tutorial_exit.png", id:"MainAssets_Tutorial_exit", bundle:"MainAssets"},
		{src:"assets/skins/images/Tutorial_info.png", id:"MainAssets_Tutorial_info", bundle:"MainAssets"},
		{src:"assets/skins/images/Tutorial_pause.png", id:"MainAssets_Tutorial_pause", bundle:"MainAssets"},
		{src:"assets/skins/images/TutorialScreens_PopUpShorter.png", id:"MainAssets_TutorialScreens_PopUpShorter", bundle:"MainAssets"},
		{src:"assets/skins/images/TutorialScreens_TutorialContainer.png", id:"MainAssets_TutorialScreens_TutorialContainer", bundle:"MainAssets"},
		{src:"assets/skins/images/TutorialScreens_TutorialOverlay.png", id:"MainAssets_TutorialScreens_TutorialOverlay", bundle:"MainAssets"},
		{src:"assets/skins/images/UnlockedAnswerIcon.png", id:"MainAssets_UnlockedAnswerIcon", bundle:"MainAssets"},
		{src:"assets/skins/images/ViewKDDisabled.png", id:"MainAssets_ViewKDDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/ViewKDOver.png", id:"MainAssets_ViewKDOver", bundle:"MainAssets"},
		{src:"assets/skins/images/ViewKDUp.png", id:"MainAssets_ViewKDUp", bundle:"MainAssets"},
		{src:"assets/skins/images/Vinkje.png", id:"MainAssets_Vinkje", bundle:"MainAssets"},
		{src:"assets/skins/images/VinkjeHi.png", id:"MainAssets_VinkjeHi", bundle:"MainAssets"}
	],
	preloads: []
};



an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(lib.MainAssets = {}, images, ss, createjs, AdobeAn = AdobeAn||{});
var AdobeAn;
module.exports = lib.MainAssets;